(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ef8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ef8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iA027", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d86b9d6065f132ed$export$6503ec6e8aabbaf; }, function (v) { return $d86b9d6065f132ed$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $d86b9d6065f132ed$export$f7ad0328861e2f03; }, function (v) { return $d86b9d6065f132ed$export$f7ad0328861e2f03 = v; });
var $d86b9d6065f132ed$export$6503ec6e8aabbaf;
var $d86b9d6065f132ed$export$f7ad0328861e2f03;
"use strict";
var $d86b9d6065f132ed$var$mapping = new Map();
function $d86b9d6065f132ed$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d86b9d6065f132ed$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d86b9d6065f132ed$var$resolve(id) {
    var resolved = $d86b9d6065f132ed$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d86b9d6065f132ed$export$6503ec6e8aabbaf = $d86b9d6065f132ed$var$register;
$d86b9d6065f132ed$export$f7ad0328861e2f03 = $d86b9d6065f132ed$var$resolve;

});

parcelRegister("7rKCZ", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $56bf3959e13bb861$export$bdfd709ae4826697; }, function (v) { return $56bf3959e13bb861$export$bdfd709ae4826697 = v; });
var $56bf3959e13bb861$export$bdfd709ae4826697;
var $56bf3959e13bb861$export$c9e73fbda7da57b6;
var $56bf3959e13bb861$export$5a759dc7a1cfb72a;
"use strict";
var $56bf3959e13bb861$var$bundleURL = {};
function $56bf3959e13bb861$var$getBundleURLCached(id) {
    var value = $56bf3959e13bb861$var$bundleURL[id];
    if (!value) {
        value = $56bf3959e13bb861$var$getBundleURL();
        $56bf3959e13bb861$var$bundleURL[id] = value;
    }
    return value;
}
function $56bf3959e13bb861$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $56bf3959e13bb861$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $56bf3959e13bb861$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $56bf3959e13bb861$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$56bf3959e13bb861$export$bdfd709ae4826697 = $56bf3959e13bb861$var$getBundleURLCached;
$56bf3959e13bb861$export$c9e73fbda7da57b6 = $56bf3959e13bb861$var$getBaseURL;
$56bf3959e13bb861$export$5a759dc7a1cfb72a = $56bf3959e13bb861$var$getOrigin;

});

parcelRegister("bTB0U", function(module, exports) {
module.exports = function() {
    if (this.options.debug && console) {
        if (typeof console.log === "function") console.log.apply(console, arguments);
        else if (console.log) console.log(arguments);
    }
};

});

parcelRegister("6l3E4", function(module, exports) {
var $49d78820ac9bfdb7$var$attrState = "data-pjax-state";
module.exports = function(el) {
    switch(el.tagName.toLowerCase()){
        case "a":
            // only attach link if el does not already have link attached
            if (!el.hasAttribute($49d78820ac9bfdb7$var$attrState)) this.attachLink(el);
            break;
        case "form":
            // only attach link if el does not already have link attached
            if (!el.hasAttribute($49d78820ac9bfdb7$var$attrState)) this.attachForm(el);
            break;
        default:
            throw "Pjax can only be applied on <a> or <form> submit";
    }
};

});

parcelRegister("4Qp2J", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");

var $8kgSr = parcelRequire("8kgSr");
var $386f71c9915ec15b$var$attrState = "data-pjax-state";
var $386f71c9915ec15b$var$linkAction = function(el, event) {
    if ($386f71c9915ec15b$var$isDefaultPrevented(event)) return;
    // Since loadUrl modifies options and we may add our own modifications below,
    // clone it so the changes don't persist
    var options = $8kgSr(this.options);
    var attrValue = $386f71c9915ec15b$var$checkIfShouldAbort(el, event);
    if (attrValue) {
        el.setAttribute($386f71c9915ec15b$var$attrState, attrValue);
        return;
    }
    event.preventDefault();
    // don’t do "nothing" if user try to reload the page by clicking the same link twice
    if (this.options.currentUrlFullReload && el.href === window.location.href.split("#")[0]) {
        el.setAttribute($386f71c9915ec15b$var$attrState, "reload");
        this.reload();
        return;
    }
    el.setAttribute($386f71c9915ec15b$var$attrState, "load");
    options.triggerElement = el;
    this.loadUrl(el.href, options);
};
function $386f71c9915ec15b$var$checkIfShouldAbort(el, event) {
    // Don’t break browser special behavior on links (like page in new window)
    if (event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return "modifier";
    // we do test on href now to prevent unexpected behavior if for some reason
    // user have href that can be dynamically updated
    // Ignore external links.
    if (el.protocol !== window.location.protocol || el.host !== window.location.host) return "external";
    // Ignore anchors on the same page (keep native behavior)
    if (el.hash && el.href.replace(el.hash, "") === window.location.href.replace(location.hash, "")) return "anchor";
    // Ignore empty anchor "foo.html#"
    if (el.href === window.location.href.split("#")[0] + "#") return "anchor-empty";
}
var $386f71c9915ec15b$var$isDefaultPrevented = function(event) {
    return event.defaultPrevented || event.returnValue === false;
};
module.exports = function(el) {
    var that = this;
    el.setAttribute($386f71c9915ec15b$var$attrState, "");
    $fcCTJ(el, "click", function(event) {
        $386f71c9915ec15b$var$linkAction.call(that, el, event);
    });
    $fcCTJ(el, "keyup", (function(event) {
        if (event.keyCode === 13) $386f71c9915ec15b$var$linkAction.call(that, el, event);
    }).bind(this));
};

});
parcelRegister("fcCTJ", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(els, events, listener, useCapture) {
    events = typeof events === "string" ? events.split(" ") : events;
    events.forEach(function(e) {
        $fRaLx(els, function(el) {
            el.addEventListener(e, listener, useCapture);
        });
    });
};

});
parcelRegister("fRaLx", function(module, exports) {
/* global HTMLCollection: true */ module.exports = function(els, fn, context) {
    if (els instanceof HTMLCollection || els instanceof NodeList || els instanceof Array) return Array.prototype.forEach.call(els, fn, context);
    // assume simple DOM element
    return fn.call(context, els);
};

});


parcelRegister("8kgSr", function(module, exports) {
module.exports = function(obj) {
    /* istanbul ignore if */ if (null === obj || "object" !== typeof obj) return obj;
    var copy = obj.constructor();
    for(var attr in obj)if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    return copy;
};

});


parcelRegister("crAW0", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");

var $8kgSr = parcelRequire("8kgSr");
var $90f4a81510e65f6a$var$attrState = "data-pjax-state";
var $90f4a81510e65f6a$var$formAction = function(el, event) {
    if ($90f4a81510e65f6a$var$isDefaultPrevented(event)) return;
    // Since loadUrl modifies options and we may add our own modifications below,
    // clone it so the changes don't persist
    var options = $8kgSr(this.options);
    // Initialize requestOptions
    options.requestOptions = {
        requestUrl: el.getAttribute("action") || window.location.href,
        requestMethod: el.getAttribute("method") || "GET"
    };
    // create a testable virtual link of the form action
    var virtLinkElement = document.createElement("a");
    virtLinkElement.setAttribute("href", options.requestOptions.requestUrl);
    var attrValue = $90f4a81510e65f6a$var$checkIfShouldAbort(virtLinkElement, options);
    if (attrValue) {
        el.setAttribute($90f4a81510e65f6a$var$attrState, attrValue);
        return;
    }
    event.preventDefault();
    if (el.enctype === "multipart/form-data") options.requestOptions.formData = new FormData(el);
    else options.requestOptions.requestParams = $90f4a81510e65f6a$var$parseFormElements(el);
    el.setAttribute($90f4a81510e65f6a$var$attrState, "submit");
    options.triggerElement = el;
    this.loadUrl(virtLinkElement.href, options);
};
function $90f4a81510e65f6a$var$parseFormElements(el) {
    var requestParams = [];
    var formElements = el.elements;
    for(var i = 0; i < formElements.length; i++){
        var element = formElements[i];
        var tagName = element.tagName.toLowerCase();
        // jscs:disable disallowImplicitTypeConversion
        if (!!element.name && element.attributes !== undefined && tagName !== "button") {
            // jscs:enable disallowImplicitTypeConversion
            var type = element.attributes.type;
            if (!type || type.value !== "checkbox" && type.value !== "radio" || element.checked) {
                // Build array of values to submit
                var values = [];
                if (tagName === "select") {
                    var opt;
                    for(var j = 0; j < element.options.length; j++){
                        opt = element.options[j];
                        if (opt.selected && !opt.disabled) values.push(opt.hasAttribute("value") ? opt.value : opt.text);
                    }
                } else values.push(element.value);
                for(var k = 0; k < values.length; k++)requestParams.push({
                    name: encodeURIComponent(element.name),
                    value: encodeURIComponent(values[k])
                });
            }
        }
    }
    return requestParams;
}
function $90f4a81510e65f6a$var$checkIfShouldAbort(virtLinkElement, options) {
    // Ignore external links.
    if (virtLinkElement.protocol !== window.location.protocol || virtLinkElement.host !== window.location.host) return "external";
    // Ignore click if we are on an anchor on the same page
    if (virtLinkElement.hash && virtLinkElement.href.replace(virtLinkElement.hash, "") === window.location.href.replace(location.hash, "")) return "anchor";
    // Ignore empty anchor "foo.html#"
    if (virtLinkElement.href === window.location.href.split("#")[0] + "#") return "anchor-empty";
    // if declared as a full reload, just normally submit the form
    if (options.currentUrlFullReload && virtLinkElement.href === window.location.href.split("#")[0]) return "reload";
}
var $90f4a81510e65f6a$var$isDefaultPrevented = function(event) {
    return event.defaultPrevented || event.returnValue === false;
};
module.exports = function(el) {
    var that = this;
    el.setAttribute($90f4a81510e65f6a$var$attrState, "");
    $fcCTJ(el, "submit", function(event) {
        $90f4a81510e65f6a$var$formAction.call(that, el, event);
    });
};

});

parcelRegister("duhL3", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(selectors, cb, context, DOMcontext) {
    DOMcontext = DOMcontext || document;
    selectors.forEach(function(selector) {
        $fRaLx(DOMcontext.querySelectorAll(selector), cb, context);
    });
};

});

parcelRegister("loXQO", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");

var $7RZTV = parcelRequire("7RZTV");
module.exports = function(switches, switchesOptions, selectors, fromEl, toEl, options) {
    var switchesQueue = [];
    selectors.forEach(function(selector) {
        var newEls = fromEl.querySelectorAll(selector);
        var oldEls = toEl.querySelectorAll(selector);
        if (this.log) this.log("Pjax switch", selector, newEls, oldEls);
        if (newEls.length !== oldEls.length) throw "DOM doesn\u2019t look the same on new loaded page: \u2019" + selector + "\u2019 - new " + newEls.length + ", old " + oldEls.length;
        $fRaLx(newEls, function(newEl, i) {
            var oldEl = oldEls[i];
            if (this.log) this.log("newEl", newEl, "oldEl", oldEl);
            var callback = switches[selector] ? switches[selector].bind(this, oldEl, newEl, options, switchesOptions[selector]) : $7RZTV.outerHTML.bind(this, oldEl, newEl, options);
            switchesQueue.push(callback);
        }, this);
    }, this);
    this.state.numPendingSwitches = switchesQueue.length;
    switchesQueue.forEach(function(queuedSwitch) {
        queuedSwitch();
    });
};

});
parcelRegister("7RZTV", function(module, exports) {

var $fcCTJ = parcelRequire("fcCTJ");
module.exports = {
    outerHTML: function(oldEl, newEl) {
        oldEl.outerHTML = newEl.outerHTML;
        this.onSwitch();
    },
    innerHTML: function(oldEl, newEl) {
        oldEl.innerHTML = newEl.innerHTML;
        if (newEl.className === "") oldEl.removeAttribute("class");
        else oldEl.className = newEl.className;
        this.onSwitch();
    },
    switchElementsAlt: function(oldEl, newEl) {
        oldEl.innerHTML = newEl.innerHTML;
        // Copy attributes from the new element to the old one
        if (newEl.hasAttributes()) {
            var attrs = newEl.attributes;
            for(var i = 0; i < attrs.length; i++)oldEl.attributes.setNamedItem(attrs[i].cloneNode());
        }
        this.onSwitch();
    },
    // Equivalent to outerHTML(), but doesn't require switchElementsAlt() for <head> and <body>
    replaceNode: function(oldEl, newEl) {
        oldEl.parentNode.replaceChild(newEl, oldEl);
        this.onSwitch();
    },
    sideBySide: function(oldEl, newEl, options, switchOptions) {
        var forEach = Array.prototype.forEach;
        var elsToRemove = [];
        var elsToAdd = [];
        var fragToAppend = document.createDocumentFragment();
        var animationEventNames = "animationend webkitAnimationEnd MSAnimationEnd oanimationend";
        var animatedElsNumber = 0;
        var sexyAnimationEnd = (function(e) {
            if (e.target !== e.currentTarget) // end triggered by an animation on a child
            return;
            animatedElsNumber--;
            if (animatedElsNumber <= 0 && elsToRemove) {
                elsToRemove.forEach(function(el) {
                    // browsing quickly can make the el
                    // already removed by last page update ?
                    if (el.parentNode) el.parentNode.removeChild(el);
                });
                elsToAdd.forEach(function(el) {
                    el.className = el.className.replace(el.getAttribute("data-pjax-classes"), "");
                    el.removeAttribute("data-pjax-classes");
                });
                elsToAdd = null; // free memory
                elsToRemove = null; // free memory
                // this is to trigger some repaint (example: picturefill)
                this.onSwitch();
            }
        }).bind(this);
        switchOptions = switchOptions || {};
        forEach.call(oldEl.childNodes, function(el) {
            elsToRemove.push(el);
            if (el.classList && !el.classList.contains("js-Pjax-remove")) {
                // for fast switch, clean element that just have been added, & not cleaned yet.
                if (el.hasAttribute("data-pjax-classes")) {
                    el.className = el.className.replace(el.getAttribute("data-pjax-classes"), "");
                    el.removeAttribute("data-pjax-classes");
                }
                el.classList.add("js-Pjax-remove");
                if (switchOptions.callbacks && switchOptions.callbacks.removeElement) switchOptions.callbacks.removeElement(el);
                if (switchOptions.classNames) el.className += " " + switchOptions.classNames.remove + " " + (options.backward ? switchOptions.classNames.backward : switchOptions.classNames.forward);
                animatedElsNumber++;
                $fcCTJ(el, animationEventNames, sexyAnimationEnd, true);
            }
        });
        forEach.call(newEl.childNodes, function(el) {
            if (el.classList) {
                var addClasses = "";
                if (switchOptions.classNames) addClasses = " js-Pjax-add " + switchOptions.classNames.add + " " + (options.backward ? switchOptions.classNames.forward : switchOptions.classNames.backward);
                if (switchOptions.callbacks && switchOptions.callbacks.addElement) switchOptions.callbacks.addElement(el);
                el.className += addClasses;
                el.setAttribute("data-pjax-classes", addClasses);
                elsToAdd.push(el);
                fragToAppend.appendChild(el);
                animatedElsNumber++;
                $fcCTJ(el, animationEventNames, sexyAnimationEnd, true);
            }
        });
        // pass all className of the parent
        oldEl.className = newEl.className;
        oldEl.appendChild(fragToAppend);
    }
};

});


parcelRegister("8BsJe", function(module, exports) {

var $cukYX = parcelRequire("cukYX");
module.exports = function(request) {
    if (request && request.readyState < 4) {
        request.onreadystatechange = $cukYX;
        request.abort();
    }
};

});
parcelRegister("cukYX", function(module, exports) {
module.exports = function() {};

});


parcelRegister("aBk3q", function(module, exports) {

var $KUIr8 = parcelRequire("KUIr8");
module.exports = function(location, options, callback) {
    options = options || {};
    var queryString;
    var requestOptions = options.requestOptions || {};
    var requestMethod = (requestOptions.requestMethod || "GET").toUpperCase();
    var requestParams = requestOptions.requestParams || null;
    var formData = requestOptions.formData || null;
    var requestPayload = null;
    var request = new XMLHttpRequest();
    var timeout = options.timeout || 0;
    request.onreadystatechange = function() {
        if (request.readyState === 4) {
            if (request.status === 200) callback(request.responseText, request, location, options);
            else if (request.status !== 0) callback(null, request, location, options);
        }
    };
    request.onerror = function(e) {
        console.log(e);
        callback(null, request, location, options);
    };
    request.ontimeout = function() {
        callback(null, request, location, options);
    };
    // Prepare the request payload for forms, if available
    if (requestParams && requestParams.length) {
        // Build query string
        queryString = requestParams.map(function(param) {
            return param.name + "=" + param.value;
        }).join("&");
        switch(requestMethod){
            case "GET":
                // Reset query string to avoid an issue with repeat submissions where checkboxes that were
                // previously checked are incorrectly preserved
                location = location.split("?")[0];
                // Append new query string
                location += "?" + queryString;
                break;
            case "POST":
                // Send query string as request payload
                requestPayload = queryString;
                break;
        }
    } else if (formData) requestPayload = formData;
    // Add a timestamp as part of the query string if cache busting is enabled
    if (options.cacheBust) location = $KUIr8(location, "t", Date.now());
    request.open(requestMethod, location, true);
    request.timeout = timeout;
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.setRequestHeader("X-PJAX", "true");
    request.setRequestHeader("X-PJAX-Selectors", JSON.stringify(options.selectors));
    // Send the proper header information for POST forms
    if (requestPayload && requestMethod === "POST" && !formData) request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    request.send(requestPayload);
    return request;
};

});
parcelRegister("KUIr8", function(module, exports) {
module.exports = function(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) return uri.replace(re, "$1" + key + "=" + value + "$2");
    else return uri + separator + key + "=" + value;
};

});


parcelRegister("3vRmN", function(module, exports) {

var $8kgSr = parcelRequire("8kgSr");

var $e36no = parcelRequire("e36no");

var $ep84Q = parcelRequire("ep84Q");
module.exports = function(responseText, request, href, options) {
    options = $8kgSr(options || this.options);
    options.request = request;
    // Fail if unable to load HTML via AJAX
    if (responseText === false) {
        $ep84Q(document, "pjax:complete pjax:error", options);
        return;
    }
    // push scroll position to history
    var currentState = window.history.state || {};
    window.history.replaceState({
        url: currentState.url || window.location.href,
        title: currentState.title || document.title,
        uid: currentState.uid || $e36no(),
        scrollPos: [
            document.documentElement.scrollLeft || document.body.scrollLeft,
            document.documentElement.scrollTop || document.body.scrollTop
        ]
    }, document.title, window.location.href);
    // Check for redirects
    var oldHref = href;
    if (request.responseURL) {
        if (href !== request.responseURL) href = request.responseURL;
    } else if (request.getResponseHeader("X-PJAX-URL")) href = request.getResponseHeader("X-PJAX-URL");
    else if (request.getResponseHeader("X-XHR-Redirected-To")) href = request.getResponseHeader("X-XHR-Redirected-To");
    // Add back the hash if it was removed
    var a = document.createElement("a");
    a.href = oldHref;
    var oldHash = a.hash;
    a.href = href;
    if (oldHash && !a.hash) {
        a.hash = oldHash;
        href = a.href;
    }
    this.state.href = href;
    this.state.options = options;
    try {
        this.loadContent(responseText, options);
    } catch (e) {
        $ep84Q(document, "pjax:error", options);
        if (!this.options.debug) {
            if (console && console.error) console.error("Pjax switch fail: ", e);
            return this.latestChance(href);
        } else throw e;
    }
};

});
parcelRegister("e36no", function(module, exports) {
module.exports = function() {
    var counter = 0;
    return function() {
        var id = "pjax" + new Date().getTime() + "_" + counter;
        counter++;
        return id;
    };
}();

});

parcelRegister("ep84Q", function(module, exports) {

var $fRaLx = parcelRequire("fRaLx");
module.exports = function(els, events, opts) {
    events = typeof events === "string" ? events.split(" ") : events;
    events.forEach(function(e) {
        var event;
        event = document.createEvent("HTMLEvents");
        event.initEvent(e, true, true);
        event.eventName = e;
        if (opts) Object.keys(opts).forEach(function(key) {
            event[key] = opts[key];
        });
        $fRaLx(els, function(el) {
            var domFix = false;
            if (!el.parentNode && el !== document && el !== window) {
                // THANK YOU IE (9/10/11)
                // dispatchEvent doesn't work if the element is not in the DOM
                domFix = true;
                document.body.appendChild(el);
            }
            el.dispatchEvent(event);
            if (domFix) el.parentNode.removeChild(el);
        });
    });
};

});


parcelRegister("cODYy", function(module, exports) {
module.exports = function() {
    // Borrowed wholesale from https://github.com/defunkt/jquery-pjax
    return window.history && window.history.pushState && window.history.replaceState && // pushState isn’t reliable on iOS until 5.
    !navigator.userAgent.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]\D|WebApps\/.+CFNetwork)/);
};

});

parcelRegister("8YGgm", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("t1juM")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("ivqFp")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("t1juM")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("8dqiK")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("cDLKH")).createPopper; });

var $9sBMA = parcelRequire("9sBMA");

var $kCPJq = parcelRequire("kCPJq");

var $t1juM = parcelRequire("t1juM");
var $ivqFp = parcelRequire("ivqFp");

var $8dqiK = parcelRequire("8dqiK");

var $cDLKH = parcelRequire("cDLKH");
$parcel$exportWildcard(module.exports, $9sBMA);
$parcel$exportWildcard(module.exports, $kCPJq);

});
parcelRegister("9sBMA", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $6e3409677f3554d3$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $6e3409677f3554d3$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $6e3409677f3554d3$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $6e3409677f3554d3$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $6e3409677f3554d3$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $6e3409677f3554d3$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $6e3409677f3554d3$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $6e3409677f3554d3$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $6e3409677f3554d3$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $6e3409677f3554d3$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $6e3409677f3554d3$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $6e3409677f3554d3$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $6e3409677f3554d3$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $6e3409677f3554d3$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $6e3409677f3554d3$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $6e3409677f3554d3$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $6e3409677f3554d3$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $6e3409677f3554d3$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $6e3409677f3554d3$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $6e3409677f3554d3$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $6e3409677f3554d3$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $6e3409677f3554d3$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $6e3409677f3554d3$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $6e3409677f3554d3$export$d087d3878fdf71d5; });
var $6e3409677f3554d3$export$1e95b668f3b82d = "top";
var $6e3409677f3554d3$export$40e543e69a8b3fbb = "bottom";
var $6e3409677f3554d3$export$79ffe56a765070d2 = "right";
var $6e3409677f3554d3$export$eabcd2c8791e7bf4 = "left";
var $6e3409677f3554d3$export$dfb5619354ba860 = "auto";
var $6e3409677f3554d3$export$aec2ce47c367b8c3 = [
    $6e3409677f3554d3$export$1e95b668f3b82d,
    $6e3409677f3554d3$export$40e543e69a8b3fbb,
    $6e3409677f3554d3$export$79ffe56a765070d2,
    $6e3409677f3554d3$export$eabcd2c8791e7bf4
];
var $6e3409677f3554d3$export$b3571188c770cc5a = "start";
var $6e3409677f3554d3$export$bd5df0f255a350f8 = "end";
var $6e3409677f3554d3$export$390fd549c5303b4d = "clippingParents";
var $6e3409677f3554d3$export$d7b7311ec04a3e8f = "viewport";
var $6e3409677f3554d3$export$ae5ab1c730825774 = "popper";
var $6e3409677f3554d3$export$ca50aac9f3ba507f = "reference";
var $6e3409677f3554d3$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6e3409677f3554d3$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6e3409677f3554d3$export$b3571188c770cc5a,
        placement + "-" + $6e3409677f3554d3$export$bd5df0f255a350f8
    ]);
}, []);
var $6e3409677f3554d3$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6e3409677f3554d3$export$aec2ce47c367b8c3, [
    $6e3409677f3554d3$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6e3409677f3554d3$export$b3571188c770cc5a,
        placement + "-" + $6e3409677f3554d3$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6e3409677f3554d3$export$421679a7c3d56e = "beforeRead";
var $6e3409677f3554d3$export$aafa59e2e03f2942 = "read";
var $6e3409677f3554d3$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $6e3409677f3554d3$export$c65e99957a05207c = "beforeMain";
var $6e3409677f3554d3$export$f22da7240b7add18 = "main";
var $6e3409677f3554d3$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6e3409677f3554d3$export$8d4d2d70e7d46032 = "beforeWrite";
var $6e3409677f3554d3$export$68d8715fc104d294 = "write";
var $6e3409677f3554d3$export$70a6e5159acce2e6 = "afterWrite";
var $6e3409677f3554d3$export$d087d3878fdf71d5 = [
    $6e3409677f3554d3$export$421679a7c3d56e,
    $6e3409677f3554d3$export$aafa59e2e03f2942,
    $6e3409677f3554d3$export$6964f6c886723980,
    $6e3409677f3554d3$export$c65e99957a05207c,
    $6e3409677f3554d3$export$f22da7240b7add18,
    $6e3409677f3554d3$export$bab79516f2d662fe,
    $6e3409677f3554d3$export$8d4d2d70e7d46032,
    $6e3409677f3554d3$export$68d8715fc104d294,
    $6e3409677f3554d3$export$70a6e5159acce2e6
];

});

parcelRegister("kCPJq", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("gy0RQ")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("d1SXy")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("i7xoL")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("7j3jV")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("bJk6k")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("iIbxA")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("hLLXp")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("bwXYi")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("7oqYt")).default; });

var $gy0RQ = parcelRequire("gy0RQ");

var $d1SXy = parcelRequire("d1SXy");

var $i7xoL = parcelRequire("i7xoL");

var $7j3jV = parcelRequire("7j3jV");

var $bJk6k = parcelRequire("bJk6k");

var $iIbxA = parcelRequire("iIbxA");

var $hLLXp = parcelRequire("hLLXp");

var $bwXYi = parcelRequire("bwXYi");

var $7oqYt = parcelRequire("7oqYt");

});
parcelRegister("gy0RQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c07e8eca0d7372$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");
// and applies them to the HTMLElements such as popper and arrow
function $c0c07e8eca0d7372$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4yey3.isHTMLElement)(element) || !(0, $gNNyC.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $c0c07e8eca0d7372$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4yey3.isHTMLElement)(element) || !(0, $gNNyC.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c0c07e8eca0d7372$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $c0c07e8eca0d7372$var$applyStyles,
    effect: $c0c07e8eca0d7372$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("gNNyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b7a9fe7060c226$export$2e2bcd8739ae039; });
function $c3b7a9fe7060c226$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("4yey3", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $35059f64866235ee$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $35059f64866235ee$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $35059f64866235ee$export$af51f0f06c0f328a; });

var $cYZ7h = parcelRequire("cYZ7h");
function $35059f64866235ee$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $cYZ7h.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $35059f64866235ee$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $cYZ7h.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $35059f64866235ee$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $cYZ7h.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("cYZ7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973a7f130c9ec43f$export$2e2bcd8739ae039; });
function $973a7f130c9ec43f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("d1SXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97c60028dd08149b$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $jXC8u = parcelRequire("jXC8u");

var $lwNTw = parcelRequire("lwNTw");

var $gWO4o = parcelRequire("gWO4o");

var $9M8WM = parcelRequire("9M8WM");

var $fsgwo = parcelRequire("fsgwo");

var $93Awv = parcelRequire("93Awv");

var $lkZpD = parcelRequire("lkZpD");

var $9sBMA = parcelRequire("9sBMA");
var $97c60028dd08149b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $93Awv.default)(typeof padding !== "number" ? padding : (0, $lkZpD.default)(padding, (0, $9sBMA.basePlacements)));
};
function $97c60028dd08149b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $bjbdL.default)(state.placement);
    var axis = (0, $9M8WM.default)(basePlacement);
    var isVertical = [
        (0, $9sBMA.left),
        (0, $9sBMA.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $97c60028dd08149b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jXC8u.default)(arrowElement);
    var minProp = axis === "y" ? (0, $9sBMA.top) : (0, $9sBMA.left);
    var maxProp = axis === "y" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gWO4o.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fsgwo.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $97c60028dd08149b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lwNTw.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $97c60028dd08149b$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $97c60028dd08149b$var$arrow,
    effect: $97c60028dd08149b$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("bjbdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ba2c548bad33b9$export$2e2bcd8739ae039; });

function $83ba2c548bad33b9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("jXC8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8811c053fe33463$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");
function $e8811c053fe33463$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $iYLNX.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("iYLNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd12e9a555a8f685$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");

var $9pEtR = parcelRequire("9pEtR");

var $cYZ7h = parcelRequire("cYZ7h");

var $dXRpq = parcelRequire("dXRpq");
function $dd12e9a555a8f685$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4yey3.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9pEtR.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9pEtR.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4yey3.isElement)(element) ? (0, $cYZ7h.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $dXRpq.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("9pEtR", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $6da5d97298b86516$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $6da5d97298b86516$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $6da5d97298b86516$export$2077e0241d6afd3c; });
var $6da5d97298b86516$export$8960430cfd85939f = Math.max;
var $6da5d97298b86516$export$96ec731ed4dcb222 = Math.min;
var $6da5d97298b86516$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("dXRpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2aa36fa050ffe9c$export$2e2bcd8739ae039; });

var $7Lz1R = parcelRequire("7Lz1R");
function $a2aa36fa050ffe9c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $7Lz1R.default)());
}

});
parcelRegister("7Lz1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a781834fcf97823$export$2e2bcd8739ae039; });
function $5a781834fcf97823$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("lwNTw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fac34a254f26607f$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");
function $fac34a254f26607f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $4yey3.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("gWO4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c568e6f96d71ec07$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");

var $gNNyC = parcelRequire("gNNyC");

var $1eqAZ = parcelRequire("1eqAZ");

var $4yey3 = parcelRequire("4yey3");

var $fGs4b = parcelRequire("fGs4b");

var $cxf4H = parcelRequire("cxf4H");

var $7Lz1R = parcelRequire("7Lz1R");
function $c568e6f96d71ec07$var$getTrueOffsetParent(element) {
    if (!(0, $4yey3.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1eqAZ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $c568e6f96d71ec07$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $7Lz1R.default)());
    var isIE = /Trident/i.test((0, $7Lz1R.default)());
    if (isIE && (0, $4yey3.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1eqAZ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $cxf4H.default)(element);
    if ((0, $4yey3.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $4yey3.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $gNNyC.default)(currentNode)) < 0){
        var css = (0, $1eqAZ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $c568e6f96d71ec07$export$2e2bcd8739ae039(element) {
    var window = (0, $cYZ7h.default)(element);
    var offsetParent = $c568e6f96d71ec07$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fGs4b.default)(offsetParent) && (0, $1eqAZ.default)(offsetParent).position === "static")offsetParent = $c568e6f96d71ec07$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $gNNyC.default)(offsetParent) === "html" || (0, $gNNyC.default)(offsetParent) === "body" && (0, $1eqAZ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $c568e6f96d71ec07$var$getContainingBlock(element) || window;
}

});
parcelRegister("1eqAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e5bba94d248b9b5$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
function $0e5bba94d248b9b5$export$2e2bcd8739ae039(element) {
    return (0, $cYZ7h.default)(element).getComputedStyle(element);
}

});

parcelRegister("fGs4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6b08cb14821c798$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");
function $b6b08cb14821c798$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $gNNyC.default)(element)) >= 0;
}

});

parcelRegister("cxf4H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $920442a01184663c$export$2e2bcd8739ae039; });

var $gNNyC = parcelRequire("gNNyC");

var $eNF9s = parcelRequire("eNF9s");

var $4yey3 = parcelRequire("4yey3");
function $920442a01184663c$export$2e2bcd8739ae039(element) {
    if ((0, $gNNyC.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4yey3.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eNF9s.default)(element) // fallback
    );
}

});
parcelRegister("eNF9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac65902612ec3259$export$2e2bcd8739ae039; });

var $4yey3 = parcelRequire("4yey3");
function $ac65902612ec3259$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4yey3.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("9M8WM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71df897313ad6c55$export$2e2bcd8739ae039; });
function $71df897313ad6c55$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("fsgwo", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $b406495afd3242df$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $b406495afd3242df$export$86c8af6d3ef0b4a; });

var $9pEtR = parcelRequire("9pEtR");
function $b406495afd3242df$export$f28d906d67a997f3(min, value, max) {
    return (0, $9pEtR.max)(min, (0, $9pEtR.min)(value, max));
}
function $b406495afd3242df$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b406495afd3242df$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("93Awv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6980b9a5972dc4f1$export$2e2bcd8739ae039; });

var $8IvhE = parcelRequire("8IvhE");
function $6980b9a5972dc4f1$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8IvhE.default)(), paddingObject);
}

});
parcelRegister("8IvhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $658ab3189ce2447e$export$2e2bcd8739ae039; });
function $658ab3189ce2447e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("lkZpD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88b1a76cf5b59b4$export$2e2bcd8739ae039; });
function $f88b1a76cf5b59b4$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("i7xoL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d312c9ac7170e530$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $gWO4o = parcelRequire("gWO4o");

var $cYZ7h = parcelRequire("cYZ7h");

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $bjbdL = parcelRequire("bjbdL");

var $lc7d9 = parcelRequire("lc7d9");

var $9pEtR = parcelRequire("9pEtR");
var $d312c9ac7170e530$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d312c9ac7170e530$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9pEtR.round)(x * dpr) / dpr || 0,
        y: (0, $9pEtR.round)(y * dpr) / dpr || 0
    };
}
function $d312c9ac7170e530$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $9sBMA.left);
    var sideY = (0, $9sBMA.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gWO4o.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $cYZ7h.default)(popper)) {
            offsetParent = (0, $eNF9s.default)(popper);
            if ((0, $1eqAZ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $9sBMA.top) || (placement === (0, $9sBMA.left) || placement === (0, $9sBMA.right)) && variation === (0, $9sBMA.end)) {
            sideY = (0, $9sBMA.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $9sBMA.left) || (placement === (0, $9sBMA.top) || placement === (0, $9sBMA.bottom)) && variation === (0, $9sBMA.end)) {
            sideX = (0, $9sBMA.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d312c9ac7170e530$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d312c9ac7170e530$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $cYZ7h.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $d312c9ac7170e530$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $bjbdL.default)(state.placement),
        variation: (0, $lc7d9.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d312c9ac7170e530$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d312c9ac7170e530$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d312c9ac7170e530$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $d312c9ac7170e530$var$computeStyles,
    data: {}
};

});
parcelRegister("lc7d9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e04feedb1551d9$export$2e2bcd8739ae039; });
function $f6e04feedb1551d9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("7j3jV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $551ce215a2a4b545$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
var $551ce215a2a4b545$var$passive = {
    passive: true
};
function $551ce215a2a4b545$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $cYZ7h.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $551ce215a2a4b545$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $551ce215a2a4b545$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $551ce215a2a4b545$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $551ce215a2a4b545$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $551ce215a2a4b545$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $551ce215a2a4b545$var$effect,
    data: {}
};

});

parcelRegister("bJk6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88a37d59b97cb963$export$2e2bcd8739ae039; });

var $3RiOR = parcelRequire("3RiOR");

var $bjbdL = parcelRequire("bjbdL");

var $71NRZ = parcelRequire("71NRZ");

var $ivqFp = parcelRequire("ivqFp");

var $gvuY2 = parcelRequire("gvuY2");

var $9sBMA = parcelRequire("9sBMA");

var $lc7d9 = parcelRequire("lc7d9");
function $88a37d59b97cb963$var$getExpandedFallbackPlacements(placement) {
    if ((0, $bjbdL.default)(placement) === (0, $9sBMA.auto)) return [];
    var oppositePlacement = (0, $3RiOR.default)(placement);
    return [
        (0, $71NRZ.default)(placement),
        oppositePlacement,
        (0, $71NRZ.default)(oppositePlacement)
    ];
}
function $88a37d59b97cb963$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $bjbdL.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3RiOR.default)(preferredPlacement)
    ] : $88a37d59b97cb963$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $bjbdL.default)(placement) === (0, $9sBMA.auto) ? (0, $gvuY2.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $bjbdL.default)(placement);
        var isStartVariation = (0, $lc7d9.default)(placement) === (0, $9sBMA.start);
        var isVertical = [
            (0, $9sBMA.top),
            (0, $9sBMA.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $ivqFp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $9sBMA.right) : (0, $9sBMA.left) : isStartVariation ? (0, $9sBMA.bottom) : (0, $9sBMA.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3RiOR.default)(mainVariationSide);
        var altVariationSide = (0, $3RiOR.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $88a37d59b97cb963$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $88a37d59b97cb963$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3RiOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cf4eb790d2d2598$export$2e2bcd8739ae039; });
var $2cf4eb790d2d2598$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $2cf4eb790d2d2598$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2cf4eb790d2d2598$var$hash[matched];
    });
}

});

parcelRegister("71NRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51df4f875ef64cce$export$2e2bcd8739ae039; });
var $51df4f875ef64cce$var$hash = {
    start: "end",
    end: "start"
};
function $51df4f875ef64cce$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $51df4f875ef64cce$var$hash[matched];
    });
}

});

parcelRegister("ivqFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d78fceb84677fc94$export$2e2bcd8739ae039; });

var $iTvvq = parcelRequire("iTvvq");

var $eNF9s = parcelRequire("eNF9s");

var $iYLNX = parcelRequire("iYLNX");

var $igI1D = parcelRequire("igI1D");

var $cKet7 = parcelRequire("cKet7");

var $9sBMA = parcelRequire("9sBMA");

var $4yey3 = parcelRequire("4yey3");

var $93Awv = parcelRequire("93Awv");

var $lkZpD = parcelRequire("lkZpD");
function $d78fceb84677fc94$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $9sBMA.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $9sBMA.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $9sBMA.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $93Awv.default)(typeof padding !== "number" ? padding : (0, $lkZpD.default)(padding, (0, $9sBMA.basePlacements)));
    var altContext = elementContext === (0, $9sBMA.popper) ? (0, $9sBMA.reference) : (0, $9sBMA.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $iTvvq.default)((0, $4yey3.isElement)(element) ? element : element.contextElement || (0, $eNF9s.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $iYLNX.default)(state.elements.reference);
    var popperOffsets = (0, $igI1D.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $cKet7.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $9sBMA.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $9sBMA.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $9sBMA.right),
                (0, $9sBMA.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $9sBMA.top),
                (0, $9sBMA.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("iTvvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc15cd7a6f0044c3$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $fW0kF = parcelRequire("fW0kF");

var $1PTg9 = parcelRequire("1PTg9");

var $8BYmY = parcelRequire("8BYmY");

var $gWO4o = parcelRequire("gWO4o");

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $4yey3 = parcelRequire("4yey3");

var $iYLNX = parcelRequire("iYLNX");

var $cxf4H = parcelRequire("cxf4H");

var $lwNTw = parcelRequire("lwNTw");

var $gNNyC = parcelRequire("gNNyC");

var $cKet7 = parcelRequire("cKet7");

var $9pEtR = parcelRequire("9pEtR");
function $dc15cd7a6f0044c3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $iYLNX.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $9sBMA.viewport) ? (0, $cKet7.default)((0, $fW0kF.default)(element, strategy)) : (0, $4yey3.isElement)(clippingParent) ? $dc15cd7a6f0044c3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $cKet7.default)((0, $1PTg9.default)((0, $eNF9s.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $dc15cd7a6f0044c3$var$getClippingParents(element) {
    var clippingParents = (0, $8BYmY.default)((0, $cxf4H.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $1eqAZ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $4yey3.isHTMLElement)(element) ? (0, $gWO4o.default)(element) : element;
    if (!(0, $4yey3.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $4yey3.isElement)(clippingParent) && (0, $lwNTw.default)(clippingParent, clipperElement) && (0, $gNNyC.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $dc15cd7a6f0044c3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $dc15cd7a6f0044c3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9pEtR.max)(rect.top, accRect.top);
        accRect.right = (0, $9pEtR.min)(rect.right, accRect.right);
        accRect.bottom = (0, $9pEtR.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9pEtR.max)(rect.left, accRect.left);
        return accRect;
    }, $dc15cd7a6f0044c3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("fW0kF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b99c87cd4b8f9ce7$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");

var $eNF9s = parcelRequire("eNF9s");

var $37LVq = parcelRequire("37LVq");

var $dXRpq = parcelRequire("dXRpq");
function $b99c87cd4b8f9ce7$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $cYZ7h.default)(element);
    var html = (0, $eNF9s.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $dXRpq.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $37LVq.default)(element),
        y: y
    };
}

});
parcelRegister("37LVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2467337e98f2dda2$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");

var $eNF9s = parcelRequire("eNF9s");

var $8KllJ = parcelRequire("8KllJ");
function $2467337e98f2dda2$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $iYLNX.default)((0, $eNF9s.default)(element)).left + (0, $8KllJ.default)(element).scrollLeft;
}

});
parcelRegister("8KllJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e32e3225b6b5c7$export$2e2bcd8739ae039; });

var $cYZ7h = parcelRequire("cYZ7h");
function $65e32e3225b6b5c7$export$2e2bcd8739ae039(node) {
    var win = (0, $cYZ7h.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("1PTg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15656b45bbde3e62$export$2e2bcd8739ae039; });

var $eNF9s = parcelRequire("eNF9s");

var $1eqAZ = parcelRequire("1eqAZ");

var $37LVq = parcelRequire("37LVq");

var $8KllJ = parcelRequire("8KllJ");

var $9pEtR = parcelRequire("9pEtR");
function $15656b45bbde3e62$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eNF9s.default)(element);
    var winScroll = (0, $8KllJ.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9pEtR.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9pEtR.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $37LVq.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1eqAZ.default)(body || html).direction === "rtl") x += (0, $9pEtR.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("8BYmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64509b90c746566f$export$2e2bcd8739ae039; });

var $4AuVl = parcelRequire("4AuVl");

var $cxf4H = parcelRequire("cxf4H");

var $cYZ7h = parcelRequire("cYZ7h");

var $58ZkD = parcelRequire("58ZkD");
function $64509b90c746566f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4AuVl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $cYZ7h.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $58ZkD.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($64509b90c746566f$export$2e2bcd8739ae039((0, $cxf4H.default)(target)));
}

});
parcelRegister("4AuVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3572831447a8b90a$export$2e2bcd8739ae039; });

var $cxf4H = parcelRequire("cxf4H");

var $58ZkD = parcelRequire("58ZkD");

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");
function $3572831447a8b90a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $gNNyC.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4yey3.isHTMLElement)(node) && (0, $58ZkD.default)(node)) return node;
    return $3572831447a8b90a$export$2e2bcd8739ae039((0, $cxf4H.default)(node));
}

});
parcelRegister("58ZkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bed4651df2a8581$export$2e2bcd8739ae039; });

var $1eqAZ = parcelRequire("1eqAZ");
function $3bed4651df2a8581$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1eqAZ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("cKet7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94750115aa04ee16$export$2e2bcd8739ae039; });
function $94750115aa04ee16$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("igI1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4cbdf230537aa07$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $lc7d9 = parcelRequire("lc7d9");

var $9M8WM = parcelRequire("9M8WM");

var $9sBMA = parcelRequire("9sBMA");
function $d4cbdf230537aa07$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $bjbdL.default)(placement) : null;
    var variation = placement ? (0, $lc7d9.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $9sBMA.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $9sBMA.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $9sBMA.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $9sBMA.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9M8WM.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $9sBMA.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $9sBMA.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gvuY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0479014a72b6f48$export$2e2bcd8739ae039; });

var $lc7d9 = parcelRequire("lc7d9");

var $9sBMA = parcelRequire("9sBMA");

var $ivqFp = parcelRequire("ivqFp");

var $bjbdL = parcelRequire("bjbdL");
function $c0479014a72b6f48$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $9sBMA.placements) : _options$allowedAutoP;
    var variation = (0, $lc7d9.default)(placement);
    var placements = variation ? flipVariations ? (0, $9sBMA.variationPlacements) : (0, $9sBMA.variationPlacements).filter(function(placement) {
        return (0, $lc7d9.default)(placement) === variation;
    }) : (0, $9sBMA.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ivqFp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $bjbdL.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("iIbxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f549c999f38676$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $ivqFp = parcelRequire("ivqFp");
function $d9f549c999f38676$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d9f549c999f38676$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $9sBMA.top),
        (0, $9sBMA.right),
        (0, $9sBMA.bottom),
        (0, $9sBMA.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d9f549c999f38676$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ivqFp.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $ivqFp.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d9f549c999f38676$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d9f549c999f38676$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d9f549c999f38676$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d9f549c999f38676$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d9f549c999f38676$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $d9f549c999f38676$var$hide
};

});

parcelRegister("hLLXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cefc06bfa1823e2e$export$2e2bcd8739ae039; });

var $bjbdL = parcelRequire("bjbdL");

var $9sBMA = parcelRequire("9sBMA");
function $cefc06bfa1823e2e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $bjbdL.default)(placement);
    var invertDistance = [
        (0, $9sBMA.left),
        (0, $9sBMA.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $9sBMA.left),
        (0, $9sBMA.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $cefc06bfa1823e2e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $9sBMA.placements).reduce(function(acc, placement) {
        acc[placement] = $cefc06bfa1823e2e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cefc06bfa1823e2e$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $cefc06bfa1823e2e$var$offset
};

});

parcelRegister("bwXYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $865133f4ac58b287$export$2e2bcd8739ae039; });

var $igI1D = parcelRequire("igI1D");
function $865133f4ac58b287$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $igI1D.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $865133f4ac58b287$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $865133f4ac58b287$var$popperOffsets,
    data: {}
};

});

parcelRegister("7oqYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561fb2dc20a3be19$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");

var $bjbdL = parcelRequire("bjbdL");

var $9M8WM = parcelRequire("9M8WM");

var $4hf6V = parcelRequire("4hf6V");

var $fsgwo = parcelRequire("fsgwo");

var $jXC8u = parcelRequire("jXC8u");

var $gWO4o = parcelRequire("gWO4o");

var $ivqFp = parcelRequire("ivqFp");

var $lc7d9 = parcelRequire("lc7d9");

var $8IvhE = parcelRequire("8IvhE");

var $9pEtR = parcelRequire("9pEtR");
function $561fb2dc20a3be19$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ivqFp.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $bjbdL.default)(state.placement);
    var variation = (0, $lc7d9.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9M8WM.default)(basePlacement);
    var altAxis = (0, $4hf6V.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $9sBMA.top) : (0, $9sBMA.left);
        var altSide = mainAxis === "y" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $9sBMA.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $9sBMA.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jXC8u.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8IvhE.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fsgwo.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gWO4o.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fsgwo.within)(tether ? (0, $9pEtR.min)(min, tetherMin) : min, offset, tether ? (0, $9pEtR.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $9sBMA.top) : (0, $9sBMA.left);
        var _altSide = mainAxis === "x" ? (0, $9sBMA.bottom) : (0, $9sBMA.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $9sBMA.top),
            (0, $9sBMA.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fsgwo.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fsgwo.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $561fb2dc20a3be19$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $561fb2dc20a3be19$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("4hf6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d4789c33a2e502$export$2e2bcd8739ae039; });
function $31d4789c33a2e502$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRegister("t1juM", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $0573ba5ede1168b6$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $0573ba5ede1168b6$export$8f7491d57c8f97a9; });

var $13nAE = parcelRequire("13nAE");

var $jXC8u = parcelRequire("jXC8u");

var $8BYmY = parcelRequire("8BYmY");

var $gWO4o = parcelRequire("gWO4o");

var $8wz9t = parcelRequire("8wz9t");

var $edfR5 = parcelRequire("edfR5");

var $kVCZe = parcelRequire("kVCZe");

var $ivqFp = parcelRequire("ivqFp");

var $4yey3 = parcelRequire("4yey3");
var $0573ba5ede1168b6$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0573ba5ede1168b6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $0573ba5ede1168b6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0573ba5ede1168b6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0573ba5ede1168b6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $4yey3.isElement)(reference) ? (0, $8BYmY.default)(reference) : reference.contextElement ? (0, $8BYmY.default)(reference.contextElement) : [],
                    popper: (0, $8BYmY.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8wz9t.default)((0, $kVCZe.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0573ba5ede1168b6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $13nAE.default)(reference, (0, $gWO4o.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $jXC8u.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $edfR5.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0573ba5ede1168b6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0573ba5ede1168b6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0573ba5ede1168b6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("13nAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c485ec09dace92c$export$2e2bcd8739ae039; });

var $iYLNX = parcelRequire("iYLNX");

var $9S94R = parcelRequire("9S94R");

var $gNNyC = parcelRequire("gNNyC");

var $4yey3 = parcelRequire("4yey3");

var $37LVq = parcelRequire("37LVq");

var $eNF9s = parcelRequire("eNF9s");

var $58ZkD = parcelRequire("58ZkD");

var $9pEtR = parcelRequire("9pEtR");
function $0c485ec09dace92c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9pEtR.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9pEtR.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $0c485ec09dace92c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4yey3.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $4yey3.isHTMLElement)(offsetParent) && $0c485ec09dace92c$var$isElementScaled(offsetParent);
    var documentElement = (0, $eNF9s.default)(offsetParent);
    var rect = (0, $iYLNX.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gNNyC.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $58ZkD.default)(documentElement)) scroll = (0, $9S94R.default)(offsetParent);
        if ((0, $4yey3.isHTMLElement)(offsetParent)) {
            offsets = (0, $iYLNX.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $37LVq.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("9S94R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $730032c3ec74ae75$export$2e2bcd8739ae039; });

var $8KllJ = parcelRequire("8KllJ");

var $cYZ7h = parcelRequire("cYZ7h");

var $4yey3 = parcelRequire("4yey3");

var $duXx8 = parcelRequire("duXx8");
function $730032c3ec74ae75$export$2e2bcd8739ae039(node) {
    if (node === (0, $cYZ7h.default)(node) || !(0, $4yey3.isHTMLElement)(node)) return (0, $8KllJ.default)(node);
    else return (0, $duXx8.default)(node);
}

});
parcelRegister("duXx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3c41cc50e3b556$export$2e2bcd8739ae039; });
function $9d3c41cc50e3b556$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("8wz9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634c944904fc82cf$export$2e2bcd8739ae039; });

var $9sBMA = parcelRequire("9sBMA");
function $634c944904fc82cf$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $634c944904fc82cf$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $634c944904fc82cf$var$order(modifiers); // order based on phase
    return (0, $9sBMA.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("edfR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58e9417d8d60d4d$export$2e2bcd8739ae039; });
function $a58e9417d8d60d4d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kVCZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3c75f6f726b786e$export$2e2bcd8739ae039; });
function $f3c75f6f726b786e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("8dqiK", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $5fb3f086684b6047$export$8f7491d57c8f97a9; });

var $t1juM = parcelRequire("t1juM");

var $7j3jV = parcelRequire("7j3jV");

var $bwXYi = parcelRequire("bwXYi");

var $i7xoL = parcelRequire("i7xoL");

var $gy0RQ = parcelRequire("gy0RQ");

var $hLLXp = parcelRequire("hLLXp");

var $bJk6k = parcelRequire("bJk6k");

var $7oqYt = parcelRequire("7oqYt");

var $d1SXy = parcelRequire("d1SXy");

var $iIbxA = parcelRequire("iIbxA");


var $5fb3f086684b6047$export$d34966752335dd47 = [
    (0, $7j3jV.default),
    (0, $bwXYi.default),
    (0, $i7xoL.default),
    (0, $gy0RQ.default),
    (0, $hLLXp.default),
    (0, $bJk6k.default),
    (0, $7oqYt.default),
    (0, $d1SXy.default),
    (0, $iIbxA.default)
];
var $5fb3f086684b6047$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $t1juM.popperGenerator)({
    defaultModifiers: $5fb3f086684b6047$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("cDLKH", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $933e2b27c632eb0b$export$8f7491d57c8f97a9; });

var $t1juM = parcelRequire("t1juM");

var $7j3jV = parcelRequire("7j3jV");

var $bwXYi = parcelRequire("bwXYi");

var $i7xoL = parcelRequire("i7xoL");

var $gy0RQ = parcelRequire("gy0RQ");
var $933e2b27c632eb0b$export$d34966752335dd47 = [
    (0, $7j3jV.default),
    (0, $bwXYi.default),
    (0, $i7xoL.default),
    (0, $gy0RQ.default)
];
var $933e2b27c632eb0b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $t1juM.popperGenerator)({
    defaultModifiers: $933e2b27c632eb0b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


parcelRegister("bUxFU", function(module, exports) {


module.exports = (parcelRequire("aD1tZ"))((parcelRequire("iA027")).resolve("k0tq2")).then(()=>parcelRequire("kSicM"));

});
parcelRegister("aD1tZ", function(module, exports) {
"use strict";

var $4zwX6 = parcelRequire("4zwX6");
module.exports = $4zwX6(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("4zwX6", function(module, exports) {
"use strict";
var $3543fdf6e5e3d253$var$cachedBundles = {};
var $3543fdf6e5e3d253$var$cachedPreloads = {};
var $3543fdf6e5e3d253$var$cachedPrefetches = {};
function $3543fdf6e5e3d253$var$getCache(type) {
    switch(type){
        case "preload":
            return $3543fdf6e5e3d253$var$cachedPreloads;
        case "prefetch":
            return $3543fdf6e5e3d253$var$cachedPrefetches;
        default:
            return $3543fdf6e5e3d253$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3543fdf6e5e3d253$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $f7ac9321a99b7aa3$exports = {};


(parcelRequire("iA027")).register((parcelRequire("7rKCZ")).getBundleURL("ifylv"), JSON.parse('["ifylv","App.js","k0tq2","maplibre-gl.0efe9ed9.js","8xHIU","App.css"]'));

// Copyright (C) Konrad Gadzinowski
var $d26b75c87b693463$exports = {};
var $c074f7368ab96ac2$exports = {};

var $fRaLx = parcelRequire("fRaLx");
var $fd350b254dbe85cc$exports = {};
$fd350b254dbe85cc$exports = function(el) {
    var code = el.text || el.textContent || el.innerHTML || "";
    var src = el.src || "";
    var parent = el.parentNode || document.querySelector("head") || document.documentElement;
    var script = document.createElement("script");
    if (code.match("document.write")) {
        if (console && console.log) console.log("Script contains document.write. Can\u2019t be executed correctly. Code skipped ", el);
        return false;
    }
    script.type = "text/javascript";
    script.id = el.id;
    /* istanbul ignore if */ if (src !== "") {
        script.src = src;
        script.async = false; // force synchronous loading of peripheral JS
    }
    if (code !== "") try {
        script.appendChild(document.createTextNode(code));
    } catch (e) {
        /* istanbul ignore next */ // old IEs have funky script nodes
        script.text = code;
    }
    // execute
    parent.appendChild(script);
    // avoid pollution only in head or body tags
    if ((parent instanceof HTMLHeadElement || parent instanceof HTMLBodyElement) && parent.contains(script)) parent.removeChild(script);
    return true;
};


// Finds and executes scripts (used for newly added elements)
// Needed since innerHTML does not run scripts
$c074f7368ab96ac2$exports = function(el) {
    if (el.tagName.toLowerCase() === "script") $fd350b254dbe85cc$exports(el);
    $fRaLx(el.querySelectorAll("script"), function(script) {
        if (!script.type || script.type.toLowerCase() === "text/javascript") {
            if (script.parentNode) script.parentNode.removeChild(script);
            $fd350b254dbe85cc$exports(script);
        }
    });
};



var $fRaLx = parcelRequire("fRaLx");
var $c5f66b3403c99df5$exports = {};
/* global _gaq: true, ga: true */ 
var $7RZTV = parcelRequire("7RZTV");
$c5f66b3403c99df5$exports = function(options) {
    options = options || {};
    options.elements = options.elements || "a[href], form[action]";
    options.selectors = options.selectors || [
        "title",
        ".js-Pjax"
    ];
    options.switches = options.switches || {};
    options.switchesOptions = options.switchesOptions || {};
    options.history = typeof options.history === "undefined" ? true : options.history;
    options.analytics = typeof options.analytics === "function" || options.analytics === false ? options.analytics : $c5f66b3403c99df5$var$defaultAnalytics;
    options.scrollTo = typeof options.scrollTo === "undefined" ? 0 : options.scrollTo;
    options.scrollRestoration = typeof options.scrollRestoration !== "undefined" ? options.scrollRestoration : true;
    options.cacheBust = typeof options.cacheBust === "undefined" ? true : options.cacheBust;
    options.debug = options.debug || false;
    options.timeout = options.timeout || 0;
    options.currentUrlFullReload = typeof options.currentUrlFullReload === "undefined" ? false : options.currentUrlFullReload;
    // We can’t replace body.outerHTML or head.outerHTML.
    // It creates a bug where a new body or head are created in the DOM.
    // If you set head.outerHTML, a new body tag is appended, so the DOM has 2 body nodes, and vice versa
    if (!options.switches.head) options.switches.head = $7RZTV.switchElementsAlt;
    if (!options.switches.body) options.switches.body = $7RZTV.switchElementsAlt;
    return options;
};
/* istanbul ignore next */ function $c5f66b3403c99df5$var$defaultAnalytics() {
    if (window._gaq) _gaq.push([
        "_trackPageview"
    ]);
    if (window.ga) ga("send", "pageview", {
        page: location.pathname,
        title: document.title
    });
}



var $7RZTV = parcelRequire("7RZTV");

var $e36no = parcelRequire("e36no");

var $fcCTJ = parcelRequire("fcCTJ");

var $ep84Q = parcelRequire("ep84Q");

var $8kgSr = parcelRequire("8kgSr");
var $1a81c48da2d345f6$exports = {};
$1a81c48da2d345f6$exports = function contains(doc, selectors, el) {
    for(var i = 0; i < selectors.length; i++){
        var selectedEls = doc.querySelectorAll(selectors[i]);
        for(var j = 0; j < selectedEls.length; j++){
            if (selectedEls[j].contains(el)) return true;
        }
    }
    return false;
};


var $66781b42dee1c947$exports = {};
$66781b42dee1c947$exports = function(target) {
    if (target == null) return null;
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        if (source != null) {
            for(var key in source)// Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(source, key)) to[key] = source[key];
        }
    }
    return to;
};



var $cukYX = parcelRequire("cukYX");
var $d26b75c87b693463$var$Pjax = function(options) {
    this.state = {
        numPendingSwitches: 0,
        href: null,
        options: null
    };
    this.options = $c5f66b3403c99df5$exports(options);
    this.log("Pjax options", this.options);
    if (this.options.scrollRestoration && "scrollRestoration" in history) history.scrollRestoration = "manual";
    this.maxUid = this.lastUid = $e36no();
    this.parseDOM(document);
    $fcCTJ(window, "popstate", (function(st) {
        if (st.state) {
            var opt = $8kgSr(this.options);
            opt.url = st.state.url;
            opt.title = st.state.title;
            // Since state already exists, prevent it from being pushed again
            opt.history = false;
            opt.scrollPos = st.state.scrollPos;
            if (st.state.uid < this.lastUid) opt.backward = true;
            else opt.forward = true;
            this.lastUid = st.state.uid;
            // @todo implement history cache here, based on uid
            this.loadUrl(st.state.url, opt);
        }
    }).bind(this));
};
$d26b75c87b693463$var$Pjax.switches = $7RZTV;









$d26b75c87b693463$var$Pjax.prototype = {
    log: (parcelRequire("bTB0U")),
    getElements: function(el) {
        return el.querySelectorAll(this.options.elements);
    },
    parseDOM: function(el) {
        var parseElement = (parcelRequire("6l3E4"));
        $fRaLx(this.getElements(el), parseElement, this);
    },
    refresh: function(el) {
        this.parseDOM(el || document);
    },
    reload: function() {
        window.location.reload();
    },
    attachLink: (parcelRequire("4Qp2J")),
    attachForm: (parcelRequire("crAW0")),
    forEachSelectors: function(cb, context, DOMcontext) {
        return (parcelRequire("duhL3")).bind(this)(this.options.selectors, cb, context, DOMcontext);
    },
    switchSelectors: function(selectors, fromEl, toEl, options) {
        return (parcelRequire("loXQO")).bind(this)(this.options.switches, this.options.switchesOptions, selectors, fromEl, toEl, options);
    },
    latestChance: function(href) {
        window.location = href;
    },
    onSwitch: function() {
        $ep84Q(window, "resize scroll");
        this.state.numPendingSwitches--;
        // debounce calls, so we only run this once after all switches are finished.
        if (this.state.numPendingSwitches === 0) this.afterAllSwitches();
    },
    loadContent: function(html, options) {
        if (typeof html !== "string") {
            $ep84Q(document, "pjax:complete pjax:error", options);
            return;
        }
        var tmpEl = document.implementation.createHTMLDocument("pjax");
        // parse HTML attributes to copy them
        // since we are forced to use documentElement.innerHTML (outerHTML can't be used for <html>)
        var htmlRegex = /<html[^>]+>/gi;
        var htmlAttribsRegex = /\s?[a-z:]+(?:=['"][^'">]+['"])*/gi;
        var matches = html.match(htmlRegex);
        if (matches && matches.length) {
            matches = matches[0].match(htmlAttribsRegex);
            if (matches.length) {
                matches.shift();
                matches.forEach(function(htmlAttrib) {
                    var attr = htmlAttrib.trim().split("=");
                    if (attr.length === 1) tmpEl.documentElement.setAttribute(attr[0], true);
                    else tmpEl.documentElement.setAttribute(attr[0], attr[1].slice(1, -1));
                });
            }
        }
        tmpEl.documentElement.innerHTML = html;
        this.log("load content", tmpEl.documentElement.attributes, tmpEl.documentElement.innerHTML.length);
        // Clear out any focused controls before inserting new page contents.
        if (document.activeElement && $1a81c48da2d345f6$exports(document, this.options.selectors, document.activeElement)) try {
            document.activeElement.blur();
        } catch (e) {} // eslint-disable-line no-empty
        this.switchSelectors(this.options.selectors, tmpEl, document, options);
    },
    abortRequest: (parcelRequire("8BsJe")),
    doRequest: (parcelRequire("aBk3q")),
    handleResponse: (parcelRequire("3vRmN")),
    loadUrl: function(href, options) {
        options = typeof options === "object" ? $66781b42dee1c947$exports({}, this.options, options) : $8kgSr(this.options);
        this.log("load href", href, options);
        // Abort any previous request
        this.abortRequest(this.request);
        $ep84Q(document, "pjax:send", options);
        // Do the request
        this.request = this.doRequest(href, options, this.handleResponse.bind(this));
    },
    afterAllSwitches: function() {
        // FF bug: Won’t autofocus fields that are inserted via JS.
        // This behavior is incorrect. So if theres no current focus, autofocus
        // the last field.
        //
        // http://www.w3.org/html/wg/drafts/html/master/forms.html
        var autofocusEl = Array.prototype.slice.call(document.querySelectorAll("[autofocus]")).pop();
        if (autofocusEl && document.activeElement !== autofocusEl) autofocusEl.focus();
        // execute scripts when DOM have been completely updated
        this.options.selectors.forEach(function(selector) {
            $fRaLx(document.querySelectorAll(selector), function(el) {
                $c074f7368ab96ac2$exports(el);
            });
        });
        var state = this.state;
        if (state.options.history) {
            if (!window.history.state) {
                this.lastUid = this.maxUid = $e36no();
                window.history.replaceState({
                    url: window.location.href,
                    title: document.title,
                    uid: this.maxUid,
                    scrollPos: [
                        0,
                        0
                    ]
                }, document.title);
            }
            // Update browser history
            this.lastUid = this.maxUid = $e36no();
            window.history.pushState({
                url: state.href,
                title: state.options.title,
                uid: this.maxUid,
                scrollPos: [
                    0,
                    0
                ]
            }, state.options.title, state.href);
        }
        this.forEachSelectors(function(el) {
            this.parseDOM(el);
        }, this);
        // Fire Events
        $ep84Q(document, "pjax:complete pjax:success", state.options);
        if (typeof state.options.analytics === "function") state.options.analytics();
        if (state.options.history) {
            // First parse url and check for hash to override scroll
            var a = document.createElement("a");
            a.href = this.state.href;
            if (a.hash) {
                var name = a.hash.slice(1);
                name = decodeURIComponent(name);
                var curtop = 0;
                var target = document.getElementById(name) || document.getElementsByName(name)[0];
                if (target) {
                    // http://stackoverflow.com/questions/8111094/cross-browser-javascript-function-to-find-actual-position-of-an-element-in-page
                    if (target.offsetParent) do {
                        curtop += target.offsetTop;
                        target = target.offsetParent;
                    }while (target);
                }
                window.scrollTo(0, curtop);
            } else if (state.options.scrollTo !== false) {
                // Scroll page to top on new page load
                if (state.options.scrollTo.length > 1) window.scrollTo(state.options.scrollTo[0], state.options.scrollTo[1]);
                else window.scrollTo(0, state.options.scrollTo);
            }
        } else if (state.options.scrollRestoration && state.options.scrollPos) window.scrollTo(state.options.scrollPos[0], state.options.scrollPos[1]);
        this.state = {
            numPendingSwitches: 0,
            href: null,
            options: null
        };
    }
};

$d26b75c87b693463$var$Pjax.isSupported = (parcelRequire("cODYy"));
// arguably could do `if( require("./lib/is-supported")()) {` but that might be a little to simple
if ($d26b75c87b693463$var$Pjax.isSupported()) $d26b75c87b693463$exports = $d26b75c87b693463$var$Pjax;
else {
    var $d26b75c87b693463$var$stupidPjax = $cukYX;
    for(var $d26b75c87b693463$var$key in $d26b75c87b693463$var$Pjax.prototype)if ($d26b75c87b693463$var$Pjax.prototype.hasOwnProperty($d26b75c87b693463$var$key) && typeof $d26b75c87b693463$var$Pjax.prototype[$d26b75c87b693463$var$key] === "function") $d26b75c87b693463$var$stupidPjax[$d26b75c87b693463$var$key] = $cukYX;
    $d26b75c87b693463$exports = $d26b75c87b693463$var$stupidPjax;
}



var $e7f07339a0167292$exports = {};

/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $e7f07339a0167292$exports = factory((parcelRequire("8YGgm")));
})($e7f07339a0167292$exports, function(Popper) {
    "use strict";
    function _interopNamespaceDefault(e) {
        const n = Object.create(null, {
            [Symbol.toStringTag]: {
                value: "Module"
            }
        });
        if (e) {
            for(const k in e)if (k !== "default") {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const Data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend";
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== "object") return false;
        if (typeof object.jquery !== "undefined") object = object[0];
        return typeof object.nodeType !== "undefined";
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest("details:not([open])");
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest("summary");
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === "function") {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === "string";
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof callable !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === "" || value === "null") return null;
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === "object" ? jsonConfig : {},
                ...isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === "object" ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = "5.3.3";
    /**
   * Class definition
   */ class BaseComponent extends Config {
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
        constructor(element, config){
            super();
            element = getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttribute = element.getAttribute("href");
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
            selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(",").map((sel)=>parseSelector(sel)).join(",") : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = "hide")=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target);
            // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$f = "alert";
    const DATA_KEY$a = "bs.alert";
    const EVENT_KEY$b = `.${DATA_KEY$a}`;
    const EVENT_CLOSE = `close${EVENT_KEY$b}`;
    const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
    const CLASS_NAME_FADE$5 = "fade";
    const CLASS_NAME_SHOW$8 = "show";
    /**
   * Class definition
   */ class Alert extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$f;
        }
        // Public
        close() {
            const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
            if (closeEvent.defaultPrevented) return;
            this._element.classList.remove(CLASS_NAME_SHOW$8);
            const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
            this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
        }
        // Private
        _destroyElement() {
            this._element.remove();
            EventHandler.trigger(this._element, EVENT_CLOSED);
            this.dispose();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Alert.getOrCreateInstance(this);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Alert, "close");
    /**
   * jQuery
   */ defineJQueryPlugin(Alert);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$e = "button";
    const DATA_KEY$9 = "bs.button";
    const EVENT_KEY$a = `.${DATA_KEY$9}`;
    const DATA_API_KEY$6 = ".data-api";
    const CLASS_NAME_ACTIVE$3 = "active";
    const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
    const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
    /**
   * Class definition
   */ class Button extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$e;
        }
        // Public
        toggle() {
            // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
            this._element.setAttribute("aria-pressed", this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Button.getOrCreateInstance(this);
                if (config === "toggle") data[config]();
            });
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
        event.preventDefault();
        const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
        const data = Button.getOrCreateInstance(button);
        data.toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Button);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/swipe.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$d = "swipe";
    const EVENT_KEY$9 = ".bs.swipe";
    const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
    const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
    const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
    const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
    const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
    const POINTER_TYPE_TOUCH = "touch";
    const POINTER_TYPE_PEN = "pen";
    const CLASS_NAME_POINTER_EVENT = "pointer-event";
    const SWIPE_THRESHOLD = 40;
    const Default$c = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    };
    const DefaultType$c = {
        endCallback: "(function|null)",
        leftCallback: "(function|null)",
        rightCallback: "(function|null)"
    };
    /**
   * Class definition
   */ class Swipe extends Config {
        // Getters
        static get Default() {
            return Default$c;
        }
        static get DefaultType() {
            return DefaultType$c;
        }
        static get NAME() {
            return NAME$d;
        }
        // Public
        dispose() {
            EventHandler.off(this._element, EVENT_KEY$9);
        }
        // Private
        _start(event) {
            if (!this._supportPointerEvents) {
                this._deltaX = event.touches[0].clientX;
                return;
            }
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
        }
        _end(event) {
            if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
            this._handleSwipe();
            execute(this._config.endCallback);
        }
        _move(event) {
            this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const absDeltaX = Math.abs(this._deltaX);
            if (absDeltaX <= SWIPE_THRESHOLD) return;
            const direction = absDeltaX / this._deltaX;
            this._deltaX = 0;
            if (!direction) return;
            execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            if (this._supportPointerEvents) {
                EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
                EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
                EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
            }
        }
        _eventIsPointerPenTouch(event) {
            return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
        }
        // Static
        static isSupported() {
            return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
        }
        constructor(element, config){
            super();
            this._element = element;
            if (!element || !Swipe.isSupported()) return;
            this._config = this._getConfig(config);
            this._deltaX = 0;
            this._supportPointerEvents = Boolean(window.PointerEvent);
            this._initEvents();
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$c = "carousel";
    const DATA_KEY$8 = "bs.carousel";
    const EVENT_KEY$8 = `.${DATA_KEY$8}`;
    const DATA_API_KEY$5 = ".data-api";
    const ARROW_LEFT_KEY$1 = "ArrowLeft";
    const ARROW_RIGHT_KEY$1 = "ArrowRight";
    const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    const ORDER_NEXT = "next";
    const ORDER_PREV = "prev";
    const DIRECTION_LEFT = "left";
    const DIRECTION_RIGHT = "right";
    const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
    const EVENT_SLID = `slid${EVENT_KEY$8}`;
    const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
    const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
    const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
    const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
    const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
    const CLASS_NAME_CAROUSEL = "carousel";
    const CLASS_NAME_ACTIVE$2 = "active";
    const CLASS_NAME_SLIDE = "slide";
    const CLASS_NAME_END = "carousel-item-end";
    const CLASS_NAME_START = "carousel-item-start";
    const CLASS_NAME_NEXT = "carousel-item-next";
    const CLASS_NAME_PREV = "carousel-item-prev";
    const SELECTOR_ACTIVE = ".active";
    const SELECTOR_ITEM = ".carousel-item";
    const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
    const SELECTOR_ITEM_IMG = ".carousel-item img";
    const SELECTOR_INDICATORS = ".carousel-indicators";
    const SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
    const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
    const KEY_TO_DIRECTION = {
        [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
        [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
    };
    const Default$b = {
        interval: 5000,
        keyboard: true,
        pause: "hover",
        ride: false,
        touch: true,
        wrap: true
    };
    const DefaultType$b = {
        interval: "(number|boolean)",
        // TODO:v6 remove boolean support
        keyboard: "boolean",
        pause: "(string|boolean)",
        ride: "(boolean|string)",
        touch: "boolean",
        wrap: "boolean"
    };
    /**
   * Class definition
   */ class Carousel extends BaseComponent {
        // Getters
        static get Default() {
            return Default$b;
        }
        static get DefaultType() {
            return DefaultType$b;
        }
        static get NAME() {
            return NAME$c;
        }
        // Public
        next() {
            this._slide(ORDER_NEXT);
        }
        nextWhenVisible() {
            // FIXME TODO use `document.visibilityState`
            // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && isVisible(this._element)) this.next();
        }
        prev() {
            this._slide(ORDER_PREV);
        }
        pause() {
            if (this._isSliding) triggerTransitionEnd(this._element);
            this._clearInterval();
        }
        cycle() {
            this._clearInterval();
            this._updateInterval();
            this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            if (!this._config.ride) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
                return;
            }
            this.cycle();
        }
        to(index) {
            const items = this._getItems();
            if (index > items.length - 1 || index < 0) return;
            if (this._isSliding) {
                EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
                return;
            }
            const activeIndex = this._getItemIndex(this._getActive());
            if (activeIndex === index) return;
            const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
            this._slide(order, items[index]);
        }
        dispose() {
            if (this._swipeHelper) this._swipeHelper.dispose();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            config.defaultInterval = config.interval;
            return config;
        }
        _addEventListeners() {
            if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
            if (this._config.pause === "hover") {
                EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
                EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
            }
            if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
            const endCallBack = ()=>{
                if (this._config.pause !== "hover") return;
                // If it's a touch-enabled device, mouseenter/leave are fired as
                // part of the mouse compatibility events on first tap - the carousel
                // would stop cycling until user tapped out of it;
                // here, we listen for touchend, explicitly pause the carousel
                // (as if it's the second time we tap on it, mouseenter compat event
                // is NOT fired) and after a timeout (to allow for mouse compatibility
                // events to fire) we explicitly restart cycling
                this.pause();
                if (this.touchTimeout) clearTimeout(this.touchTimeout);
                this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
            };
            const swipeConfig = {
                leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
                rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
                endCallback: endCallBack
            };
            this._swipeHelper = new Swipe(this._element, swipeConfig);
        }
        _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            const direction = KEY_TO_DIRECTION[event.key];
            if (direction) {
                event.preventDefault();
                this._slide(this._directionToOrder(direction));
            }
        }
        _getItemIndex(element) {
            return this._getItems().indexOf(element);
        }
        _setActiveIndicatorElement(index) {
            if (!this._indicatorsElement) return;
            const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
            activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
            activeIndicator.removeAttribute("aria-current");
            const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
            if (newActiveIndicator) {
                newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
                newActiveIndicator.setAttribute("aria-current", "true");
            }
        }
        _updateInterval() {
            const element = this._activeElement || this._getActive();
            if (!element) return;
            const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
            this._config.interval = elementInterval || this._config.defaultInterval;
        }
        _slide(order, element = null) {
            if (this._isSliding) return;
            const activeElement = this._getActive();
            const isNext = order === ORDER_NEXT;
            const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
            if (nextElement === activeElement) return;
            const nextElementIndex = this._getItemIndex(nextElement);
            const triggerEvent = (eventName)=>{
                return EventHandler.trigger(this._element, eventName, {
                    relatedTarget: nextElement,
                    direction: this._orderToDirection(order),
                    from: this._getItemIndex(activeElement),
                    to: nextElementIndex
                });
            };
            const slideEvent = triggerEvent(EVENT_SLIDE);
            if (slideEvent.defaultPrevented) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            // TODO: change tests that use empty divs to avoid this check
            return;
            const isCycling = Boolean(this._interval);
            this.pause();
            this._isSliding = true;
            this._setActiveIndicatorElement(nextElementIndex);
            this._activeElement = nextElement;
            const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
            const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
            nextElement.classList.add(orderClassName);
            reflow(nextElement);
            activeElement.classList.add(directionalClassName);
            nextElement.classList.add(directionalClassName);
            const completeCallBack = ()=>{
                nextElement.classList.remove(directionalClassName, orderClassName);
                nextElement.classList.add(CLASS_NAME_ACTIVE$2);
                activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                this._isSliding = false;
                triggerEvent(EVENT_SLID);
            };
            this._queueCallback(completeCallBack, activeElement, this._isAnimated());
            if (isCycling) this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_SLIDE);
        }
        _getActive() {
            return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
        }
        _getItems() {
            return SelectorEngine.find(SELECTOR_ITEM, this._element);
        }
        _clearInterval() {
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
        }
        _directionToOrder(direction) {
            if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
            return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
        }
        _orderToDirection(order) {
            if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
            return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Carousel.getOrCreateInstance(this, config);
                if (typeof config === "number") {
                    data.to(config);
                    return;
                }
                if (typeof config === "string") {
                    if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._interval = null;
            this._activeElement = null;
            this._isSliding = false;
            this.touchTimeout = null;
            this._swipeHelper = null;
            this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
            this._addEventListeners();
            if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        const carousel = Carousel.getOrCreateInstance(target);
        const slideIndex = this.getAttribute("data-bs-slide-to");
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if (Manipulator.getDataAttribute(this, "slide") === "next") {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
        const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
        for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Carousel);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$b = "collapse";
    const DATA_KEY$7 = "bs.collapse";
    const EVENT_KEY$7 = `.${DATA_KEY$7}`;
    const DATA_API_KEY$4 = ".data-api";
    const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
    const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
    const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
    const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
    const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
    const CLASS_NAME_SHOW$7 = "show";
    const CLASS_NAME_COLLAPSE = "collapse";
    const CLASS_NAME_COLLAPSING = "collapsing";
    const CLASS_NAME_COLLAPSED = "collapsed";
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    const WIDTH = "width";
    const HEIGHT = "height";
    const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
    const Default$a = {
        parent: null,
        toggle: true
    };
    const DefaultType$a = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        // Getters
        static get Default() {
            return Default$a;
        }
        static get DefaultType() {
            return DefaultType$a;
        }
        static get NAME() {
            return NAME$b;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
                this._element.style[dimension] = "";
                EventHandler.trigger(this._element, EVENT_SHOWN$6);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN$6);
            };
            this._element.style[dimension] = "";
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW$7);
        }
        // Private
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute("aria-expanded", isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Collapse);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$a = "dropdown";
    const DATA_KEY$6 = "bs.dropdown";
    const EVENT_KEY$6 = `.${DATA_KEY$6}`;
    const DATA_API_KEY$3 = ".data-api";
    const ESCAPE_KEY$2 = "Escape";
    const TAB_KEY$1 = "Tab";
    const ARROW_UP_KEY$1 = "ArrowUp";
    const ARROW_DOWN_KEY$1 = "ArrowDown";
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
    const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
    const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
    const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
    const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
    const CLASS_NAME_SHOW$6 = "show";
    const CLASS_NAME_DROPUP = "dropup";
    const CLASS_NAME_DROPEND = "dropend";
    const CLASS_NAME_DROPSTART = "dropstart";
    const CLASS_NAME_DROPUP_CENTER = "dropup-center";
    const CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
    const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
    const SELECTOR_MENU = ".dropdown-menu";
    const SELECTOR_NAVBAR = ".navbar";
    const SELECTOR_NAVBAR_NAV = ".navbar-nav";
    const SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    const PLACEMENT_TOP = isRTL() ? "top-end" : "top-start";
    const PLACEMENT_TOPEND = isRTL() ? "top-start" : "top-end";
    const PLACEMENT_BOTTOM = isRTL() ? "bottom-end" : "bottom-start";
    const PLACEMENT_BOTTOMEND = isRTL() ? "bottom-start" : "bottom-end";
    const PLACEMENT_RIGHT = isRTL() ? "left-start" : "right-start";
    const PLACEMENT_LEFT = isRTL() ? "right-start" : "left-start";
    const PLACEMENT_TOPCENTER = "top";
    const PLACEMENT_BOTTOMCENTER = "bottom";
    const Default$9 = {
        autoClose: true,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    };
    const DefaultType$9 = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    /**
   * Class definition
   */ class Dropdown extends BaseComponent {
        // Getters
        static get Default() {
            return Default$9;
        }
        static get DefaultType() {
            return DefaultType$9;
        }
        static get NAME() {
            return NAME$a;
        }
        // Public
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
            if (showEvent.defaultPrevented) return;
            this._createPopper();
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            this._menu.classList.add(CLASS_NAME_SHOW$6);
            this._element.classList.add(CLASS_NAME_SHOW$6);
            EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown()) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        // Private
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
            if (hideEvent.defaultPrevented) return;
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW$6);
            this._element.classList.remove(CLASS_NAME_SHOW$6);
            this._element.setAttribute("aria-expanded", "false");
            Manipulator.removeDataAttribute(this._menu, "popper");
            EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
        }
        _getConfig(config) {
            config = super._getConfig(config);
            if (typeof config.reference === "object" && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper() {
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
            let referenceElement = this._element;
            if (this._config.reference === "parent") referenceElement = this._parent;
            else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
        }
        _isShown() {
            return this._menu.classList.contains(CLASS_NAME_SHOW$6);
        }
        _getPlacement() {
            const parentDropdown = this._parent;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
            // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(SELECTOR_NAVBAR) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            // Disable Popper if we have a static display or Dropdown is in Navbar
            if (this._inNavbar || this._config.display === "static") {
                Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
                defaultBsPopperConfig.modifiers = [
                    {
                        name: "applyStyles",
                        enabled: false
                    }
                ];
            }
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ])
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
            if (!items.length) return;
            // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY$1) return;
            const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
            for (const toggle of openToggles){
                const context = Dropdown.getInstance(toggle);
                if (!context || context._config.autoClose === false) continue;
                const composedPath = event.composedPath();
                const isMenuTarget = composedPath.includes(context._menu);
                if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
                // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event.type === "click") relatedTarget.clickEvent = event;
                context._completeHide(relatedTarget);
            }
        }
        static dataApiKeydownHandler(event) {
            // If not an UP | DOWN | ESCAPE key => not a dropdown command
            // If input/textarea && if key is other than ESCAPE => not a dropdown command
            const isInput = /input|textarea/i.test(event.target.tagName);
            const isEscapeEvent = event.key === ESCAPE_KEY$2;
            const isUpOrDownEvent = [
                ARROW_UP_KEY$1,
                ARROW_DOWN_KEY$1
            ].includes(event.key);
            if (!isUpOrDownEvent && !isEscapeEvent) return;
            if (isInput && !isEscapeEvent) return;
            event.preventDefault();
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (isUpOrDownEvent) {
                event.stopPropagation();
                instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (instance._isShown()) {
                // else is escape and we check if it is shown
                event.stopPropagation();
                instance.hide();
                getToggleButton.focus();
            }
        }
        constructor(element, config){
            super(element, config);
            this._popper = null;
            this._parent = this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
            this._inNavbar = this._detectNavbar();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Dropdown);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$9 = "backdrop";
    const CLASS_NAME_FADE$4 = "fade";
    const CLASS_NAME_SHOW$5 = "show";
    const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
    const Default$8 = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: false,
        isVisible: true,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: "body" // give the choice to place backdrop under different elements
    };
    const DefaultType$8 = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
    };
    /**
   * Class definition
   */ class Backdrop extends Config {
        // Getters
        static get Default() {
            return Default$8;
        }
        static get DefaultType() {
            return DefaultType$8;
        }
        static get NAME() {
            return NAME$9;
        }
        // Public
        show(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._append();
            const element = this._getElement();
            if (this._config.isAnimated) reflow(element);
            element.classList.add(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                execute(callback);
            });
        }
        hide(callback) {
            if (!this._config.isVisible) {
                execute(callback);
                return;
            }
            this._getElement().classList.remove(CLASS_NAME_SHOW$5);
            this._emulateAnimation(()=>{
                this.dispose();
                execute(callback);
            });
        }
        dispose() {
            if (!this._isAppended) return;
            EventHandler.off(this._element, EVENT_MOUSEDOWN);
            this._element.remove();
            this._isAppended = false;
        }
        // Private
        _getElement() {
            if (!this._element) {
                const backdrop = document.createElement("div");
                backdrop.className = this._config.className;
                if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
                this._element = backdrop;
            }
            return this._element;
        }
        _configAfterMerge(config) {
            // use getElement() with the default "body" to get a fresh Element on each instantiation
            config.rootElement = getElement(config.rootElement);
            return config;
        }
        _append() {
            if (this._isAppended) return;
            const element = this._getElement();
            this._config.rootElement.append(element);
            EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
                execute(this._config.clickCallback);
            });
            this._isAppended = true;
        }
        _emulateAnimation(callback) {
            executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isAppended = false;
            this._element = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$8 = "focustrap";
    const DATA_KEY$5 = "bs.focustrap";
    const EVENT_KEY$5 = `.${DATA_KEY$5}`;
    const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
    const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
    const TAB_KEY = "Tab";
    const TAB_NAV_FORWARD = "forward";
    const TAB_NAV_BACKWARD = "backward";
    const Default$7 = {
        autofocus: true,
        trapElement: null // The element to trap focus inside of
    };
    const DefaultType$7 = {
        autofocus: "boolean",
        trapElement: "element"
    };
    /**
   * Class definition
   */ class FocusTrap extends Config {
        // Getters
        static get Default() {
            return Default$7;
        }
        static get DefaultType() {
            return DefaultType$7;
        }
        static get NAME() {
            return NAME$8;
        }
        // Public
        activate() {
            if (this._isActive) return;
            if (this._config.autofocus) this._config.trapElement.focus();
            EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
            EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
            EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
            this._isActive = true;
        }
        deactivate() {
            if (!this._isActive) return;
            this._isActive = false;
            EventHandler.off(document, EVENT_KEY$5);
        }
        // Private
        _handleFocusin(event) {
            const { trapElement: trapElement } = this._config;
            if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
            const elements = SelectorEngine.focusableChildren(trapElement);
            if (elements.length === 0) trapElement.focus();
            else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
            else elements[0].focus();
        }
        _handleKeydown(event) {
            if (event.key !== TAB_KEY) return;
            this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
            this._isActive = false;
            this._lastTabNavDirection = null;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    const SELECTOR_STICKY_CONTENT = ".sticky-top";
    const PROPERTY_PADDING = "padding-right";
    const PROPERTY_MARGIN = "margin-right";
    /**
   * Class definition
   */ class ScrollBarHelper {
        // Public
        getWidth() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
            const documentWidth = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - documentWidth);
        }
        hide() {
            const width = this.getWidth();
            this._disableOverFlow();
            // give padding to element to balance the hidden scrollbar width
            this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
            this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
            this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
        }
        reset() {
            this._resetElementAttributes(this._element, "overflow");
            this._resetElementAttributes(this._element, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
            this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, "overflow");
            this._element.style.overflow = "hidden";
        }
        _setElementAttributes(selector, styleProperty, callback) {
            const scrollbarWidth = this.getWidth();
            const manipulationCallBack = (element)=>{
                if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                this._saveInitialAttribute(element, styleProperty);
                const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _saveInitialAttribute(element, styleProperty) {
            const actualValue = element.style.getPropertyValue(styleProperty);
            if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
        }
        _resetElementAttributes(selector, styleProperty) {
            const manipulationCallBack = (element)=>{
                const value = Manipulator.getDataAttribute(element, styleProperty);
                // We only want to remove the property if the value is `null`; the value can also be zero
                if (value === null) {
                    element.style.removeProperty(styleProperty);
                    return;
                }
                Manipulator.removeDataAttribute(element, styleProperty);
                element.style.setProperty(styleProperty, value);
            };
            this._applyManipulationCallback(selector, manipulationCallBack);
        }
        _applyManipulationCallback(selector, callBack) {
            if (isElement(selector)) {
                callBack(selector);
                return;
            }
            for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
        }
        constructor(){
            this._element = document.body;
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$7 = "modal";
    const DATA_KEY$4 = "bs.modal";
    const EVENT_KEY$4 = `.${DATA_KEY$4}`;
    const DATA_API_KEY$2 = ".data-api";
    const ESCAPE_KEY$1 = "Escape";
    const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
    const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
    const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
    const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
    const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
    const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
    const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
    const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
    const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
    const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
    const CLASS_NAME_OPEN = "modal-open";
    const CLASS_NAME_FADE$3 = "fade";
    const CLASS_NAME_SHOW$4 = "show";
    const CLASS_NAME_STATIC = "modal-static";
    const OPEN_SELECTOR$1 = ".modal.show";
    const SELECTOR_DIALOG = ".modal-dialog";
    const SELECTOR_MODAL_BODY = ".modal-body";
    const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
    const Default$6 = {
        backdrop: true,
        focus: true,
        keyboard: true
    };
    const DefaultType$6 = {
        backdrop: "(boolean|string)",
        focus: "boolean",
        keyboard: "boolean"
    };
    /**
   * Class definition
   */ class Modal extends BaseComponent {
        // Getters
        static get Default() {
            return Default$6;
        }
        static get DefaultType() {
            return DefaultType$6;
        }
        static get NAME() {
            return NAME$7;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown || this._isTransitioning) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._isTransitioning = true;
            this._scrollBar.hide();
            document.body.classList.add(CLASS_NAME_OPEN);
            this._adjustDialog();
            this._backdrop.show(()=>this._showElement(relatedTarget));
        }
        hide() {
            if (!this._isShown || this._isTransitioning) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
            if (hideEvent.defaultPrevented) return;
            this._isShown = false;
            this._isTransitioning = true;
            this._focustrap.deactivate();
            this._element.classList.remove(CLASS_NAME_SHOW$4);
            this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
        }
        dispose() {
            EventHandler.off(window, EVENT_KEY$4);
            EventHandler.off(this._dialog, EVENT_KEY$4);
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        // Private
        _initializeBackDrop() {
            return new Backdrop({
                isVisible: Boolean(this._config.backdrop),
                // 'static' option will be translated to true, and booleans will keep their value,
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _showElement(relatedTarget) {
            // try to append dynamic modal
            if (!document.body.contains(this._element)) document.body.append(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            this._element.scrollTop = 0;
            const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
            if (modalBody) modalBody.scrollTop = 0;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW$4);
            const transitionComplete = ()=>{
                if (this._config.focus) this._focustrap.activate();
                this._isTransitioning = false;
                EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
                if (event.key !== ESCAPE_KEY$1) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                this._triggerBackdropTransition();
            });
            EventHandler.on(window, EVENT_RESIZE$1, ()=>{
                if (this._isShown && !this._isTransitioning) this._adjustDialog();
            });
            EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
                // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                    if (this._element !== event.target || this._element !== event2.target) return;
                    if (this._config.backdrop === "static") {
                        this._triggerBackdropTransition();
                        return;
                    }
                    if (this._config.backdrop) this.hide();
                });
            });
        }
        _hideModal() {
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._backdrop.hide(()=>{
                document.body.classList.remove(CLASS_NAME_OPEN);
                this._resetAdjustments();
                this._scrollBar.reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$4);
            });
        }
        _isAnimated() {
            return this._element.classList.contains(CLASS_NAME_FADE$3);
        }
        _triggerBackdropTransition() {
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
            if (hideEvent.defaultPrevented) return;
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const initialOverflowY = this._element.style.overflowY;
            // return if the following background transition hasn't yet completed
            if (initialOverflowY === "hidden" || this._element.classList.contains(CLASS_NAME_STATIC)) return;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.classList.remove(CLASS_NAME_STATIC);
                this._queueCallback(()=>{
                    this._element.style.overflowY = initialOverflowY;
                }, this._dialog);
            }, this._dialog);
            this._element.focus();
        }
        /**
     * The following methods are used to handle overflowing modals
     */ _adjustDialog() {
            const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            const scrollbarWidth = this._scrollBar.getWidth();
            const isBodyOverflowing = scrollbarWidth > 0;
            if (isBodyOverflowing && !isModalOverflowing) {
                const property = isRTL() ? "paddingLeft" : "paddingRight";
                this._element.style[property] = `${scrollbarWidth}px`;
            }
            if (!isBodyOverflowing && isModalOverflowing) {
                const property = isRTL() ? "paddingRight" : "paddingLeft";
                this._element.style[property] = `${scrollbarWidth}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        }
        // Static
        static jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                const data = Modal.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            });
        }
        constructor(element, config){
            super(element, config);
            this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._isShown = false;
            this._isTransitioning = false;
            this._scrollBar = new ScrollBarHelper();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
            if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
            return;
            EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
                if (isVisible(this)) this.focus();
            });
        });
        // avoid conflict when clicking modal toggler while another one is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
        if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
        const data = Modal.getOrCreateInstance(target);
        data.toggle(this);
    });
    enableDismissTrigger(Modal);
    /**
   * jQuery
   */ defineJQueryPlugin(Modal);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap offcanvas.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$6 = "offcanvas";
    const DATA_KEY$3 = "bs.offcanvas";
    const EVENT_KEY$3 = `.${DATA_KEY$3}`;
    const DATA_API_KEY$1 = ".data-api";
    const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const ESCAPE_KEY = "Escape";
    const CLASS_NAME_SHOW$3 = "show";
    const CLASS_NAME_SHOWING$1 = "showing";
    const CLASS_NAME_HIDING = "hiding";
    const CLASS_NAME_BACKDROP = "offcanvas-backdrop";
    const OPEN_SELECTOR = ".offcanvas.show";
    const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
    const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
    const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
    const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
    const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
    const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
    const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
    const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
    const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
    const Default$5 = {
        backdrop: true,
        keyboard: true,
        scroll: false
    };
    const DefaultType$5 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        scroll: "boolean"
    };
    /**
   * Class definition
   */ class Offcanvas extends BaseComponent {
        // Getters
        static get Default() {
            return Default$5;
        }
        static get DefaultType() {
            return DefaultType$5;
        }
        static get NAME() {
            return NAME$6;
        }
        // Public
        toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        }
        show(relatedTarget) {
            if (this._isShown) return;
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
                relatedTarget: relatedTarget
            });
            if (showEvent.defaultPrevented) return;
            this._isShown = true;
            this._backdrop.show();
            if (!this._config.scroll) new ScrollBarHelper().hide();
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            this._element.classList.add(CLASS_NAME_SHOWING$1);
            const completeCallBack = ()=>{
                if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
                this._element.classList.add(CLASS_NAME_SHOW$3);
                this._element.classList.remove(CLASS_NAME_SHOWING$1);
                EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                    relatedTarget: relatedTarget
                });
            };
            this._queueCallback(completeCallBack, this._element, true);
        }
        hide() {
            if (!this._isShown) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
            if (hideEvent.defaultPrevented) return;
            this._focustrap.deactivate();
            this._element.blur();
            this._isShown = false;
            this._element.classList.add(CLASS_NAME_HIDING);
            this._backdrop.hide();
            const completeCallback = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
                this._element.removeAttribute("aria-modal");
                this._element.removeAttribute("role");
                if (!this._config.scroll) new ScrollBarHelper().reset();
                EventHandler.trigger(this._element, EVENT_HIDDEN$3);
            };
            this._queueCallback(completeCallback, this._element, true);
        }
        dispose() {
            this._backdrop.dispose();
            this._focustrap.deactivate();
            super.dispose();
        }
        // Private
        _initializeBackDrop() {
            const clickCallback = ()=>{
                if (this._config.backdrop === "static") {
                    EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                    return;
                }
                this.hide();
            };
            // 'static' option will be translated to true, and booleans will keep their value
            const isVisible = Boolean(this._config.backdrop);
            return new Backdrop({
                className: CLASS_NAME_BACKDROP,
                isVisible: isVisible,
                isAnimated: true,
                rootElement: this._element.parentNode,
                clickCallback: isVisible ? clickCallback : null
            });
        }
        _initializeFocusTrap() {
            return new FocusTrap({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
                if (event.key !== ESCAPE_KEY) return;
                if (this._config.keyboard) {
                    this.hide();
                    return;
                }
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
            });
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Offcanvas.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            });
        }
        constructor(element, config){
            super(element, config);
            this._isShown = false;
            this._backdrop = this._initializeBackDrop();
            this._focustrap = this._initializeFocusTrap();
            this._addEventListeners();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        const target = SelectorEngine.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
            // focus on trigger when it is closed
            if (isVisible(this)) this.focus();
        });
        // avoid conflict when clicking a toggler of an offcanvas, while another is open
        const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        const data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
        for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
    });
    EventHandler.on(window, EVENT_RESIZE, ()=>{
        for (const element of SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") Offcanvas.getOrCreateInstance(element).hide();
    });
    enableDismissTrigger(Offcanvas);
    /**
   * jQuery
   */ defineJQueryPlugin(Offcanvas);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    const uriAttributes = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ // eslint-disable-next-line unicorn/better-regex
    const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList)=>{
        const attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
        const domParser = new window.DOMParser();
        const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
        for (const element of elements){
            const elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            const attributeList = [].concat(...element.attributes);
            const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
            for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$5 = "TemplateFactory";
    const Default$4 = {
        allowList: DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: "<div></div>"
    };
    const DefaultType$4 = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    };
    const DefaultContentType = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    /**
   * Class definition
   */ class TemplateFactory extends Config {
        // Getters
        static get Default() {
            return Default$4;
        }
        static get DefaultType() {
            return DefaultType$4;
        }
        static get NAME() {
            return NAME$5;
        }
        // Public
        getContent() {
            return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(content) {
            this._checkContent(content);
            this._config.content = {
                ...this._config.content,
                ...content
            };
            return this;
        }
        toHtml() {
            const templateWrapper = document.createElement("div");
            templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
            for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
            const template = templateWrapper.children[0];
            const extraClass = this._resolvePossibleFunction(this._config.extraClass);
            if (extraClass) template.classList.add(...extraClass.split(" "));
            return template;
        }
        // Private
        _typeCheckConfig(config) {
            super._typeCheckConfig(config);
            this._checkContent(config.content);
        }
        _checkContent(arg) {
            for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
                selector: selector,
                entry: content
            }, DefaultContentType);
        }
        _setContent(template, content, selector) {
            const templateElement = SelectorEngine.findOne(selector, template);
            if (!templateElement) return;
            content = this._resolvePossibleFunction(content);
            if (!content) {
                templateElement.remove();
                return;
            }
            if (isElement(content)) {
                this._putElementInTemplate(getElement(content), templateElement);
                return;
            }
            if (this._config.html) {
                templateElement.innerHTML = this._maybeSanitize(content);
                return;
            }
            templateElement.textContent = content;
        }
        _maybeSanitize(arg) {
            return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this
            ]);
        }
        _putElementInTemplate(element, templateElement) {
            if (this._config.html) {
                templateElement.innerHTML = "";
                templateElement.append(element);
                return;
            }
            templateElement.textContent = element.textContent;
        }
        constructor(config){
            super();
            this._config = this._getConfig(config);
        }
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$4 = "tooltip";
    const DISALLOWED_ATTRIBUTES = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]);
    const CLASS_NAME_FADE$2 = "fade";
    const CLASS_NAME_MODAL = "modal";
    const CLASS_NAME_SHOW$2 = "show";
    const SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
    const EVENT_MODAL_HIDE = "hide.bs.modal";
    const TRIGGER_HOVER = "hover";
    const TRIGGER_FOCUS = "focus";
    const TRIGGER_CLICK = "click";
    const TRIGGER_MANUAL = "manual";
    const EVENT_HIDE$2 = "hide";
    const EVENT_HIDDEN$2 = "hidden";
    const EVENT_SHOW$2 = "show";
    const EVENT_SHOWN$2 = "shown";
    const EVENT_INSERTED = "inserted";
    const EVENT_CLICK$1 = "click";
    const EVENT_FOCUSIN$1 = "focusin";
    const EVENT_FOCUSOUT$1 = "focusout";
    const EVENT_MOUSEENTER = "mouseenter";
    const EVENT_MOUSELEAVE = "mouseleave";
    const AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: isRTL() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: isRTL() ? "right" : "left"
    };
    const Default$3 = {
        allowList: DefaultAllowlist,
        animation: true,
        boundary: "clippingParents",
        container: false,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    };
    const DefaultType$3 = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    /**
   * Class definition
   */ class Tooltip extends BaseComponent {
        // Getters
        static get Default() {
            return Default$3;
        }
        static get DefaultType() {
            return DefaultType$3;
        }
        static get NAME() {
            return NAME$4;
        }
        // Public
        enable() {
            this._isEnabled = true;
        }
        disable() {
            this._isEnabled = false;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            if (!this._isEnabled) return;
            this._activeTrigger.click = !this._activeTrigger.click;
            if (this._isShown()) {
                this._leave();
                return;
            }
            this._enter();
        }
        dispose() {
            clearTimeout(this._timeout);
            EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
            if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
            this._disposePopper();
            super.dispose();
        }
        show() {
            if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
            if (!(this._isWithContent() && this._isEnabled)) return;
            const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
            const shadowRoot = findShadowRoot(this._element);
            const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
            if (showEvent.defaultPrevented || !isInTheDom) return;
            // TODO: v6 remove this or make it optional
            this._disposePopper();
            const tip = this._getTipElement();
            this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
            const { container: container } = this._config;
            if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                container.append(tip);
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
            }
            this._popper = this._createPopper(tip);
            tip.classList.add(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", noop);
            const complete = ()=>{
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
                if (this._isHovered === false) this._leave();
                this._isHovered = false;
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        hide() {
            if (!this._isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
            if (hideEvent.defaultPrevented) return;
            const tip = this._getTipElement();
            tip.classList.remove(CLASS_NAME_SHOW$2);
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            this._isHovered = null; // it is a trick to support manual triggering
            const complete = ()=>{
                if (this._isWithActiveTrigger()) return;
                if (!this._isHovered) this._disposePopper();
                this._element.removeAttribute("aria-describedby");
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        update() {
            if (this._popper) this._popper.update();
        }
        // Protected
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
            return this.tip;
        }
        _createTipElement(content) {
            const tip = this._getTemplateFactory(content).toHtml();
            // TODO: remove this check in v6
            if (!tip) return null;
            tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
            // TODO: v6 the following can be achieved with CSS only
            tip.classList.add(`bs-${this.constructor.NAME}-auto`);
            const tipId = getUID(this.constructor.NAME).toString();
            tip.setAttribute("id", tipId);
            if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
            return tip;
        }
        setContent(content) {
            this._newContent = content;
            if (this._isShown()) {
                this._disposePopper();
                this.show();
            }
        }
        _getTemplateFactory(content) {
            if (this._templateFactory) this._templateFactory.changeContent(content);
            else this._templateFactory = new TemplateFactory({
                ...this._config,
                content: // the `content` var has to be after `this._config`
                // to override config.content in case of popover
                content,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            });
            return this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [SELECTOR_TOOLTIP_INNER]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
        }
        // Private
        _initializeOnDelegatedTarget(event) {
            return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
        }
        _createPopper(tip) {
            const placement = execute(this._config.placement, [
                this,
                tip,
                this._element
            ]);
            const attachment = AttachmentMap[placement.toUpperCase()];
            return Popper__namespace.createPopper(this._element, tip, this._getPopperConfig(attachment));
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _resolvePossibleFunction(arg) {
            return execute(arg, [
                this._element
            ]);
        }
        _getPopperConfig(attachment) {
            const defaultBsPopperConfig = {
                placement: attachment,
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "arrow",
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: "preSetPlacement",
                        enabled: true,
                        phase: "beforeMain",
                        fn: (data)=>{
                            // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                            // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                            this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                        }
                    }
                ]
            };
            return {
                ...defaultBsPopperConfig,
                ...execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ])
            };
        }
        _setListeners() {
            const triggers = this._config.trigger.split(" ");
            for (const trigger of triggers){
                if (trigger === "click") EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context.toggle();
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                    const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                    EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                        context._enter();
                    });
                    EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                        context._leave();
                    });
                }
            }
            this._hideModalHandler = ()=>{
                if (this._element) this.hide();
            };
            EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        }
        _fixTitle() {
            const title = this._element.getAttribute("title");
            if (!title) return;
            if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
            this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
            this._element.removeAttribute("title");
        }
        _enter() {
            if (this._isShown() || this._isHovered) {
                this._isHovered = true;
                return;
            }
            this._isHovered = true;
            this._setTimeout(()=>{
                if (this._isHovered) this.show();
            }, this._config.delay.show);
        }
        _leave() {
            if (this._isWithActiveTrigger()) return;
            this._isHovered = false;
            this._setTimeout(()=>{
                if (!this._isHovered) this.hide();
            }, this._config.delay.hide);
        }
        _setTimeout(handler, timeout) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(handler, timeout);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(true);
        }
        _getConfig(config) {
            const dataAttributes = Manipulator.getDataAttributes(this._element);
            for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
            config = {
                ...dataAttributes,
                ...typeof config === "object" && config ? config : {}
            };
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            config.container = config.container === false ? document.body : getElement(config.container);
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            return config;
        }
        _getDelegateConfig() {
            const config = {};
            for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
            config.selector = false;
            config.trigger = "manual";
            // In the future can be replaced with:
            // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
            // `Object.fromEntries(keysWithDifferentValues)`
            return config;
        }
        _disposePopper() {
            if (this._popper) {
                this._popper.destroy();
                this._popper = null;
            }
            if (this.tip) {
                this.tip.remove();
                this.tip = null;
            }
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tooltip.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            super(element, config);
            // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._isHovered = null;
            this._activeTrigger = {};
            this._popper = null;
            this._templateFactory = null;
            this._newContent = null;
            // Protected
            this.tip = null;
            this._setListeners();
            if (!this._config.selector) this._fixTitle();
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Tooltip);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$3 = "popover";
    const SELECTOR_TITLE = ".popover-header";
    const SELECTOR_CONTENT = ".popover-body";
    const Default$2 = {
        ...Tooltip.Default,
        content: "",
        offset: [
            0,
            8
        ],
        placement: "right",
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: "click"
    };
    const DefaultType$2 = {
        ...Tooltip.DefaultType,
        content: "(null|string|element|function)"
    };
    /**
   * Class definition
   */ class Popover extends Tooltip {
        // Getters
        static get Default() {
            return Default$2;
        }
        static get DefaultType() {
            return DefaultType$2;
        }
        static get NAME() {
            return NAME$3;
        }
        // Overrides
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        // Private
        _getContentForTemplate() {
            return {
                [SELECTOR_TITLE]: this._getTitle(),
                [SELECTOR_CONTENT]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Popover.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ defineJQueryPlugin(Popover);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$2 = "scrollspy";
    const DATA_KEY$2 = "bs.scrollspy";
    const EVENT_KEY$2 = `.${DATA_KEY$2}`;
    const DATA_API_KEY = ".data-api";
    const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
    const EVENT_CLICK = `click${EVENT_KEY$2}`;
    const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    const CLASS_NAME_ACTIVE$1 = "active";
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_TARGET_LINKS = "[href]";
    const SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    const SELECTOR_NAV_LINKS = ".nav-link";
    const SELECTOR_NAV_ITEMS = ".nav-item";
    const SELECTOR_LIST_ITEMS = ".list-group-item";
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
    const SELECTOR_DROPDOWN = ".dropdown";
    const SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    const Default$1 = {
        offset: null,
        // TODO: v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: "0px 0px -25%",
        smoothScroll: false,
        target: null,
        threshold: [
            0.1,
            0.5,
            1
        ]
    };
    const DefaultType$1 = {
        offset: "(number|null)",
        // TODO v6 @deprecated, keep it for backwards compatibility reasons
        rootMargin: "string",
        smoothScroll: "boolean",
        target: "element",
        threshold: "array"
    };
    /**
   * Class definition
   */ class ScrollSpy extends BaseComponent {
        // Getters
        static get Default() {
            return Default$1;
        }
        static get DefaultType() {
            return DefaultType$1;
        }
        static get NAME() {
            return NAME$2;
        }
        // Public
        refresh() {
            this._initializeTargetsAndObservables();
            this._maybeEnableSmoothScroll();
            if (this._observer) this._observer.disconnect();
            else this._observer = this._getNewObserver();
            for (const section of this._observableSections.values())this._observer.observe(section);
        }
        dispose() {
            this._observer.disconnect();
            super.dispose();
        }
        // Private
        _configAfterMerge(config) {
            // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
            config.target = getElement(config.target) || document.body;
            // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
            config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
            if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
            return config;
        }
        _maybeEnableSmoothScroll() {
            if (!this._config.smoothScroll) return;
            // unregister any previous listeners
            EventHandler.off(this._config.target, EVENT_CLICK);
            EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
                const observableSection = this._observableSections.get(event.target.hash);
                if (observableSection) {
                    event.preventDefault();
                    const root = this._rootElement || window;
                    const height = observableSection.offsetTop - this._element.offsetTop;
                    if (root.scrollTo) {
                        root.scrollTo({
                            top: height,
                            behavior: "smooth"
                        });
                        return;
                    }
                    // Chrome 60 doesn't support `scrollTo`
                    root.scrollTop = height;
                }
            });
        }
        _getNewObserver() {
            const options = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
        }
        // The logic of selection
        _observerCallback(entries) {
            const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
            const activate = (entry)=>{
                this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                this._process(targetElement(entry));
            };
            const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
            const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = parentScrollTop;
            for (const entry of entries){
                if (!entry.isIntersecting) {
                    this._activeTarget = null;
                    this._clearActiveClass(targetElement(entry));
                    continue;
                }
                const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                // if we are scrolling down, pick the bigger offsetTop
                if (userScrollsDown && entryIsLowerThanPrevious) {
                    activate(entry);
                    // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                    if (!parentScrollTop) return;
                    continue;
                }
                // if we are scrolling up, pick the smallest offsetTop
                if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map();
            this._observableSections = new Map();
            const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
            for (const anchor of targetLinks){
                // ensure that the anchor has an id and is not disabled
                if (!anchor.hash || isDisabled(anchor)) continue;
                const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                // ensure that the observableSection exists & is visible
                if (isVisible(observableSection)) {
                    this._targetLinks.set(decodeURI(anchor.hash), anchor);
                    this._observableSections.set(anchor.hash, observableSection);
                }
            }
        }
        _process(target) {
            if (this._activeTarget === target) return;
            this._clearActiveClass(this._config.target);
            this._activeTarget = target;
            target.classList.add(CLASS_NAME_ACTIVE$1);
            this._activateParents(target);
            EventHandler.trigger(this._element, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _activateParents(target) {
            // Activate dropdown parents
            if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
                SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
                return;
            }
            for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
            for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
        }
        _clearActiveClass(parent) {
            parent.classList.remove(CLASS_NAME_ACTIVE$1);
            const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
            for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element, config){
            super(element, config);
            // this._element is the observablesContainer and config.target the menu links wrapper
            this._targetLinks = new Map();
            this._observableSections = new Map();
            this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
            this._activeTarget = null;
            this._observer = null;
            this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            };
            this.refresh(); // initialize
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
        for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(ScrollSpy);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME$1 = "tab";
    const DATA_KEY$1 = "bs.tab";
    const EVENT_KEY$1 = `.${DATA_KEY$1}`;
    const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
    const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
    const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
    const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
    const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
    const ARROW_LEFT_KEY = "ArrowLeft";
    const ARROW_RIGHT_KEY = "ArrowRight";
    const ARROW_UP_KEY = "ArrowUp";
    const ARROW_DOWN_KEY = "ArrowDown";
    const HOME_KEY = "Home";
    const END_KEY = "End";
    const CLASS_NAME_ACTIVE = "active";
    const CLASS_NAME_FADE$1 = "fade";
    const CLASS_NAME_SHOW$1 = "show";
    const CLASS_DROPDOWN = "dropdown";
    const SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    const SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
    const NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${SELECTOR_DROPDOWN_TOGGLE})`;
    const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    const SELECTOR_OUTER = ".nav-item, .list-group-item";
    const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
    /**
   * Class definition
   */ class Tab extends BaseComponent {
        // Getters
        static get NAME() {
            return NAME$1;
        }
        // Public
        show() {
            // Shows this elem and deactivate the active sibling if exists
            const innerElem = this._element;
            if (this._elemIsActive(innerElem)) return;
            // Search for active tab on same parent to deactivate it
            const active = this._getActiveElem();
            const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
                relatedTarget: innerElem
            }) : null;
            const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
                relatedTarget: active
            });
            if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
            this._deactivate(active, innerElem);
            this._activate(innerElem, active);
        }
        // Private
        _activate(element, relatedElem) {
            if (!element) return;
            element.classList.add(CLASS_NAME_ACTIVE);
            this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
            const complete = ()=>{
                if (element.getAttribute("role") !== "tab") {
                    element.classList.add(CLASS_NAME_SHOW$1);
                    return;
                }
                element.removeAttribute("tabindex");
                element.setAttribute("aria-selected", true);
                this._toggleDropDown(element, true);
                EventHandler.trigger(element, EVENT_SHOWN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _deactivate(element, relatedElem) {
            if (!element) return;
            element.classList.remove(CLASS_NAME_ACTIVE);
            element.blur();
            this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
            const complete = ()=>{
                if (element.getAttribute("role") !== "tab") {
                    element.classList.remove(CLASS_NAME_SHOW$1);
                    return;
                }
                element.setAttribute("aria-selected", false);
                element.setAttribute("tabindex", "-1");
                this._toggleDropDown(element, false);
                EventHandler.trigger(element, EVENT_HIDDEN$1, {
                    relatedTarget: relatedElem
                });
            };
            this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
        }
        _keydown(event) {
            if (![
                ARROW_LEFT_KEY,
                ARROW_RIGHT_KEY,
                ARROW_UP_KEY,
                ARROW_DOWN_KEY,
                HOME_KEY,
                END_KEY
            ].includes(event.key)) return;
            event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
            event.preventDefault();
            const children = this._getChildren().filter((element)=>!isDisabled(element));
            let nextActiveElement;
            if ([
                HOME_KEY,
                END_KEY
            ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
            else {
                const isNext = [
                    ARROW_RIGHT_KEY,
                    ARROW_DOWN_KEY
                ].includes(event.key);
                nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
            }
            if (nextActiveElement) {
                nextActiveElement.focus({
                    preventScroll: true
                });
                Tab.getOrCreateInstance(nextActiveElement).show();
            }
        }
        _getChildren() {
            // collection of inner elements
            return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
        }
        _setInitialAttributes(parent, children) {
            this._setAttributeIfNotExists(parent, "role", "tablist");
            for (const child of children)this._setInitialAttributesOnChild(child);
        }
        _setInitialAttributesOnChild(child) {
            child = this._getInnerElement(child);
            const isActive = this._elemIsActive(child);
            const outerElem = this._getOuterElement(child);
            child.setAttribute("aria-selected", isActive);
            if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
            if (!isActive) child.setAttribute("tabindex", "-1");
            this._setAttributeIfNotExists(child, "role", "tab");
            // set attributes to the related panel too
            this._setInitialAttributesOnTargetPanel(child);
        }
        _setInitialAttributesOnTargetPanel(child) {
            const target = SelectorEngine.getElementFromSelector(child);
            if (!target) return;
            this._setAttributeIfNotExists(target, "role", "tabpanel");
            if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
        }
        _toggleDropDown(element, open) {
            const outerElem = this._getOuterElement(element);
            if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
            const toggle = (selector, className)=>{
                const element = SelectorEngine.findOne(selector, outerElem);
                if (element) element.classList.toggle(className, open);
            };
            toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
            toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
            outerElem.setAttribute("aria-expanded", open);
        }
        _setAttributeIfNotExists(element, attribute, value) {
            if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
        }
        _elemIsActive(elem) {
            return elem.classList.contains(CLASS_NAME_ACTIVE);
        }
        // Try to get the inner element (usually the .nav-link)
        _getInnerElement(elem) {
            return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
        }
        // Try to get the outer element (usually the .nav-item)
        _getOuterElement(elem) {
            return elem.closest(SELECTOR_OUTER) || elem;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tab.getOrCreateInstance(this);
                if (typeof config !== "string") return;
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        constructor(element){
            super(element);
            this._parent = this._element.closest(SELECTOR_TAB_PANEL);
            if (!this._parent) return;
            // Set up initial aria attributes
            this._setInitialAttributes(this._parent, this._getChildren());
            EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
        for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
    });
    /**
   * jQuery
   */ defineJQueryPlugin(Tab);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = "toast";
    const DATA_KEY = "bs.toast";
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = "fade";
    const CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_SHOWING = "showing";
    const DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * Class definition
   */ class Toast extends BaseComponent {
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        show() {
            const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this.isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        isShown() {
            return this._element.classList.contains(CLASS_NAME_SHOW);
        }
        // Private
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = isInteracting;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
    }
    /**
   * Data API implementation
   */ enableDismissTrigger(Toast);
    /**
   * jQuery
   */ defineJQueryPlugin(Toast);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const index_umd = {
        Alert: Alert,
        Button: Button,
        Carousel: Carousel,
        Collapse: Collapse,
        Dropdown: Dropdown,
        Modal: Modal,
        Offcanvas: Offcanvas,
        Popover: Popover,
        ScrollSpy: ScrollSpy,
        Tab: Tab,
        Toast: Toast,
        Tooltip: Tooltip
    };
    return index_umd;
});




var $bfd143f5026247cb$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else $bfd143f5026247cb$exports = factory();
})($bfd143f5026247cb$exports, function() {
    var NProgress = {};
    NProgress.version = "0.2.0";
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === "") Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: "none",
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: "all " + speed + "ms linear",
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === "number";
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== "number") amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById("nprogress");
        addClass(document.documentElement, "nprogress-busy");
        var progress = document.createElement("div");
        progress.id = "nprogress";
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? "-100" : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: "all 0 linear",
            transform: "translate3d(" + perc + "%,0,0)"
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, "nprogress-custom-parent");
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, "nprogress-busy");
        removeClass(document.querySelector(Settings.parent), "nprogress-custom-parent");
        var progress = document.getElementById("nprogress");
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById("nprogress");
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = "WebkitTransform" in bodyStyle ? "Webkit" : "MozTransform" in bodyStyle ? "Moz" : "msTransform" in bodyStyle ? "ms" : "OTransform" in bodyStyle ? "O" : "";
        if (vendorPrefix + "Perspective" in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return "translate3d";
        else if (vendorPrefix + "Transform" in bodyStyle) // Browsers without 3D support, e.g. IE9
        return "translate";
        else // Browsers without translate() support, e.g. IE7-8
        return "margin";
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === "translate3d") barCSS = {
            transform: "translate3d(" + toBarPerc(n) + "%,0,0)"
        };
        else if (Settings.positionUsing === "translate") barCSS = {
            transform: "translate(" + toBarPerc(n) + "%,0)"
        };
        else barCSS = {
            "margin-left": toBarPerc(n) + "%"
        };
        barCSS.transition = "all " + speed + "ms " + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            "Webkit",
            "O",
            "Moz",
            "ms"
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == "string" ? element : classList(element);
        return list.indexOf(" " + name + " ") >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(" " + name + " ", " ");
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (" " + (element.className || "") + " ").replace(/\s+/gi, " ");
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});


// Copyright (C) Konrad Gadzinowski
class $b75b7c1126578ead$export$9701f5bc74a805e5 {
    constructor(){
        this.pages = new Array();
        this.addPage = (page)=>{
            this.pages.push(page);
        };
        this.setPjax = (pjax)=>{
            this.pjax = pjax;
        };
        this.getCurrentPageId = ()=>{
            if (!this.currentPage) return "";
            return this.currentPage.getPageId();
        };
        this.setupPage = ()=>{
            this.closePage();
            let page = this.executeCurrentPageLogic();
            if (page) this.currentPage = page;
        };
        this.closePage = ()=>{
            if (this.currentPage) {
                this.currentPage.onPageClose();
                this.currentPage = null;
            }
        };
        this.executeCurrentPageLogic = ()=>{
            const pageIdElement = document.querySelector("#pageId");
            if (!pageIdElement) return;
            const pageId = pageIdElement.innerText;
            pageIdElement.parentNode.removeChild(pageIdElement);
            if (!pageId || pageId.length === 0) return;
            for(let i = 0; i < this.pages.length; i++){
                let page = this.pages[i];
                if (pageId == page.getPageId()) {
                    page.execute(this.pjax);
                    return page;
                }
            }
            return null;
        };
        this.pages = new Array();
    }
}


// Copyright (C) Konrad Gadzinowski
class $54f37c9212c86cf8$export$a7fed597f4b8afd8 {
}
$54f37c9212c86cf8$export$a7fed597f4b8afd8.setupForms = ()=>{
    // Validate forms
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(".needs-validation");
    // Loop over them and prevent submission
    for (const form of forms){
        var _form_querySelectorAll;
        // In Firefox, check validity on submit button click. You can't prevent form submit event on Firefox.
        const submitButtons = (_form_querySelectorAll = form.querySelectorAll("button[type=submit]")) !== null && _form_querySelectorAll !== void 0 ? _form_querySelectorAll : [];
        for (const button of submitButtons)// Handle submit event
        button.addEventListener("click", (event)=>{
            form.classList.add("was-validated");
            // Validate form
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return true;
        }, true);
        // Handle submit event
        form.addEventListener("submit", (event)=>{
            form.classList.add("was-validated");
            // Validate form
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            // If valid block all submit buttons, so that they can't be clicked again
            const submitButtons = form.querySelectorAll("button[type=submit]");
            for (const button of submitButtons){
                button.type = "button";
                button.disabled = "true";
            }
        }, true);
    }
};




class $63b595d905f6b553$export$9bbedc1992a787b4 {
    constructor(onPageLoaded){
        this.initiated = false;
        this.start = (pages)=>{
            if (this.initiated) return;
            this.initiated = true;
            this.setupPjax();
            this.pagesCtrl = new (0, $b75b7c1126578ead$export$9701f5bc74a805e5)();
            if (!!pages) for (const page of pages)this.pagesCtrl.addPage(page);
        };
        this.setupPjax = ()=>{
            document.addEventListener("DOMContentLoaded", ()=>{
                this.pjax = new (0, (/*@__PURE__*/$parcel$interopDefault($d26b75c87b693463$exports)))({
                    elements: 'a:not([target="_blank"]):not(.noPjax)[href], form.pjax',
                    selectors: [
                        "title",
                        'meta[name="description"]',
                        'link[rel="canonical"]',
                        "style[data-styled]",
                        "header",
                        "main",
                        "footer"
                    ],
                    cacheBust: false
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).configure({
                    parent: "body",
                    showSpinner: false
                });
                this.pagesCtrl.setPjax(this.pjax);
                this.pagesCtrl.setupPage();
                (0, $54f37c9212c86cf8$export$a7fed597f4b8afd8).setupForms();
                if (!!this.onPageLoaded) this.onPageLoaded();
            });
            document.addEventListener("pjax:send", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).start();
            });
            document.addEventListener("pjax:complete", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
            });
            document.addEventListener("pjax:error", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
            });
            document.addEventListener("pjax:success", ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bfd143f5026247cb$exports))).done();
                this.pagesCtrl.setupPage();
                (0, $54f37c9212c86cf8$export$a7fed597f4b8afd8).setupForms();
                if (!!this.onPageLoaded) this.onPageLoaded();
            });
        };
        this.onPageLoaded = onPageLoaded;
    }
}


// Copyright (C) Digital Jetty - All Rights Reserved
class $a30b3a9a137baaed$export$1d8a493107fb4b3a {
}
$a30b3a9a137baaed$export$1d8a493107fb4b3a.toClipboard = (text)=>{
    if (!navigator.clipboard) {
        $a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback(text);
        return;
    }
    navigator.clipboard.writeText(text).then(()=>{
    // Ignore
    }, (error)=>{
        $a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback(text);
    });
};
$a30b3a9a137baaed$export$1d8a493107fb4b3a.copyToClipboardFallback = (text)=>{
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    // Rewmember existing selection
    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    // If a selection existed before copying, unselect everything on the HTML document and restore the original selection
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};


class $a5749f8efb25cf9e$export$593bf50f5d507e87 {
    constructor(app){
        this.getPageId = ()=>{
            return "page-verify-emails";
        };
        this.execute = ()=>{
            const typeSelect = document.querySelector("select[name='type']");
            typeSelect.addEventListener("change", (event)=>{
                this.app.pjax.loadUrl(location.pathname + "?type=" + event.target.value);
            });
            // Add copy email button
            const copyButtons = document.querySelectorAll(".btn-copy");
            for (const button of copyButtons)button.addEventListener("click", (event)=>{
                const email = event.target.getAttribute("data-email");
                (0, $a30b3a9a137baaed$export$1d8a493107fb4b3a).toClipboard(email);
            });
        };
        this.onPageClose = ()=>{};
        this.app = app;
    }
}


var $5a075e5df43f8e0c$export$2e2bcd8739ae039 = $5a075e5df43f8e0c$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $5a075e5df43f8e0c$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == "boolean") deep = args.shift();
    var result = args[0];
    if ($5a075e5df43f8e0c$var$isUnextendable(result)) throw new Error("extendee must be an object");
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $5a075e5df43f8e0c$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $5a075e5df43f8e0c$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$5a075e5df43f8e0c$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $5a075e5df43f8e0c$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == "[object Object]";
}
function $5a075e5df43f8e0c$var$isUnextendable(val) {
    return !val || typeof val != "object" && typeof val != "function";
}


function $c180364cf43a262f$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    // Add an event listener for given event
    on(event, fn) {
        this._callbacks = this._callbacks || {};
        // Create namespace for this event
        if (!this._callbacks[event]) this._callbacks[event] = [];
        this._callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        this._callbacks = this._callbacks || {};
        let callbacks = this._callbacks[event];
        if (callbacks) for (let callback of callbacks)callback.apply(this, args);
        // trigger a corresponding DOM event
        if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
            args: args
        }));
        return this;
    }
    makeEvent(eventName, detail) {
        let params = {
            bubbles: true,
            cancelable: true,
            detail: detail
        };
        if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
        else {
            // IE 11 support
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
    }
    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.
    off(event, fn) {
        if (!this._callbacks || arguments.length === 0) {
            this._callbacks = {};
            return this;
        }
        // specific event
        let callbacks = this._callbacks[event];
        if (!callbacks) return this;
        // remove all handlers
        if (arguments.length === 1) {
            delete this._callbacks[event];
            return this;
        }
        // remove specific handler
        for(let i = 0; i < callbacks.length; i++){
            let callback = callbacks[i];
            if (callback === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        return this;
    }
}
var $c180364cf43a262f$var$$fd6031f88dce2e32$exports = {};
$c180364cf43a262f$var$$fd6031f88dce2e32$exports = '<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail=""></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size=""></span></div>\n    <div class="dz-filename"><span data-dz-name=""></span></div>\n  </div>\n  <div class="dz-progress">\n    <span class="dz-upload" data-dz-uploadprogress=""></span>\n  </div>\n  <div class="dz-error-message"><span data-dz-errormessage=""></span></div>\n  <div class="dz-success-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z"></path>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54" height="54" viewBox="0 0 54 54" fill="white" xmlns="http://www.w3.org/2000/svg">\n      <path d="M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z"></path>\n    </svg>\n  </div>\n</div>\n';
let $c180364cf43a262f$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init () {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params (files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept (file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback () {
        // This code should pass in IE7... :(
        let messageElement;
        this.element.className = `${this.element.className} dz-browser-not-supported`;
        for (let child of this.element.getElementsByTagName("div"))if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message"; // Removes the 'dz-default' class
            break;
        }
        if (!messageElement) {
            messageElement = $c180364cf43a262f$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        let span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize (file, width, height, resizeMethod) {
        let info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        let srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        let trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error(`Unknown resizeMethod '${resizeMethod}'`);
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile (file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $c180364cf43a262f$var$$parcel$interopDefault($c180364cf43a262f$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart (e) {},
    dragend (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste (e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset () {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile (file) {
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            for (var node of file.previewElement.querySelectorAll("[data-dz-name]"))node.textContent = file.name;
            for (node of file.previewElement.querySelectorAll("[data-dz-size]"))node.innerHTML = this.filesize(file.size);
            if (this.options.addRemoveLinks) {
                file._removeLink = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<a class="dz-remove" href="javascript:undefined;" data-dz-remove>${this.options.dictRemoveFile}</a>`);
                file.previewElement.appendChild(file._removeLink);
            }
            let removeFileEvent = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) return $c180364cf43a262f$export$2e2bcd8739ae039.confirm(this.options.dictCancelUploadConfirmation, ()=>this.removeFile(file));
                else {
                    if (this.options.dictRemoveFileConfirmation) return $c180364cf43a262f$export$2e2bcd8739ae039.confirm(this.options.dictRemoveFileConfirmation, ()=>this.removeFile(file));
                    else return this.removeFile(file);
                }
            };
            for (let removeLink of file.previewElement.querySelectorAll("[data-dz-remove]"))removeLink.addEventListener("click", removeFileEvent);
        }
    },
    // Called whenever a file is removed.
    removedfile (file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail (file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")){
                thumbnailElement.alt = file.name;
                thumbnailElement.src = dataUrl;
            }
            return setTimeout(()=>file.previewElement.classList.add("dz-image-preview"), 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error (file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            for (let node of file.previewElement.querySelectorAll("[data-dz-errormessage]"))node.textContent = message;
        }
    },
    errormultiple () {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing (file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple () {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress (file, progress, bytesSent) {
        if (file.previewElement) for (let node of file.previewElement.querySelectorAll("[data-dz-uploadprogress]"))node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = `${progress}%`;
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress () {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending () {},
    sendingmultiple () {},
    // When the complete upload is finished and successful
    // Receives `file`
    success (file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple () {},
    // When the upload is canceled.
    canceled (file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple () {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete (file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple () {},
    maxfilesexceeded () {},
    maxfilesreached () {},
    queuecomplete () {},
    addedfiles () {}
};
var $c180364cf43a262f$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $c180364cf43a262f$var$$4ca367182776f80b$var$defaultOptions;
class $c180364cf43a262f$export$2e2bcd8739ae039 extends $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    static initClass() {
        // Exposing the emitter class, mainly for tests
        this.prototype.Emitter = $c180364cf43a262f$var$$4040acfd8584338d$export$2e2bcd8739ae039;
        /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
            "drop",
            "dragstart",
            "dragend",
            "dragenter",
            "dragover",
            "dragleave",
            "addedfile",
            "addedfiles",
            "removedfile",
            "thumbnail",
            "error",
            "errormultiple",
            "processing",
            "processingmultiple",
            "uploadprogress",
            "totaluploadprogress",
            "sending",
            "sendingmultiple",
            "success",
            "successmultiple",
            "canceled",
            "canceledmultiple",
            "complete",
            "completemultiple",
            "reset",
            "maxfilesexceeded",
            "maxfilesreached",
            "queuecomplete"
        ];
        this.prototype._thumbnailQueue = [];
        this.prototype._processingThumbnail = false;
    }
    // Returns all files that have been accepted
    getAcceptedFiles() {
        return this.files.filter((file)=>file.accepted).map((file)=>file);
    }
    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.
    getRejectedFiles() {
        return this.files.filter((file)=>!file.accepted).map((file)=>file);
    }
    getFilesWithStatus(status) {
        return this.files.filter((file)=>file.status === status).map((file)=>file);
    }
    // Returns all files that are in the queue
    getQueuedFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.QUEUED);
    }
    getUploadingFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING);
    }
    getAddedFiles() {
        return this.getFilesWithStatus($c180364cf43a262f$export$2e2bcd8739ae039.ADDED);
    }
    // Files that are either queued or uploading
    getActiveFiles() {
        return this.files.filter((file)=>file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING || file.status === $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED).map((file)=>file);
    }
    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.
    init() {
        // In case it isn't set already
        if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
        if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<div class="dz-default dz-message"><button class="dz-button" type="button">${this.options.dictDefaultMessage}</button></div>`));
        if (this.clickableElements.length) {
            let setupHiddenFileInput = ()=>{
                if (this.hiddenFileInput) this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                this.hiddenFileInput = document.createElement("input");
                this.hiddenFileInput.setAttribute("type", "file");
                if (this.options.maxFiles === null || this.options.maxFiles > 1) this.hiddenFileInput.setAttribute("multiple", "multiple");
                this.hiddenFileInput.className = "dz-hidden-input";
                if (this.options.acceptedFiles !== null) this.hiddenFileInput.setAttribute("accept", this.options.acceptedFiles);
                if (this.options.capture !== null) this.hiddenFileInput.setAttribute("capture", this.options.capture);
                // Making sure that no one can "tab" into this field.
                this.hiddenFileInput.setAttribute("tabindex", "-1");
                // Not setting `display="none"` because some browsers don't accept clicks
                // on elements that aren't displayed.
                this.hiddenFileInput.style.visibility = "hidden";
                this.hiddenFileInput.style.position = "absolute";
                this.hiddenFileInput.style.top = "0";
                this.hiddenFileInput.style.left = "0";
                this.hiddenFileInput.style.height = "0";
                this.hiddenFileInput.style.width = "0";
                $c180364cf43a262f$export$2e2bcd8739ae039.getElement(this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(this.hiddenFileInput);
                this.hiddenFileInput.addEventListener("change", ()=>{
                    let { files: files } = this.hiddenFileInput;
                    if (files.length) for (let file of files)this.addFile(file);
                    this.emit("addedfiles", files);
                    setupHiddenFileInput();
                });
            };
            setupHiddenFileInput();
        }
        this.URL = window.URL !== null ? window.URL : window.webkitURL;
        // Setup all event listeners on the Dropzone object itself.
        // They're not in @setupEventListeners() because they shouldn't be removed
        // again when the dropzone gets disabled.
        for (let eventName of this.events)this.on(eventName, this.options[eventName]);
        this.on("uploadprogress", ()=>this.updateTotalUploadProgress());
        this.on("removedfile", ()=>this.updateTotalUploadProgress());
        this.on("canceled", (file)=>this.emit("complete", file));
        // Emit a `queuecomplete` event if all files finished uploading.
        this.on("complete", (file)=>{
            if (this.getAddedFiles().length === 0 && this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) return setTimeout(()=>this.emit("queuecomplete"), 0);
        });
        const containsFiles = function(e) {
            if (e.dataTransfer.types) // IE, we need to iterate like this instead of
            // using e.dataTransfer.types.some()
            for(var i = 0; i < e.dataTransfer.types.length; i++){
                if (e.dataTransfer.types[i] === "Files") return true;
            }
            return false;
        };
        let noPropagation = function(e) {
            // If there are no files, we don't want to stop
            // propagation so we don't interfere with other
            // drag and drop behaviour.
            if (!containsFiles(e)) return;
            e.stopPropagation();
            if (e.preventDefault) return e.preventDefault();
            else return e.returnValue = false;
        };
        // Create the listeners
        this.listeners = [
            {
                element: this.element,
                events: {
                    dragstart: (e)=>{
                        return this.emit("dragstart", e);
                    },
                    dragenter: (e)=>{
                        noPropagation(e);
                        return this.emit("dragenter", e);
                    },
                    dragover: (e)=>{
                        // Makes it possible to drag files from chrome's download bar
                        // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                        // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                        let efct;
                        try {
                            efct = e.dataTransfer.effectAllowed;
                        } catch (error) {}
                        e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                        noPropagation(e);
                        return this.emit("dragover", e);
                    },
                    dragleave: (e)=>{
                        return this.emit("dragleave", e);
                    },
                    drop: (e)=>{
                        noPropagation(e);
                        return this.drop(e);
                    },
                    dragend: (e)=>{
                        return this.emit("dragend", e);
                    }
                }
            }
        ];
        this.clickableElements.forEach((clickableElement)=>{
            return this.listeners.push({
                element: clickableElement,
                events: {
                    click: (evt)=>{
                        // Only the actual dropzone or the message element should trigger file selection
                        if (clickableElement !== this.element || evt.target === this.element || $c180364cf43a262f$export$2e2bcd8739ae039.elementInside(evt.target, this.element.querySelector(".dz-message"))) this.hiddenFileInput.click(); // Forward the click
                        return true;
                    }
                }
            });
        });
        this.enable();
        return this.options.init.call(this);
    }
    // Not fully tested yet
    destroy() {
        this.disable();
        this.removeAllFiles(true);
        if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
            this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
            this.hiddenFileInput = null;
        }
        delete this.element.dropzone;
        return $c180364cf43a262f$export$2e2bcd8739ae039.instances.splice($c180364cf43a262f$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
    updateTotalUploadProgress() {
        let totalUploadProgress;
        let totalBytesSent = 0;
        let totalBytes = 0;
        let activeFiles = this.getActiveFiles();
        if (activeFiles.length) {
            for (let file of this.getActiveFiles()){
                totalBytesSent += file.upload.bytesSent;
                totalBytes += file.upload.total;
            }
            totalUploadProgress = 100 * totalBytesSent / totalBytes;
        } else totalUploadProgress = 100;
        return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }
    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.
    _getParamName(n) {
        if (typeof this.options.paramName === "function") return this.options.paramName(n);
        else return `${this.options.paramName}${this.options.uploadMultiple ? `[${n}]` : ""}`;
    }
    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData
    _renameFile(file) {
        if (typeof this.options.renameFile !== "function") return file.name;
        return this.options.renameFile(file);
    }
    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(
    getFallbackForm() {
        let existingFallback, form;
        if (existingFallback = this.getExistingFallback()) return existingFallback;
        let fieldsString = '<div class="dz-fallback">';
        if (this.options.dictFallbackText) fieldsString += `<p>${this.options.dictFallbackText}</p>`;
        fieldsString += `<input type="file" name="${this._getParamName(0)}" ${this.options.uploadMultiple ? 'multiple="multiple"' : undefined} /><input type="submit" value="Upload!"></div>`;
        let fields = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(fieldsString);
        if (this.element.tagName !== "FORM") {
            form = $c180364cf43a262f$export$2e2bcd8739ae039.createElement(`<form action="${this.options.url}" enctype="multipart/form-data" method="${this.options.method}"></form>`);
            form.appendChild(fields);
        } else {
            // Make sure that the enctype and method attributes are set properly
            this.element.setAttribute("enctype", "multipart/form-data");
            this.element.setAttribute("method", this.options.method);
        }
        return form != null ? form : fields;
    }
    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(
    getExistingFallback() {
        let getFallback = function(elements) {
            for (let el of elements){
                if (/(^| )fallback($| )/.test(el.className)) return el;
            }
        };
        for (let tagName of [
            "div",
            "form"
        ]){
            var fallback;
            if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
        }
    }
    // Activates all listeners stored in @listeners
    setupEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.addEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Deactivates all listeners stored in @listeners
    removeEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.removeEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Removes all event listeners and cancels all files in the queue or being processed.
    disable() {
        this.clickableElements.forEach((element)=>element.classList.remove("dz-clickable"));
        this.removeEventListeners();
        this.disabled = true;
        return this.files.map((file)=>this.cancelUpload(file));
    }
    enable() {
        delete this.disabled;
        this.clickableElements.forEach((element)=>element.classList.add("dz-clickable"));
        return this.setupEventListeners();
    }
    // Returns a nicely formatted filesize
    filesize(size) {
        let selectedSize = 0;
        let selectedUnit = "b";
        if (size > 0) {
            let units = [
                "tb",
                "gb",
                "mb",
                "kb",
                "b"
            ];
            for(let i = 0; i < units.length; i++){
                let unit = units[i];
                let cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }
        return `<strong>${selectedSize}</strong> ${this.options.dictFileSizeUnits[selectedUnit]}`;
    }
    // Adds or removes the `dz-max-files-reached` class from the form.
    _updateMaxFilesReachedClass() {
        if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
            return this.element.classList.add("dz-max-files-reached");
        } else return this.element.classList.remove("dz-max-files-reached");
    }
    drop(e) {
        if (!e.dataTransfer) return;
        this.emit("drop", e);
        // Convert the FileList to an Array
        // This is necessary for IE11
        let files = [];
        for(let i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
        // Even if it's a folder, files.length will contain the folders.
        if (files.length) {
            let { items: items } = e.dataTransfer;
            if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
            else this.handleFiles(files);
        }
        this.emit("addedfiles", files);
    }
    paste(e) {
        if ($c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, (x)=>x.items) == null) return;
        this.emit("paste", e);
        let { items: items } = e.clipboardData;
        if (items.length) return this._addFilesFromItems(items);
    }
    handleFiles(files) {
        for (let file of files)this.addFile(file);
    }
    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.
    _addFilesFromItems(items) {
        return (()=>{
            let result = [];
            for (let item of items){
                var entry;
                if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                    if (entry.isFile) result.push(this.addFile(item.getAsFile()));
                    else if (entry.isDirectory) result.push(this._addFilesFromDirectory(entry, entry.name));
                    else result.push(undefined);
                } else if (item.getAsFile != null) {
                    if (item.kind == null || item.kind === "file") result.push(this.addFile(item.getAsFile()));
                    else result.push(undefined);
                } else result.push(undefined);
            }
            return result;
        })();
    }
    // Goes through the directory, and adds each file it finds recursively
    _addFilesFromDirectory(directory, path) {
        let dirReader = directory.createReader();
        let errorHandler = (error)=>$c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", (o)=>o.log(error));
        var readEntries = ()=>{
            return dirReader.readEntries((entries)=>{
                if (entries.length > 0) {
                    for (let entry of entries){
                        if (entry.isFile) entry.file((file)=>{
                            if (this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                            file.fullPath = `${path}/${file.name}`;
                            return this.addFile(file);
                        });
                        else if (entry.isDirectory) this._addFilesFromDirectory(entry, `${path}/${entry.name}`);
                    }
                    // Recursively call readEntries() again, since browser only handle
                    // the first 100 entries.
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                    readEntries();
                }
                return null;
            }, errorHandler);
        };
        return readEntries();
    }
    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.
    accept(file, done) {
        if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        else if (!$c180364cf43a262f$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
        else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
            this.emit("maxfilesexceeded", file);
        } else this.options.accept.call(this, file, done);
    }
    addFile(file) {
        file.upload = {
            uuid: $c180364cf43a262f$export$2e2bcd8739ae039.uuidv4(),
            progress: 0,
            // Setting the total upload size to file.size for the beginning
            // It's actual different than the size to be transmitted.
            total: file.size,
            bytesSent: 0,
            filename: this._renameFile(file)
        };
        this.files.push(file);
        file.status = $c180364cf43a262f$export$2e2bcd8739ae039.ADDED;
        this.emit("addedfile", file);
        this._enqueueThumbnail(file);
        this.accept(file, (error)=>{
            if (error) {
                file.accepted = false;
                this._errorProcessing([
                    file
                ], error); // Will set the file.status
            } else {
                file.accepted = true;
                if (this.options.autoQueue) this.enqueueFile(file);
            // Will set .accepted = true
            }
            this._updateMaxFilesReachedClass();
        });
    }
    // Wrapper for enqueueFile
    enqueueFiles(files) {
        for (let file of files)this.enqueueFile(file);
        return null;
    }
    enqueueFile(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED;
            if (this.options.autoProcessQueue) return setTimeout(()=>this.processQueue(), 0); // Deferring the call
        } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
    _enqueueThumbnail(file) {
        if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
            this._thumbnailQueue.push(file);
            return setTimeout(()=>this._processThumbnailQueue(), 0); // Deferring the call
        }
    }
    _processThumbnailQueue() {
        if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
        this._processingThumbnail = true;
        let file = this._thumbnailQueue.shift();
        return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, (dataUrl)=>{
            this.emit("thumbnail", file, dataUrl);
            this._processingThumbnail = false;
            return this._processThumbnailQueue();
        });
    }
    // Can be called by the user to remove a file
    removeFile(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
        this.files = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$without(this.files, file);
        this.emit("removedfile", file);
        if (this.files.length === 0) return this.emit("reset");
    }
    // Removes all files that aren't currently processed from the list
    removeAllFiles(cancelIfNecessary) {
        // Create a copy of files since removeFile() changes the @files array.
        if (cancelIfNecessary == null) cancelIfNecessary = false;
        for (let file of this.files.slice())if (file.status !== $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
        return null;
    }
    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.
    resizeImage(file, width, height, resizeMethod, callback) {
        return this.createThumbnail(file, width, height, resizeMethod, true, (dataUrl, canvas)=>{
            if (canvas == null) return callback(file);
            else {
                let { resizeMimeType: resizeMimeType } = this.options;
                if (resizeMimeType == null) resizeMimeType = file.type;
                let resizedDataURL = canvas.toDataURL(resizeMimeType, this.options.resizeQuality);
                if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                return callback($c180364cf43a262f$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
            }
        });
    }
    createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
        let fileReader = new FileReader();
        fileReader.onload = ()=>{
            file.dataURL = fileReader.result;
            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) callback(fileReader.result);
                return;
            }
            this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
        };
        fileReader.readAsDataURL(file);
    }
    // `mockFile` needs to have these attributes:
    //
    //     { name: 'name', size: 12345, imageUrl: '' }
    //
    // `callback` will be invoked when the image has been downloaded and displayed.
    // `crossOrigin` will be added to the `img` tag when accessing the file.
    displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail = true) {
        this.emit("addedfile", mockFile);
        this.emit("complete", mockFile);
        if (!resizeThumbnail) {
            this.emit("thumbnail", mockFile, imageUrl);
            if (callback) callback();
        } else {
            let onDone = (thumbnail)=>{
                this.emit("thumbnail", mockFile, thumbnail);
                if (callback) callback();
            };
            mockFile.dataURL = imageUrl;
            this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
        }
    }
    createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        let img = document.createElement("img");
        if (crossOrigin) img.crossOrigin = crossOrigin;
        // fixOrientation is not needed anymore with browsers handling imageOrientation
        fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
        img.onload = ()=>{
            let loadExif = (callback)=>callback(1);
            if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = (callback)=>EXIF.getData(img, function() {
                    return callback(EXIF.getTag(this, "Orientation"));
                });
            return loadExif((orientation)=>{
                file.width = img.width;
                file.height = img.height;
                let resizeInfo = this.options.resize.call(this, file, width, height, resizeMethod);
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;
                if (orientation > 4) {
                    canvas.width = resizeInfo.trgHeight;
                    canvas.height = resizeInfo.trgWidth;
                }
                switch(orientation){
                    case 2:
                        // horizontal flip
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(canvas.width, canvas.height);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, canvas.height);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -canvas.width);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(canvas.height, -canvas.width);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-canvas.height, 0);
                        break;
                }
                // This is a bugfix for iOS' scaling bug.
                $c180364cf43a262f$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                let thumbnail = canvas.toDataURL("image/png");
                if (callback != null) return callback(thumbnail, canvas);
            });
        };
        if (callback != null) img.onerror = callback;
        return img.src = file.dataURL;
    }
    // Goes through the queue and processes files if there aren't too many already.
    processQueue() {
        let { parallelUploads: parallelUploads } = this.options;
        let processingLength = this.getUploadingFiles().length;
        let i = processingLength;
        // There are already at least as many files uploading than should be
        if (processingLength >= parallelUploads) return;
        let queuedFiles = this.getQueuedFiles();
        if (!(queuedFiles.length > 0)) return;
        if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
        else while(i < parallelUploads){
            if (!queuedFiles.length) return;
            // Nothing left to process
            this.processFile(queuedFiles.shift());
            i++;
        }
    }
    // Wrapper for `processFiles`
    processFile(file) {
        return this.processFiles([
            file
        ]);
    }
    // Loads the file, then calls finishedLoading()
    processFiles(files) {
        for (let file of files){
            file.processing = true; // Backwards compatibility
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING;
            this.emit("processing", file);
        }
        if (this.options.uploadMultiple) this.emit("processingmultiple", files);
        return this.uploadFiles(files);
    }
    _getFilesWithXhr(xhr) {
        let files;
        return files = this.files.filter((file)=>file.xhr === xhr).map((file)=>file);
    }
    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.
    cancelUpload(file) {
        if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING) {
            let groupedFiles = this._getFilesWithXhr(file.xhr);
            for (let groupedFile of groupedFiles)groupedFile.status = $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED;
            if (typeof file.xhr !== "undefined") file.xhr.abort();
            for (let groupedFile1 of groupedFiles)this.emit("canceled", groupedFile1);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
        } else if (file.status === $c180364cf43a262f$export$2e2bcd8739ae039.ADDED || file.status === $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED) {
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED;
            this.emit("canceled", file);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                file
            ]);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    resolveOption(option, ...args) {
        if (typeof option === "function") return option.apply(this, args);
        return option;
    }
    uploadFile(file) {
        return this.uploadFiles([
            file
        ]);
    }
    uploadFiles(files) {
        this._transformFiles(files, (transformedFiles)=>{
            if (this.options.chunking) {
                // Chunking is not allowed to be used with `uploadMultiple` so we know
                // that there is only __one__file.
                let transformedFile = transformedFiles[0];
                files[0].upload.chunked = this.options.chunking && (this.options.forceChunking || transformedFile.size > this.options.chunkSize);
                files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / this.options.chunkSize);
            }
            if (files[0].upload.chunked) {
                // This file should be sent in chunks!
                // If the chunking option is set, we **know** that there can only be **one** file, since
                // uploadMultiple is not allowed with this option.
                let file = files[0];
                let transformedFile = transformedFiles[0];
                let startedChunkCount = 0;
                file.upload.chunks = [];
                let handleNextChunk = ()=>{
                    let chunkIndex = 0;
                    // Find the next item in file.upload.chunks that is not defined yet.
                    while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                    // This means, that all chunks have already been started.
                    if (chunkIndex >= file.upload.totalChunkCount) return;
                    startedChunkCount++;
                    let start = chunkIndex * this.options.chunkSize;
                    let end = Math.min(start + this.options.chunkSize, transformedFile.size);
                    let dataBlock = {
                        name: this._getParamName(0),
                        data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
                        filename: file.upload.filename,
                        chunkIndex: chunkIndex
                    };
                    file.upload.chunks[chunkIndex] = {
                        file: file,
                        index: chunkIndex,
                        dataBlock: dataBlock,
                        status: $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING,
                        progress: 0,
                        retries: 0
                    };
                    this._uploadData(files, [
                        dataBlock
                    ]);
                };
                file.upload.finishedChunkUpload = (chunk, response)=>{
                    let allFinished = true;
                    chunk.status = $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS;
                    // Clear the data from the chunk
                    chunk.dataBlock = null;
                    chunk.response = chunk.xhr.responseText;
                    chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                    // Leaving this reference to xhr will cause memory leaks.
                    chunk.xhr = null;
                    for(let i = 0; i < file.upload.totalChunkCount; i++){
                        if (file.upload.chunks[i] === undefined) return handleNextChunk();
                        if (file.upload.chunks[i].status !== $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                    }
                    if (allFinished) this.options.chunksUploaded(file, ()=>{
                        this._finished(files, response, null);
                    });
                };
                if (this.options.parallelChunkUploads) for(let i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                else handleNextChunk();
            } else {
                let dataBlocks = [];
                for(let i = 0; i < files.length; i++)dataBlocks[i] = {
                    name: this._getParamName(i),
                    data: transformedFiles[i],
                    filename: files[i].upload.filename
                };
                this._uploadData(files, dataBlocks);
            }
        });
    }
    /// Returns the right chunk for given file and xhr
    _getChunk(file, xhr) {
        for(let i = 0; i < file.upload.totalChunkCount; i++){
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
        }
    }
    // This function actually uploads the file(s) to the server.
    //
    //  If dataBlocks contains the actual data to upload (meaning, that this could
    // either be transformed files, or individual chunks for chunked upload) then
    // they will be used for the actual data to upload.
    _uploadData(files, dataBlocks) {
        let xhr = new XMLHttpRequest();
        // Put the xhr object in the file objects to be able to reference it later.
        for (let file of files)file.xhr = xhr;
        if (files[0].upload.chunked) // later, and found with _getChunk.
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
        let method = this.resolveOption(this.options.method, files, dataBlocks);
        let url = this.resolveOption(this.options.url, files, dataBlocks);
        xhr.open(method, url, true);
        // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
        let timeout = this.resolveOption(this.options.timeout, files);
        if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
        // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
        xhr.withCredentials = !!this.options.withCredentials;
        xhr.onload = (e)=>{
            this._finishedUploading(files, xhr, e);
        };
        xhr.ontimeout = ()=>{
            this._handleUploadError(files, xhr, `Request timedout after ${this.options.timeout / 1000} seconds`);
        };
        xhr.onerror = ()=>{
            this._handleUploadError(files, xhr);
        };
        // Some browsers do not have the .upload property
        let progressObj = xhr.upload != null ? xhr.upload : xhr;
        progressObj.onprogress = (e)=>this._updateFilesUploadProgress(files, xhr, e);
        let headers = this.options.defaultHeaders ? {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            "X-Requested-With": "XMLHttpRequest"
        } : {};
        if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
        if (this.options.headers) (0, $5a075e5df43f8e0c$export$2e2bcd8739ae039)(headers, this.options.headers);
        for(let headerName in headers){
            let headerValue = headers[headerName];
            if (headerValue) xhr.setRequestHeader(headerName, headerValue);
        }
        if (this.options.binaryBody) {
            // Since the file is going to be sent as binary body, it doesn't make
            // any sense to generate `FormData` for it.
            for (let file of files)this.emit("sending", file, xhr);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
            this.submitRequest(xhr, null, files);
        } else {
            let formData = new FormData();
            // Adding all @options parameters
            if (this.options.params) {
                let additionalParams = this.options.params;
                if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                for(let key in additionalParams){
                    let value = additionalParams[key];
                    if (Array.isArray(value)) // so lets iterate over it to attach each value
                    // individually.
                    for(let i = 0; i < value.length; i++)formData.append(key, value[i]);
                    else formData.append(key, value);
                }
            }
            // Let the user add additional data if necessary
            for (let file of files)this.emit("sending", file, xhr, formData);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
            this._addFormElementData(formData);
            // Finally add the files
            // Has to be last because some servers (eg: S3) expect the file to be the last parameter
            for(let i = 0; i < dataBlocks.length; i++){
                let dataBlock = dataBlocks[i];
                formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
            }
            this.submitRequest(xhr, formData, files);
        }
    }
    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
    _transformFiles(files, done) {
        let transformedFiles = [];
        // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
        let doneCounter = 0;
        for(let i = 0; i < files.length; i++)this.options.transformFile.call(this, files[i], (transformedFile)=>{
            transformedFiles[i] = transformedFile;
            if (++doneCounter === files.length) done(transformedFiles);
        });
    }
    // Takes care of adding other input elements of the form to the AJAX request
    _addFormElementData(formData) {
        // Take care of other input elements
        if (this.element.tagName === "FORM") for (let input of this.element.querySelectorAll("input, textarea, select, button")){
            let inputName = input.getAttribute("name");
            let inputType = input.getAttribute("type");
            if (inputType) inputType = inputType.toLowerCase();
            // If the input doesn't have a name, we can't use it.
            if (typeof inputName === "undefined" || inputName === null) continue;
            if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                // Possibly multiple values
                for (let option of input.options)if (option.selected) formData.append(inputName, option.value);
            } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
        }
    }
    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.
    _updateFilesUploadProgress(files, xhr, e) {
        if (!files[0].upload.chunked) for (let file of files){
            if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
            if (e) {
                file.upload.progress = 100 * e.loaded / e.total;
                file.upload.total = e.total;
                file.upload.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                file.upload.progress = 100;
                file.upload.bytesSent = file.upload.total;
            }
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
        else {
            // Handle chunked file uploads
            // Chunked upload is not compatible with uploading multiple files in one
            // request, so we know there's only one file.
            let file = files[0];
            // Since this is a chunked upload, we need to update the appropriate chunk
            // progress.
            let chunk = this._getChunk(file, xhr);
            if (e) {
                chunk.progress = 100 * e.loaded / e.total;
                chunk.total = e.total;
                chunk.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                chunk.progress = 100;
                chunk.bytesSent = chunk.total;
            }
            // Now tally the *file* upload progress from its individual chunks
            file.upload.progress = 0;
            file.upload.total = 0;
            file.upload.bytesSent = 0;
            for(let i = 0; i < file.upload.totalChunkCount; i++)if (file.upload.chunks[i] && typeof file.upload.chunks[i].progress !== "undefined") {
                file.upload.progress += file.upload.chunks[i].progress;
                file.upload.total += file.upload.chunks[i].total;
                file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
            // Since the process is a percentage, we need to divide by the amount of
            // chunks we've used.
            file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
    }
    _finishedUploading(files, xhr, e) {
        let response;
        if (files[0].status === $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED) return;
        if (xhr.readyState !== 4) return;
        if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
            response = xhr.responseText;
            if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                response = JSON.parse(response);
            } catch (error) {
                e = error;
                response = "Invalid JSON response from server.";
            }
        }
        this._updateFilesUploadProgress(files, xhr);
        if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
        else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
        else this._finished(files, response, e);
    }
    _handleUploadError(files, xhr, response) {
        if (files[0].status === $c180364cf43a262f$export$2e2bcd8739ae039.CANCELED) return;
        if (files[0].upload.chunked && this.options.retryChunks) {
            let chunk = this._getChunk(files[0], xhr);
            if (chunk.retries++ < this.options.retryChunksLimit) {
                this._uploadData(files, [
                    chunk.dataBlock
                ]);
                return;
            } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
    }
    submitRequest(xhr, formData, files) {
        if (xhr.readyState != 1) {
            console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
            return;
        }
        if (this.options.binaryBody) {
            if (files[0].upload.chunked) {
                const chunk = this._getChunk(files[0], xhr);
                xhr.send(chunk.dataBlock.data);
            } else xhr.send(files[0]);
        } else xhr.send(formData);
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _finished(files, responseText, e) {
        for (let file of files){
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS;
            this.emit("success", file, responseText, e);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("successmultiple", files, responseText, e);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _errorProcessing(files, message, xhr) {
        for (let file of files){
            file.status = $c180364cf43a262f$export$2e2bcd8739ae039.ERROR;
            this.emit("error", file, message, xhr);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("errormultiple", files, message, xhr);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    constructor(el, options){
        super();
        let fallback, left;
        this.element = el;
        this.clickableElements = [];
        this.listeners = [];
        this.files = []; // All files
        if (typeof this.element === "string") this.element = document.querySelector(this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!this.element || this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $c180364cf43a262f$export$2e2bcd8739ae039.instances.push(this);
        // Put the dropzone inside the element itself.
        this.element.dropzone = this;
        let elementOptions = (left = $c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement(this.element)) != null ? left : {};
        this.options = (0, $5a075e5df43f8e0c$export$2e2bcd8739ae039)(true, {}, $c180364cf43a262f$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        this.options.previewTemplate = this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (this.options.forceFallback || !$c180364cf43a262f$export$2e2bcd8739ae039.isBrowserSupported()) return this.options.fallback.call(this);
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (this.options.url == null) this.options.url = this.element.getAttribute("action");
        if (!this.options.url) throw new Error("No URL provided.");
        if (this.options.acceptedFiles && this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (this.options.uploadMultiple && this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (this.options.binaryBody && this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (this.options.acceptedMimeTypes) {
            this.options.acceptedFiles = this.options.acceptedMimeTypes;
            delete this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (this.options.renameFilename != null) this.options.renameFile = (file)=>this.options.renameFilename.call(this, file.name, file);
        if (typeof this.options.method === "string") this.options.method = this.options.method.toUpperCase();
        if ((fallback = this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (this.options.previewsContainer !== false) {
            if (this.options.previewsContainer) this.previewsContainer = $c180364cf43a262f$export$2e2bcd8739ae039.getElement(this.options.previewsContainer, "previewsContainer");
            else this.previewsContainer = this.element;
        }
        if (this.options.clickable) {
            if (this.options.clickable === true) this.clickableElements = [
                this.element
            ];
            else this.clickableElements = $c180364cf43a262f$export$2e2bcd8739ae039.getElements(this.options.clickable, "clickable");
        }
        this.init();
    }
}
$c180364cf43a262f$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$c180364cf43a262f$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $c180364cf43a262f$export$2e2bcd8739ae039.options[$c180364cf43a262f$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$c180364cf43a262f$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$c180364cf43a262f$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$c180364cf43a262f$export$2e2bcd8739ae039.discover = function() {
    let dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        let checkElements = (elements)=>(()=>{
                let result = [];
                for (let el of elements)if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                else result.push(undefined);
                return result;
            })();
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return (()=>{
        let result = [];
        for (let dropzone of dropzones)if ($c180364cf43a262f$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $c180364cf43a262f$export$2e2bcd8739ae039(dropzone));
        else result.push(undefined);
        return result;
    })();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$c180364cf43a262f$export$2e2bcd8739ae039.isBrowserSupported = function() {
    let capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($c180364cf43a262f$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers = $c180364cf43a262f$export$2e2bcd8739ae039.blacklistedBrowsers;
            // The browser supports the API, but may be blocked.
            for (let regex of $c180364cf43a262f$export$2e2bcd8739ae039.blockedBrowsers)if (regex.test(navigator.userAgent)) {
                capableBrowser = false;
                continue;
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$c180364cf43a262f$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for(let i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
const $c180364cf43a262f$var$$3ed269f2f0fb224b$var$without = (list, rejectedItem)=>list.filter((item)=>item !== rejectedItem).map((item)=>item);
// abc-def_ghi -> abcDefGhi
const $c180364cf43a262f$var$$3ed269f2f0fb224b$var$camelize = (str)=>str.replace(/[\-_](\w)/g, (match)=>match.charAt(1).toUpperCase());
// Creates an element from string
$c180364cf43a262f$export$2e2bcd8739ae039.createElement = function(string) {
    let div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$c180364cf43a262f$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$c180364cf43a262f$export$2e2bcd8739ae039.getElement = function(el, name) {
    let element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector or a plain HTML element.`);
    return element;
};
$c180364cf43a262f$export$2e2bcd8739ae039.getElements = function(els, name) {
    let el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            for (el of els)elements.push(this.getElement(el, name));
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        for (el of document.querySelectorAll(els))elements.push(el);
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector, a plain HTML element or a list of those.`);
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$c180364cf43a262f$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$c180364cf43a262f$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");
    for (let validType of acceptedFiles){
        validType = validType.trim();
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (mimeType === validType) return true;
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $c180364cf43a262f$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$c180364cf43a262f$export$2e2bcd8739ae039.ADDED = "added";
$c180364cf43a262f$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$c180364cf43a262f$export$2e2bcd8739ae039.ACCEPTED = $c180364cf43a262f$export$2e2bcd8739ae039.QUEUED;
$c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING = "uploading";
$c180364cf43a262f$export$2e2bcd8739ae039.PROCESSING = $c180364cf43a262f$export$2e2bcd8739ae039.UPLOADING; // alias
$c180364cf43a262f$export$2e2bcd8739ae039.CANCELED = "canceled";
$c180364cf43a262f$export$2e2bcd8739ae039.ERROR = "error";
$c180364cf43a262f$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
let $c180364cf43a262f$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function(img) {
    let iw = img.naturalWidth;
    let ih = img.naturalHeight;
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let { data: data } = ctx.getImageData(1, 0, 1, ih);
    // search image edge pixel position in case it is squashed vertically.
    let sy = 0;
    let ey = ih;
    let py = ih;
    while(py > sy){
        let alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    let ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $c180364cf43a262f$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    let vertSquashRatio = $c180364cf43a262f$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
class $c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore {
    static initClass() {
        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }
    static encode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        while(true){
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return output;
    }
    static restore(origFileBase64, resizedFileBase64) {
        if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
        let rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
        let segments = this.slice2Segments(rawImage);
        let image = this.exifManipulation(resizedFileBase64, segments);
        return `data:image/jpeg;base64,${this.encode64(image)}`;
    }
    static exifManipulation(resizedFileBase64, segments) {
        let exifArray = this.getExifArray(segments);
        let newImageArray = this.insertExif(resizedFileBase64, exifArray);
        let aBuffer = new Uint8Array(newImageArray);
        return aBuffer;
    }
    static getExifArray(segments) {
        let seg = undefined;
        let x = 0;
        while(x < segments.length){
            seg = segments[x];
            if (seg[0] === 255 & seg[1] === 225) return seg;
            x++;
        }
        return [];
    }
    static insertExif(resizedFileBase64, exifArray) {
        let imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
        let buf = this.decode64(imageData);
        let separatePoint = buf.indexOf(255, 3);
        let mae = buf.slice(0, separatePoint);
        let ato = buf.slice(separatePoint);
        let array = mae;
        array = array.concat(exifArray);
        array = array.concat(ato);
        return array;
    }
    static slice2Segments(rawImageArray) {
        let head = 0;
        let segments = [];
        while(true){
            var length;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
            else {
                length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                let endPoint = head + length + 2;
                let seg = rawImageArray.slice(head, endPoint);
                segments.push(seg);
                head = endPoint;
            }
            if (head > rawImageArray.length) break;
        }
        return segments;
    }
    static decode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        let buf = [];
        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        let base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while(true){
            enc1 = this.KEY_STR.indexOf(input.charAt(i++));
            enc2 = this.KEY_STR.indexOf(input.charAt(i++));
            enc3 = this.KEY_STR.indexOf(input.charAt(i++));
            enc4 = this.KEY_STR.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            buf.push(chr1);
            if (enc3 !== 64) buf.push(chr2);
            if (enc4 !== 64) buf.push(chr3);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return buf;
    }
}
$c180364cf43a262f$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
let $c180364cf43a262f$var$$3ed269f2f0fb224b$var$contentLoaded = function(win, fn) {
    let done = false;
    let top = true;
    let doc = win.document;
    let root = doc.documentElement;
    let add = doc.addEventListener ? "addEventListener" : "attachEvent";
    let rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    let pre = doc.addEventListener ? "" : "on";
    var init = function(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $c180364cf43a262f$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $864e3137db0bdda5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $864e3137db0bdda5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $864e3137db0bdda5$var$ownKeys(Object(source), true).forEach(function(key) {
            $864e3137db0bdda5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $864e3137db0bdda5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $864e3137db0bdda5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $864e3137db0bdda5$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $864e3137db0bdda5$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $864e3137db0bdda5$var$_typeof(obj);
}
function $864e3137db0bdda5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $864e3137db0bdda5$var$_extends() {
    $864e3137db0bdda5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $864e3137db0bdda5$var$_extends.apply(this, arguments);
}
function $864e3137db0bdda5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $864e3137db0bdda5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $864e3137db0bdda5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $864e3137db0bdda5$var$_toConsumableArray(arr) {
    return $864e3137db0bdda5$var$_arrayWithoutHoles(arr) || $864e3137db0bdda5$var$_iterableToArray(arr) || $864e3137db0bdda5$var$_unsupportedIterableToArray(arr) || $864e3137db0bdda5$var$_nonIterableSpread();
}
function $864e3137db0bdda5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $864e3137db0bdda5$var$_arrayLikeToArray(arr);
}
function $864e3137db0bdda5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $864e3137db0bdda5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $864e3137db0bdda5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $864e3137db0bdda5$var$_arrayLikeToArray(o, minLen);
}
function $864e3137db0bdda5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $864e3137db0bdda5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $864e3137db0bdda5$var$version = "1.15.2";
function $864e3137db0bdda5$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $864e3137db0bdda5$var$IE11OrLess = $864e3137db0bdda5$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $864e3137db0bdda5$var$Edge = $864e3137db0bdda5$var$userAgent(/Edge/i);
var $864e3137db0bdda5$var$FireFox = $864e3137db0bdda5$var$userAgent(/firefox/i);
var $864e3137db0bdda5$var$Safari = $864e3137db0bdda5$var$userAgent(/safari/i) && !$864e3137db0bdda5$var$userAgent(/chrome/i) && !$864e3137db0bdda5$var$userAgent(/android/i);
var $864e3137db0bdda5$var$IOS = $864e3137db0bdda5$var$userAgent(/iP(ad|od|hone)/i);
var $864e3137db0bdda5$var$ChromeForAndroid = $864e3137db0bdda5$var$userAgent(/chrome/i) && $864e3137db0bdda5$var$userAgent(/android/i);
var $864e3137db0bdda5$var$captureMode = {
    capture: false,
    passive: false
};
function $864e3137db0bdda5$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$864e3137db0bdda5$var$IE11OrLess && $864e3137db0bdda5$var$captureMode);
}
function $864e3137db0bdda5$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$864e3137db0bdda5$var$IE11OrLess && $864e3137db0bdda5$var$captureMode);
}
function $864e3137db0bdda5$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $864e3137db0bdda5$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $864e3137db0bdda5$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $864e3137db0bdda5$var$matches(el, selector) : $864e3137db0bdda5$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $864e3137db0bdda5$var$getParentOrHost(el));
    }
    return null;
}
var $864e3137db0bdda5$var$R_SPACE = /\s+/g;
function $864e3137db0bdda5$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($864e3137db0bdda5$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($864e3137db0bdda5$var$R_SPACE, " ");
        }
    }
}
function $864e3137db0bdda5$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $864e3137db0bdda5$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $864e3137db0bdda5$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $864e3137db0bdda5$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $864e3137db0bdda5$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $864e3137db0bdda5$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $864e3137db0bdda5$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$864e3137db0bdda5$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($864e3137db0bdda5$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $864e3137db0bdda5$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($864e3137db0bdda5$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($864e3137db0bdda5$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $864e3137db0bdda5$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $864e3137db0bdda5$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $864e3137db0bdda5$var$getParentAutoScrollElement(el, true), elSideVal = $864e3137db0bdda5$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $864e3137db0bdda5$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $864e3137db0bdda5$var$getWindowScrollingElement()) break;
        parent = $864e3137db0bdda5$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $864e3137db0bdda5$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $864e3137db0bdda5$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $864e3137db0bdda5$export$31b3ca70d8f57423.dragged) && $864e3137db0bdda5$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $864e3137db0bdda5$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $864e3137db0bdda5$export$31b3ca70d8f57423.ghost || $864e3137db0bdda5$var$css(last, "display") === "none" || selector && !$864e3137db0bdda5$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $864e3137db0bdda5$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $864e3137db0bdda5$export$31b3ca70d8f57423.clone && (!selector || $864e3137db0bdda5$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $864e3137db0bdda5$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $864e3137db0bdda5$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $864e3137db0bdda5$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $864e3137db0bdda5$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $864e3137db0bdda5$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $864e3137db0bdda5$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $864e3137db0bdda5$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $864e3137db0bdda5$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $864e3137db0bdda5$var$getWindowScrollingElement();
}
function $864e3137db0bdda5$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $864e3137db0bdda5$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $864e3137db0bdda5$var$_throttleTimeout;
function $864e3137db0bdda5$var$throttle(callback, ms) {
    return function() {
        if (!$864e3137db0bdda5$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $864e3137db0bdda5$var$_throttleTimeout = setTimeout(function() {
                $864e3137db0bdda5$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $864e3137db0bdda5$var$cancelThrottle() {
    clearTimeout($864e3137db0bdda5$var$_throttleTimeout);
    $864e3137db0bdda5$var$_throttleTimeout = void 0;
}
function $864e3137db0bdda5$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $864e3137db0bdda5$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $864e3137db0bdda5$var$setRect(el, rect) {
    $864e3137db0bdda5$var$css(el, "position", "absolute");
    $864e3137db0bdda5$var$css(el, "top", rect.top);
    $864e3137db0bdda5$var$css(el, "left", rect.left);
    $864e3137db0bdda5$var$css(el, "width", rect.width);
    $864e3137db0bdda5$var$css(el, "height", rect.height);
}
function $864e3137db0bdda5$var$unsetRect(el) {
    $864e3137db0bdda5$var$css(el, "position", "");
    $864e3137db0bdda5$var$css(el, "top", "");
    $864e3137db0bdda5$var$css(el, "left", "");
    $864e3137db0bdda5$var$css(el, "width", "");
    $864e3137db0bdda5$var$css(el, "height", "");
}
function $864e3137db0bdda5$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$864e3137db0bdda5$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $864e3137db0bdda5$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $864e3137db0bdda5$var$expando = "Sortable" + new Date().getTime();
function $864e3137db0bdda5$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($864e3137db0bdda5$var$css(child, "display") === "none" || child === $864e3137db0bdda5$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $864e3137db0bdda5$var$getRect(child)
                });
                var fromRect = $864e3137db0bdda5$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $864e3137db0bdda5$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($864e3137db0bdda5$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $864e3137db0bdda5$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $864e3137db0bdda5$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($864e3137db0bdda5$var$isRectEqual(prevFromRect, toRect) && !$864e3137db0bdda5$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $864e3137db0bdda5$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$864e3137db0bdda5$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $864e3137db0bdda5$var$css(target, "transition", "");
                $864e3137db0bdda5$var$css(target, "transform", "");
                var elMatrix = $864e3137db0bdda5$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $864e3137db0bdda5$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $864e3137db0bdda5$var$repaint(target); // repaint
                $864e3137db0bdda5$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $864e3137db0bdda5$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $864e3137db0bdda5$var$css(target, "transition", "");
                    $864e3137db0bdda5$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $864e3137db0bdda5$var$repaint(target) {
    return target.offsetWidth;
}
function $864e3137db0bdda5$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $864e3137db0bdda5$var$plugins = [];
var $864e3137db0bdda5$var$defaults = {
    initializeByDefault: true
};
var $864e3137db0bdda5$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $864e3137db0bdda5$var$defaults)if ($864e3137db0bdda5$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $864e3137db0bdda5$var$defaults[option];
        $864e3137db0bdda5$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $864e3137db0bdda5$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($864e3137db0bdda5$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($864e3137db0bdda5$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $864e3137db0bdda5$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $864e3137db0bdda5$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $864e3137db0bdda5$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $864e3137db0bdda5$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$864e3137db0bdda5$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$864e3137db0bdda5$var$IE11OrLess && !$864e3137db0bdda5$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $864e3137db0bdda5$var$_objectSpread2($864e3137db0bdda5$var$_objectSpread2({}, extraEventProperties), $864e3137db0bdda5$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $864e3137db0bdda5$var$_excluded = [
    "evt"
];
var $864e3137db0bdda5$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $864e3137db0bdda5$var$_objectWithoutProperties(_ref, $864e3137db0bdda5$var$_excluded);
    $864e3137db0bdda5$var$PluginManager.pluginEvent.bind($864e3137db0bdda5$export$31b3ca70d8f57423)(eventName, sortable, $864e3137db0bdda5$var$_objectSpread2({
        dragEl: $864e3137db0bdda5$var$dragEl,
        parentEl: $864e3137db0bdda5$var$parentEl,
        ghostEl: $864e3137db0bdda5$var$ghostEl,
        rootEl: $864e3137db0bdda5$var$rootEl,
        nextEl: $864e3137db0bdda5$var$nextEl,
        lastDownEl: $864e3137db0bdda5$var$lastDownEl,
        cloneEl: $864e3137db0bdda5$var$cloneEl,
        cloneHidden: $864e3137db0bdda5$var$cloneHidden,
        dragStarted: $864e3137db0bdda5$var$moved,
        putSortable: $864e3137db0bdda5$var$putSortable,
        activeSortable: $864e3137db0bdda5$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $864e3137db0bdda5$var$oldIndex,
        oldDraggableIndex: $864e3137db0bdda5$var$oldDraggableIndex,
        newIndex: $864e3137db0bdda5$var$newIndex,
        newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex,
        hideGhostForTarget: $864e3137db0bdda5$var$_hideGhostForTarget,
        unhideGhostForTarget: $864e3137db0bdda5$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $864e3137db0bdda5$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $864e3137db0bdda5$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $864e3137db0bdda5$var$_dispatchEvent(info) {
    $864e3137db0bdda5$var$dispatchEvent($864e3137db0bdda5$var$_objectSpread2({
        putSortable: $864e3137db0bdda5$var$putSortable,
        cloneEl: $864e3137db0bdda5$var$cloneEl,
        targetEl: $864e3137db0bdda5$var$dragEl,
        rootEl: $864e3137db0bdda5$var$rootEl,
        oldIndex: $864e3137db0bdda5$var$oldIndex,
        oldDraggableIndex: $864e3137db0bdda5$var$oldDraggableIndex,
        newIndex: $864e3137db0bdda5$var$newIndex,
        newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex
    }, info));
}
var $864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$parentEl, $864e3137db0bdda5$var$ghostEl, $864e3137db0bdda5$var$rootEl, $864e3137db0bdda5$var$nextEl, $864e3137db0bdda5$var$lastDownEl, $864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$cloneHidden, $864e3137db0bdda5$var$oldIndex, $864e3137db0bdda5$var$newIndex, $864e3137db0bdda5$var$oldDraggableIndex, $864e3137db0bdda5$var$newDraggableIndex, $864e3137db0bdda5$var$activeGroup, $864e3137db0bdda5$var$putSortable, $864e3137db0bdda5$var$awaitingDragStarted = false, $864e3137db0bdda5$var$ignoreNextClick = false, $864e3137db0bdda5$var$sortables = [], $864e3137db0bdda5$var$tapEvt, $864e3137db0bdda5$var$touchEvt, $864e3137db0bdda5$var$lastDx, $864e3137db0bdda5$var$lastDy, $864e3137db0bdda5$var$tapDistanceLeft, $864e3137db0bdda5$var$tapDistanceTop, $864e3137db0bdda5$var$moved, $864e3137db0bdda5$var$lastTarget, $864e3137db0bdda5$var$lastDirection, $864e3137db0bdda5$var$pastFirstInvertThresh = false, $864e3137db0bdda5$var$isCircumstantialInvert = false, $864e3137db0bdda5$var$targetMoveDistance, // For positioning ghost absolutely
$864e3137db0bdda5$var$ghostRelativeParent, $864e3137db0bdda5$var$ghostRelativeParentInitialScroll = [], // (left, top)
$864e3137db0bdda5$var$_silent = false, $864e3137db0bdda5$var$savedInputChecked = [];
/** @const */ var $864e3137db0bdda5$var$documentExists = typeof document !== "undefined", $864e3137db0bdda5$var$PositionGhostAbsolutely = $864e3137db0bdda5$var$IOS, $864e3137db0bdda5$var$CSSFloatProperty = $864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$864e3137db0bdda5$var$supportDraggable = $864e3137db0bdda5$var$documentExists && !$864e3137db0bdda5$var$ChromeForAndroid && !$864e3137db0bdda5$var$IOS && "draggable" in document.createElement("div"), $864e3137db0bdda5$var$supportCssPointerEvents = function() {
    if (!$864e3137db0bdda5$var$documentExists) return;
    // false when <= IE11
    if ($864e3137db0bdda5$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $864e3137db0bdda5$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $864e3137db0bdda5$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $864e3137db0bdda5$var$getChild(el, 0, options), child2 = $864e3137db0bdda5$var$getChild(el, 1, options), firstChildCSS = child1 && $864e3137db0bdda5$var$css(child1), secondChildCSS = child2 && $864e3137db0bdda5$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $864e3137db0bdda5$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $864e3137db0bdda5$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$864e3137db0bdda5$var$CSSFloatProperty] === "none" || child2 && elCSS[$864e3137db0bdda5$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $864e3137db0bdda5$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $864e3137db0bdda5$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $864e3137db0bdda5$var$sortables.some(function(sortable) {
        var threshold = sortable[$864e3137db0bdda5$var$expando].options.emptyInsertThreshold;
        if (!threshold || $864e3137db0bdda5$var$lastChild(sortable)) return;
        var rect = $864e3137db0bdda5$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $864e3137db0bdda5$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $864e3137db0bdda5$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $864e3137db0bdda5$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$864e3137db0bdda5$var$supportCssPointerEvents && $864e3137db0bdda5$var$ghostEl) $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "display", "none");
}, $864e3137db0bdda5$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$864e3137db0bdda5$var$supportCssPointerEvents && $864e3137db0bdda5$var$ghostEl) $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($864e3137db0bdda5$var$documentExists && !$864e3137db0bdda5$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($864e3137db0bdda5$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $864e3137db0bdda5$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($864e3137db0bdda5$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $864e3137db0bdda5$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$864e3137db0bdda5$var$expando]._onDragOver(event);
        }
    }
};
var $864e3137db0bdda5$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($864e3137db0bdda5$var$dragEl) $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $864e3137db0bdda5$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $864e3137db0bdda5$var$_extends({}, options);
    // Export instance
    el[$864e3137db0bdda5$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $864e3137db0bdda5$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $864e3137db0bdda5$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$864e3137db0bdda5$var$Safari,
        emptyInsertThreshold: 5
    };
    $864e3137db0bdda5$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $864e3137db0bdda5$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $864e3137db0bdda5$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $864e3137db0bdda5$var$on(el, "pointerdown", this._onTapStart);
    else {
        $864e3137db0bdda5$var$on(el, "mousedown", this._onTapStart);
        $864e3137db0bdda5$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $864e3137db0bdda5$var$on(el, "dragover", this);
        $864e3137db0bdda5$var$on(el, "dragenter", this);
    }
    $864e3137db0bdda5$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $864e3137db0bdda5$var$_extends(this, $864e3137db0bdda5$var$AnimationStateManager());
}
$864e3137db0bdda5$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $864e3137db0bdda5$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $864e3137db0bdda5$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $864e3137db0bdda5$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $864e3137db0bdda5$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($864e3137db0bdda5$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $864e3137db0bdda5$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $864e3137db0bdda5$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($864e3137db0bdda5$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $864e3137db0bdda5$var$oldIndex = $864e3137db0bdda5$var$index(target);
        $864e3137db0bdda5$var$oldDraggableIndex = $864e3137db0bdda5$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $864e3137db0bdda5$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $864e3137db0bdda5$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $864e3137db0bdda5$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $864e3137db0bdda5$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$864e3137db0bdda5$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$864e3137db0bdda5$var$dragEl && target.parentNode === el) {
            var dragRect = $864e3137db0bdda5$var$getRect(target);
            $864e3137db0bdda5$var$rootEl = el;
            $864e3137db0bdda5$var$dragEl = target;
            $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl.parentNode;
            $864e3137db0bdda5$var$nextEl = $864e3137db0bdda5$var$dragEl.nextSibling;
            $864e3137db0bdda5$var$lastDownEl = target;
            $864e3137db0bdda5$var$activeGroup = options.group;
            $864e3137db0bdda5$export$31b3ca70d8f57423.dragged = $864e3137db0bdda5$var$dragEl;
            $864e3137db0bdda5$var$tapEvt = {
                target: $864e3137db0bdda5$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $864e3137db0bdda5$var$tapDistanceLeft = $864e3137db0bdda5$var$tapEvt.clientX - dragRect.left;
            $864e3137db0bdda5$var$tapDistanceTop = $864e3137db0bdda5$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $864e3137db0bdda5$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $864e3137db0bdda5$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$864e3137db0bdda5$var$FireFox && _this.nativeDraggable) $864e3137db0bdda5$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $864e3137db0bdda5$var$find($864e3137db0bdda5$var$dragEl, criteria.trim(), $864e3137db0bdda5$var$_disableDraggable);
            });
            $864e3137db0bdda5$var$on(ownerDocument, "dragover", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "mousemove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "touchmove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
            $864e3137db0bdda5$var$on(ownerDocument, "mouseup", _this._onDrop);
            $864e3137db0bdda5$var$on(ownerDocument, "touchend", _this._onDrop);
            $864e3137db0bdda5$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($864e3137db0bdda5$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $864e3137db0bdda5$var$dragEl.draggable = true;
            }
            $864e3137db0bdda5$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess))) {
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $864e3137db0bdda5$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $864e3137db0bdda5$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $864e3137db0bdda5$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $864e3137db0bdda5$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $864e3137db0bdda5$var$dragEl && $864e3137db0bdda5$var$_disableDraggable($864e3137db0bdda5$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $864e3137db0bdda5$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $864e3137db0bdda5$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $864e3137db0bdda5$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $864e3137db0bdda5$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $864e3137db0bdda5$var$on(document, "touchmove", this._onTouchMove);
            else $864e3137db0bdda5$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $864e3137db0bdda5$var$on($864e3137db0bdda5$var$dragEl, "dragend", this);
            $864e3137db0bdda5$var$on($864e3137db0bdda5$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $864e3137db0bdda5$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $864e3137db0bdda5$var$awaitingDragStarted = false;
        if ($864e3137db0bdda5$var$rootEl && $864e3137db0bdda5$var$dragEl) {
            $864e3137db0bdda5$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $864e3137db0bdda5$var$on(document, "dragover", $864e3137db0bdda5$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.dragClass, false);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.ghostClass, true);
            $864e3137db0bdda5$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($864e3137db0bdda5$var$touchEvt) {
            this._lastX = $864e3137db0bdda5$var$touchEvt.clientX;
            this._lastY = $864e3137db0bdda5$var$touchEvt.clientY;
            $864e3137db0bdda5$var$_hideGhostForTarget();
            var target = document.elementFromPoint($864e3137db0bdda5$var$touchEvt.clientX, $864e3137db0bdda5$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($864e3137db0bdda5$var$touchEvt.clientX, $864e3137db0bdda5$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$864e3137db0bdda5$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$864e3137db0bdda5$var$expando]._onDragOver({
                        clientX: $864e3137db0bdda5$var$touchEvt.clientX,
                        clientY: $864e3137db0bdda5$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $864e3137db0bdda5$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($864e3137db0bdda5$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $864e3137db0bdda5$var$ghostEl && $864e3137db0bdda5$var$matrix($864e3137db0bdda5$var$ghostEl, true), scaleX = $864e3137db0bdda5$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $864e3137db0bdda5$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $864e3137db0bdda5$var$PositionGhostAbsolutely && $864e3137db0bdda5$var$ghostRelativeParent && $864e3137db0bdda5$var$getRelativeScrollOffset($864e3137db0bdda5$var$ghostRelativeParent), dx = (touch.clientX - $864e3137db0bdda5$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $864e3137db0bdda5$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $864e3137db0bdda5$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $864e3137db0bdda5$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$864e3137db0bdda5$export$31b3ca70d8f57423.active && !$864e3137db0bdda5$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($864e3137db0bdda5$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($864e3137db0bdda5$var$lastDx || 0);
                    ghostMatrix.f += dy - ($864e3137db0bdda5$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "webkitTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "mozTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "msTransform", cssMatrix);
                $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform", cssMatrix);
                $864e3137db0bdda5$var$lastDx = dx;
                $864e3137db0bdda5$var$lastDy = dy;
                $864e3137db0bdda5$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$864e3137db0bdda5$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $864e3137db0bdda5$var$rootEl, rect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl, true, $864e3137db0bdda5$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($864e3137db0bdda5$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $864e3137db0bdda5$var$ghostRelativeParent = container;
                while($864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostRelativeParent, "position") === "static" && $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostRelativeParent, "transform") === "none" && $864e3137db0bdda5$var$ghostRelativeParent !== document)$864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$ghostRelativeParent.parentNode;
                if ($864e3137db0bdda5$var$ghostRelativeParent !== document.body && $864e3137db0bdda5$var$ghostRelativeParent !== document.documentElement) {
                    if ($864e3137db0bdda5$var$ghostRelativeParent === document) $864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$getWindowScrollingElement();
                    rect.top += $864e3137db0bdda5$var$ghostRelativeParent.scrollTop;
                    rect.left += $864e3137db0bdda5$var$ghostRelativeParent.scrollLeft;
                } else $864e3137db0bdda5$var$ghostRelativeParent = $864e3137db0bdda5$var$getWindowScrollingElement();
                $864e3137db0bdda5$var$ghostRelativeParentInitialScroll = $864e3137db0bdda5$var$getRelativeScrollOffset($864e3137db0bdda5$var$ghostRelativeParent);
            }
            $864e3137db0bdda5$var$ghostEl = $864e3137db0bdda5$var$dragEl.cloneNode(true);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.ghostClass, false);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.fallbackClass, true);
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$ghostEl, options.dragClass, true);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transition", "");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform", "");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "box-sizing", "border-box");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "margin", 0);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "top", rect.top);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "left", rect.left);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "width", rect.width);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "height", rect.height);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "opacity", "0.8");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "position", $864e3137db0bdda5$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "zIndex", "100000");
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "pointerEvents", "none");
            $864e3137db0bdda5$export$31b3ca70d8f57423.ghost = $864e3137db0bdda5$var$ghostEl;
            container.appendChild($864e3137db0bdda5$var$ghostEl);
            // Set transform-origin
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$ghostEl, "transform-origin", $864e3137db0bdda5$var$tapDistanceLeft / parseInt($864e3137db0bdda5$var$ghostEl.style.width) * 100 + "% " + $864e3137db0bdda5$var$tapDistanceTop / parseInt($864e3137db0bdda5$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $864e3137db0bdda5$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $864e3137db0bdda5$var$pluginEvent("setupClone", this);
        if (!$864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            $864e3137db0bdda5$var$cloneEl = $864e3137db0bdda5$var$clone($864e3137db0bdda5$var$dragEl);
            $864e3137db0bdda5$var$cloneEl.removeAttribute("id");
            $864e3137db0bdda5$var$cloneEl.draggable = false;
            $864e3137db0bdda5$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$cloneEl, this.options.chosenClass, false);
            $864e3137db0bdda5$export$31b3ca70d8f57423.clone = $864e3137db0bdda5$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $864e3137db0bdda5$var$_nextTick(function() {
            $864e3137db0bdda5$var$pluginEvent("clone", _this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$dragEl);
            _this._hideClone();
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $864e3137db0bdda5$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $864e3137db0bdda5$var$off(document, "mouseup", _this._onDrop);
            $864e3137db0bdda5$var$off(document, "touchend", _this._onDrop);
            $864e3137db0bdda5$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $864e3137db0bdda5$var$dragEl);
            }
            $864e3137db0bdda5$var$on(document, "drop", _this);
            // #1276 fix:
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$dragEl, "transform", "translateZ(0)");
        }
        $864e3137db0bdda5$var$awaitingDragStarted = true;
        _this._dragStartId = $864e3137db0bdda5$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $864e3137db0bdda5$var$on(document, "selectstart", _this);
        $864e3137db0bdda5$var$moved = true;
        if ($864e3137db0bdda5$var$Safari) $864e3137db0bdda5$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $864e3137db0bdda5$export$31b3ca70d8f57423.active, isOwner = $864e3137db0bdda5$var$activeGroup === group, canSort = options.sort, fromSortable = $864e3137db0bdda5$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($864e3137db0bdda5$var$_silent) return;
        function dragOverEvent(name, extra) {
            $864e3137db0bdda5$var$pluginEvent(name, _this, $864e3137db0bdda5$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, $864e3137db0bdda5$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$putSortable ? $864e3137db0bdda5$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, options.ghostClass, true);
                }
                if ($864e3137db0bdda5$var$putSortable !== _this && _this !== $864e3137db0bdda5$export$31b3ca70d8f57423.active) $864e3137db0bdda5$var$putSortable = _this;
                else if (_this === $864e3137db0bdda5$export$31b3ca70d8f57423.active && $864e3137db0bdda5$var$putSortable) $864e3137db0bdda5$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $864e3137db0bdda5$var$dragEl && !$864e3137db0bdda5$var$dragEl.animated || target === el && !target.animated) $864e3137db0bdda5$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $864e3137db0bdda5$var$dragEl.parentNode[$864e3137db0bdda5$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
            $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
            $864e3137db0bdda5$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $864e3137db0bdda5$var$newIndex,
                newDraggableIndex: $864e3137db0bdda5$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $864e3137db0bdda5$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($864e3137db0bdda5$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $864e3137db0bdda5$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $864e3137db0bdda5$var$parentEl !== $864e3137db0bdda5$var$rootEl // Reverting item into the original list
        ) : $864e3137db0bdda5$var$putSortable === this || (this.lastPutMode = $864e3137db0bdda5$var$activeGroup.checkPull(this, activeSortable, $864e3137db0bdda5$var$dragEl, evt)) && group.checkPut(this, activeSortable, $864e3137db0bdda5$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
                    if ($864e3137db0bdda5$var$nextEl) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$nextEl);
                    else $864e3137db0bdda5$var$rootEl.appendChild($864e3137db0bdda5$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $864e3137db0bdda5$var$lastChild(el, options.draggable);
            if (!elLastChild || $864e3137db0bdda5$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $864e3137db0bdda5$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $864e3137db0bdda5$var$getRect(target);
                if ($864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($864e3137db0bdda5$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($864e3137db0bdda5$var$dragEl);
                    $864e3137db0bdda5$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $864e3137db0bdda5$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $864e3137db0bdda5$var$getChild(el, 0, options, true);
                if (firstChild === $864e3137db0bdda5$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $864e3137db0bdda5$var$getRect(target);
                if ($864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($864e3137db0bdda5$var$dragEl, firstChild);
                    $864e3137db0bdda5$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $864e3137db0bdda5$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $864e3137db0bdda5$var$dragEl.parentNode !== el, differentRowCol = !$864e3137db0bdda5$var$_dragElInRowColumn($864e3137db0bdda5$var$dragEl.animated && $864e3137db0bdda5$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $864e3137db0bdda5$var$isScrolledPast(target, "top", "top") || $864e3137db0bdda5$var$isScrolledPast($864e3137db0bdda5$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($864e3137db0bdda5$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $864e3137db0bdda5$var$pastFirstInvertThresh = false;
                    $864e3137db0bdda5$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $864e3137db0bdda5$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $864e3137db0bdda5$var$isCircumstantialInvert, $864e3137db0bdda5$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $864e3137db0bdda5$var$parentEl.children[dragIndex];
                    }while (sibling && ($864e3137db0bdda5$var$css(sibling, "display") === "none" || sibling === $864e3137db0bdda5$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $864e3137db0bdda5$var$lastTarget = target;
                $864e3137db0bdda5$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $864e3137db0bdda5$var$_onMove($864e3137db0bdda5$var$rootEl, el, $864e3137db0bdda5$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $864e3137db0bdda5$var$_silent = true;
                    setTimeout($864e3137db0bdda5$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($864e3137db0bdda5$var$dragEl);
                    else target.parentNode.insertBefore($864e3137db0bdda5$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $864e3137db0bdda5$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$864e3137db0bdda5$var$isCircumstantialInvert) $864e3137db0bdda5$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $864e3137db0bdda5$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($864e3137db0bdda5$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $864e3137db0bdda5$var$off(document, "mousemove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "touchmove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "pointermove", this._onTouchMove);
        $864e3137db0bdda5$var$off(document, "dragover", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
        $864e3137db0bdda5$var$off(document, "mousemove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
        $864e3137db0bdda5$var$off(document, "touchmove", $864e3137db0bdda5$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $864e3137db0bdda5$var$off(ownerDocument, "mouseup", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "touchend", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "pointerup", this._onDrop);
        $864e3137db0bdda5$var$off(ownerDocument, "touchcancel", this._onDrop);
        $864e3137db0bdda5$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
        $864e3137db0bdda5$var$pluginEvent("drop", this, {
            evt: evt
        });
        $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$dragEl && $864e3137db0bdda5$var$dragEl.parentNode;
        // Get again after plugin event
        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl);
        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl, options.draggable);
        if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $864e3137db0bdda5$var$awaitingDragStarted = false;
        $864e3137db0bdda5$var$isCircumstantialInvert = false;
        $864e3137db0bdda5$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $864e3137db0bdda5$var$_cancelNextTick(this.cloneId);
        $864e3137db0bdda5$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $864e3137db0bdda5$var$off(document, "drop", this);
            $864e3137db0bdda5$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($864e3137db0bdda5$var$Safari) $864e3137db0bdda5$var$css(document.body, "user-select", "");
        $864e3137db0bdda5$var$css($864e3137db0bdda5$var$dragEl, "transform", "");
        if (evt) {
            if ($864e3137db0bdda5$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $864e3137db0bdda5$var$ghostEl && $864e3137db0bdda5$var$ghostEl.parentNode && $864e3137db0bdda5$var$ghostEl.parentNode.removeChild($864e3137db0bdda5$var$ghostEl);
            if ($864e3137db0bdda5$var$rootEl === $864e3137db0bdda5$var$parentEl || $864e3137db0bdda5$var$putSortable && $864e3137db0bdda5$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $864e3137db0bdda5$var$cloneEl && $864e3137db0bdda5$var$cloneEl.parentNode && $864e3137db0bdda5$var$cloneEl.parentNode.removeChild($864e3137db0bdda5$var$cloneEl);
            if ($864e3137db0bdda5$var$dragEl) {
                if (this.nativeDraggable) $864e3137db0bdda5$var$off($864e3137db0bdda5$var$dragEl, "dragend", this);
                $864e3137db0bdda5$var$_disableDraggable($864e3137db0bdda5$var$dragEl);
                $864e3137db0bdda5$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($864e3137db0bdda5$var$moved && !$864e3137db0bdda5$var$awaitingDragStarted) $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$putSortable ? $864e3137db0bdda5$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $864e3137db0bdda5$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $864e3137db0bdda5$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($864e3137db0bdda5$var$rootEl !== $864e3137db0bdda5$var$parentEl) {
                    if ($864e3137db0bdda5$var$newIndex >= 0) {
                        // Add event
                        $864e3137db0bdda5$var$_dispatchEvent({
                            rootEl: $864e3137db0bdda5$var$parentEl,
                            name: "add",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            fromEl: $864e3137db0bdda5$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $864e3137db0bdda5$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $864e3137db0bdda5$var$_dispatchEvent({
                            rootEl: $864e3137db0bdda5$var$parentEl,
                            name: "sort",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            fromEl: $864e3137db0bdda5$var$rootEl,
                            originalEvent: evt
                        });
                        $864e3137db0bdda5$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $864e3137db0bdda5$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $864e3137db0bdda5$var$putSortable && $864e3137db0bdda5$var$putSortable.save();
                } else {
                    if ($864e3137db0bdda5$var$newIndex !== $864e3137db0bdda5$var$oldIndex) {
                        if ($864e3137db0bdda5$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $864e3137db0bdda5$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $864e3137db0bdda5$var$parentEl,
                                originalEvent: evt
                            });
                            $864e3137db0bdda5$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $864e3137db0bdda5$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($864e3137db0bdda5$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($864e3137db0bdda5$var$newIndex == null || $864e3137db0bdda5$var$newIndex === -1) {
                        $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$oldIndex;
                        $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$oldDraggableIndex;
                    }
                    $864e3137db0bdda5$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $864e3137db0bdda5$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $864e3137db0bdda5$var$pluginEvent("nulling", this);
        $864e3137db0bdda5$var$rootEl = $864e3137db0bdda5$var$dragEl = $864e3137db0bdda5$var$parentEl = $864e3137db0bdda5$var$ghostEl = $864e3137db0bdda5$var$nextEl = $864e3137db0bdda5$var$cloneEl = $864e3137db0bdda5$var$lastDownEl = $864e3137db0bdda5$var$cloneHidden = $864e3137db0bdda5$var$tapEvt = $864e3137db0bdda5$var$touchEvt = $864e3137db0bdda5$var$moved = $864e3137db0bdda5$var$newIndex = $864e3137db0bdda5$var$newDraggableIndex = $864e3137db0bdda5$var$oldIndex = $864e3137db0bdda5$var$oldDraggableIndex = $864e3137db0bdda5$var$lastTarget = $864e3137db0bdda5$var$lastDirection = $864e3137db0bdda5$var$putSortable = $864e3137db0bdda5$var$activeGroup = $864e3137db0bdda5$export$31b3ca70d8f57423.dragged = $864e3137db0bdda5$export$31b3ca70d8f57423.ghost = $864e3137db0bdda5$export$31b3ca70d8f57423.clone = $864e3137db0bdda5$export$31b3ca70d8f57423.active = null;
        $864e3137db0bdda5$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $864e3137db0bdda5$var$savedInputChecked.length = $864e3137db0bdda5$var$lastDx = $864e3137db0bdda5$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($864e3137db0bdda5$var$dragEl) {
                    this._onDragOver(evt);
                    $864e3137db0bdda5$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($864e3137db0bdda5$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $864e3137db0bdda5$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($864e3137db0bdda5$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $864e3137db0bdda5$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $864e3137db0bdda5$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $864e3137db0bdda5$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $864e3137db0bdda5$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$864e3137db0bdda5$var$expando] = null;
        $864e3137db0bdda5$var$off(el, "mousedown", this._onTapStart);
        $864e3137db0bdda5$var$off(el, "touchstart", this._onTapStart);
        $864e3137db0bdda5$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $864e3137db0bdda5$var$off(el, "dragover", this);
            $864e3137db0bdda5$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $864e3137db0bdda5$var$sortables.splice($864e3137db0bdda5$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$864e3137db0bdda5$var$cloneHidden) {
            $864e3137db0bdda5$var$pluginEvent("hideClone", this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $864e3137db0bdda5$var$cloneEl.parentNode) $864e3137db0bdda5$var$cloneEl.parentNode.removeChild($864e3137db0bdda5$var$cloneEl);
            $864e3137db0bdda5$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($864e3137db0bdda5$var$cloneHidden) {
            $864e3137db0bdda5$var$pluginEvent("showClone", this);
            if ($864e3137db0bdda5$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($864e3137db0bdda5$var$dragEl.parentNode == $864e3137db0bdda5$var$rootEl && !this.options.group.revertClone) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$dragEl);
            else if ($864e3137db0bdda5$var$nextEl) $864e3137db0bdda5$var$rootEl.insertBefore($864e3137db0bdda5$var$cloneEl, $864e3137db0bdda5$var$nextEl);
            else $864e3137db0bdda5$var$rootEl.appendChild($864e3137db0bdda5$var$cloneEl);
            if (this.options.group.revertClone) this.animate($864e3137db0bdda5$var$dragEl, $864e3137db0bdda5$var$cloneEl);
            $864e3137db0bdda5$var$css($864e3137db0bdda5$var$cloneEl, "display", "");
            $864e3137db0bdda5$var$cloneHidden = false;
        }
    }
};
function $864e3137db0bdda5$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $864e3137db0bdda5$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$864e3137db0bdda5$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$864e3137db0bdda5$var$IE11OrLess && !$864e3137db0bdda5$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $864e3137db0bdda5$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $864e3137db0bdda5$var$_disableDraggable(el) {
    el.draggable = false;
}
function $864e3137db0bdda5$var$_unsilent() {
    $864e3137db0bdda5$var$_silent = false;
}
function $864e3137db0bdda5$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $864e3137db0bdda5$var$getChildContainingRectFromElement(sortable.el, sortable.options, $864e3137db0bdda5$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $864e3137db0bdda5$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $864e3137db0bdda5$var$getChildContainingRectFromElement(sortable.el, sortable.options, $864e3137db0bdda5$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $864e3137db0bdda5$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $864e3137db0bdda5$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$864e3137db0bdda5$var$pastFirstInvertThresh && ($864e3137db0bdda5$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $864e3137db0bdda5$var$pastFirstInvertThresh = true;
            if (!$864e3137db0bdda5$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($864e3137db0bdda5$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $864e3137db0bdda5$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $864e3137db0bdda5$var$targetMoveDistance) return -$864e3137db0bdda5$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $864e3137db0bdda5$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $864e3137db0bdda5$var$_getInsertDirection(target) {
    if ($864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl) < $864e3137db0bdda5$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $864e3137db0bdda5$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $864e3137db0bdda5$var$_saveInputCheckedState(root) {
    $864e3137db0bdda5$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $864e3137db0bdda5$var$savedInputChecked.push(el);
    }
}
function $864e3137db0bdda5$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $864e3137db0bdda5$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($864e3137db0bdda5$var$documentExists) $864e3137db0bdda5$var$on(document, "touchmove", function(evt) {
    if (($864e3137db0bdda5$export$31b3ca70d8f57423.active || $864e3137db0bdda5$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$864e3137db0bdda5$export$31b3ca70d8f57423.utils = {
    on: $864e3137db0bdda5$var$on,
    off: $864e3137db0bdda5$var$off,
    css: $864e3137db0bdda5$var$css,
    find: $864e3137db0bdda5$var$find,
    is: function is(el, selector) {
        return !!$864e3137db0bdda5$var$closest(el, selector, el, false);
    },
    extend: $864e3137db0bdda5$var$extend,
    throttle: $864e3137db0bdda5$var$throttle,
    closest: $864e3137db0bdda5$var$closest,
    toggleClass: $864e3137db0bdda5$var$toggleClass,
    clone: $864e3137db0bdda5$var$clone,
    index: $864e3137db0bdda5$var$index,
    nextTick: $864e3137db0bdda5$var$_nextTick,
    cancelNextTick: $864e3137db0bdda5$var$_cancelNextTick,
    detectDirection: $864e3137db0bdda5$var$_detectDirection,
    getChild: $864e3137db0bdda5$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.get = function(element) {
    return element[$864e3137db0bdda5$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $864e3137db0bdda5$export$31b3ca70d8f57423.utils = $864e3137db0bdda5$var$_objectSpread2($864e3137db0bdda5$var$_objectSpread2({}, $864e3137db0bdda5$export$31b3ca70d8f57423.utils), plugin.utils);
        $864e3137db0bdda5$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $864e3137db0bdda5$export$31b3ca70d8f57423.create = function(el, options) {
    return new $864e3137db0bdda5$export$31b3ca70d8f57423(el, options);
};
// Export
$864e3137db0bdda5$export$31b3ca70d8f57423.version = $864e3137db0bdda5$var$version;
var $864e3137db0bdda5$var$autoScrolls = [], $864e3137db0bdda5$var$scrollEl, $864e3137db0bdda5$var$scrollRootEl, $864e3137db0bdda5$var$scrolling = false, $864e3137db0bdda5$var$lastAutoScrollX, $864e3137db0bdda5$var$lastAutoScrollY, $864e3137db0bdda5$var$touchEvt$1, $864e3137db0bdda5$var$pointerElemChangedInterval;
function $864e3137db0bdda5$export$3fb39aee5567f02e() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $864e3137db0bdda5$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $864e3137db0bdda5$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $864e3137db0bdda5$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $864e3137db0bdda5$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $864e3137db0bdda5$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $864e3137db0bdda5$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $864e3137db0bdda5$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $864e3137db0bdda5$var$clearPointerElemChangedInterval();
            $864e3137db0bdda5$var$clearAutoScrolls();
            $864e3137db0bdda5$var$cancelThrottle();
        },
        nulling: function nulling() {
            $864e3137db0bdda5$var$touchEvt$1 = $864e3137db0bdda5$var$scrollRootEl = $864e3137db0bdda5$var$scrollEl = $864e3137db0bdda5$var$scrolling = $864e3137db0bdda5$var$pointerElemChangedInterval = $864e3137db0bdda5$var$lastAutoScrollX = $864e3137db0bdda5$var$lastAutoScrollY = null;
            $864e3137db0bdda5$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $864e3137db0bdda5$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $864e3137db0bdda5$var$Edge || $864e3137db0bdda5$var$IE11OrLess || $864e3137db0bdda5$var$Safari) {
                $864e3137db0bdda5$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $864e3137db0bdda5$var$getParentAutoScrollElement(elem, true);
                if ($864e3137db0bdda5$var$scrolling && (!$864e3137db0bdda5$var$pointerElemChangedInterval || x !== $864e3137db0bdda5$var$lastAutoScrollX || y !== $864e3137db0bdda5$var$lastAutoScrollY)) {
                    $864e3137db0bdda5$var$pointerElemChangedInterval && $864e3137db0bdda5$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $864e3137db0bdda5$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $864e3137db0bdda5$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $864e3137db0bdda5$var$clearAutoScrolls();
                        }
                        $864e3137db0bdda5$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $864e3137db0bdda5$var$lastAutoScrollX = x;
                    $864e3137db0bdda5$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $864e3137db0bdda5$var$getParentAutoScrollElement(elem, true) === $864e3137db0bdda5$var$getWindowScrollingElement()) {
                    $864e3137db0bdda5$var$clearAutoScrolls();
                    return;
                }
                $864e3137db0bdda5$var$autoScroll(evt, this.options, $864e3137db0bdda5$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $864e3137db0bdda5$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $864e3137db0bdda5$var$clearAutoScrolls() {
    $864e3137db0bdda5$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $864e3137db0bdda5$var$autoScrolls = [];
}
function $864e3137db0bdda5$var$clearPointerElemChangedInterval() {
    clearInterval($864e3137db0bdda5$var$pointerElemChangedInterval);
}
var $864e3137db0bdda5$var$autoScroll = $864e3137db0bdda5$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $864e3137db0bdda5$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($864e3137db0bdda5$var$scrollRootEl !== rootEl) {
        $864e3137db0bdda5$var$scrollRootEl = rootEl;
        $864e3137db0bdda5$var$clearAutoScrolls();
        $864e3137db0bdda5$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($864e3137db0bdda5$var$scrollEl === true) $864e3137db0bdda5$var$scrollEl = $864e3137db0bdda5$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $864e3137db0bdda5$var$scrollEl;
    do {
        var el = currentParent, rect = $864e3137db0bdda5$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $864e3137db0bdda5$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$864e3137db0bdda5$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$864e3137db0bdda5$var$autoScrolls[i]) $864e3137db0bdda5$var$autoScrolls[i] = {};
        }
        if ($864e3137db0bdda5$var$autoScrolls[layersOut].vx != vx || $864e3137db0bdda5$var$autoScrolls[layersOut].vy != vy || $864e3137db0bdda5$var$autoScrolls[layersOut].el !== el) {
            $864e3137db0bdda5$var$autoScrolls[layersOut].el = el;
            $864e3137db0bdda5$var$autoScrolls[layersOut].vx = vx;
            $864e3137db0bdda5$var$autoScrolls[layersOut].vy = vy;
            clearInterval($864e3137db0bdda5$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $864e3137db0bdda5$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $864e3137db0bdda5$export$31b3ca70d8f57423.active._onTouchMove($864e3137db0bdda5$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $864e3137db0bdda5$var$autoScrolls[this.layer].vy ? $864e3137db0bdda5$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $864e3137db0bdda5$var$autoScrolls[this.layer].vx ? $864e3137db0bdda5$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($864e3137db0bdda5$export$31b3ca70d8f57423.dragged.parentNode[$864e3137db0bdda5$var$expando], scrollOffsetX, scrollOffsetY, evt, $864e3137db0bdda5$var$touchEvt$1, $864e3137db0bdda5$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $864e3137db0bdda5$var$scrollBy($864e3137db0bdda5$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $864e3137db0bdda5$var$getParentAutoScrollElement(currentParent, false)));
    $864e3137db0bdda5$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $864e3137db0bdda5$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $864e3137db0bdda5$var$Revert() {}
$864e3137db0bdda5$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $864e3137db0bdda5$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $864e3137db0bdda5$var$drop
};
$864e3137db0bdda5$var$_extends($864e3137db0bdda5$var$Revert, {
    pluginName: "revertOnSpill"
});
function $864e3137db0bdda5$var$Remove() {}
$864e3137db0bdda5$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $864e3137db0bdda5$var$drop
};
$864e3137db0bdda5$var$_extends($864e3137db0bdda5$var$Remove, {
    pluginName: "removeOnSpill"
});
var $864e3137db0bdda5$export$55b3d9f7b2513474 = [
    $864e3137db0bdda5$var$Remove,
    $864e3137db0bdda5$var$Revert
];
var $864e3137db0bdda5$var$lastSwapEl;
function $864e3137db0bdda5$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $864e3137db0bdda5$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $864e3137db0bdda5$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $864e3137db0bdda5$var$toggleClass(target, options.swapClass, true);
                    $864e3137db0bdda5$var$lastSwapEl = target;
                } else $864e3137db0bdda5$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $864e3137db0bdda5$var$lastSwapEl) $864e3137db0bdda5$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $864e3137db0bdda5$var$lastSwapEl && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$lastSwapEl, options.swapClass, false);
            if ($864e3137db0bdda5$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $864e3137db0bdda5$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $864e3137db0bdda5$var$swapNodes(dragEl, $864e3137db0bdda5$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $864e3137db0bdda5$var$lastSwapEl = null;
        }
    };
    return $864e3137db0bdda5$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $864e3137db0bdda5$var$lastSwapEl
            };
        }
    });
}
function $864e3137db0bdda5$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $864e3137db0bdda5$var$index(n1);
    i2 = $864e3137db0bdda5$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $864e3137db0bdda5$var$multiDragElements = [], $864e3137db0bdda5$var$multiDragClones = [], $864e3137db0bdda5$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$864e3137db0bdda5$var$multiDragSortable, $864e3137db0bdda5$var$initialFolding = false, // Initial multi-drag fold when drag started
$864e3137db0bdda5$var$folding = false, // Folding any other time
$864e3137db0bdda5$var$dragStarted = false, $864e3137db0bdda5$var$dragEl$1, $864e3137db0bdda5$var$clonesFromRect, $864e3137db0bdda5$var$clonesHidden;
function $864e3137db0bdda5$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $864e3137db0bdda5$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $864e3137db0bdda5$var$on(document, "mouseup", this._deselectMultiDrag);
                $864e3137db0bdda5$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $864e3137db0bdda5$var$on(document, "keydown", this._checkKeyDown);
        $864e3137db0bdda5$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($864e3137db0bdda5$var$multiDragElements.length && $864e3137db0bdda5$var$multiDragSortable === sortable) $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $864e3137db0bdda5$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $864e3137db0bdda5$var$multiDragElements.length; i++){
                $864e3137db0bdda5$var$multiDragClones.push($864e3137db0bdda5$var$clone($864e3137db0bdda5$var$multiDragElements[i]));
                $864e3137db0bdda5$var$multiDragClones[i].sortableIndex = $864e3137db0bdda5$var$multiDragElements[i].sortableIndex;
                $864e3137db0bdda5$var$multiDragClones[i].draggable = false;
                $864e3137db0bdda5$var$multiDragClones[i].style["will-change"] = "";
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$multiDragClones[i], this.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements[i] === $864e3137db0bdda5$var$dragEl$1 && $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($864e3137db0bdda5$var$multiDragElements.length && $864e3137db0bdda5$var$multiDragSortable === sortable) {
                    $864e3137db0bdda5$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $864e3137db0bdda5$var$insertMultiDragClones(false, rootEl);
            $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                $864e3137db0bdda5$var$css(clone, "display", "");
            });
            cloneNowShown();
            $864e3137db0bdda5$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                $864e3137db0bdda5$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $864e3137db0bdda5$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $864e3137db0bdda5$var$multiDragSortable) $864e3137db0bdda5$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $864e3137db0bdda5$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $864e3137db0bdda5$var$multiDragElements = $864e3137db0bdda5$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $864e3137db0bdda5$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1, false, true, true);
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$setRect(multiDragElement, dragRect);
                    });
                    $864e3137db0bdda5$var$folding = true;
                    $864e3137db0bdda5$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$initialFolding = false;
                if (_this2.options.animation) $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                    $864e3137db0bdda5$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $864e3137db0bdda5$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($864e3137db0bdda5$var$folding && ~$864e3137db0bdda5$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($864e3137db0bdda5$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $864e3137db0bdda5$var$folding ? $864e3137db0bdda5$var$getRect(multiDragElement) : dragRect
                    });
                    $864e3137db0bdda5$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $864e3137db0bdda5$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $864e3137db0bdda5$var$multiDragElements.length > 1 && ($864e3137db0bdda5$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1, false, true, true);
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
                        $864e3137db0bdda5$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $864e3137db0bdda5$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$864e3137db0bdda5$var$folding) $864e3137db0bdda5$var$removeMultiDragElements();
                    if ($864e3137db0bdda5$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $864e3137db0bdda5$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$864e3137db0bdda5$var$clonesHidden && clonesHiddenBefore) $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $864e3137db0bdda5$var$clonesFromRect
                            });
                            clone.fromRect = $864e3137db0bdda5$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $864e3137db0bdda5$var$clonesFromRect = $864e3137db0bdda5$var$_extends({}, dragRect);
                var dragMatrix = $864e3137db0bdda5$var$matrix($864e3137db0bdda5$var$dragEl$1, true);
                $864e3137db0bdda5$var$clonesFromRect.top -= dragMatrix.f;
                $864e3137db0bdda5$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($864e3137db0bdda5$var$folding) {
                $864e3137db0bdda5$var$folding = false;
                $864e3137db0bdda5$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$864e3137db0bdda5$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $864e3137db0bdda5$var$toggleClass($864e3137db0bdda5$var$dragEl$1, options.selectedClass, !~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1));
                if (!~$864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1)) {
                    $864e3137db0bdda5$var$multiDragElements.push($864e3137db0bdda5$var$dragEl$1);
                    $864e3137db0bdda5$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $864e3137db0bdda5$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $864e3137db0bdda5$var$lastMultiDragSelect && sortable.el.contains($864e3137db0bdda5$var$lastMultiDragSelect)) {
                        var lastIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$lastMultiDragSelect), currentIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$864e3137db0bdda5$var$multiDragElements.indexOf(children[i])) continue;
                                $864e3137db0bdda5$var$toggleClass(children[i], options.selectedClass, true);
                                $864e3137db0bdda5$var$multiDragElements.push(children[i]);
                                $864e3137db0bdda5$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $864e3137db0bdda5$var$lastMultiDragSelect = $864e3137db0bdda5$var$dragEl$1;
                    $864e3137db0bdda5$var$multiDragSortable = toSortable;
                } else {
                    $864e3137db0bdda5$var$multiDragElements.splice($864e3137db0bdda5$var$multiDragElements.indexOf($864e3137db0bdda5$var$dragEl$1), 1);
                    $864e3137db0bdda5$var$lastMultiDragSelect = null;
                    $864e3137db0bdda5$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $864e3137db0bdda5$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($864e3137db0bdda5$var$dragStarted && this.isMultiDrag) {
                $864e3137db0bdda5$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$864e3137db0bdda5$var$expando].options.sort || parentEl !== rootEl) && $864e3137db0bdda5$var$multiDragElements.length > 1) {
                    var dragRect = $864e3137db0bdda5$var$getRect($864e3137db0bdda5$var$dragEl$1), multiDragIndex = $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$864e3137db0bdda5$var$initialFolding && options.animation) $864e3137db0bdda5$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$864e3137db0bdda5$var$initialFolding) {
                        if (options.animation) {
                            $864e3137db0bdda5$var$dragEl$1.fromRect = dragRect;
                            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $864e3137db0bdda5$var$dragEl$1) {
                                    var rect = $864e3137db0bdda5$var$folding ? $864e3137db0bdda5$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $864e3137db0bdda5$var$removeMultiDragElements();
                        $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $864e3137db0bdda5$var$index($864e3137db0bdda5$var$dragEl$1)) {
                            var update = false;
                            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $864e3137db0bdda5$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                        $864e3137db0bdda5$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $864e3137db0bdda5$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $864e3137db0bdda5$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $864e3137db0bdda5$var$dragStarted = false;
            $864e3137db0bdda5$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $864e3137db0bdda5$var$off(document, "pointerup", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "mouseup", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "touchend", this._deselectMultiDrag);
            $864e3137db0bdda5$var$off(document, "keydown", this._checkKeyDown);
            $864e3137db0bdda5$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $864e3137db0bdda5$var$dragStarted !== "undefined" && $864e3137db0bdda5$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($864e3137db0bdda5$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $864e3137db0bdda5$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($864e3137db0bdda5$var$multiDragElements.length){
                var el = $864e3137db0bdda5$var$multiDragElements[0];
                $864e3137db0bdda5$var$toggleClass(el, this.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements.shift();
                $864e3137db0bdda5$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $864e3137db0bdda5$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$864e3137db0bdda5$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$864e3137db0bdda5$var$multiDragElements.indexOf(el)) return;
                if ($864e3137db0bdda5$var$multiDragSortable && $864e3137db0bdda5$var$multiDragSortable !== sortable) {
                    $864e3137db0bdda5$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $864e3137db0bdda5$var$multiDragSortable = sortable;
                }
                $864e3137db0bdda5$var$toggleClass(el, sortable.options.selectedClass, true);
                $864e3137db0bdda5$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$864e3137db0bdda5$var$expando], index = $864e3137db0bdda5$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $864e3137db0bdda5$var$toggleClass(el, sortable.options.selectedClass, false);
                $864e3137db0bdda5$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($864e3137db0bdda5$var$folding && multiDragElement !== $864e3137db0bdda5$var$dragEl$1) newIndex = -1;
                else if ($864e3137db0bdda5$var$folding) newIndex = $864e3137db0bdda5$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $864e3137db0bdda5$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $864e3137db0bdda5$var$_toConsumableArray($864e3137db0bdda5$var$multiDragElements),
                clones: [].concat($864e3137db0bdda5$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $864e3137db0bdda5$var$insertMultiDragElements(clonesInserted, rootEl) {
    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $864e3137db0bdda5$var$insertMultiDragClones(elementsInserted, rootEl) {
    $864e3137db0bdda5$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $864e3137db0bdda5$var$removeMultiDragElements() {
    $864e3137db0bdda5$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $864e3137db0bdda5$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
var $864e3137db0bdda5$export$2e2bcd8739ae039 = $864e3137db0bdda5$export$31b3ca70d8f57423;





class $00e16369510e6292$export$3f10bfc286408f86 {
    constructor(){
        this.init = (dropzoneElement, dropzoneOptions, csrf, dataToLoad, onDataSave)=>{
            this.url = dropzoneOptions.url;
            this.urlPreview = dropzoneOptions.urlPreview || dropzoneOptions.url;
            this.onDataSave = onDataSave;
            this.uploadPhotos = dropzoneElement;
            this.uploadPhotosDropzone = new (0, $c180364cf43a262f$export$2e2bcd8739ae039)(this.uploadPhotos, dropzoneOptions);
            this.populateExistingData(dataToLoad);
            this.addSortability();
            this.uploadPhotosDropzone.on("sending", (file, xhr, formData)=>{
                formData.append("_csrf", csrf);
            });
            this.uploadPhotosDropzone.on("success", (file, response)=>{
                file.upload.key = response;
                let thumbnailUrl = this.urlPreview + "/" + response;
                file.dataURL = thumbnailUrl;
                this.uploadPhotosDropzone.emit("thumbnail", file, thumbnailUrl);
                this.updatePhotoData();
            });
            this.uploadPhotosDropzone.on("removedfile", (file)=>{
                this.updatePhotoData();
                if (!file || !file.upload || !file.upload.key) return;
                // Call endpoint and remove photo if it's not used anywhere else
                fetch(this.url + "/" + file.upload.key, {
                    method: "DELETE",
                    body: JSON.stringify({
                        _csrf: csrf
                    })
                }).then((response)=>{
                // Ignore
                }).catch((error)=>{
                // Ignore
                });
            });
        };
        this.updatePhotoData = ()=>{
            let photos = [];
            for (let file of this.uploadPhotosDropzone.files){
                if (!file || !file.upload || !file.upload.key) continue;
                let data = {
                    key: file.upload.key,
                    name: file.upload.filename,
                    sizeBytes: file.upload.total
                };
                photos.push(data);
            }
            if ($00e16369510e6292$export$3f10bfc286408f86.DEBUG) console.info("Dropzone keys order: ", photos);
            let photosData = JSON.stringify(photos);
            if (this.onDataSave) this.onDataSave(photosData);
        };
        this.populateExistingData = (dataToLoad)=>{
            if (!!dataToLoad && dataToLoad.length > 0) {
                if (typeof dataToLoad === "string") dataToLoad = JSON.parse(dataToLoad);
            } else dataToLoad = [];
            for (let data of dataToLoad){
                let url = this.urlPreview + "/" + data.key;
                let mimeType = data.mimetype;
                if (mimeType) {
                    if (!mimeType.includes("image")) mimeType = "image/" + mimeType;
                } else mimeType = "image/*";
                let file = {
                    key: data.key,
                    name: data.name,
                    size: data.sizeBytes,
                    type: mimeType,
                    status: (0, $c180364cf43a262f$export$2e2bcd8739ae039).ADDED,
                    url: url,
                    upload: {
                        key: data.key,
                        filename: data.name,
                        total: data.sizeBytes
                    }
                };
                this.uploadPhotosDropzone.files.push(file);
                this.uploadPhotosDropzone.emit("addedfile", file);
                this.uploadPhotosDropzone.emit("thumbnail", file, url);
                this.uploadPhotosDropzone.emit("complete", file);
            }
        };
        this.addSortability = ()=>{
            let sortable = new (0, $864e3137db0bdda5$export$2e2bcd8739ae039)(this.uploadPhotos, {
                draggable: ".dz-preview",
                animation: 150,
                onStart: (evt)=>{
                    evt.item.dataset.dragStartPos = evt.oldIndex.toString();
                },
                onSort: (evt)=>{
                    evt.item.dataset.dragFinishPos = evt.newIndex.toString();
                    let startPos = Number(evt.item.dataset.dragStartPos) - 1;
                    let finishPos = Number(evt.item.dataset.dragFinishPos) - 1;
                    startPos = Math.max(0, startPos);
                    finishPos = Math.min(this.uploadPhotosDropzone.files.length - 1, finishPos);
                    if ($00e16369510e6292$export$3f10bfc286408f86.DEBUG) console.info("Moved from:: ", startPos, " to ", finishPos);
                    // Move files
                    let element = this.uploadPhotosDropzone.files[startPos];
                    this.uploadPhotosDropzone.files.splice(startPos, 1);
                    this.uploadPhotosDropzone.files.splice(finishPos, 0, element);
                    this.updatePhotoData();
                }
            });
        };
    }
}
$00e16369510e6292$export$3f10bfc286408f86.DEBUG = false;
$00e16369510e6292$export$3f10bfc286408f86.setupDropzones = ()=>{
    const dropzones = document.querySelectorAll(".component-dropzone");
    if (dropzones && dropzones.length > 0) {
        const csrf = document.querySelector("input[name='_csrf']").getAttribute("value");
        for (const dropzone of dropzones){
            const dropzoneOrdered = new $00e16369510e6292$export$3f10bfc286408f86();
            const name = dropzone.getAttribute("data-name");
            var _dropzone_getAttribute, _dropzone_getAttribute1, _dropzone_getAttribute2, _dropzone_getAttribute3, _dropzone_getAttribute4;
            dropzoneOrdered.init(dropzone, {
                url: (_dropzone_getAttribute = dropzone.getAttribute("data-url")) !== null && _dropzone_getAttribute !== void 0 ? _dropzone_getAttribute : location.pathname,
                acceptedFiles: (_dropzone_getAttribute1 = dropzone.getAttribute("data-accepted-files")) !== null && _dropzone_getAttribute1 !== void 0 ? _dropzone_getAttribute1 : "*/*",
                paramName: dropzone.getAttribute("data-name"),
                addRemoveLinks: dropzone.getAttribute("data-add-remove-links") == "true",
                parallelUploads: parseInt((_dropzone_getAttribute2 = dropzone.getAttribute("data-parallel-uploads")) !== null && _dropzone_getAttribute2 !== void 0 ? _dropzone_getAttribute2 : "5"),
                maxFilesize: parseInt((_dropzone_getAttribute3 = dropzone.getAttribute("data-max-file-size-mb")) !== null && _dropzone_getAttribute3 !== void 0 ? _dropzone_getAttribute3 : "1"),
                maxFiles: parseInt((_dropzone_getAttribute4 = dropzone.getAttribute("data-max-files")) !== null && _dropzone_getAttribute4 !== void 0 ? _dropzone_getAttribute4 : "10")
            }, csrf, document.querySelector("input[name='" + name + "']").getAttribute("value"), (data)=>{
                document.querySelector("input[name='" + name + "']").setAttribute("value", data);
            });
        }
    }
};


var $e2e66a1c8132829f$exports = {};
!function(t, e) {
    $e2e66a1c8132829f$exports = e();
}($e2e66a1c8132829f$exports, function() {
    "use strict";
    class t {
        constructor(t){
            t || (t = {}), this.main = t.main || "ss-main", this.placeholder = t.placeholder || "ss-placeholder", this.values = t.values || "ss-values", this.single = t.single || "ss-single", this.max = t.max || "ss-max", this.value = t.value || "ss-value", this.valueText = t.valueText || "ss-value-text", this.valueDelete = t.valueDelete || "ss-value-delete", this.valueOut = t.valueOut || "ss-value-out", this.deselect = t.deselect || "ss-deselect", this.deselectPath = t.deselectPath || "M10,10 L90,90 M10,90 L90,10", this.arrow = t.arrow || "ss-arrow", this.arrowClose = t.arrowClose || "M10,30 L50,70 L90,30", this.arrowOpen = t.arrowOpen || "M10,70 L50,30 L90,70", this.content = t.content || "ss-content", this.openAbove = t.openAbove || "ss-open-above", this.openBelow = t.openBelow || "ss-open-below", this.search = t.search || "ss-search", this.searchHighlighter = t.searchHighlighter || "ss-search-highlight", this.searching = t.searching || "ss-searching", this.addable = t.addable || "ss-addable", this.addablePath = t.addablePath || "M50,10 L50,90 M10,50 L90,50", this.list = t.list || "ss-list", this.optgroup = t.optgroup || "ss-optgroup", this.optgroupLabel = t.optgroupLabel || "ss-optgroup-label", this.optgroupLabelText = t.optgroupLabelText || "ss-optgroup-label-text", this.optgroupActions = t.optgroupActions || "ss-optgroup-actions", this.optgroupSelectAll = t.optgroupSelectAll || "ss-selectall", this.optgroupSelectAllBox = t.optgroupSelectAllBox || "M60,10 L10,10 L10,90 L90,90 L90,50", this.optgroupSelectAllCheck = t.optgroupSelectAllCheck || "M30,45 L50,70 L90,10", this.optgroupClosable = t.optgroupClosable || "ss-closable", this.option = t.option || "ss-option", this.optionDelete = t.optionDelete || "M10,10 L90,90 M10,90 L90,10", this.highlighted = t.highlighted || "ss-highlighted", this.open = t.open || "ss-open", this.close = t.close || "ss-close", this.selected = t.selected || "ss-selected", this.error = t.error || "ss-error", this.disabled = t.disabled || "ss-disabled", this.hide = t.hide || "ss-hide";
        }
    }
    function e() {
        return Math.random().toString(36).substring(2, 10);
    }
    function s(t, e = 50, s = !1) {
        let i;
        return function(...n) {
            const a = self, l = s && !i;
            clearTimeout(i), i = setTimeout(()=>{
                i = null, s || t.apply(a, n);
            }, e), l && t.apply(a, n);
        };
    }
    function i(t, e) {
        return JSON.stringify(t) === JSON.stringify(e);
    }
    class n {
        constructor(t){
            if (this.id = t.id && "" !== t.id ? t.id : e(), this.label = t.label || "", this.selectAll = void 0 !== t.selectAll && t.selectAll, this.selectAllText = t.selectAllText || "Select All", this.closable = t.closable || "off", this.options = [], t.options) for (const e of t.options)this.options.push(new a(e));
        }
    }
    class a {
        constructor(t){
            this.id = t.id && "" !== t.id ? t.id : e(), this.value = void 0 === t.value ? t.text : t.value, this.text = t.text || "", this.html = t.html || "", this.defaultSelected = void 0 !== t.defaultSelected && t.defaultSelected, this.selected = void 0 !== t.selected && t.selected, this.display = void 0 === t.display || t.display, this.disabled = void 0 !== t.disabled && t.disabled, this.mandatory = void 0 !== t.mandatory && t.mandatory, this.placeholder = void 0 !== t.placeholder && t.placeholder, this.class = t.class || "", this.style = t.style || "", this.data = t.data || {};
        }
    }
    class l {
        validateDataArray(t) {
            if (!Array.isArray(t)) return new Error("Data must be an array");
            for (let e of t)if (e instanceof n || "label" in e) {
                if (!("label" in e)) return new Error("Optgroup must have a label");
                if ("options" in e && e.options) for (let t of e.options){
                    const e = this.validateOption(t);
                    if (e) return e;
                }
            } else {
                if (!(e instanceof a || "text" in e)) return new Error("Data object must be a valid optgroup or option");
                {
                    const t = this.validateOption(e);
                    if (t) return t;
                }
            }
            return null;
        }
        validateOption(t) {
            return "text" in t ? null : new Error("Option must have a text");
        }
        partialToFullData(t) {
            let e = [];
            return t.forEach((t)=>{
                if (t instanceof n || "label" in t) {
                    let s = [];
                    "options" in t && t.options && t.options.forEach((t)=>{
                        s.push(new a(t));
                    }), s.length > 0 && e.push(new n(t));
                }
                (t instanceof a || "text" in t) && e.push(new a(t));
            }), e;
        }
        setData(t) {
            this.data = this.partialToFullData(t), "single" === this.selectType && this.setSelectedBy("id", this.getSelected());
        }
        getData() {
            return this.filter(null, !0);
        }
        getDataOptions() {
            return this.filter(null, !1);
        }
        addOption(t, e = !1) {
            if (e) {
                let e = [
                    new a(t)
                ];
                this.setData(e.concat(this.getData()));
            } else this.setData(this.getData().concat(new a(t)));
        }
        setSelectedBy(t, e) {
            let s = null, i = !1;
            const l = [];
            for (let o of this.data){
                if (o instanceof n) for (let n of o.options)s || (s = n), n.selected = !i && e.includes(n[t]), n.selected && (l.push(n), "single" === this.selectType && (i = !0));
                o instanceof a && (s || (s = o), o.selected = !i && e.includes(o[t]), o.selected && (l.push(o), "single" === this.selectType && (i = !0)));
            }
            "single" === this.selectType && s && !i && (s.selected = !0, l.push(s));
            const o = e.map((e)=>{
                var s;
                return (null === (s = l.find((s)=>s[t] === e)) || void 0 === s ? void 0 : s.id) || "";
            });
            this.selectedOrder = o;
        }
        getSelected() {
            return this.getSelectedOptions().map((t)=>t.id);
        }
        getSelectedValues() {
            return this.getSelectedOptions().map((t)=>t.value);
        }
        getSelectedOptions() {
            return this.filter((t)=>t.selected, !1);
        }
        getOptgroupByID(t) {
            for (let e of this.data)if (e instanceof n && e.id === t) return e;
            return null;
        }
        getOptionByID(t) {
            let e = this.filter((e)=>e.id === t, !1);
            return e.length ? e[0] : null;
        }
        getSelectType() {
            return this.selectType;
        }
        getFirstOption() {
            let t = null;
            for (let e of this.data)if (e instanceof n ? t = e.options[0] : e instanceof a && (t = e), t) break;
            return t;
        }
        search(t, e) {
            return "" === (t = t.trim()) ? this.getData() : this.filter((s)=>e(s, t), !0);
        }
        filter(t, e) {
            const s = [];
            return this.data.forEach((i)=>{
                if (i instanceof n) {
                    let l = [];
                    if (i.options.forEach((i)=>{
                        t && !t(i) || (e ? l.push(new a(i)) : s.push(new a(i)));
                    }), l.length > 0) {
                        let t = new n(i);
                        t.options = l, s.push(t);
                    }
                }
                i instanceof a && (t && !t(i) || s.push(new a(i)));
            }), s;
        }
        selectedOrderOptions(t) {
            const e = [];
            return this.selectedOrder.forEach((s)=>{
                const i = t.find((t)=>t.id === s);
                i && e.push(i);
            }), t.forEach((t)=>{
                let s = !1;
                e.forEach((e)=>{
                    t.id !== e.id || (s = !0);
                }), s || e.push(t);
            }), e;
        }
        constructor(t, e){
            this.selectType = "single", this.data = [], this.selectedOrder = [], this.selectType = t, this.setData(e);
        }
    }
    class o {
        enable() {
            this.main.main.classList.remove(this.classes.disabled), this.content.search.input.disabled = !1;
        }
        disable() {
            this.main.main.classList.add(this.classes.disabled), this.content.search.input.disabled = !0;
        }
        open() {
            this.main.arrow.path.setAttribute("d", this.classes.arrowOpen), this.main.main.classList.add("up" === this.settings.openPosition ? this.classes.openAbove : this.classes.openBelow), this.main.main.setAttribute("aria-expanded", "true"), this.moveContent();
            const t = this.store.getSelectedOptions();
            if (t.length) {
                const e = t[t.length - 1].id, s = this.content.list.querySelector('[data-id="' + e + '"]');
                s && this.ensureElementInView(this.content.list, s);
            }
        }
        close() {
            this.main.main.classList.remove(this.classes.openAbove), this.main.main.classList.remove(this.classes.openBelow), this.main.main.setAttribute("aria-expanded", "false"), this.content.main.classList.remove(this.classes.openAbove), this.content.main.classList.remove(this.classes.openBelow), this.main.arrow.path.setAttribute("d", this.classes.arrowClose);
        }
        updateClassStyles() {
            if (this.main.main.className = "", this.main.main.removeAttribute("style"), this.content.main.className = "", this.content.main.removeAttribute("style"), this.main.main.classList.add(this.classes.main), this.content.main.classList.add(this.classes.content), "" !== this.settings.style && (this.main.main.style.cssText = this.settings.style, this.content.main.style.cssText = this.settings.style), this.settings.class.length) for (const t of this.settings.class)"" !== t.trim() && (this.main.main.classList.add(t.trim()), this.content.main.classList.add(t.trim()));
            "relative" !== this.settings.contentPosition && "fixed" !== this.settings.contentPosition || this.content.main.classList.add("ss-" + this.settings.contentPosition);
        }
        updateAriaAttributes() {
            var t;
            this.main.main.role = "combobox", this.main.main.setAttribute("aria-haspopup", "listbox"), this.main.main.setAttribute("aria-controls", null !== (t = this.content.main.dataset.id) && void 0 !== t ? t : ""), this.main.main.setAttribute("aria-expanded", "false"), this.content.main.setAttribute("role", "listbox");
        }
        mainDiv() {
            var t;
            const e = document.createElement("div");
            e.dataset.id = this.settings.id, e.setAttribute("aria-label", this.settings.ariaLabel), e.tabIndex = 0, e.onkeydown = (t)=>{
                switch(t.key){
                    case "ArrowUp":
                    case "ArrowDown":
                        return this.callbacks.open(), "ArrowDown" === t.key ? this.highlight("down") : this.highlight("up"), !1;
                    case "Tab":
                        return this.callbacks.close(), !0;
                    case "Enter":
                    case " ":
                        this.callbacks.open();
                        const e = this.content.list.querySelector("." + this.classes.highlighted);
                        return e && e.click(), !1;
                    case "Escape":
                        return this.callbacks.close(), !1;
                }
                return 1 === t.key.length && this.callbacks.open(), !0;
            }, e.onclick = (t)=>{
                this.settings.disabled || (this.settings.isOpen ? this.callbacks.close() : this.callbacks.open());
            };
            const s = document.createElement("div");
            s.classList.add(this.classes.values), e.appendChild(s);
            const i = document.createElement("div");
            i.classList.add(this.classes.deselect);
            const n = null === (t = this.store) || void 0 === t ? void 0 : t.getSelectedOptions();
            !this.settings.allowDeselect || this.settings.isMultiple && n && n.length <= 0 ? i.classList.add(this.classes.hide) : i.classList.remove(this.classes.hide), i.onclick = (t)=>{
                if (t.stopPropagation(), this.settings.disabled) return;
                let e = !0;
                const s = this.store.getSelectedOptions(), i = [];
                if (this.callbacks.beforeChange && (e = !0 === this.callbacks.beforeChange(i, s)), e) {
                    if (this.settings.isMultiple) this.callbacks.setSelected([], !1), this.updateDeselectAll();
                    else {
                        const t = this.store.getFirstOption(), e = t ? t.id : "";
                        this.callbacks.setSelected(e, !1);
                    }
                    this.settings.closeOnSelect && this.callbacks.close(), this.callbacks.afterChange && this.callbacks.afterChange(this.store.getSelectedOptions());
                }
            };
            const a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            a.setAttribute("viewBox", "0 0 100 100");
            const l = document.createElementNS("http://www.w3.org/2000/svg", "path");
            l.setAttribute("d", this.classes.deselectPath), a.appendChild(l), i.appendChild(a), e.appendChild(i);
            const o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            o.classList.add(this.classes.arrow), o.setAttribute("viewBox", "0 0 100 100");
            const c = document.createElementNS("http://www.w3.org/2000/svg", "path");
            return c.setAttribute("d", this.classes.arrowClose), this.settings.alwaysOpen && o.classList.add(this.classes.hide), o.appendChild(c), e.appendChild(o), {
                main: e,
                values: s,
                deselect: {
                    main: i,
                    svg: a,
                    path: l
                },
                arrow: {
                    main: o,
                    path: c
                }
            };
        }
        mainFocus(t) {
            "click" !== t && this.main.main.focus({
                preventScroll: !0
            });
        }
        placeholder() {
            const t = this.store.filter((t)=>t.placeholder, !1);
            let e = this.settings.placeholderText;
            t.length && ("" !== t[0].html ? e = t[0].html : "" !== t[0].text && (e = t[0].text));
            const s = document.createElement("div");
            return s.classList.add(this.classes.placeholder), s.innerHTML = e, s;
        }
        renderValues() {
            this.settings.isMultiple ? (this.renderMultipleValues(), this.updateDeselectAll()) : this.renderSingleValue();
        }
        renderSingleValue() {
            const t = this.store.filter((t)=>t.selected && !t.placeholder, !1), e = t.length > 0 ? t[0] : null;
            if (e) {
                const t = document.createElement("div");
                t.classList.add(this.classes.single), e.html ? t.innerHTML = e.html : t.innerText = e.text, this.main.values.innerHTML = t.outerHTML;
            } else this.main.values.innerHTML = this.placeholder().outerHTML;
            this.settings.allowDeselect && t.length ? this.main.deselect.main.classList.remove(this.classes.hide) : this.main.deselect.main.classList.add(this.classes.hide);
        }
        renderMultipleValues() {
            let t = this.main.values.childNodes, e = this.store.filter((t)=>t.selected && t.display, !1);
            if (0 === e.length) return void (this.main.values.innerHTML = this.placeholder().outerHTML);
            {
                const t = this.main.values.querySelector("." + this.classes.placeholder);
                t && t.remove();
            }
            if (e.length > this.settings.maxValuesShown) {
                const t = document.createElement("div");
                return t.classList.add(this.classes.max), t.textContent = this.settings.maxValuesMessage.replace("{number}", e.length.toString()), void (this.main.values.innerHTML = t.outerHTML);
            }
            {
                const t = this.main.values.querySelector("." + this.classes.max);
                t && t.remove();
            }
            this.settings.keepOrder && (e = this.store.selectedOrderOptions(e));
            let s = [];
            for(let i = 0; i < t.length; i++){
                const n = t[i], a = n.getAttribute("data-id");
                if (a) e.filter((t)=>t.id === a, !1).length || s.push(n);
            }
            for (const t of s)t.classList.add(this.classes.valueOut), setTimeout(()=>{
                this.main.values.hasChildNodes() && this.main.values.contains(t) && this.main.values.removeChild(t);
            }, 100);
            t = this.main.values.childNodes;
            for(let s = 0; s < e.length; s++){
                let i = !0;
                for(let n = 0; n < t.length; n++)e[s].id === String(t[n].dataset.id) && (i = !1);
                i && (this.settings.keepOrder || 0 === t.length ? this.main.values.appendChild(this.multipleValue(e[s])) : 0 === s ? this.main.values.insertBefore(this.multipleValue(e[s]), t[s]) : t[s - 1].insertAdjacentElement("afterend", this.multipleValue(e[s])));
            }
        }
        multipleValue(t) {
            const e = document.createElement("div");
            e.classList.add(this.classes.value), e.dataset.id = t.id;
            const s = document.createElement("div");
            if (s.classList.add(this.classes.valueText), s.textContent = t.text, e.appendChild(s), !t.mandatory) {
                const s = document.createElement("div");
                s.classList.add(this.classes.valueDelete), s.setAttribute("tabindex", "0"), s.onclick = (e)=>{
                    if (e.preventDefault(), e.stopPropagation(), this.settings.disabled) return;
                    let s = !0;
                    const i = this.store.getSelectedOptions(), l = i.filter((e)=>e.selected && e.id !== t.id, !0);
                    if (!(this.settings.minSelected && l.length < this.settings.minSelected) && (this.callbacks.beforeChange && (s = !0 === this.callbacks.beforeChange(l, i)), s)) {
                        let t = [];
                        for (const e of l){
                            if (e instanceof n) for (const s of e.options)t.push(s.id);
                            e instanceof a && t.push(e.id);
                        }
                        this.callbacks.setSelected(t, !1), this.settings.closeOnSelect && this.callbacks.close(), this.callbacks.afterChange && this.callbacks.afterChange(l), this.updateDeselectAll();
                    }
                };
                const i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                i.setAttribute("viewBox", "0 0 100 100");
                const l = document.createElementNS("http://www.w3.org/2000/svg", "path");
                l.setAttribute("d", this.classes.optionDelete), i.appendChild(l), s.appendChild(i), e.appendChild(s), s.onkeydown = (t)=>{
                    "Enter" === t.key && s.click();
                };
            }
            return e;
        }
        contentDiv() {
            const t = document.createElement("div");
            t.dataset.id = this.settings.id;
            const e = this.searchDiv();
            t.appendChild(e.main);
            const s = this.listDiv();
            return t.appendChild(s), {
                main: t,
                search: e,
                list: s
            };
        }
        moveContent() {
            "relative" !== this.settings.contentPosition && "down" !== this.settings.openPosition ? "up" !== this.settings.openPosition ? "up" === this.putContent() ? this.moveContentAbove() : this.moveContentBelow() : this.moveContentAbove() : this.moveContentBelow();
        }
        searchDiv() {
            const t = document.createElement("div"), e = document.createElement("input"), i = document.createElement("div");
            t.classList.add(this.classes.search);
            const n = {
                main: t,
                input: e
            };
            if (this.settings.showSearch || (t.classList.add(this.classes.hide), e.readOnly = !0), e.type = "search", e.placeholder = this.settings.searchPlaceholder, e.tabIndex = -1, e.setAttribute("aria-label", this.settings.searchPlaceholder), e.setAttribute("autocapitalize", "off"), e.setAttribute("autocomplete", "off"), e.setAttribute("autocorrect", "off"), e.oninput = s((t)=>{
                this.callbacks.search(t.target.value);
            }, 100), e.onkeydown = (t)=>{
                switch(t.key){
                    case "ArrowUp":
                    case "ArrowDown":
                        return "ArrowDown" === t.key ? this.highlight("down") : this.highlight("up"), !1;
                    case "Tab":
                        return this.callbacks.close(), !0;
                    case "Escape":
                        return this.callbacks.close(), !1;
                    case " ":
                        const e = this.content.list.querySelector("." + this.classes.highlighted);
                        return !e || (e.click(), !1);
                    case "Enter":
                        if (this.callbacks.addable) return i.click(), !1;
                        {
                            const t = this.content.list.querySelector("." + this.classes.highlighted);
                            if (t) return t.click(), !1;
                        }
                        return !0;
                }
                return !0;
            }, t.appendChild(e), this.callbacks.addable) {
                i.classList.add(this.classes.addable);
                const e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                e.setAttribute("viewBox", "0 0 100 100");
                const s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                s.setAttribute("d", this.classes.addablePath), e.appendChild(s), i.appendChild(e), i.onclick = (t)=>{
                    if (t.preventDefault(), t.stopPropagation(), !this.callbacks.addable) return;
                    const e = this.content.search.input.value.trim();
                    if ("" === e) return void this.content.search.input.focus();
                    const s = (t)=>{
                        let e = new a(t);
                        if (this.callbacks.addOption(e), this.settings.isMultiple) {
                            let t = this.store.getSelected();
                            t.push(e.id), this.callbacks.setSelected(t, !0);
                        } else this.callbacks.setSelected([
                            e.id
                        ], !0);
                        this.callbacks.search(""), this.settings.closeOnSelect && setTimeout(()=>{
                            this.callbacks.close();
                        }, 100);
                    }, i = this.callbacks.addable(e);
                    !1 !== i && null != i && (i instanceof Promise ? i.then((t)=>{
                        "string" == typeof t ? s({
                            text: t,
                            value: t
                        }) : i instanceof Error ? this.renderError(i.message) : s(t);
                    }) : "string" == typeof i ? s({
                        text: i,
                        value: i
                    }) : i instanceof Error ? this.renderError(i.message) : s(i));
                }, t.appendChild(i), n.addable = {
                    main: i,
                    svg: e,
                    path: s
                };
            }
            return n;
        }
        searchFocus() {
            this.content.search.input.focus();
        }
        getOptions(t = !1, e = !1, s = !1) {
            let i = "." + this.classes.option;
            return t && (i += ":not(." + this.classes.placeholder + ")"), e && (i += ":not(." + this.classes.disabled + ")"), s && (i += ":not(." + this.classes.hide + ")"), Array.from(this.content.list.querySelectorAll(i));
        }
        highlight(t) {
            const e = this.getOptions(!0, !0, !0);
            if (0 === e.length) return;
            if (1 === e.length && !e[0].classList.contains(this.classes.highlighted)) return void e[0].classList.add(this.classes.highlighted);
            let s = !1;
            for (const t of e)t.classList.contains(this.classes.highlighted) && (s = !0);
            if (!s) {
                for (const t of e)if (t.classList.contains(this.classes.selected)) {
                    t.classList.add(this.classes.highlighted);
                    break;
                }
            }
            for(let s = 0; s < e.length; s++)if (e[s].classList.contains(this.classes.highlighted)) {
                const i = e[s];
                i.classList.remove(this.classes.highlighted);
                const n = i.parentElement;
                if (n && n.classList.contains(this.classes.open)) {
                    const t = n.querySelector("." + this.classes.optgroupLabel);
                    t && t.click();
                }
                let a = e["down" === t ? s + 1 < e.length ? s + 1 : 0 : s - 1 >= 0 ? s - 1 : e.length - 1];
                a.classList.add(this.classes.highlighted), this.ensureElementInView(this.content.list, a);
                const l = a.parentElement;
                if (l && l.classList.contains(this.classes.close)) {
                    const t = l.querySelector("." + this.classes.optgroupLabel);
                    t && t.click();
                }
                return;
            }
            e["down" === t ? 0 : e.length - 1].classList.add(this.classes.highlighted), this.ensureElementInView(this.content.list, e["down" === t ? 0 : e.length - 1]);
        }
        listDiv() {
            const t = document.createElement("div");
            return t.classList.add(this.classes.list), t;
        }
        renderError(t) {
            this.content.list.innerHTML = "";
            const e = document.createElement("div");
            e.classList.add(this.classes.error), e.textContent = t, this.content.list.appendChild(e);
        }
        renderSearching() {
            this.content.list.innerHTML = "";
            const t = document.createElement("div");
            t.classList.add(this.classes.searching), t.textContent = this.settings.searchingText, this.content.list.appendChild(t);
        }
        renderOptions(t) {
            if (this.content.list.innerHTML = "", 0 === t.length) {
                const t = document.createElement("div");
                return t.classList.add(this.classes.search), this.callbacks.addable ? t.innerHTML = this.settings.addableText.replace("{value}", this.content.search.input.value) : t.innerHTML = this.settings.searchText, void this.content.list.appendChild(t);
            }
            if (this.settings.allowDeselect && !this.settings.isMultiple) this.store.filter((t)=>t.placeholder, !1).length || this.store.addOption(new a({
                text: "",
                value: "",
                selected: !1,
                placeholder: !0
            }), !0);
            const e = document.createDocumentFragment();
            for (const s of t){
                if (s instanceof n) {
                    const t = document.createElement("div");
                    t.classList.add(this.classes.optgroup);
                    const i = document.createElement("div");
                    i.classList.add(this.classes.optgroupLabel), t.appendChild(i);
                    const n = document.createElement("div");
                    n.classList.add(this.classes.optgroupLabelText), n.textContent = s.label, i.appendChild(n);
                    const a = document.createElement("div");
                    if (a.classList.add(this.classes.optgroupActions), i.appendChild(a), this.settings.isMultiple && s.selectAll) {
                        const t = document.createElement("div");
                        t.classList.add(this.classes.optgroupSelectAll);
                        let e = !0;
                        for (const t of s.options)if (!t.selected) {
                            e = !1;
                            break;
                        }
                        e && t.classList.add(this.classes.selected);
                        const i = document.createElement("span");
                        i.textContent = s.selectAllText, t.appendChild(i);
                        const n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        n.setAttribute("viewBox", "0 0 100 100"), t.appendChild(n);
                        const l = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        l.setAttribute("d", this.classes.optgroupSelectAllBox), n.appendChild(l);
                        const o = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        o.setAttribute("d", this.classes.optgroupSelectAllCheck), n.appendChild(o), t.addEventListener("click", (t)=>{
                            t.preventDefault(), t.stopPropagation();
                            const i = this.store.getSelected();
                            if (e) {
                                const t = i.filter((t)=>{
                                    for (const e of s.options)if (t === e.id) return !1;
                                    return !0;
                                });
                                this.callbacks.setSelected(t, !0);
                            } else {
                                const t = i.concat(s.options.map((t)=>t.id));
                                for (const t of s.options)this.store.getOptionByID(t.id) || this.callbacks.addOption(t);
                                this.callbacks.setSelected(t, !0);
                            }
                        }), a.appendChild(t);
                    }
                    if ("off" !== s.closable) {
                        const e = document.createElement("div");
                        e.classList.add(this.classes.optgroupClosable);
                        const n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                        n.setAttribute("viewBox", "0 0 100 100"), n.classList.add(this.classes.arrow), e.appendChild(n);
                        const l = document.createElementNS("http://www.w3.org/2000/svg", "path");
                        n.appendChild(l), s.options.some((t)=>t.selected) || "" !== this.content.search.input.value.trim() ? (e.classList.add(this.classes.open), l.setAttribute("d", this.classes.arrowOpen)) : "open" === s.closable ? (t.classList.add(this.classes.open), l.setAttribute("d", this.classes.arrowOpen)) : "close" === s.closable && (t.classList.add(this.classes.close), l.setAttribute("d", this.classes.arrowClose)), i.addEventListener("click", (e)=>{
                            e.preventDefault(), e.stopPropagation(), t.classList.contains(this.classes.close) ? (t.classList.remove(this.classes.close), t.classList.add(this.classes.open), l.setAttribute("d", this.classes.arrowOpen)) : (t.classList.remove(this.classes.open), t.classList.add(this.classes.close), l.setAttribute("d", this.classes.arrowClose));
                        }), a.appendChild(e);
                    }
                    t.appendChild(i);
                    for (const i of s.options)t.appendChild(this.option(i)), e.appendChild(t);
                }
                s instanceof a && e.appendChild(this.option(s));
            }
            this.content.list.appendChild(e);
        }
        option(t) {
            if (t.placeholder) {
                const t = document.createElement("div");
                return t.classList.add(this.classes.option), t.classList.add(this.classes.hide), t;
            }
            const e = document.createElement("div");
            return e.dataset.id = t.id, e.classList.add(this.classes.option), e.setAttribute("role", "option"), t.class && t.class.split(" ").forEach((t)=>{
                e.classList.add(t);
            }), t.style && (e.style.cssText = t.style), this.settings.searchHighlight && "" !== this.content.search.input.value.trim() ? e.innerHTML = this.highlightText("" !== t.html ? t.html : t.text, this.content.search.input.value, this.classes.searchHighlighter) : "" !== t.html ? e.innerHTML = t.html : e.textContent = t.text, this.settings.showOptionTooltips && e.textContent && e.setAttribute("title", e.textContent), t.display || e.classList.add(this.classes.hide), t.disabled && e.classList.add(this.classes.disabled), t.selected && this.settings.hideSelected && e.classList.add(this.classes.hide), t.selected ? (e.classList.add(this.classes.selected), e.setAttribute("aria-selected", "true"), this.main.main.setAttribute("aria-activedescendant", e.id)) : (e.classList.remove(this.classes.selected), e.setAttribute("aria-selected", "false")), e.addEventListener("click", (e)=>{
                e.preventDefault(), e.stopPropagation();
                const s = this.store.getSelected(), i = e.currentTarget, n = String(i.dataset.id);
                if (t.disabled || t.selected && !this.settings.allowDeselect) return;
                if (this.settings.isMultiple && this.settings.maxSelected <= s.length && !t.selected || this.settings.isMultiple && this.settings.minSelected >= s.length && t.selected) return;
                let a = !1;
                const l = this.store.getSelectedOptions();
                let o = [];
                if (this.settings.isMultiple) {
                    if (t.selected) o = l.filter((t)=>t.id !== n);
                    else if (o = l.concat(t), !this.settings.closeOnSelect) {
                        if (e.shiftKey && this.lastSelectedOption) {
                            const e = this.store.getDataOptions();
                            let s = e.findIndex((t)=>t.id === this.lastSelectedOption.id), i = e.findIndex((e)=>e.id === t.id);
                            if (s >= 0 && i >= 0) {
                                const t = Math.min(s, i), n = Math.max(s, i), a = e.slice(t, n + 1);
                                a.length > 0 && a.length < this.settings.maxSelected && (o = l.concat(a.filter((t)=>!l.find((e)=>e.id === t.id))));
                            }
                        } else t.selected || (this.lastSelectedOption = t);
                    }
                }
                this.settings.isMultiple || (o = t.selected ? [] : [
                    t
                ]), this.callbacks.beforeChange || (a = !0), this.callbacks.beforeChange && (a = !1 !== this.callbacks.beforeChange(o, l)), a && (this.store.getOptionByID(n) || this.callbacks.addOption(t), this.callbacks.setSelected(o.map((t)=>t.id), !1), this.settings.closeOnSelect && this.callbacks.close(), this.callbacks.afterChange && this.callbacks.afterChange(o));
            }), e;
        }
        destroy() {
            this.main.main.remove(), this.content.main.remove();
        }
        highlightText(t, e, s) {
            let i = t;
            const n = new RegExp("(?![^<]*>)(" + e.trim() + ")(?![^<]*>[^<>]*</)", "i");
            if (!t.match(n)) return t;
            const a = t.match(n).index, l = a + t.match(n)[0].toString().length, o = t.substring(a, l);
            return i = i.replace(n, `<mark class="${s}">${o}</mark>`), i;
        }
        moveContentAbove() {
            const t = this.main.main.offsetHeight, e = this.content.main.offsetHeight;
            this.main.main.classList.remove(this.classes.openBelow), this.main.main.classList.add(this.classes.openAbove), this.content.main.classList.remove(this.classes.openBelow), this.content.main.classList.add(this.classes.openAbove);
            const s = this.main.main.getBoundingClientRect();
            this.content.main.style.margin = "-" + (t + e - 1) + "px 0px 0px 0px", this.content.main.style.top = s.top + s.height + ("fixed" === this.settings.contentPosition ? 0 : window.scrollY) + "px", this.content.main.style.left = s.left + ("fixed" === this.settings.contentPosition ? 0 : window.scrollX) + "px", this.content.main.style.width = s.width + "px";
        }
        moveContentBelow() {
            this.main.main.classList.remove(this.classes.openAbove), this.main.main.classList.add(this.classes.openBelow), this.content.main.classList.remove(this.classes.openAbove), this.content.main.classList.add(this.classes.openBelow);
            const t = this.main.main.getBoundingClientRect();
            this.content.main.style.margin = "-1px 0px 0px 0px", "relative" !== this.settings.contentPosition && (this.content.main.style.top = t.top + t.height + ("fixed" === this.settings.contentPosition ? 0 : window.scrollY) + "px", this.content.main.style.left = t.left + ("fixed" === this.settings.contentPosition ? 0 : window.scrollX) + "px", this.content.main.style.width = t.width + "px");
        }
        ensureElementInView(t, e) {
            const s = t.scrollTop + t.offsetTop, i = s + t.clientHeight, n = e.offsetTop, a = n + e.clientHeight;
            n < s ? t.scrollTop -= s - n : a > i && (t.scrollTop += a - i);
        }
        putContent() {
            const t = this.main.main.offsetHeight, e = this.main.main.getBoundingClientRect(), s = this.content.main.offsetHeight;
            return window.innerHeight - (e.top + t) <= s && e.top > s ? "up" : "down";
        }
        updateDeselectAll() {
            if (!this.store || !this.settings) return;
            const t = this.store.getSelectedOptions(), e = t && t.length > 0, s = this.settings.isMultiple, i = this.settings.allowDeselect, n = this.main.deselect.main, a = this.classes.hide;
            !i || s && !e ? n.classList.add(a) : n.classList.remove(a);
        }
        constructor(t, e, s, i){
            this.store = s, this.settings = t, this.classes = e, this.callbacks = i, this.lastSelectedOption = null, this.main = this.mainDiv(), this.content = this.contentDiv(), this.updateClassStyles(), this.updateAriaAttributes(), this.settings.contentLocation && this.settings.contentLocation.appendChild(this.content.main);
        }
    }
    class c {
        enable() {
            this.select.disabled = !1;
        }
        disable() {
            this.select.disabled = !0;
        }
        hideUI() {
            this.select.tabIndex = -1, this.select.style.display = "none", this.select.setAttribute("aria-hidden", "true");
        }
        showUI() {
            this.select.removeAttribute("tabindex"), this.select.style.display = "", this.select.removeAttribute("aria-hidden");
        }
        changeListen(t) {
            this.listen = t, t && this.observer && this.observer.observe(this.select, {
                subtree: !0,
                childList: !0,
                attributes: !0
            }), t || this.observer && this.observer.disconnect();
        }
        valueChange(t) {
            return this.listen && this.onValueChange && this.onValueChange(this.getSelectedOptions()), !0;
        }
        observeCall(t) {
            if (!this.listen) return;
            let e = !1, s = !1, i = !1;
            for (const n of t){
                if (n.target === this.select && ("disabled" === n.attributeName && (s = !0), "class" === n.attributeName && (e = !0), "childList" === n.type)) {
                    for (const t of n.addedNodes)if ("OPTION" === t.nodeName && t.value === this.select.value) {
                        this.select.dispatchEvent(new Event("change"));
                        break;
                    }
                    i = !0;
                }
                "OPTGROUP" !== n.target.nodeName && "OPTION" !== n.target.nodeName || (i = !0);
            }
            e && this.onClassChange && this.onClassChange(this.select.className.split(" ")), s && this.onDisabledChange && (this.changeListen(!1), this.onDisabledChange(this.select.disabled), this.changeListen(!0)), i && this.onOptionsChange && (this.changeListen(!1), this.onOptionsChange(this.getData()), this.changeListen(!0));
        }
        getData() {
            let t = [];
            const e = this.select.childNodes;
            for (const s of e)"OPTGROUP" === s.nodeName && t.push(this.getDataFromOptgroup(s)), "OPTION" === s.nodeName && t.push(this.getDataFromOption(s));
            return t;
        }
        getDataFromOptgroup(t) {
            let e = {
                id: t.id,
                label: t.label,
                selectAll: !!t.dataset && "true" === t.dataset.selectall,
                selectAllText: t.dataset ? t.dataset.selectalltext : "Select all",
                closable: t.dataset ? t.dataset.closable : "off",
                options: []
            };
            const s = t.childNodes;
            for (const t of s)"OPTION" === t.nodeName && e.options.push(this.getDataFromOption(t));
            return e;
        }
        getDataFromOption(t) {
            return {
                id: t.id,
                value: t.value,
                text: t.text,
                html: t.dataset && t.dataset.html ? t.dataset.html : "",
                defaultSelected: t.defaultSelected,
                selected: t.selected,
                display: "none" !== t.style.display,
                disabled: t.disabled,
                mandatory: !!t.dataset && "true" === t.dataset.mandatory,
                placeholder: "true" === t.dataset.placeholder,
                class: t.className,
                style: t.style.cssText,
                data: t.dataset
            };
        }
        getSelectedOptions() {
            let t = [];
            const e = this.select.childNodes;
            for (const s of e){
                if ("OPTGROUP" === s.nodeName) {
                    const e = s.childNodes;
                    for (const s of e)if ("OPTION" === s.nodeName) {
                        const e = s;
                        e.selected && t.push(this.getDataFromOption(e));
                    }
                }
                if ("OPTION" === s.nodeName) {
                    const e = s;
                    e.selected && t.push(this.getDataFromOption(e));
                }
            }
            return t;
        }
        getSelectedValues() {
            return this.getSelectedOptions().map((t)=>t.value);
        }
        setSelected(t) {
            this.changeListen(!1);
            const e = this.select.childNodes;
            for (const s of e){
                if ("OPTGROUP" === s.nodeName) {
                    const e = s.childNodes;
                    for (const s of e)if ("OPTION" === s.nodeName) {
                        const e = s;
                        e.selected = t.includes(e.id);
                    }
                }
                if ("OPTION" === s.nodeName) {
                    const e = s;
                    e.selected = t.includes(e.id);
                }
            }
            this.changeListen(!0);
        }
        setSelectedByValue(t) {
            this.changeListen(!1);
            const e = this.select.childNodes;
            for (const s of e){
                if ("OPTGROUP" === s.nodeName) {
                    const e = s.childNodes;
                    for (const s of e)if ("OPTION" === s.nodeName) {
                        const e = s;
                        e.selected = t.includes(e.value);
                    }
                }
                if ("OPTION" === s.nodeName) {
                    const e = s;
                    e.selected = t.includes(e.value);
                }
            }
            this.changeListen(!0);
        }
        updateSelect(t, e, s) {
            this.changeListen(!1), t && (this.select.dataset.id = t), e && (this.select.style.cssText = e), s && (this.select.className = "", s.forEach((t)=>{
                "" !== t.trim() && this.select.classList.add(t.trim());
            })), this.changeListen(!0);
        }
        updateOptions(t) {
            this.changeListen(!1), this.select.innerHTML = "";
            for (const e of t)e instanceof n && this.select.appendChild(this.createOptgroup(e)), e instanceof a && this.select.appendChild(this.createOption(e));
            this.select.dispatchEvent(new Event("change", {
                bubbles: !0
            })), this.changeListen(!0);
        }
        createOptgroup(t) {
            const e = document.createElement("optgroup");
            if (e.id = t.id, e.label = t.label, t.selectAll && (e.dataset.selectAll = "true"), "off" !== t.closable && (e.dataset.closable = t.closable), t.options) for (const s of t.options)e.appendChild(this.createOption(s));
            return e;
        }
        createOption(t) {
            const e = document.createElement("option");
            return e.id = t.id, e.value = t.value, e.textContent = t.text, "" !== t.html && e.setAttribute("data-html", t.html), e.defaultSelected = t.defaultSelected, e.selected = t.selected, t.disabled && (e.disabled = !0), t.display || (e.style.display = "none"), t.placeholder && e.setAttribute("data-placeholder", "true"), t.mandatory && e.setAttribute("data-mandatory", "true"), t.class && t.class.split(" ").forEach((t)=>{
                e.classList.add(t);
            }), t.data && "object" == typeof t.data && Object.keys(t.data).forEach((s)=>{
                e.setAttribute("data-" + function(t) {
                    const e = t.replace(/[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g, (t)=>"-" + t.toLowerCase());
                    return t[0] === t[0].toUpperCase() ? e.substring(1) : e;
                }(s), t.data[s]);
            }), e;
        }
        destroy() {
            this.changeListen(!1), this.select.removeEventListener("change", this.valueChange), this.observer && (this.observer.disconnect(), this.observer = null), delete this.select.dataset.id, this.showUI();
        }
        constructor(t){
            this.listen = !1, this.observer = null, this.select = t, this.valueChange = this.valueChange.bind(this), this.select.addEventListener("change", this.valueChange, {
                passive: !0
            }), this.observer = new MutationObserver(this.observeCall.bind(this)), this.changeListen(!0);
        }
    }
    class h {
        constructor(t){
            this.id = "", this.style = "", this.class = [], this.isMultiple = !1, this.isOpen = !1, this.isFullOpen = !1, this.intervalMove = null, t || (t = {}), this.id = "ss-" + e(), this.style = t.style || "", this.class = t.class || [], this.disabled = void 0 !== t.disabled && t.disabled, this.alwaysOpen = void 0 !== t.alwaysOpen && t.alwaysOpen, this.showSearch = void 0 === t.showSearch || t.showSearch, this.focusSearch = void 0 === t.focusSearch || t.focusSearch, this.ariaLabel = t.ariaLabel || "Combobox", this.searchPlaceholder = t.searchPlaceholder || "Search", this.searchText = t.searchText || "No Results", this.searchingText = t.searchingText || "Searching...", this.searchHighlight = void 0 !== t.searchHighlight && t.searchHighlight, this.closeOnSelect = void 0 === t.closeOnSelect || t.closeOnSelect, this.contentLocation = t.contentLocation || document.body, this.contentPosition = t.contentPosition || "absolute", this.openPosition = t.openPosition || "auto", this.placeholderText = void 0 !== t.placeholderText ? t.placeholderText : "Select Value", this.allowDeselect = void 0 !== t.allowDeselect && t.allowDeselect, this.hideSelected = void 0 !== t.hideSelected && t.hideSelected, this.keepOrder = void 0 !== t.keepOrder && t.keepOrder, this.showOptionTooltips = void 0 !== t.showOptionTooltips && t.showOptionTooltips, this.minSelected = t.minSelected || 0, this.maxSelected = t.maxSelected || 1e3, this.timeoutDelay = t.timeoutDelay || 200, this.maxValuesShown = t.maxValuesShown || 20, this.maxValuesMessage = t.maxValuesMessage || "{number} selected", this.addableText = t.addableText || 'Press "Enter" to add {value}';
        }
    }
    return class {
        enable() {
            this.settings.disabled = !1, this.select.enable(), this.render.enable();
        }
        disable() {
            this.settings.disabled = !0, this.select.disable(), this.render.disable();
        }
        getData() {
            return this.store.getData();
        }
        setData(t) {
            const e = this.store.getSelected(), s = this.store.validateDataArray(t);
            if (s) return void (this.events.error && this.events.error(s));
            this.store.setData(t);
            const n = this.store.getData();
            this.select.updateOptions(n), this.render.renderValues(), this.render.renderOptions(n), this.events.afterChange && !i(e, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions());
        }
        getSelected() {
            let t = this.store.getSelectedOptions();
            return this.settings.keepOrder && (t = this.store.selectedOrderOptions(t)), t.map((t)=>t.value);
        }
        setSelected(t, e = !0) {
            const s = this.store.getSelected(), n = this.store.getDataOptions();
            t = Array.isArray(t) ? t : [
                t
            ];
            const a = [];
            for (const e of t)if (n.find((t)=>t.id == e)) a.push(e);
            else for (const t of n.filter((t)=>t.value == e))a.push(t.id);
            this.store.setSelectedBy("id", a);
            const l = this.store.getData();
            this.select.updateOptions(l), this.render.renderValues(), "" !== this.render.content.search.input.value ? this.search(this.render.content.search.input.value) : this.render.renderOptions(l), e && this.events.afterChange && !i(s, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions());
        }
        addOption(t) {
            const e = this.store.getSelected();
            this.store.getDataOptions().some((e)=>{
                var s;
                return e.value === (null !== (s = t.value) && void 0 !== s ? s : t.text);
            }) || this.store.addOption(t);
            const s = this.store.getData();
            this.select.updateOptions(s), this.render.renderValues(), this.render.renderOptions(s), this.events.afterChange && !i(e, this.store.getSelected()) && this.events.afterChange(this.store.getSelectedOptions());
        }
        open() {
            this.settings.disabled || this.settings.isOpen || (this.events.beforeOpen && this.events.beforeOpen(), this.render.open(), this.settings.showSearch && this.settings.focusSearch && this.render.searchFocus(), this.settings.isOpen = !0, setTimeout(()=>{
                this.events.afterOpen && this.events.afterOpen(), this.settings.isOpen && (this.settings.isFullOpen = !0), document.addEventListener("click", this.documentClick);
            }, this.settings.timeoutDelay), "absolute" === this.settings.contentPosition && (this.settings.intervalMove && clearInterval(this.settings.intervalMove), this.settings.intervalMove = setInterval(this.render.moveContent.bind(this.render), 500)));
        }
        close(t = null) {
            this.settings.isOpen && !this.settings.alwaysOpen && (this.events.beforeClose && this.events.beforeClose(), this.render.close(), "" !== this.render.content.search.input.value && this.search(""), this.render.mainFocus(t), this.settings.isOpen = !1, this.settings.isFullOpen = !1, setTimeout(()=>{
                this.events.afterClose && this.events.afterClose(), document.removeEventListener("click", this.documentClick);
            }, this.settings.timeoutDelay), this.settings.intervalMove && clearInterval(this.settings.intervalMove));
        }
        search(t) {
            if (this.render.content.search.input.value !== t && (this.render.content.search.input.value = t), !this.events.search) return void this.render.renderOptions("" === t ? this.store.getData() : this.store.search(t, this.events.searchFilter));
            this.render.renderSearching();
            const e = this.events.search(t, this.store.getSelectedOptions());
            e instanceof Promise ? e.then((t)=>{
                this.render.renderOptions(this.store.partialToFullData(t));
            }).catch((t)=>{
                this.render.renderError("string" == typeof t ? t : t.message);
            }) : Array.isArray(e) ? this.render.renderOptions(this.store.partialToFullData(e)) : this.render.renderError("Search event must return a promise or an array of data");
        }
        destroy() {
            document.removeEventListener("click", this.documentClick), window.removeEventListener("resize", this.windowResize, !1), "auto" === this.settings.openPosition && window.removeEventListener("scroll", this.windowScroll, !1), document.removeEventListener("visibilitychange", this.windowVisibilityChange), this.store.setData([]), this.render.destroy(), this.select.destroy();
        }
        constructor(e){
            var i;
            if (this.events = {
                search: void 0,
                searchFilter: (t, e)=>-1 !== t.text.toLowerCase().indexOf(e.toLowerCase()),
                addable: void 0,
                beforeChange: void 0,
                afterChange: void 0,
                beforeOpen: void 0,
                afterOpen: void 0,
                beforeClose: void 0,
                afterClose: void 0
            }, this.windowResize = s(()=>{
                (this.settings.isOpen || this.settings.isFullOpen) && this.render.moveContent();
            }), this.windowScroll = s(()=>{
                (this.settings.isOpen || this.settings.isFullOpen) && this.render.moveContent();
            }), this.documentClick = (t)=>{
                this.settings.isOpen && t.target && !function(t, e) {
                    function s(t, s) {
                        return s && t && t.classList && t.classList.contains(s) || s && t && t.dataset && t.dataset.id && t.dataset.id === e ? t : null;
                    }
                    return s(t, e) || function t(e, i) {
                        return e && e !== document ? s(e, i) ? e : t(e.parentNode, i) : null;
                    }(t, e);
                }(t.target, this.settings.id) && this.close(t.type);
            }, this.windowVisibilityChange = ()=>{
                document.hidden && this.close();
            }, this.selectEl = "string" == typeof e.select ? document.querySelector(e.select) : e.select, !this.selectEl) return void (e.events && e.events.error && e.events.error(new Error("Could not find select element")));
            if ("SELECT" !== this.selectEl.tagName) return void (e.events && e.events.error && e.events.error(new Error("Element isnt of type select")));
            this.selectEl.dataset.ssid && this.destroy(), this.settings = new h(e.settings), this.cssClasses = new t(e.cssClasses);
            const n = [
                "afterChange",
                "beforeOpen",
                "afterOpen",
                "beforeClose",
                "afterClose"
            ];
            for(const t in e.events)e.events.hasOwnProperty(t) && (-1 !== n.indexOf(t) ? this.events[t] = s(e.events[t], 100) : this.events[t] = e.events[t]);
            this.settings.disabled = (null === (i = e.settings) || void 0 === i ? void 0 : i.disabled) ? e.settings.disabled : this.selectEl.disabled, this.settings.isMultiple = this.selectEl.multiple, this.settings.style = this.selectEl.style.cssText, this.settings.class = this.selectEl.className.split(" "), this.select = new c(this.selectEl), this.select.updateSelect(this.settings.id, this.settings.style, this.settings.class), this.select.hideUI(), this.select.onValueChange = (t)=>{
                this.setSelected(t.map((t)=>t.id));
            }, this.select.onClassChange = (t)=>{
                this.settings.class = t, this.render.updateClassStyles();
            }, this.select.onDisabledChange = (t)=>{
                t ? this.disable() : this.enable();
            }, this.select.onOptionsChange = (t)=>{
                this.setData(t);
            }, this.store = new l(this.settings.isMultiple ? "multiple" : "single", e.data ? e.data : this.select.getData()), e.data && this.select.updateOptions(this.store.getData());
            const a = {
                open: this.open.bind(this),
                close: this.close.bind(this),
                addable: this.events.addable ? this.events.addable : void 0,
                setSelected: this.setSelected.bind(this),
                addOption: this.addOption.bind(this),
                search: this.search.bind(this),
                beforeChange: this.events.beforeChange,
                afterChange: this.events.afterChange
            };
            this.render = new o(this.settings, this.cssClasses, this.store, a), this.render.renderValues(), this.render.renderOptions(this.store.getData());
            const r = this.selectEl.getAttribute("aria-label"), d = this.selectEl.getAttribute("aria-labelledby");
            r ? this.render.main.main.setAttribute("aria-label", r) : d && this.render.main.main.setAttribute("aria-labelledby", d), this.selectEl.parentNode && this.selectEl.parentNode.insertBefore(this.render.main.main, this.selectEl.nextSibling), window.addEventListener("resize", this.windowResize, !1), "auto" === this.settings.openPosition && window.addEventListener("scroll", this.windowScroll, !1), document.addEventListener("visibilitychange", this.windowVisibilityChange), this.settings.disabled && this.disable(), this.settings.alwaysOpen && this.open(), this.selectEl.slim = this;
        }
    };
});


var $23aee52180e1383d$exports = {};
/** Cookies EU banner v2.0.1 by Alex-D - alex-d.github.io/Cookies-EU-banner/ - MIT License */ !function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define([], t) : $23aee52180e1383d$exports = t();
}(window, function() {
    "use strict";
    var i, u = window.document;
    return (i = function(e, t, o, n) {
        if (!(this instanceof i)) return new i(e);
        this.cookieTimeout = 33696e6, this.bots = /bot|crawler|spider|crawling/i, this.cookieName = "hasConsent", this.trackingCookiesNames = [
            "__utma",
            "__utmb",
            "__utmc",
            "__utmt",
            "__utmv",
            "__utmz",
            "_ga",
            "_gat",
            "_gid"
        ], this.launchFunction = e, this.waitAccept = t || !1, this.useLocalStorage = o || !1, this.init();
    }).prototype = {
        init: function() {
            var e = this.bots.test(navigator.userAgent), t = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
            return e || !(null == t || t && "yes" !== t && 1 !== t && "1" !== t) || !1 === this.hasConsent() ? (this.removeBanner(0), !1) : !0 === this.hasConsent() ? (this.launchFunction(), !0) : (this.showBanner(), void (this.waitAccept || this.setConsent(!0)));
        },
        showBanner: function() {
            var e = this, t = u.getElementById.bind(u), o = t("cookies-eu-banner"), n = t("cookies-eu-reject"), i = t("cookies-eu-accept"), s = t("cookies-eu-more"), a = void 0 === o.dataset.waitRemove ? 0 : parseInt(o.dataset.waitRemove), c = this.addClickListener, r = e.removeBanner.bind(e, a);
            o.style.display = "block", s && c(s, function() {
                e.deleteCookie(e.cookieName);
            }), i && c(i, function() {
                r(), e.setConsent(!0), e.launchFunction();
            }), n && c(n, function() {
                r(), e.setConsent(!1), e.trackingCookiesNames.map(e.deleteCookie);
            });
        },
        setConsent: function(e) {
            if (this.useLocalStorage) return localStorage.setItem(this.cookieName, e);
            this.setCookie(this.cookieName, e);
        },
        hasConsent: function() {
            function e(e) {
                return -1 < u.cookie.indexOf(t + "=" + e) || localStorage.getItem(t) === e;
            }
            var t = this.cookieName;
            return !!e("true") || !e("false") && null;
        },
        setCookie: function(e, t) {
            var o = new Date;
            o.setTime(o.getTime() + this.cookieTimeout), u.cookie = e + "=" + t + ";expires=" + o.toGMTString() + ";path=/";
        },
        deleteCookie: function(e) {
            var t = u.location.hostname.replace(/^www\./, ""), o = "; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
            u.cookie = e + "=; domain=." + t + o, u.cookie = e + "=" + o;
        },
        addClickListener: function(e, t) {
            if (e.attachEvent) return e.attachEvent("onclick", t);
            e.addEventListener("click", t);
        },
        removeBanner: function(e) {
            setTimeout(function() {
                var e = u.getElementById("cookies-eu-banner");
                e && e.parentNode && e.parentNode.removeChild(e);
            }, e);
        }
    }, i;
});


// Copyright (C) Konrad Gadzinowski

const $d9aa5c6b16d90faa$export$2b77a92f1a5ad772 = (0, (/*@__PURE__*/$parcel$interopDefault($e7f07339a0167292$exports))).Modal;
const $d9aa5c6b16d90faa$export$931cbfb6bfb85fc = (0, (/*@__PURE__*/$parcel$interopDefault($e7f07339a0167292$exports))).Dropdown;
const $d9aa5c6b16d90faa$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($e7f07339a0167292$exports))).Tooltip;
const $d9aa5c6b16d90faa$export$8d8dc7d5f743331b = (0, (/*@__PURE__*/$parcel$interopDefault($e7f07339a0167292$exports))).Toast;
const $d9aa5c6b16d90faa$export$144901db2ea8e967 = (0, (/*@__PURE__*/$parcel$interopDefault($e7f07339a0167292$exports))).Carousel;


class $67061d0c53254dc4$export$4d6073818885b9cc {
}
$67061d0c53254dc4$export$4d6073818885b9cc.CONTAINER_ID = "message-toast-container";
$67061d0c53254dc4$export$4d6073818885b9cc.CONTAINER_STYLE = "position:fixed;top:1rem;right:1rem;z-index:1100;min-width:280px;";
$67061d0c53254dc4$export$4d6073818885b9cc.AUTOHIDE_DELAY_MS = 8000;
$67061d0c53254dc4$export$4d6073818885b9cc.ERROR_ICON_CLASS = "bi bi-exclamation-triangle-fill text-danger";
$67061d0c53254dc4$export$4d6073818885b9cc.showError = (title, message)=>{
    $67061d0c53254dc4$export$4d6073818885b9cc.show($67061d0c53254dc4$export$4d6073818885b9cc.ERROR_ICON_CLASS, title, message);
};
$67061d0c53254dc4$export$4d6073818885b9cc.show = (iconClass, title, message)=>{
    const container = $67061d0c53254dc4$export$4d6073818885b9cc.getOrCreateContainer();
    const toastEl = document.createElement("div");
    toastEl.className = "toast";
    toastEl.setAttribute("role", "alert");
    toastEl.setAttribute("aria-live", "assertive");
    toastEl.setAttribute("aria-atomic", "true");
    const header = document.createElement("div");
    header.className = "toast-header";
    const icon = document.createElement("i");
    icon.className = `${iconClass} me-2`;
    const titleEl = document.createElement("strong");
    titleEl.className = "me-auto";
    titleEl.textContent = title;
    const closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "btn-close";
    closeButton.setAttribute("data-bs-dismiss", "toast");
    closeButton.setAttribute("aria-label", "Close");
    header.append(icon, titleEl, closeButton);
    const body = document.createElement("div");
    body.className = "toast-body";
    body.textContent = message;
    toastEl.append(header, body);
    container.appendChild(toastEl);
    const toast = new (0, $d9aa5c6b16d90faa$export$8d8dc7d5f743331b)(toastEl, {
        autohide: true,
        delay: $67061d0c53254dc4$export$4d6073818885b9cc.AUTOHIDE_DELAY_MS
    });
    toast.show();
    toastEl.addEventListener("hidden.bs.toast", ()=>toastEl.remove());
};
$67061d0c53254dc4$export$4d6073818885b9cc.getOrCreateContainer = ()=>{
    let container = document.getElementById($67061d0c53254dc4$export$4d6073818885b9cc.CONTAINER_ID);
    if (!container) {
        container = document.createElement("div");
        container.id = $67061d0c53254dc4$export$4d6073818885b9cc.CONTAINER_ID;
        container.style.cssText = $67061d0c53254dc4$export$4d6073818885b9cc.CONTAINER_STYLE;
        document.body.appendChild(container);
    }
    return container;
};


class $b464f021e34710d1$export$ea3253f9deb4bf31 {
    constructor(){
        this.uploadCounter = 0;
        this.getPageId = ()=>"edit-article";
        this.execute = ()=>{
            this.contentTextarea = document.querySelector($b464f021e34710d1$export$ea3253f9deb4bf31.CONTENT_SELECTOR);
            if (!this.contentTextarea) return;
            this.contentTextarea.addEventListener("dragover", this.onDragOver);
            this.contentTextarea.addEventListener("dragleave", this.onDragLeave);
            this.contentTextarea.addEventListener("drop", this.onDrop);
        };
        this.onPageClose = ()=>{
            if (!this.contentTextarea) return;
            this.contentTextarea.removeEventListener("dragover", this.onDragOver);
            this.contentTextarea.removeEventListener("dragleave", this.onDragLeave);
            this.contentTextarea.removeEventListener("drop", this.onDrop);
        };
        this.onDragOver = (event)=>{
            if (!this.hasFiles(event)) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = "copy";
            this.contentTextarea.classList.add($b464f021e34710d1$export$ea3253f9deb4bf31.DRAG_OVER_CLASS);
        };
        this.onDragLeave = ()=>{
            this.contentTextarea.classList.remove($b464f021e34710d1$export$ea3253f9deb4bf31.DRAG_OVER_CLASS);
        };
        this.onDrop = async (event)=>{
            this.contentTextarea.classList.remove($b464f021e34710d1$export$ea3253f9deb4bf31.DRAG_OVER_CLASS);
            if (!this.hasFiles(event)) return;
            event.preventDefault();
            const images = Array.from(event.dataTransfer.files).filter((file)=>file.type.startsWith($b464f021e34710d1$export$ea3253f9deb4bf31.IMAGE_MIME_PREFIX));
            if (images.length === 0) return;
            this.contentTextarea.focus();
            for (const image of images)await this.uploadImage(image);
        };
        this.hasFiles = (event)=>{
            var _event_dataTransfer;
            var _event_dataTransfer_types;
            return Array.from((_event_dataTransfer_types = (_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.types) !== null && _event_dataTransfer_types !== void 0 ? _event_dataTransfer_types : []).includes($b464f021e34710d1$export$ea3253f9deb4bf31.FILES_TRANSFER_TYPE);
        };
        this.uploadImage = async (image)=>{
            const uploadId = ++this.uploadCounter;
            const placeholder = `![Uploading ${image.name}...](uploading-${uploadId})`;
            this.insertAtCursor(placeholder);
            try {
                const key = await this.sendImage(image);
                const altText = this.getAltText(image.name);
                this.replaceText(placeholder, `![${altText}](${$b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_URL}/${key})`);
            } catch (error) {
                this.replaceText(placeholder, "");
                var _error_message;
                (0, $67061d0c53254dc4$export$4d6073818885b9cc).showError($b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FAILED_TITLE, `Couldn't upload ${image.name}. ${(_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : ""}`.trim());
            }
        };
        this.sendImage = async (image)=>{
            var _document_querySelector;
            const formData = new FormData();
            formData.append($b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FIELD_NAME, image);
            var _document_querySelector_value;
            const csrfToken = (_document_querySelector_value = (_document_querySelector = document.querySelector($b464f021e34710d1$export$ea3253f9deb4bf31.CSRF_INPUT_SELECTOR)) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value) !== null && _document_querySelector_value !== void 0 ? _document_querySelector_value : "";
            const response = await fetch($b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_URL, {
                method: "POST",
                headers: {
                    [$b464f021e34710d1$export$ea3253f9deb4bf31.CSRF_HEADER]: csrfToken
                },
                body: formData
            });
            const key = (await response.text()).trim();
            if (!response.ok || !key) throw new Error(key || $b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FAILED_MESSAGE);
            return key;
        };
        this.getAltText = (fileName)=>{
            return fileName.replace($b464f021e34710d1$export$ea3253f9deb4bf31.FILE_EXTENSION_REGEX, "").replace($b464f021e34710d1$export$ea3253f9deb4bf31.WORD_SEPARATORS_REGEX, " ").replace($b464f021e34710d1$export$ea3253f9deb4bf31.MARKDOWN_BRACKETS_REGEX, "").trim();
        };
        this.insertAtCursor = (text)=>{
            const textarea = this.contentTextarea;
            var _textarea_selectionStart;
            const selectionStart = (_textarea_selectionStart = textarea.selectionStart) !== null && _textarea_selectionStart !== void 0 ? _textarea_selectionStart : textarea.value.length;
            var _textarea_selectionEnd;
            const selectionEnd = (_textarea_selectionEnd = textarea.selectionEnd) !== null && _textarea_selectionEnd !== void 0 ? _textarea_selectionEnd : selectionStart;
            const textBefore = textarea.value.substring(0, selectionStart);
            const textAfter = textarea.value.substring(selectionEnd);
            const leadingBreak = textBefore.length > 0 && !textBefore.endsWith($b464f021e34710d1$export$ea3253f9deb4bf31.LINE_BREAK) ? $b464f021e34710d1$export$ea3253f9deb4bf31.LINE_BREAK : "";
            const trailingBreak = textAfter.length > 0 && !textAfter.startsWith($b464f021e34710d1$export$ea3253f9deb4bf31.LINE_BREAK) ? $b464f021e34710d1$export$ea3253f9deb4bf31.LINE_BREAK : "";
            const insertion = leadingBreak + text + trailingBreak;
            textarea.value = textBefore + insertion + textAfter;
            const cursorPosition = textBefore.length + insertion.length;
            textarea.setSelectionRange(cursorPosition, cursorPosition);
            this.notifyContentChanged();
        };
        this.replaceText = (search, replacement)=>{
            const textarea = this.contentTextarea;
            const searchPosition = textarea.value.indexOf(search);
            if (searchPosition === $b464f021e34710d1$export$ea3253f9deb4bf31.NOT_FOUND_INDEX) return;
            const selectionStart = textarea.selectionStart;
            const selectionEnd = textarea.selectionEnd;
            textarea.value = textarea.value.substring(0, searchPosition) + replacement + textarea.value.substring(searchPosition + search.length);
            const lengthDifference = replacement.length - search.length;
            textarea.setSelectionRange(this.shiftSelection(selectionStart, searchPosition, lengthDifference), this.shiftSelection(selectionEnd, searchPosition, lengthDifference));
            this.notifyContentChanged();
        };
        this.shiftSelection = (index, changePosition, lengthDifference)=>{
            if (index <= changePosition) return index;
            return Math.max(changePosition, index + lengthDifference);
        };
        this.notifyContentChanged = ()=>{
            this.contentTextarea.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        };
    }
}
$b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_URL = "/api/v1/photo";
$b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FIELD_NAME = "file";
$b464f021e34710d1$export$ea3253f9deb4bf31.CSRF_HEADER = "X-CSRF-Token";
$b464f021e34710d1$export$ea3253f9deb4bf31.CSRF_INPUT_SELECTOR = 'input[name="_csrf"]';
$b464f021e34710d1$export$ea3253f9deb4bf31.CONTENT_SELECTOR = 'textarea[name="content"]';
$b464f021e34710d1$export$ea3253f9deb4bf31.DRAG_OVER_CLASS = "border-primary";
$b464f021e34710d1$export$ea3253f9deb4bf31.IMAGE_MIME_PREFIX = "image/";
$b464f021e34710d1$export$ea3253f9deb4bf31.FILES_TRANSFER_TYPE = "Files";
$b464f021e34710d1$export$ea3253f9deb4bf31.LINE_BREAK = "\n";
$b464f021e34710d1$export$ea3253f9deb4bf31.NOT_FOUND_INDEX = -1;
$b464f021e34710d1$export$ea3253f9deb4bf31.FILE_EXTENSION_REGEX = /\.[^.]+$/;
$b464f021e34710d1$export$ea3253f9deb4bf31.WORD_SEPARATORS_REGEX = /[-_]+/g;
$b464f021e34710d1$export$ea3253f9deb4bf31.MARKDOWN_BRACKETS_REGEX = /[\[\]]/g;
$b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FAILED_TITLE = "Image upload failed";
$b464f021e34710d1$export$ea3253f9deb4bf31.UPLOAD_FAILED_MESSAGE = "Couldn't upload image";




class $b27ab831ffac140c$export$7d2670a66155874b {
    show() {
        document.body.appendChild(this.modalElement);
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    setOptionsFromSettings(obj) {
        return Object.keys(obj).reduce((p, c)=>Object.assign(p, {
                [c]: this.settings[c]
            }), {});
    }
    getSrc(el) {
        let src = el.dataset.src || el.dataset.remote || el.href || "http://via.placeholder.com/1600x900";
        if (el.dataset.type === "html") return src;
        if (!/\:\/\//.test(src)) src = window.location.origin + src;
        const url = new URL(src);
        if (el.dataset.footer || el.dataset.caption) url.searchParams.set("caption", el.dataset.footer || el.dataset.caption);
        return url.toString();
    }
    getGalleryItems() {
        let galleryTarget;
        if (this.settings.gallery) {
            if (Array.isArray(this.settings.gallery)) return this.settings.gallery;
            galleryTarget = this.settings.gallery;
        } else if (this.el.dataset.gallery) galleryTarget = this.el.dataset.gallery;
        const gallery = galleryTarget ? [
            ...new Set(Array.from(document.querySelectorAll(`[data-gallery="${galleryTarget}"]`), (v)=>`${v.dataset.type ? v.dataset.type : ""}${this.getSrc(v)}`))
        ] : [
            `${this.type ? this.type : ""}${this.src}`
        ];
        return gallery;
    }
    getYoutubeId(src) {
        if (!src) return false;
        const matches = src.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/);
        return matches && matches[2].length === 11 ? matches[2] : false;
    }
    getYoutubeLink(src) {
        const youtubeId = this.getYoutubeId(src);
        if (!youtubeId) return false;
        const arr = src.split("?");
        let params = arr.length > 1 ? "?" + arr[1] : "";
        return `https://www.youtube.com/embed/${youtubeId}${params}`;
    }
    getInstagramEmbed(src) {
        if (/instagram/.test(src)) {
            src += /\/embed$/.test(src) ? "" : "/embed";
            return `<iframe src="${src}" class="start-50 translate-middle-x" style="max-width: 500px" frameborder="0" scrolling="no" allowtransparency="true"></iframe>`;
        }
    }
    isEmbed(src) {
        const regex = new RegExp("(" + $b27ab831ffac140c$export$7d2670a66155874b.allowedEmbedTypes.join("|") + ")");
        const isEmbed = regex.test(src);
        const isImg = /\.(png|jpe?g|gif|svg|webp)/i.test(src) || this.el.dataset.type === "image";
        return isEmbed || !isImg;
    }
    createCarousel() {
        const template = document.createElement("template");
        const types = $b27ab831ffac140c$export$7d2670a66155874b.allowedMediaTypes.join("|");
        const slidesHtml = this.sources.map((src, i)=>{
            src = src.replace(/\/$/, "");
            const regex = new RegExp(`^(${types})`, "i");
            const isHtml = /^html/.test(src);
            const isForcedImage = /^image/.test(src);
            if (regex.test(src)) src = src.replace(regex, "");
            const imgClasses = this.settings.constrain ? "mw-100 mh-100 w-auto m-auto top-0 end-0 bottom-0 start-0" : "h-100 w-100";
            const params = new URLSearchParams(src.split("?")[1]);
            let caption = "";
            let url = src;
            if (params.get("caption")) {
                try {
                    url = new URL(src);
                    url.searchParams.delete("caption");
                    url = url.toString();
                } catch (e) {
                    url = src;
                }
                caption = `<p class="lightbox-caption m-0 p-2 text-center text-white small"><em>${params.get("caption")}</em></p>`;
            }
            let inner = `<img src="${url}" class="d-block ${imgClasses} img-fluid" style="z-index: 1; object-fit: contain;" />`;
            let attributes = "";
            const instagramEmbed = this.getInstagramEmbed(src);
            const youtubeLink = this.getYoutubeLink(src);
            if (this.isEmbed(src) && !isForcedImage) {
                if (youtubeLink) {
                    src = youtubeLink;
                    attributes = 'title="YouTube video player" frameborder="0" allow="accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture"';
                }
                inner = instagramEmbed || `<iframe src="${src}" ${attributes} allowfullscreen></iframe>`;
            }
            if (isHtml) inner = src;
            const spinner = `<div class="position-absolute top-50 start-50 translate-middle text-white"><div class="spinner-border" style="width: 3rem height: 3rem" role="status"></div></div>`;
            return `
				<div class="carousel-item ${!i ? "active" : ""}" style="min-height: 100px">
					${spinner}
					<div class="ratio ratio-16x9" style="background-color: #000;">${inner}</div>
					${caption}
				</div>`;
        }).join("");
        const controlsHtml = this.sources.length < 2 ? "" : `
			<button id="#lightboxCarousel-${this.hash}-prev" class="carousel-control carousel-control-prev h-75 m-auto" type="button" data-bs-target="#lightboxCarousel-${this.hash}" data-bs-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
				<span class="visually-hidden">Previous</span>
			</button>
			<button id="#lightboxCarousel-${this.hash}-next" class="carousel-control carousel-control-next h-75 m-auto" type="button" data-bs-target="#lightboxCarousel-${this.hash}" data-bs-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
				<span class="visually-hidden">Next</span>
			</button>`;
        let classes = "lightbox-carousel carousel slide";
        if (this.settings.size === "fullscreen") classes += " position-absolute w-100 translate-middle top-50 start-50";
        const html = `
			<div id="lightboxCarousel-${this.hash}" class="${classes}" data-bs-ride="carousel" data-bs-interval="${this.carouselOptions.interval}">
				<div class="carousel-inner">
					${slidesHtml}
				</div>
				${controlsHtml}
			</div>`;
        template.innerHTML = html.trim();
        this.carouselElement = template.content.firstChild;
        const carouselOptions = Object.assign(Object.assign({}, this.carouselOptions), {
            keyboard: false
        });
        this.carousel = new (0, $d9aa5c6b16d90faa$export$144901db2ea8e967)(this.carouselElement, carouselOptions);
        const elSrc = this.type && this.type !== "image" ? this.type + this.src : this.src;
        this.carousel.to(this.findGalleryItemIndex(this.sources, elSrc));
        if (this.carouselOptions.keyboard === true) document.addEventListener("keydown", (e)=>{
            if (e.code === "ArrowLeft") {
                const prev = document.getElementById(`#lightboxCarousel-${this.hash}-prev`);
                if (prev) prev.click();
                return false;
            }
            if (e.code === "ArrowRight") {
                const next = document.getElementById(`#lightboxCarousel-${this.hash}-next`);
                if (next) next.click();
                return false;
            }
        });
        return this.carousel;
    }
    findGalleryItemIndex(haystack, needle) {
        let index = 0;
        for (const item of haystack){
            if (item.includes(needle)) return index;
            index++;
        }
        return 0;
    }
    createModal() {
        const template = document.createElement("template");
        const btnInner = '<svg xmlns="http://www.w3.org/2000/svg" style="position: relative; top: -5px;" viewBox="0 0 16 16" fill="#fff"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"/></svg>';
        const html = `
			<div class="modal lightbox fade" id="lightboxModal-${this.hash}" tabindex="-1" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-${this.settings.size}">
					<div class="modal-content border-0 bg-transparent">
						<div class="modal-body p-0">
							<button type="button" class="btn-close position-absolute top-0 end-0 p-3" data-bs-dismiss="modal" aria-label="Close" style="z-index: 2; background: none;">${btnInner}</button>
						</div>
					</div>
				</div>
			</div>`;
        template.innerHTML = html.trim();
        this.modalElement = template.content.firstChild;
        this.modalElement.querySelector(".modal-body").appendChild(this.carouselElement);
        this.modalElement.addEventListener("hidden.bs.modal", ()=>this.modalElement.remove());
        this.modalElement.querySelector("[data-bs-dismiss]").addEventListener("click", ()=>this.modal.hide());
        this.modal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(this.modalElement, this.modalOptions);
        return this.modal;
    }
    randomHash(length = 8) {
        return Array.from({
            length: length
        }, ()=>Math.floor(Math.random() * 36).toString(36)).join("");
    }
    constructor(el, options = {}){
        this.hash = this.randomHash();
        this.settings = Object.assign(Object.assign(Object.assign({}, (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).Default), (0, $d9aa5c6b16d90faa$export$144901db2ea8e967).Default), {
            interval: false,
            target: '[data-toggle="lightbox"]',
            gallery: "",
            size: "xl",
            constrain: true
        });
        this.settings = Object.assign(Object.assign({}, this.settings), options);
        this.modalOptions = (()=>this.setOptionsFromSettings((0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).Default))();
        this.carouselOptions = (()=>this.setOptionsFromSettings((0, $d9aa5c6b16d90faa$export$144901db2ea8e967).Default))();
        if (typeof el === "string") {
            this.settings.target = el;
            el = document.querySelector(this.settings.target);
        }
        this.el = el;
        this.type = el.dataset.type || "";
        this.src = this.getSrc(el);
        this.sources = this.getGalleryItems();
        this.createCarousel();
        this.createModal();
    }
}
$b27ab831ffac140c$export$7d2670a66155874b.allowedEmbedTypes = [
    "embed",
    "youtube",
    "vimeo",
    "instagram",
    "url"
];
$b27ab831ffac140c$export$7d2670a66155874b.allowedMediaTypes = [
    ...$b27ab831ffac140c$export$7d2670a66155874b.allowedEmbedTypes,
    "image",
    "html"
];
$b27ab831ffac140c$export$7d2670a66155874b.defaultSelector = '[data-toggle="lightbox"]';
$b27ab831ffac140c$export$7d2670a66155874b.initialize = function(e) {
    e.preventDefault();
    const lightbox = new $b27ab831ffac140c$export$7d2670a66155874b(this);
    lightbox.show();
};


class $605c700ea6afc11e$export$c3da8c344445fc4f {
    constructor(){
        this.countrySelect = null;
        this.stateSelect = null;
        this.wasUsaBefore = false;
        this.getPageId = ()=>"edit-location";
        this.execute = ()=>{
            var _this_countrySelect, _this_countrySelect1;
            this.countrySelect = document.querySelector('select[name="country"]');
            this.stateSelect = document.querySelector('select[name="state"]');
            this.wasUsaBefore = ((_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value) === "US";
            this.setupSelectStateElement();
            (_this_countrySelect1 = this.countrySelect) === null || _this_countrySelect1 === void 0 ? void 0 : _this_countrySelect1.addEventListener("change", ()=>{
                this.setupSelectStateElement();
            });
        };
        this.setupSelectStateElement = ()=>{
            var _this_countrySelect;
            const selectedCountryCode = (_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value;
            const isUsaNow = selectedCountryCode === "US";
            if (isUsaNow) {
                var _this_stateSelect_parentElement_classList, _this_stateSelect_parentElement, _this_stateSelect;
                if (!this.wasUsaBefore) {
                    // Deselect state
                    this.stateSelect.value = "";
                    const event = new Event("change", {
                        bubbles: true
                    });
                    this.stateSelect.dispatchEvent(event);
                }
                (_this_stateSelect = this.stateSelect) === null || _this_stateSelect === void 0 ? void 0 : (_this_stateSelect_parentElement = _this_stateSelect.parentElement) === null || _this_stateSelect_parentElement === void 0 ? void 0 : (_this_stateSelect_parentElement_classList = _this_stateSelect_parentElement.classList) === null || _this_stateSelect_parentElement_classList === void 0 ? void 0 : _this_stateSelect_parentElement_classList.remove("d-none");
            } else {
                var // Hide and mark as not required
                _this_stateSelect_parentElement_classList1, _this_stateSelect_parentElement1, _this_stateSelect1;
                (_this_stateSelect1 = this.stateSelect) === null || _this_stateSelect1 === void 0 ? void 0 : (_this_stateSelect_parentElement1 = _this_stateSelect1.parentElement) === null || _this_stateSelect_parentElement1 === void 0 ? void 0 : (_this_stateSelect_parentElement_classList1 = _this_stateSelect_parentElement1.classList) === null || _this_stateSelect_parentElement_classList1 === void 0 ? void 0 : _this_stateSelect_parentElement_classList1.add("d-none");
                this.stateSelect.value = "WY" // Select any valid option, it won't get saved anyway
                ;
            }
            this.wasUsaBefore = isUsaNow;
        };
        this.onPageClose = ()=>{};
    }
}


class $e73952d971edfb9c$export$9ed9778d182ca50d {
    static init(theme = "light") {
        var _0x4AAAAAACJd7bOod1FfCNIw;
        $e73952d971edfb9c$export$9ed9778d182ca50d.theme = theme;
        if (((_0x4AAAAAACJd7bOod1FfCNIw = "0x4AAAAAACJd7bOod1FfCNIw") === null || _0x4AAAAAACJd7bOod1FfCNIw === void 0 ? void 0 : _0x4AAAAAACJd7bOod1FfCNIw.trim().length) === 0) return;
        window.onloadTurnstileCallback = ()=>{
            this.initCloudflareTurnslide();
        };
    }
    static initCloudflareTurnslide() {
        turnstile.render("#cloudFlareTurnslide", {
            sitekey: "0x4AAAAAACJd7bOod1FfCNIw",
            theme: $e73952d971edfb9c$export$9ed9778d182ca50d.theme,
            callback: (token)=>{
            // Challenge completed successfuly
            }
        });
    }
}
$e73952d971edfb9c$export$9ed9778d182ca50d.theme = "light";


class $bd361655b21580a8$export$da8e434173032913 {
    constructor(){
        this.getPageId = ()=>"login";
        this.execute = ()=>{
            (0, $e73952d971edfb9c$export$9ed9778d182ca50d).init();
        };
        this.onPageClose = ()=>{};
    }
}


class $803ccfd1ca478a7a$export$5035f9ff3312fcc3 {
    constructor(options){
        this.rating = null;
        this.currentRating = 0;
        this.myRating = 0;
        this.isRating = false;
        this.disabled = false;
        this.onMouseMove = (event)=>{
            this.onMove(event, false);
        };
        this.onMove = (event, isTouch)=>{
            if (this.disabled || this.isRating) return;
            const width = this.element.offsetWidth;
            const parentOffset = this.element.getBoundingClientRect();
            let xCoordinate;
            let percent;
            if (this.reverse) {
                if (isTouch) xCoordinate = event.changedTouches[0].pageX - parentOffset.left;
                else xCoordinate = event.pageX - window.scrollX - parentOffset.left;
                const relativeXRtl = width - xCoordinate;
                const valueForDivision = width / $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX;
                percent = relativeXRtl / valueForDivision;
            } else {
                if (isTouch) xCoordinate = event.changedTouches[0].pageX - parentOffset.left;
                else xCoordinate = event.offsetX;
                percent = xCoordinate / width * $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX;
            }
            if (percent > $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX) return;
            if (this.step === $803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STEP) this.currentRating = Math.ceil(percent / $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX * this.maxStars);
            else {
                const exactRating = percent / $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX * this.maxStars;
                for(let candidate = 0;; candidate += this.step)if (candidate >= exactRating) {
                    this.currentRating = candidate;
                    break;
                }
            }
            if (this.currentRating > this.maxStars) this.currentRating = this.maxStars;
            this.starValueElement.style.width = this.currentRating / this.maxStars * $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX + "%";
            if (this.showToolTip) {
                const toolTip = this.ratingText.replace("{rating}", String(this.currentRating)).replace("{maxRating}", String(this.maxStars));
                this.element.setAttribute("title", toolTip);
            }
            if (this.onHover) this.onHover(this.currentRating, this.rating);
        };
        this.onStarOut = ()=>{
            if (!this.rating) {
                this.starValueElement.style.width = "0%";
                this.element.removeAttribute("data-rating");
            } else {
                this.starValueElement.style.width = this.rating / this.maxStars * $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX + "%";
                this.element.setAttribute("data-rating", String(this.rating));
            }
            if (this.onLeave) this.onLeave(this.currentRating, this.rating);
        };
        this.onStarClick = ()=>{
            if (this.disabled || this.isRating) return;
            if (this.rateCallback) {
                this.isRating = true;
                this.myRating = this.currentRating;
                if (this.isBusyText === undefined) this.element.removeAttribute("title");
                else this.element.setAttribute("title", this.isBusyText);
                this.element.classList.add("is-busy");
                this.rateCallback(this.myRating, ()=>{
                    if (!this.disabled) this.element.removeAttribute("title");
                    this.isRating = false;
                    this.element.classList.remove("is-busy");
                });
            }
        };
        this.handleMove = (event)=>{
            event.preventDefault();
            this.onMove(event, true);
        };
        this.handleStart = (event)=>{
            event.preventDefault();
            this.onMove(event, true);
        };
        this.handleEnd = (event)=>{
            event.preventDefault();
            this.onMove(event, true);
            this.onStarClick();
        };
        this.handleCancel = (event)=>{
            event.preventDefault();
            this.onStarOut();
        };
        this.disable = ()=>{
            this.disabled = true;
            this.element.classList.add("disabled");
            if (this.showToolTip && !!this.disableText) {
                const toolTip = this.disableText.replace("{rating}", String(this.rating ? this.rating : 0)).replace("{maxRating}", String(this.maxStars));
                this.element.setAttribute("title", toolTip);
            } else this.element.removeAttribute("title");
        };
        this.enable = ()=>{
            this.disabled = false;
            this.element.removeAttribute("title");
            this.element.classList.remove("disabled");
        };
        this.setRating = (value)=>{
            if (value === undefined || value === null) throw new Error("Value not set.");
            if (typeof value !== "number") throw new Error("Value must be a number.");
            if (value < 0 || value > this.maxStars) throw new Error("Value too high. Please set a rating of " + this.maxStars + " or below.");
            this.rating = value;
            this.starValueElement.style.width = value / this.maxStars * $803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX + "%";
            this.element.setAttribute("data-rating", String(value));
        };
        this.getRating = ()=>{
            return this.rating;
        };
        this.clear = ()=>{
            this.rating = null;
            this.starValueElement.style.width = "0px";
            this.element.removeAttribute("title");
        };
        this.dispose = ()=>{
            this.element.removeEventListener("mousemove", this.onMouseMove);
            this.element.removeEventListener("mouseleave", this.onStarOut);
            this.element.removeEventListener("click", this.onStarClick);
            this.element.removeEventListener("touchmove", this.handleMove, false);
            this.element.removeEventListener("touchstart", this.handleStart, false);
            this.element.removeEventListener("touchend", this.handleEnd, false);
            this.element.removeEventListener("touchcancel", this.handleCancel, false);
        };
        this.getElement = ()=>{
            return this.element;
        };
        if (!options.element) throw new Error("element required");
        if (options.step !== undefined && (options.step <= 0 || options.step > $803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STEP)) throw new Error("step must be a number between 0 and 1");
        this.element = options.element;
        this.reverse = !!options.reverse;
        this.maxStars = options.max || $803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_MAX_STARS;
        this.starSize = options.starSize || $803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STAR_SIZE;
        this.step = options.step || $803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STEP;
        this.showToolTip = options.showToolTip !== undefined ? !!options.showToolTip : true;
        this.rateCallback = options.rateCallback;
        this.onHover = options.onHover;
        this.onLeave = options.onLeave;
        this.isBusyText = options.isBusyText;
        this.disableText = options.disableText !== undefined ? options.disableText : $803ccfd1ca478a7a$export$5035f9ff3312fcc3.RATING_PLACEHOLDER;
        this.ratingText = options.ratingText !== undefined ? options.ratingText : $803ccfd1ca478a7a$export$5035f9ff3312fcc3.RATING_PLACEHOLDER;
        this.disabled = !!options.readOnly;
        this.element.classList.add("star-rating");
        this.starValueElement = document.createElement("div");
        this.starValueElement.classList.add("star-value");
        if (this.reverse) this.starValueElement.classList.add("rtl");
        this.starValueElement.style.backgroundSize = this.starSize + "px";
        this.element.appendChild(this.starValueElement);
        this.element.style.width = this.starSize * this.maxStars + "px";
        this.element.style.height = this.starSize + "px";
        this.element.style.backgroundSize = this.starSize + "px";
        if (options.rating) this.setRating(options.rating);
        else {
            const dataRating = this.element.dataset.rating;
            if (dataRating) this.setRating(+dataRating);
        }
        if (!this.rating) this.starValueElement.style.width = "0px";
        if (this.disabled) this.disable();
        this.element.addEventListener("mousemove", this.onMouseMove);
        this.element.addEventListener("mouseleave", this.onStarOut);
        this.element.addEventListener("click", this.onStarClick);
        this.element.addEventListener("touchmove", this.handleMove, false);
        this.element.addEventListener("touchstart", this.handleStart, false);
        this.element.addEventListener("touchend", this.handleEnd, false);
        this.element.addEventListener("touchcancel", this.handleCancel, false);
    }
}
$803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_MAX_STARS = 5;
$803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STAR_SIZE = 16;
$803ccfd1ca478a7a$export$5035f9ff3312fcc3.DEFAULT_STEP = 1;
$803ccfd1ca478a7a$export$5035f9ff3312fcc3.PERCENT_MAX = 100;
$803ccfd1ca478a7a$export$5035f9ff3312fcc3.RATING_PLACEHOLDER = "{rating}/{maxRating}";


class $9f73d72aa8d837e0$export$61bde38e73a8e56f {
    constructor(){
        this.getPageId = ()=>"feedback";
        this.execute = ()=>{
            const ratingElement = document.querySelector(".js-feedback-rater");
            const liveRatingElement = document.querySelector(".js-feedback-live-rating");
            const starsInput = document.querySelector('input[name="stars"]');
            if (!ratingElement || !starsInput) return;
            const initialRating = parseFloat(starsInput.value);
            const hasInitial = !isNaN(initialRating) && initialRating > 0;
            const renderLive = (value)=>{
                if (!liveRatingElement) return;
                liveRatingElement.textContent = value > 0 ? String(value) : "";
            };
            const starSelector = new (0, $803ccfd1ca478a7a$export$5035f9ff3312fcc3)({
                element: ratingElement,
                starSize: $9f73d72aa8d837e0$export$61bde38e73a8e56f.STAR_SIZE,
                step: 1,
                showToolTip: false,
                rating: hasInitial ? initialRating : undefined,
                rateCallback: (rating, done)=>{
                    starSelector.setRating(rating);
                    starsInput.value = String(rating);
                    renderLive(rating);
                    done();
                },
                onHover: (currentRating)=>{
                    renderLive(currentRating);
                },
                onLeave: (_currentRating, rating)=>{
                    renderLive(rating !== null && rating !== void 0 ? rating : 0);
                }
            });
            renderLive(hasInitial ? initialRating : 0);
        };
        this.onPageClose = ()=>{};
    }
}
$9f73d72aa8d837e0$export$61bde38e73a8e56f.STAR_SIZE = 32;




class $bb8053455085b9f5$export$b86106c69b68c29f {
    constructor(){
        this.countrySelect = null;
        this.stateSelect = null;
        this.wasUsaBefore = false;
        this.map = null;
        this.marker = null;
        this.locationModal = null;
        this.pinnedLocation = null;
        this.getPageId = ()=>"restaurant-details-panel";
        this.execute = (pjax)=>{
            var _this_countrySelect, _this_countrySelect1;
            this.pjax = pjax;
            this.countrySelect = document.querySelector('select[name="country"]');
            this.stateSelect = document.querySelector('select[name="state"]');
            this.wasUsaBefore = ((_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value) === "US";
            this.setupSelectStateElement();
            (_this_countrySelect1 = this.countrySelect) === null || _this_countrySelect1 === void 0 ? void 0 : _this_countrySelect1.addEventListener("change", ()=>{
                this.setupSelectStateElement();
            });
            this.setupRemoveRestaurant();
            this.setupLocationPicker();
            this.setupCoordinatesResetOnAddressChange();
        };
        this.setupRemoveRestaurant = ()=>{
            const confirmBtn = document.querySelector('[data-action="confirm-remove-restaurant"]');
            if (!confirmBtn) return;
            confirmBtn.addEventListener("click", async ()=>{
                const removeUrl = confirmBtn.dataset.removeUrl;
                if (!removeUrl) return;
                confirmBtn.disabled = true;
                try {
                    var _document_querySelector;
                    var _document_querySelector_value;
                    const csrfToken = (_document_querySelector_value = (_document_querySelector = document.querySelector('input[name="_csrf"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value) !== null && _document_querySelector_value !== void 0 ? _document_querySelector_value : "";
                    const response = await fetch(removeUrl, {
                        method: "DELETE",
                        headers: {
                            "X-CSRF-Token": csrfToken
                        }
                    });
                    if (response.ok) {
                        this.pjax.loadUrl("/");
                        return;
                    }
                } catch  {
                // Ignore and re-enable so the user can retry
                }
                confirmBtn.disabled = false;
            });
        };
        this.setupSelectStateElement = ()=>{
            var _this_countrySelect;
            const selectedCountryCode = (_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value;
            const isUsaNow = selectedCountryCode === "US";
            if (isUsaNow) {
                var _this_stateSelect_parentElement_classList, _this_stateSelect_parentElement, _this_stateSelect;
                if (!this.wasUsaBefore) {
                    // Deselect state
                    this.stateSelect.value = "";
                    const event = new Event("change", {
                        bubbles: true
                    });
                    this.stateSelect.dispatchEvent(event);
                }
                (_this_stateSelect = this.stateSelect) === null || _this_stateSelect === void 0 ? void 0 : (_this_stateSelect_parentElement = _this_stateSelect.parentElement) === null || _this_stateSelect_parentElement === void 0 ? void 0 : (_this_stateSelect_parentElement_classList = _this_stateSelect_parentElement.classList) === null || _this_stateSelect_parentElement_classList === void 0 ? void 0 : _this_stateSelect_parentElement_classList.remove("d-none");
            } else {
                var // Hide and mark as not required
                _this_stateSelect_parentElement_classList1, _this_stateSelect_parentElement1, _this_stateSelect1;
                (_this_stateSelect1 = this.stateSelect) === null || _this_stateSelect1 === void 0 ? void 0 : (_this_stateSelect_parentElement1 = _this_stateSelect1.parentElement) === null || _this_stateSelect_parentElement1 === void 0 ? void 0 : (_this_stateSelect_parentElement_classList1 = _this_stateSelect_parentElement1.classList) === null || _this_stateSelect_parentElement_classList1 === void 0 ? void 0 : _this_stateSelect_parentElement_classList1.add("d-none");
                this.stateSelect.value = "WY" // Select any valid option, it won't get saved anyway
                ;
            }
            this.wasUsaBefore = isUsaNow;
        };
        this.setupLocationPicker = ()=>{
            var _document_querySelector;
            const openButton = document.querySelector("[data-location-open]");
            const modalElement = document.getElementById("location-picker-modal");
            if (!openButton || !modalElement) return;
            this.locationModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalElement);
            openButton.addEventListener("click", async ()=>{
                this.locationModal.show();
                await this.initializeMap();
                await this.showRestaurantLocation();
            });
            modalElement.addEventListener("shown.bs.modal", ()=>{
                var _this_map;
                (_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.resize();
            });
            (_document_querySelector = document.querySelector("[data-location-save]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener("click", ()=>{
                var _this_locationModal;
                if (!this.pinnedLocation) return;
                this.setHiddenCoordinates(this.pinnedLocation);
                this.showPinnedHint();
                (_this_locationModal = this.locationModal) === null || _this_locationModal === void 0 ? void 0 : _this_locationModal.hide();
            });
        };
        this.setupCoordinatesResetOnAddressChange = ()=>{
            var _document_querySelector, _this_countrySelect, _this_stateSelect;
            for (const fieldName of $bb8053455085b9f5$export$b86106c69b68c29f.ADDRESS_FIELD_NAMES)(_document_querySelector = document.querySelector(`input[name="${fieldName}"]`)) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener("change", this.clearPinnedLocation);
            (_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.addEventListener("change", this.clearPinnedLocation);
            (_this_stateSelect = this.stateSelect) === null || _this_stateSelect === void 0 ? void 0 : _this_stateSelect.addEventListener("change", this.clearPinnedLocation);
        };
        this.clearPinnedLocation = ()=>{
            var _document_querySelector;
            const latitudeInput = document.querySelector("[data-location-latitude]");
            const longitudeInput = document.querySelector("[data-location-longitude]");
            if (latitudeInput) latitudeInput.value = "";
            if (longitudeInput) longitudeInput.value = "";
            (_document_querySelector = document.querySelector("[data-location-pinned-hint]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("d-none");
        };
        this.showRestaurantLocation = async ()=>{
            const existingLocation = this.getHiddenCoordinates();
            if (existingLocation) {
                this.moveMarker(existingLocation, true);
                return;
            }
            const foundLocation = await this.geocodeFormAddress();
            if (foundLocation) this.moveMarker(foundLocation, true);
        };
        this.showPinnedHint = ()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector("[data-location-pinned-hint]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("d-none");
        };
        this.initializeMap = async ()=>{
            if (this.map) return;
            const mapContainer = document.querySelector("[data-location-map]");
            if (!mapContainer) return;
            const initialLocation = this.getHiddenCoordinates();
            const center = initialLocation !== null && initialLocation !== void 0 ? initialLocation : $bb8053455085b9f5$export$b86106c69b68c29f.WORLD_CENTER;
            const zoom = initialLocation ? $bb8053455085b9f5$export$b86106c69b68c29f.PINNED_ZOOM : $bb8053455085b9f5$export$b86106c69b68c29f.WORLD_ZOOM;
            this.pinnedLocation = center;
            const maplibreModule = await (parcelRequire("bUxFU"));
            var _maplibreModule_default;
            const maplibre = (_maplibreModule_default = maplibreModule.default) !== null && _maplibreModule_default !== void 0 ? _maplibreModule_default : maplibreModule;
            this.map = new maplibre.Map({
                container: mapContainer,
                style: mapContainer.dataset.mapStyle || $bb8053455085b9f5$export$b86106c69b68c29f.DEFAULT_MAP_STYLE_URL,
                center: [
                    center.lng,
                    center.lat
                ],
                zoom: zoom
            });
            this.map.addControl(new maplibre.NavigationControl());
            this.marker = new maplibre.Marker({
                draggable: true,
                color: "#f26125"
            }).setLngLat([
                center.lng,
                center.lat
            ]).addTo(this.map);
            this.marker.on("dragend", ()=>{
                const position = this.marker.getLngLat();
                this.pinnedLocation = {
                    lat: position.lat,
                    lng: position.lng
                };
                this.updateCoordinatesDisplay();
            });
            this.map.on("click", (event)=>{
                this.moveMarker({
                    lat: event.lngLat.lat,
                    lng: event.lngLat.lng
                }, false);
            });
            this.map.resize();
            this.updateCoordinatesDisplay();
        };
        this.moveMarker = (location, recenter)=>{
            var _this_marker, _this_map;
            this.pinnedLocation = location;
            (_this_marker = this.marker) === null || _this_marker === void 0 ? void 0 : _this_marker.setLngLat([
                location.lng,
                location.lat
            ]);
            if (recenter) (_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.jumpTo({
                center: [
                    location.lng,
                    location.lat
                ],
                zoom: $bb8053455085b9f5$export$b86106c69b68c29f.PINNED_ZOOM
            });
            this.updateCoordinatesDisplay();
        };
        this.updateCoordinatesDisplay = ()=>{
            const coordsElement = document.querySelector("[data-location-coords]");
            if (!coordsElement || !this.pinnedLocation) return;
            const decimals = $bb8053455085b9f5$export$b86106c69b68c29f.COORDS_DISPLAY_DECIMALS;
            coordsElement.textContent = `${this.pinnedLocation.lat.toFixed(decimals)}, ${this.pinnedLocation.lng.toFixed(decimals)}`;
        };
        this.getHiddenCoordinates = ()=>{
            const latitudeInput = document.querySelector("[data-location-latitude]");
            const longitudeInput = document.querySelector("[data-location-longitude]");
            var _latitudeInput_value;
            const lat = parseFloat((_latitudeInput_value = latitudeInput === null || latitudeInput === void 0 ? void 0 : latitudeInput.value) !== null && _latitudeInput_value !== void 0 ? _latitudeInput_value : "");
            var _longitudeInput_value;
            const lng = parseFloat((_longitudeInput_value = longitudeInput === null || longitudeInput === void 0 ? void 0 : longitudeInput.value) !== null && _longitudeInput_value !== void 0 ? _longitudeInput_value : "");
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
            return {
                lat: lat,
                lng: lng
            };
        };
        this.setHiddenCoordinates = (location)=>{
            const latitudeInput = document.querySelector("[data-location-latitude]");
            const longitudeInput = document.querySelector("[data-location-longitude]");
            const decimals = $bb8053455085b9f5$export$b86106c69b68c29f.COORDS_DECIMALS;
            if (latitudeInput) latitudeInput.value = location.lat.toFixed(decimals);
            if (longitudeInput) longitudeInput.value = location.lng.toFixed(decimals);
        };
        this.geocodeFormAddress = async ()=>{
            var _this_countrySelect, _this_stateSelect;
            const getFieldValue = (name)=>{
                var _document_querySelector_value, _document_querySelector;
                var _document_querySelector_value_trim;
                return (_document_querySelector_value_trim = (_document_querySelector = document.querySelector(`[name="${name}"]`)) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_value = _document_querySelector.value) === null || _document_querySelector_value === void 0 ? void 0 : _document_querySelector_value.trim()) !== null && _document_querySelector_value_trim !== void 0 ? _document_querySelector_value_trim : "";
            };
            const city = getFieldValue("city");
            if (!city) return null;
            var _this_stateSelect_value;
            return this.geocode({
                street: getFieldValue("street"),
                city: city,
                state: ((_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value) === "US" ? (_this_stateSelect_value = (_this_stateSelect = this.stateSelect) === null || _this_stateSelect === void 0 ? void 0 : _this_stateSelect.value) !== null && _this_stateSelect_value !== void 0 ? _this_stateSelect_value : "" : "",
                postCode: getFieldValue("postCode")
            });
        };
        this.geocode = async (params)=>{
            var _this_countrySelect;
            var _this_countrySelect_value;
            const country = (_this_countrySelect_value = (_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value) !== null && _this_countrySelect_value !== void 0 ? _this_countrySelect_value : "";
            const searchParams = new URLSearchParams({
                ...params,
                country: country
            });
            try {
                const response = await fetch(`/api/v1/geocode?${searchParams.toString()}`);
                if (!response.ok) return null;
                const result = await response.json();
                if (!Number.isFinite(result === null || result === void 0 ? void 0 : result.latitude) || !Number.isFinite(result === null || result === void 0 ? void 0 : result.longitude)) return null;
                return {
                    lat: result.latitude,
                    lng: result.longitude
                };
            } catch (error) {
                return null;
            }
        };
        this.onPageClose = ()=>{
            var _this_map;
            (_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.remove();
            this.map = null;
            this.marker = null;
            this.locationModal = null;
            this.pinnedLocation = null;
        };
    }
}
$bb8053455085b9f5$export$b86106c69b68c29f.DEFAULT_MAP_STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";
$bb8053455085b9f5$export$b86106c69b68c29f.PINNED_ZOOM = 16;
$bb8053455085b9f5$export$b86106c69b68c29f.WORLD_ZOOM = 1;
$bb8053455085b9f5$export$b86106c69b68c29f.WORLD_CENTER = {
    lat: 20,
    lng: 0
};
$bb8053455085b9f5$export$b86106c69b68c29f.COORDS_DECIMALS = 7;
$bb8053455085b9f5$export$b86106c69b68c29f.COORDS_DISPLAY_DECIMALS = 5;
$bb8053455085b9f5$export$b86106c69b68c29f.ADDRESS_FIELD_NAMES = [
    "street",
    "city",
    "postCode"
];



class $f3204faad6b88721$export$58b4806257715dc0 {
    constructor(){
        this.downgradeModal = null;
        this.pendingPlan = "";
        this.getPageId = ()=>"select-plan-panel";
        this.execute = ()=>{
            this.setupDowngradeModal();
        };
        this.onPageClose = ()=>{};
        this.setupDowngradeModal = ()=>{
            const formEl = document.getElementById("select-plan-form");
            if (!formEl) return;
            const modalEl = document.getElementById("downgrade-confirm-modal");
            if (!modalEl) return;
            var _formEl_dataset_currentPlan;
            const currentPlan = (_formEl_dataset_currentPlan = formEl.dataset.currentPlan) !== null && _formEl_dataset_currentPlan !== void 0 ? _formEl_dataset_currentPlan : "";
            var _PanelSelectPlan_PLAN_TIERS_currentPlan;
            const currentTier = (_PanelSelectPlan_PLAN_TIERS_currentPlan = $f3204faad6b88721$export$58b4806257715dc0.PLAN_TIERS[currentPlan]) !== null && _PanelSelectPlan_PLAN_TIERS_currentPlan !== void 0 ? _PanelSelectPlan_PLAN_TIERS_currentPlan : 0;
            if (currentTier === 0) return;
            this.downgradeModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            formEl.querySelectorAll('button[name="licenseType"]').forEach((btn)=>{
                const newPlan = btn.value;
                var _PanelSelectPlan_PLAN_TIERS_newPlan;
                const newTier = (_PanelSelectPlan_PLAN_TIERS_newPlan = $f3204faad6b88721$export$58b4806257715dc0.PLAN_TIERS[newPlan]) !== null && _PanelSelectPlan_PLAN_TIERS_newPlan !== void 0 ? _PanelSelectPlan_PLAN_TIERS_newPlan : 0;
                if (newTier < currentTier) btn.addEventListener("click", (event)=>{
                    var _this_downgradeModal;
                    event.preventDefault();
                    this.pendingPlan = newPlan;
                    const loseMultipleUsers = modalEl.querySelector("[data-lose-multiple-users]");
                    const loseOrdering = modalEl.querySelector("[data-lose-ordering]");
                    if (loseMultipleUsers) loseMultipleUsers.style.display = currentPlan === "business" ? "" : "none";
                    if (loseOrdering) loseOrdering.style.display = newPlan === "starter" ? "" : "none";
                    (_this_downgradeModal = this.downgradeModal) === null || _this_downgradeModal === void 0 ? void 0 : _this_downgradeModal.show();
                });
            });
            const confirmBtn = modalEl.querySelector('[data-action="confirm-downgrade"]');
            confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.addEventListener("click", ()=>{
                var _this_downgradeModal;
                const hiddenInput = document.createElement("input");
                hiddenInput.type = "hidden";
                hiddenInput.name = "licenseType";
                hiddenInput.value = this.pendingPlan;
                formEl.appendChild(hiddenInput);
                (_this_downgradeModal = this.downgradeModal) === null || _this_downgradeModal === void 0 ? void 0 : _this_downgradeModal.hide();
                formEl.submit();
            });
        };
    }
}
$f3204faad6b88721$export$58b4806257715dc0.PLAN_TIERS = {
    starter: 1,
    basic: 2,
    business: 3
};


class $152116d178fe9046$export$26dd6e4410a57735 {
    constructor(){
        this.getPageId = ()=>"opening-hours-panel";
        this.execute = ()=>{
            var _row_querySelector;
            const closedCheckboxes = document.querySelectorAll('input[type="checkbox"][name^="hours_"][name$="_closed"]');
            for (const checkbox of closedCheckboxes){
                const day = checkbox.dataset.day;
                this.toggleTimeInputs(day, checkbox.checked);
                checkbox.addEventListener("change", ()=>{
                    this.toggleTimeInputs(day, checkbox.checked);
                });
            }
            const addButtons = document.querySelectorAll("[data-add-range]");
            for (const btn of addButtons)btn.addEventListener("click", ()=>{
                this.addTimeRange(btn.dataset.addRange, btn.closest("tr"));
            });
            const prerenderedExtraRows = document.querySelectorAll("[data-extra-range-day]");
            for (const row of prerenderedExtraRows)(_row_querySelector = row.querySelector("button")) === null || _row_querySelector === void 0 ? void 0 : _row_querySelector.addEventListener("click", ()=>{
                row.remove();
                this.reindexExtraRows(row.dataset.extraRangeDay);
            });
        };
        this.addTimeRange = (day, originalRow)=>{
            var _document_querySelector;
            const existingCount = document.querySelectorAll(`[data-extra-range-day="${day}"]`).length;
            const index = existingCount + 1;
            const isClosed = !!((_document_querySelector = document.querySelector(`input[name="hours_${day}_closed"]`)) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.checked);
            const newRow = document.createElement("tr");
            newRow.dataset.extraRangeDay = day;
            if (isClosed) newRow.style.display = "none";
            newRow.innerHTML = `
      <td></td>
      <td></td>
      <td><input type="time" class="form-control form-control-sm" name="hours_${day}_open_${index}" value="09:00" /></td>
      <td><input type="time" class="form-control form-control-sm" name="hours_${day}_close_${index}" value="22:00" /></td>
      <td><button type="button" class="btn btn-sm btn-outline-secondary">&minus;</button></td>
    `;
            this.findLastRowForDay(day, originalRow).after(newRow);
            newRow.querySelector("button").addEventListener("click", ()=>{
                newRow.remove();
                this.reindexExtraRows(day);
            });
        };
        this.reindexExtraRows = (day)=>{
            const extraRows = document.querySelectorAll(`[data-extra-range-day="${day}"]`);
            extraRows.forEach((row, index)=>{
                const newIndex = index + 1;
                const openInput = row.querySelector(`input[name^="hours_${day}_open_"]`);
                const closeInput = row.querySelector(`input[name^="hours_${day}_close_"]`);
                if (openInput) openInput.name = `hours_${day}_open_${newIndex}`;
                if (closeInput) closeInput.name = `hours_${day}_close_${newIndex}`;
            });
        };
        this.findLastRowForDay = (day, originalRow)=>{
            let lastRow = originalRow;
            let next = originalRow.nextElementSibling;
            while((next === null || next === void 0 ? void 0 : next.dataset.extraRangeDay) === day){
                lastRow = next;
                next = next.nextElementSibling;
            }
            return lastRow;
        };
        this.toggleTimeInputs = (day, isClosed)=>{
            var _document_querySelector;
            const originalRow = (_document_querySelector = document.querySelector(`input[name="hours_${day}_closed"]`)) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.closest("tr");
            const openCell = originalRow === null || originalRow === void 0 ? void 0 : originalRow.querySelector(`td:nth-child(3)`);
            const closeCell = originalRow === null || originalRow === void 0 ? void 0 : originalRow.querySelector(`td:nth-child(4)`);
            const addCell = originalRow === null || originalRow === void 0 ? void 0 : originalRow.querySelector(`td:nth-child(5)`);
            const display = isClosed ? "none" : "";
            if (openCell) openCell.style.display = display;
            if (closeCell) closeCell.style.display = display;
            if (addCell) addCell.style.display = display;
            const openInput = originalRow === null || originalRow === void 0 ? void 0 : originalRow.querySelector(`input[name="hours_${day}_open_0"]`);
            const closeInput = originalRow === null || originalRow === void 0 ? void 0 : originalRow.querySelector(`input[name="hours_${day}_close_0"]`);
            if (openInput) openInput.required = !isClosed;
            if (closeInput) closeInput.required = !isClosed;
            const extraRows = document.querySelectorAll(`[data-extra-range-day="${day}"]`);
            for (const row of extraRows)row.style.display = display;
        };
        this.onPageClose = ()=>{};
    }
}


var $9b19a0a83ad61f86$exports = {};
var $4f2b320d6577794c$exports = {};
// shim for using process in browser
var $4f2b320d6577794c$var$process = $4f2b320d6577794c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4f2b320d6577794c$var$cachedSetTimeout;
var $4f2b320d6577794c$var$cachedClearTimeout;
function $4f2b320d6577794c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4f2b320d6577794c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4f2b320d6577794c$var$cachedSetTimeout = setTimeout;
        else $4f2b320d6577794c$var$cachedSetTimeout = $4f2b320d6577794c$var$defaultSetTimout;
    } catch (e) {
        $4f2b320d6577794c$var$cachedSetTimeout = $4f2b320d6577794c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4f2b320d6577794c$var$cachedClearTimeout = clearTimeout;
        else $4f2b320d6577794c$var$cachedClearTimeout = $4f2b320d6577794c$var$defaultClearTimeout;
    } catch (e) {
        $4f2b320d6577794c$var$cachedClearTimeout = $4f2b320d6577794c$var$defaultClearTimeout;
    }
})();
function $4f2b320d6577794c$var$runTimeout(fun) {
    if ($4f2b320d6577794c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4f2b320d6577794c$var$cachedSetTimeout === $4f2b320d6577794c$var$defaultSetTimout || !$4f2b320d6577794c$var$cachedSetTimeout) && setTimeout) {
        $4f2b320d6577794c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4f2b320d6577794c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4f2b320d6577794c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4f2b320d6577794c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4f2b320d6577794c$var$runClearTimeout(marker) {
    if ($4f2b320d6577794c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4f2b320d6577794c$var$cachedClearTimeout === $4f2b320d6577794c$var$defaultClearTimeout || !$4f2b320d6577794c$var$cachedClearTimeout) && clearTimeout) {
        $4f2b320d6577794c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4f2b320d6577794c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4f2b320d6577794c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4f2b320d6577794c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4f2b320d6577794c$var$queue = [];
var $4f2b320d6577794c$var$draining = false;
var $4f2b320d6577794c$var$currentQueue;
var $4f2b320d6577794c$var$queueIndex = -1;
function $4f2b320d6577794c$var$cleanUpNextTick() {
    if (!$4f2b320d6577794c$var$draining || !$4f2b320d6577794c$var$currentQueue) return;
    $4f2b320d6577794c$var$draining = false;
    if ($4f2b320d6577794c$var$currentQueue.length) $4f2b320d6577794c$var$queue = $4f2b320d6577794c$var$currentQueue.concat($4f2b320d6577794c$var$queue);
    else $4f2b320d6577794c$var$queueIndex = -1;
    if ($4f2b320d6577794c$var$queue.length) $4f2b320d6577794c$var$drainQueue();
}
function $4f2b320d6577794c$var$drainQueue() {
    if ($4f2b320d6577794c$var$draining) return;
    var timeout = $4f2b320d6577794c$var$runTimeout($4f2b320d6577794c$var$cleanUpNextTick);
    $4f2b320d6577794c$var$draining = true;
    var len = $4f2b320d6577794c$var$queue.length;
    while(len){
        $4f2b320d6577794c$var$currentQueue = $4f2b320d6577794c$var$queue;
        $4f2b320d6577794c$var$queue = [];
        while(++$4f2b320d6577794c$var$queueIndex < len)if ($4f2b320d6577794c$var$currentQueue) $4f2b320d6577794c$var$currentQueue[$4f2b320d6577794c$var$queueIndex].run();
        $4f2b320d6577794c$var$queueIndex = -1;
        len = $4f2b320d6577794c$var$queue.length;
    }
    $4f2b320d6577794c$var$currentQueue = null;
    $4f2b320d6577794c$var$draining = false;
    $4f2b320d6577794c$var$runClearTimeout(timeout);
}
$4f2b320d6577794c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4f2b320d6577794c$var$queue.push(new $4f2b320d6577794c$var$Item(fun, args));
    if ($4f2b320d6577794c$var$queue.length === 1 && !$4f2b320d6577794c$var$draining) $4f2b320d6577794c$var$runTimeout($4f2b320d6577794c$var$drainQueue);
};
// v8 likes predictible objects
function $4f2b320d6577794c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4f2b320d6577794c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4f2b320d6577794c$var$process.title = "browser";
$4f2b320d6577794c$var$process.browser = true;
$4f2b320d6577794c$var$process.env = {};
$4f2b320d6577794c$var$process.argv = [];
$4f2b320d6577794c$var$process.version = ""; // empty string to avoid regexp issues
$4f2b320d6577794c$var$process.versions = {};
function $4f2b320d6577794c$var$noop() {}
$4f2b320d6577794c$var$process.on = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.addListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.once = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.off = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.removeListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.removeAllListeners = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.emit = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.prependListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.prependOnceListener = $4f2b320d6577794c$var$noop;
$4f2b320d6577794c$var$process.listeners = function(name) {
    return [];
};
$4f2b320d6577794c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4f2b320d6577794c$var$process.cwd = function() {
    return "/";
};
$4f2b320d6577794c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4f2b320d6577794c$var$process.umask = function() {
    return 0;
};


"classList" in document.createElement("_") || !function(a) {
    "use strict";
    if ("Element" in a) {
        var b = "classList", c = "prototype", d = a.Element[c], e = Object, f = String[c].trim || function() {
            return this.replace(/^\s+|\s+$/g, "");
        }, g = Array[c].indexOf || function(a) {
            for(var b = 0, c = this.length; c > b; b++)if (b in this && this[b] === a) return b;
            return -1;
        }, h = function(a, b) {
            this.name = a, this.code = DOMException[a], this.message = b;
        }, i = function(a, b) {
            if ("" === b) throw new h("SYNTAX_ERR", "An invalid or illegal string was specified");
            if (/\s/.test(b)) throw new h("INVALID_CHARACTER_ERR", "String contains an invalid character");
            return g.call(a, b);
        }, j = function(a) {
            for(var b = f.call(a.getAttribute("class") || ""), c = b ? b.split(/\s+/) : [], d = 0, e = c.length; e > d; d++)this.push(c[d]);
            this._updateClassName = function() {
                a.setAttribute("class", this.toString());
            };
        }, k = j[c] = [], l = function() {
            return new j(this);
        };
        if (h[c] = Error[c], k.item = function(a) {
            return this[a] || null;
        }, k.contains = function(a) {
            return a += "", -1 !== i(this, a);
        }, k.add = function() {
            var a, b = arguments, c = 0, d = b.length, e = !1;
            do a = b[c] + "", -1 === i(this, a) && (this.push(a), e = !0);
            while (++c < d);
            e && this._updateClassName();
        }, k.remove = function() {
            var a, b, c = arguments, d = 0, e = c.length, f = !1;
            do for(a = c[d] + "", b = i(this, a); -1 !== b;)this.splice(b, 1), f = !0, b = i(this, a);
            while (++d < e);
            f && this._updateClassName();
        }, k.toggle = function(a, b) {
            a += "";
            var c = this.contains(a), d = c ? b !== !0 && "remove" : b !== !1 && "add";
            return d && this[d](a), b === !0 || b === !1 ? b : !c;
        }, k.toString = function() {
            return this.join(" ");
        }, e.defineProperty) {
            var m = {
                get: l,
                enumerable: !0,
                configurable: !0
            };
            try {
                e.defineProperty(d, b, m);
            } catch (n) {
                -2146823252 === n.number && (m.enumerable = !1, e.defineProperty(d, b, m));
            }
        } else e[c].__defineGetter__ && d.__defineGetter__(b, l);
    }
}(self), function(a) {
    "use strict";
    if (a.URL = a.URL || a.webkitURL, a.Blob && a.URL) try {
        return void new Blob;
    } catch (b) {}
    var c = a.BlobBuilder || a.WebKitBlobBuilder || a.MozBlobBuilder || function(a) {
        var b = function(a) {
            return Object.prototype.toString.call(a).match(/^\[object\s(.*)\]$/)[1];
        }, c = function() {
            this.data = [];
        }, d = function(a, b, c) {
            this.data = a, this.size = a.length, this.type = b, this.encoding = c;
        }, e = c.prototype, f = d.prototype, g = a.FileReaderSync, h = function(a) {
            this.code = this[this.name = a];
        }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), j = i.length, k = a.URL || a.webkitURL || a, l = k.createObjectURL, m = k.revokeObjectURL, n = k, o = a.btoa, p = a.atob, q = a.ArrayBuffer, r = a.Uint8Array, s = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
        for(d.fake = f.fake = !0; j--;)h.prototype[i[j]] = j + 1;
        return k.createObjectURL || (n = a.URL = function(a) {
            var b, c = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            return c.href = a, "origin" in c || ("data:" === c.protocol.toLowerCase() ? c.origin = null : (b = a.match(s), c.origin = b && b[1])), c;
        }), n.createObjectURL = function(a) {
            var b, c = a.type;
            return null === c && (c = "application/octet-stream"), a instanceof d ? (b = "data:" + c, "base64" === a.encoding ? b + ";base64," + a.data : "URI" === a.encoding ? b + "," + decodeURIComponent(a.data) : o ? b + ";base64," + o(a.data) : b + "," + encodeURIComponent(a.data)) : l ? l.call(k, a) : void 0;
        }, n.revokeObjectURL = function(a) {
            "data:" !== a.substring(0, 5) && m && m.call(k, a);
        }, e.append = function(a) {
            var c = this.data;
            if (r && (a instanceof q || a instanceof r)) {
                for(var e = "", f = new r(a), i = 0, j = f.length; j > i; i++)e += String.fromCharCode(f[i]);
                c.push(e);
            } else if ("Blob" === b(a) || "File" === b(a)) {
                if (!g) throw new h("NOT_READABLE_ERR");
                var k = new g;
                c.push(k.readAsBinaryString(a));
            } else a instanceof d ? "base64" === a.encoding && p ? c.push(p(a.data)) : "URI" === a.encoding ? c.push(decodeURIComponent(a.data)) : "raw" === a.encoding && c.push(a.data) : ("string" != typeof a && (a += ""), c.push(unescape(encodeURIComponent(a))));
        }, e.getBlob = function(a) {
            return arguments.length || (a = null), new d(this.data.join(""), a, "raw");
        }, e.toString = function() {
            return "[object BlobBuilder]";
        }, f.slice = function(a, b, c) {
            var e = arguments.length;
            return 3 > e && (c = null), new d(this.data.slice(a, e > 1 ? b : this.data.length), c, this.encoding);
        }, f.toString = function() {
            return "[object Blob]";
        }, f.close = function() {
            this.size = 0, delete this.data;
        }, c;
    }(a);
    a.Blob = function(a, b) {
        var d = b ? b.type || "" : "", e = new c;
        if (a) for(var f = 0, g = a.length; g > f; f++)Uint8Array && a[f] instanceof Uint8Array ? e.append(a[f].buffer) : e.append(a[f]);
        var h = e.getBlob(d);
        return !h.slice && h.webkitSlice && (h.slice = h.webkitSlice), h;
    };
    var d = Object.getPrototypeOf || function(a) {
        return a.__proto__;
    };
    a.Blob.prototype = d(new a.Blob);
}("undefined" != typeof self && self || "undefined" != typeof window && window || $9b19a0a83ad61f86$exports.content || $9b19a0a83ad61f86$exports), function(a, b) {
    "use strict";
    var c = "undefined" != typeof $4f2b320d6577794c$exports && $4f2b320d6577794c$exports && $4f2b320d6577794c$exports.versions && $4f2b320d6577794c$exports.versions.electron;
    c || false ? "function" == typeof define && define.amd ? define(function() {
        return b;
    }) : a.MediumEditor = b : $9b19a0a83ad61f86$exports = b;
}($9b19a0a83ad61f86$exports, function() {
    "use strict";
    function a(a, b) {
        return this.init(a, b);
    }
    return a.extensions = {}, function(b) {
        function c(a, b) {
            var c, d = Array.prototype.slice.call(arguments, 2);
            b = b || {};
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                if (f) for(c in f)f.hasOwnProperty(c) && "undefined" != typeof f[c] && (a || b.hasOwnProperty(c) === !1) && (b[c] = f[c]);
            }
            return b;
        }
        var d = !1;
        try {
            var e = document.createElement("div"), f = document.createTextNode(" ");
            e.appendChild(f), d = e.contains(f);
        } catch (g) {}
        var h = {
            isIE: "Microsoft Internet Explorer" === navigator.appName || "Netscape" === navigator.appName && null !== new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent),
            isEdge: null !== /Edge\/\d+/.exec(navigator.userAgent),
            isFF: navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
            isMac: b.navigator.platform.toUpperCase().indexOf("MAC") >= 0,
            keyCode: {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                SPACE: 32,
                DELETE: 46,
                K: 75,
                M: 77,
                V: 86
            },
            isMetaCtrlKey: function(a) {
                return !!(h.isMac && a.metaKey || !h.isMac && a.ctrlKey);
            },
            isKey: function(a, b) {
                var c = h.getKeyCode(a);
                return !1 === Array.isArray(b) ? c === b : -1 !== b.indexOf(c);
            },
            getKeyCode: function(a) {
                var b = a.which;
                return null === b && (b = null !== a.charCode ? a.charCode : a.keyCode), b;
            },
            blockContainerElementNames: [
                "p",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "blockquote",
                "pre",
                "ul",
                "li",
                "ol",
                "address",
                "article",
                "aside",
                "audio",
                "canvas",
                "dd",
                "dl",
                "dt",
                "fieldset",
                "figcaption",
                "figure",
                "footer",
                "form",
                "header",
                "hgroup",
                "main",
                "nav",
                "noscript",
                "output",
                "section",
                "video",
                "table",
                "thead",
                "tbody",
                "tfoot",
                "tr",
                "th",
                "td"
            ],
            emptyElementNames: [
                "br",
                "col",
                "colgroup",
                "hr",
                "img",
                "input",
                "source",
                "wbr"
            ],
            extend: function() {
                var a = [
                    !0
                ].concat(Array.prototype.slice.call(arguments));
                return c.apply(this, a);
            },
            defaults: function() {
                var a = [
                    !1
                ].concat(Array.prototype.slice.call(arguments));
                return c.apply(this, a);
            },
            createLink: function(a, b, c, d) {
                var e = a.createElement("a");
                return h.moveTextRangeIntoElement(b[0], b[b.length - 1], e), e.setAttribute("href", c), d && ("_blank" === d && e.setAttribute("rel", "noopener noreferrer"), e.setAttribute("target", d)), e;
            },
            findOrCreateMatchingTextNodes: function(a, b, c) {
                for(var d = a.createTreeWalker(b, NodeFilter.SHOW_ALL, null, !1), e = [], f = 0, g = !1, i = null, j = null; null !== (i = d.nextNode());)if (!(i.nodeType > 3)) {
                    if (3 === i.nodeType) {
                        if (!g && c.start < f + i.nodeValue.length && (g = !0, j = h.splitStartNodeIfNeeded(i, c.start, f)), g && h.splitEndNodeIfNeeded(i, j, c.end, f), g && f === c.end) break;
                        if (g && f > c.end + 1) throw new Error("PerformLinking overshot the target!");
                        g && e.push(j || i), f += i.nodeValue.length, null !== j && (f += j.nodeValue.length, d.nextNode()), j = null;
                    } else "img" === i.tagName.toLowerCase() && (!g && c.start <= f && (g = !0), g && e.push(i));
                }
                return e;
            },
            splitStartNodeIfNeeded: function(a, b, c) {
                return b !== c ? a.splitText(b - c) : null;
            },
            splitEndNodeIfNeeded: function(a, b, c, d) {
                var e, f;
                e = d + a.nodeValue.length + (b ? b.nodeValue.length : 0) - 1, f = c - d - (b ? a.nodeValue.length : 0), e >= c && d !== e && 0 !== f && (b || a).splitText(f);
            },
            splitByBlockElements: function(b) {
                if (3 !== b.nodeType && 1 !== b.nodeType) return [];
                var c = [], d = a.util.blockContainerElementNames.join(",");
                if (3 === b.nodeType || 0 === b.querySelectorAll(d).length) return [
                    b
                ];
                for(var e = 0; e < b.childNodes.length; e++){
                    var f = b.childNodes[e];
                    if (3 === f.nodeType) c.push(f);
                    else if (1 === f.nodeType) {
                        var g = f.querySelectorAll(d);
                        0 === g.length ? c.push(f) : c = c.concat(a.util.splitByBlockElements(f));
                    }
                }
                return c;
            },
            findAdjacentTextNodeWithContent: function(a, b, c) {
                var d, e = !1, f = c.createNodeIterator(a, NodeFilter.SHOW_TEXT, null, !1);
                for(d = f.nextNode(); d;){
                    if (d === b) e = !0;
                    else if (e && 3 === d.nodeType && d.nodeValue && d.nodeValue.trim().length > 0) break;
                    d = f.nextNode();
                }
                return d;
            },
            findPreviousSibling: function(a) {
                if (!a || h.isMediumEditorElement(a)) return !1;
                for(var b = a.previousSibling; !b && !h.isMediumEditorElement(a.parentNode);)a = a.parentNode, b = a.previousSibling;
                return b;
            },
            isDescendant: function(a, b, c) {
                if (!a || !b) return !1;
                if (a === b) return !!c;
                if (1 !== a.nodeType) return !1;
                if (d || 3 !== b.nodeType) return a.contains(b);
                for(var e = b.parentNode; null !== e;){
                    if (e === a) return !0;
                    e = e.parentNode;
                }
                return !1;
            },
            isElement: function(a) {
                return !(!a || 1 !== a.nodeType);
            },
            throttle: function(a, b) {
                var c, d, e, f = 50, g = null, h = 0, i = function() {
                    h = Date.now(), g = null, e = a.apply(c, d), g || (c = d = null);
                };
                return b || 0 === b || (b = f), function() {
                    var f = Date.now(), j = b - (f - h);
                    return c = this, d = arguments, 0 >= j || j > b ? (g && (clearTimeout(g), g = null), h = f, e = a.apply(c, d), g || (c = d = null)) : g || (g = setTimeout(i, j)), e;
                };
            },
            traverseUp: function(a, b) {
                if (!a) return !1;
                do {
                    if (1 === a.nodeType) {
                        if (b(a)) return a;
                        if (h.isMediumEditorElement(a)) return !1;
                    }
                    a = a.parentNode;
                }while (a);
                return !1;
            },
            htmlEntities: function(a) {
                return String(a).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
            },
            insertHTMLCommand: function(b, c) {
                var d, e, f, g, i, j, k, l = !1, m = [
                    "insertHTML",
                    !1,
                    c
                ];
                if (!a.util.isEdge && b.queryCommandSupported("insertHTML")) try {
                    return b.execCommand.apply(b, m);
                } catch (n) {}
                if (d = b.getSelection(), d.rangeCount) {
                    if (e = d.getRangeAt(0), k = e.commonAncestorContainer, h.isMediumEditorElement(k) && !k.firstChild) e.selectNode(k.appendChild(b.createTextNode("")));
                    else if (3 === k.nodeType && 0 === e.startOffset && e.endOffset === k.nodeValue.length || 3 !== k.nodeType && k.innerHTML === e.toString()) {
                        for(; !h.isMediumEditorElement(k) && k.parentNode && 1 === k.parentNode.childNodes.length && !h.isMediumEditorElement(k.parentNode);)k = k.parentNode;
                        e.selectNode(k);
                    }
                    for(e.deleteContents(), f = b.createElement("div"), f.innerHTML = c, g = b.createDocumentFragment(); f.firstChild;)i = f.firstChild, j = g.appendChild(i);
                    e.insertNode(g), j && (e = e.cloneRange(), e.setStartAfter(j), e.collapse(!0), a.selection.selectRange(b, e)), l = !0;
                }
                return b.execCommand.callListeners && b.execCommand.callListeners(m, l), l;
            },
            execFormatBlock: function(b, c) {
                var d, e = h.getTopBlockContainer(a.selection.getSelectionStart(b));
                if ("blockquote" === c) {
                    if (e && (d = Array.prototype.slice.call(e.childNodes), d.some(function(a) {
                        return h.isBlockContainer(a);
                    }))) return b.execCommand("outdent", !1, null);
                    if (h.isIE) return b.execCommand("indent", !1, c);
                }
                if (e && c === e.nodeName.toLowerCase() && (c = "p"), h.isIE && (c = "<" + c + ">"), e && "blockquote" === e.nodeName.toLowerCase()) {
                    if (h.isIE && "<p>" === c) return b.execCommand("outdent", !1, c);
                    if ((h.isFF || h.isEdge) && "p" === c) return d = Array.prototype.slice.call(e.childNodes), d.some(function(a) {
                        return !h.isBlockContainer(a);
                    }) && b.execCommand("formatBlock", !1, c), b.execCommand("outdent", !1, c);
                }
                return b.execCommand("formatBlock", !1, c);
            },
            setTargetBlank: function(a, b) {
                var c, d = b || !1;
                if ("a" === a.nodeName.toLowerCase()) a.target = "_blank", a.rel = "noopener noreferrer";
                else for(a = a.getElementsByTagName("a"), c = 0; c < a.length; c += 1)!1 !== d && d !== a[c].attributes.href.value || (a[c].target = "_blank", a[c].rel = "noopener noreferrer");
            },
            removeTargetBlank: function(a, b) {
                var c;
                if ("a" === a.nodeName.toLowerCase()) a.removeAttribute("target"), a.removeAttribute("rel");
                else for(a = a.getElementsByTagName("a"), c = 0; c < a.length; c += 1)b === a[c].attributes.href.value && (a[c].removeAttribute("target"), a[c].removeAttribute("rel"));
            },
            addClassToAnchors: function(a, b) {
                var c, d, e = b.split(" ");
                if ("a" === a.nodeName.toLowerCase()) for(d = 0; d < e.length; d += 1)a.classList.add(e[d]);
                else {
                    var f = a.getElementsByTagName("a");
                    if (0 === f.length) {
                        var g = h.getClosestTag(a, "a");
                        a = g ? [
                            g
                        ] : [];
                    } else a = f;
                    for(c = 0; c < a.length; c += 1)for(d = 0; d < e.length; d += 1)a[c].classList.add(e[d]);
                }
            },
            isListItem: function(a) {
                if (!a) return !1;
                if ("li" === a.nodeName.toLowerCase()) return !0;
                for(var b = a.parentNode, c = b.nodeName.toLowerCase(); "li" === c || !h.isBlockContainer(b) && "div" !== c;){
                    if ("li" === c) return !0;
                    if (b = b.parentNode, !b) return !1;
                    c = b.nodeName.toLowerCase();
                }
                return !1;
            },
            cleanListDOM: function(b, c) {
                if ("li" === c.nodeName.toLowerCase()) {
                    var d = c.parentElement;
                    "p" === d.parentElement.nodeName.toLowerCase() && (h.unwrap(d.parentElement, b), a.selection.moveCursor(b, c.firstChild, c.firstChild.textContent.length));
                }
            },
            splitOffDOMTree: function(a, b, c) {
                for(var d = b, e = null, f = !c; d !== a;){
                    var g, h = d.parentNode, i = h.cloneNode(!1), j = f ? d : h.firstChild;
                    for(e && (f ? i.appendChild(e) : g = e), e = i; j;){
                        var k = j.nextSibling;
                        j === d ? (j.hasChildNodes() ? j = j.cloneNode(!1) : j.parentNode.removeChild(j), j.textContent && e.appendChild(j), j = f ? k : null) : (j.parentNode.removeChild(j), (j.hasChildNodes() || j.textContent) && e.appendChild(j), j = k);
                    }
                    g && e.appendChild(g), d = h;
                }
                return e;
            },
            moveTextRangeIntoElement: function(a, b, c) {
                if (!a || !b) return !1;
                var d = h.findCommonRoot(a, b);
                if (!d) return !1;
                if (b === a) {
                    var e = a.parentNode, f = a.nextSibling;
                    return e.removeChild(a), c.appendChild(a), f ? e.insertBefore(c, f) : e.appendChild(c), c.hasChildNodes();
                }
                for(var g, i, j, k = [], l = 0; l < d.childNodes.length; l++)if (j = d.childNodes[l], g) {
                    if (h.isDescendant(j, b, !0)) {
                        i = j;
                        break;
                    }
                    k.push(j);
                } else h.isDescendant(j, a, !0) && (g = j);
                var m = i.nextSibling, n = d.ownerDocument.createDocumentFragment();
                return g === a ? (g.parentNode.removeChild(g), n.appendChild(g)) : n.appendChild(h.splitOffDOMTree(g, a)), k.forEach(function(a) {
                    a.parentNode.removeChild(a), n.appendChild(a);
                }), i === b ? (i.parentNode.removeChild(i), n.appendChild(i)) : n.appendChild(h.splitOffDOMTree(i, b, !0)), c.appendChild(n), i.parentNode === d ? d.insertBefore(c, i) : m ? d.insertBefore(c, m) : d.appendChild(c), c.hasChildNodes();
            },
            depthOfNode: function(a) {
                for(var b = 0, c = a; null !== c.parentNode;)c = c.parentNode, b++;
                return b;
            },
            findCommonRoot: function(a, b) {
                for(var c = h.depthOfNode(a), d = h.depthOfNode(b), e = a, f = b; c !== d;)c > d ? (e = e.parentNode, c -= 1) : (f = f.parentNode, d -= 1);
                for(; e !== f;)e = e.parentNode, f = f.parentNode;
                return e;
            },
            isElementAtBeginningOfBlock: function(a) {
                for(var b, c; !h.isBlockContainer(a) && !h.isMediumEditorElement(a);){
                    for(c = a; c = c.previousSibling;)if (b = 3 === c.nodeType ? c.nodeValue : c.textContent, b.length > 0) return !1;
                    a = a.parentNode;
                }
                return !0;
            },
            isMediumEditorElement: function(a) {
                return a && a.getAttribute && !!a.getAttribute("data-medium-editor-element");
            },
            getContainerEditorElement: function(a) {
                return h.traverseUp(a, function(a) {
                    return h.isMediumEditorElement(a);
                });
            },
            isBlockContainer: function(a) {
                return a && 3 !== a.nodeType && -1 !== h.blockContainerElementNames.indexOf(a.nodeName.toLowerCase());
            },
            getClosestBlockContainer: function(a) {
                return h.traverseUp(a, function(a) {
                    return h.isBlockContainer(a) || h.isMediumEditorElement(a);
                });
            },
            getTopBlockContainer: function(a) {
                var b = h.isBlockContainer(a) ? a : !1;
                return h.traverseUp(a, function(a) {
                    return h.isBlockContainer(a) && (b = a), !b && h.isMediumEditorElement(a) ? (b = a, !0) : !1;
                }), b;
            },
            getFirstSelectableLeafNode: function(a) {
                for(; a && a.firstChild;)a = a.firstChild;
                if (a = h.traverseUp(a, function(a) {
                    return -1 === h.emptyElementNames.indexOf(a.nodeName.toLowerCase());
                }), "table" === a.nodeName.toLowerCase()) {
                    var b = a.querySelector("th, td");
                    b && (a = b);
                }
                return a;
            },
            getFirstTextNode: function(a) {
                return h.warn("getFirstTextNode is deprecated and will be removed in version 6.0.0"), h._getFirstTextNode(a);
            },
            _getFirstTextNode: function(a) {
                if (3 === a.nodeType) return a;
                for(var b = 0; b < a.childNodes.length; b++){
                    var c = h._getFirstTextNode(a.childNodes[b]);
                    if (null !== c) return c;
                }
                return null;
            },
            ensureUrlHasProtocol: function(a) {
                return -1 === a.indexOf("://") ? "http://" + a : a;
            },
            warn: function() {
                void 0 !== b.console && "function" == typeof b.console.warn && b.console.warn.apply(b.console, arguments);
            },
            deprecated: function(a, b, c) {
                var d = a + " is deprecated, please use " + b + " instead.";
                c && (d += " Will be removed in " + c), h.warn(d);
            },
            deprecatedMethod: function(a, b, c, d) {
                h.deprecated(a, b, d), "function" == typeof this[b] && this[b].apply(this, c);
            },
            cleanupAttrs: function(a, b) {
                b.forEach(function(b) {
                    a.removeAttribute(b);
                });
            },
            cleanupTags: function(a, b) {
                -1 !== b.indexOf(a.nodeName.toLowerCase()) && a.parentNode.removeChild(a);
            },
            unwrapTags: function(b, c) {
                -1 !== c.indexOf(b.nodeName.toLowerCase()) && a.util.unwrap(b, document);
            },
            getClosestTag: function(a, b) {
                return h.traverseUp(a, function(a) {
                    return a.nodeName.toLowerCase() === b.toLowerCase();
                });
            },
            unwrap: function(a, b) {
                for(var c = b.createDocumentFragment(), d = Array.prototype.slice.call(a.childNodes), e = 0; e < d.length; e++)c.appendChild(d[e]);
                c.childNodes.length ? a.parentNode.replaceChild(c, a) : a.parentNode.removeChild(a);
            },
            guid: function() {
                function a() {
                    return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
                }
                return a() + a() + "-" + a() + "-" + a() + "-" + a() + "-" + a() + a() + a();
            }
        };
        a.util = h;
    }(window), function() {
        var b = function(b) {
            a.util.extend(this, b);
        };
        b.extend = function(b) {
            var c, d = this;
            c = b && b.hasOwnProperty("constructor") ? b.constructor : function() {
                return d.apply(this, arguments);
            }, a.util.extend(c, d);
            var e = function() {
                this.constructor = c;
            };
            return e.prototype = d.prototype, c.prototype = new e, b && a.util.extend(c.prototype, b), c;
        }, b.prototype = {
            init: function() {},
            base: void 0,
            name: void 0,
            checkState: void 0,
            destroy: void 0,
            queryCommandState: void 0,
            isActive: void 0,
            isAlreadyApplied: void 0,
            setActive: void 0,
            setInactive: void 0,
            getInteractionElements: void 0,
            window: void 0,
            document: void 0,
            getEditorElements: function() {
                return this.base.elements;
            },
            getEditorId: function() {
                return this.base.id;
            },
            getEditorOption: function(a) {
                return this.base.options[a];
            }
        }, [
            "execAction",
            "on",
            "off",
            "subscribe",
            "trigger"
        ].forEach(function(a) {
            b.prototype[a] = function() {
                return this.base[a].apply(this.base, arguments);
            };
        }), a.Extension = b;
    }(), function() {
        function b(b) {
            return a.util.isBlockContainer(b) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
        var c = {
            findMatchingSelectionParent: function(b, c) {
                var d, e, f = c.getSelection();
                return 0 === f.rangeCount ? !1 : (d = f.getRangeAt(0), e = d.commonAncestorContainer, a.util.traverseUp(e, b));
            },
            getSelectionElement: function(b) {
                return this.findMatchingSelectionParent(function(b) {
                    return a.util.isMediumEditorElement(b);
                }, b);
            },
            exportSelection: function(a, b) {
                if (!a) return null;
                var c = null, d = b.getSelection();
                if (d.rangeCount > 0) {
                    var e, f = d.getRangeAt(0), g = f.cloneRange();
                    g.selectNodeContents(a), g.setEnd(f.startContainer, f.startOffset), e = g.toString().length, c = {
                        start: e,
                        end: e + f.toString().length
                    }, this.doesRangeStartWithImages(f, b) && (c.startsWithImage = !0);
                    var h = this.getTrailingImageCount(a, c, f.endContainer, f.endOffset);
                    if (h && (c.trailingImageCount = h), 0 !== e) {
                        var i = this.getIndexRelativeToAdjacentEmptyBlocks(b, a, f.startContainer, f.startOffset);
                        -1 !== i && (c.emptyBlocksIndex = i);
                    }
                }
                return c;
            },
            importSelection: function(a, b, c, d) {
                if (a && b) {
                    var e = c.createRange();
                    e.setStart(b, 0), e.collapse(!0);
                    var f, g = b, h = [], i = 0, j = !1, k = !1, l = 0, m = !1, n = !1, o = null;
                    for((d || a.startsWithImage || "undefined" != typeof a.emptyBlocksIndex) && (n = !0); !m && g;)if (g.nodeType > 3) g = h.pop();
                    else {
                        if (3 !== g.nodeType || k) {
                            if (a.trailingImageCount && k && ("img" === g.nodeName.toLowerCase() && l++, l === a.trailingImageCount)) {
                                for(var p = 0; g.parentNode.childNodes[p] !== g;)p++;
                                e.setEnd(g.parentNode, p + 1), m = !0;
                            }
                            if (!m && 1 === g.nodeType) for(var q = g.childNodes.length - 1; q >= 0;)h.push(g.childNodes[q]), q -= 1;
                        } else f = i + g.length, !j && a.start >= i && a.start <= f && (n || a.start < f ? (e.setStart(g, a.start - i), j = !0) : o = g), j && a.end >= i && a.end <= f && (a.trailingImageCount ? k = !0 : (e.setEnd(g, a.end - i), m = !0)), i = f;
                        m || (g = h.pop());
                    }
                    !j && o && (e.setStart(o, o.length), e.setEnd(o, o.length)), "undefined" != typeof a.emptyBlocksIndex && (e = this.importSelectionMoveCursorPastBlocks(c, b, a.emptyBlocksIndex, e)), d && (e = this.importSelectionMoveCursorPastAnchor(a, e)), this.selectRange(c, e);
                }
            },
            importSelectionMoveCursorPastAnchor: function(b, c) {
                var d = function(a) {
                    return "a" === a.nodeName.toLowerCase();
                };
                if (b.start === b.end && 3 === c.startContainer.nodeType && c.startOffset === c.startContainer.nodeValue.length && a.util.traverseUp(c.startContainer, d)) {
                    for(var e = c.startContainer, f = c.startContainer.parentNode; null !== f && "a" !== f.nodeName.toLowerCase();)f.childNodes[f.childNodes.length - 1] !== e ? f = null : (e = f, f = f.parentNode);
                    if (null !== f && "a" === f.nodeName.toLowerCase()) {
                        for(var g = null, h = 0; null === g && h < f.parentNode.childNodes.length; h++)f.parentNode.childNodes[h] === f && (g = h);
                        c.setStart(f.parentNode, g + 1), c.collapse(!0);
                    }
                }
                return c;
            },
            importSelectionMoveCursorPastBlocks: function(c, d, e, f) {
                var g, h, i = c.createTreeWalker(d, NodeFilter.SHOW_ELEMENT, b, !1), j = f.startContainer, k = 0;
                for(e = e || 1, g = 3 === j.nodeType && a.util.isBlockContainer(j.previousSibling) ? j.previousSibling : a.util.getClosestBlockContainer(j); i.nextNode();)if (h) {
                    if (h = i.currentNode, k++, k === e) break;
                    if (h.textContent.length > 0) break;
                } else g === i.currentNode && (h = i.currentNode);
                return h || (h = g), f.setStart(a.util.getFirstSelectableLeafNode(h), 0), f;
            },
            getIndexRelativeToAdjacentEmptyBlocks: function(c, d, e, f) {
                if (e.textContent.length > 0 && f > 0) return -1;
                var g = e;
                if (3 !== g.nodeType && (g = e.childNodes[f]), g) {
                    if (!a.util.isElementAtBeginningOfBlock(g)) return -1;
                    var h = a.util.findPreviousSibling(g);
                    if (!h) return -1;
                    if (h.nodeValue) return -1;
                }
                for(var i = a.util.getClosestBlockContainer(e), j = c.createTreeWalker(d, NodeFilter.SHOW_ELEMENT, b, !1), k = 0; j.nextNode();){
                    var l = "" === j.currentNode.textContent;
                    if ((l || k > 0) && (k += 1), j.currentNode === i) return k;
                    l || (k = 0);
                }
                return k;
            },
            doesRangeStartWithImages: function(a, b) {
                if (0 !== a.startOffset || 1 !== a.startContainer.nodeType) return !1;
                if ("img" === a.startContainer.nodeName.toLowerCase()) return !0;
                var c = a.startContainer.querySelector("img");
                if (!c) return !1;
                for(var d = b.createTreeWalker(a.startContainer, NodeFilter.SHOW_ALL, null, !1); d.nextNode();){
                    var e = d.currentNode;
                    if (e === c) break;
                    if (e.nodeValue) return !1;
                }
                return !0;
            },
            getTrailingImageCount: function(a, b, c, d) {
                if (0 === d || 1 !== c.nodeType) return 0;
                if ("img" !== c.nodeName.toLowerCase() && !c.querySelector("img")) return 0;
                for(var e = c.childNodes[d - 1]; e.hasChildNodes();)e = e.lastChild;
                for(var f, g = a, h = [], i = 0, j = !1, k = !1, l = !1, m = 0; !l && g;)if (g.nodeType > 3) g = h.pop();
                else {
                    if (3 !== g.nodeType || k) {
                        if ("img" === g.nodeName.toLowerCase() && m++, g === e) l = !0;
                        else if (1 === g.nodeType) for(var n = g.childNodes.length - 1; n >= 0;)h.push(g.childNodes[n]), n -= 1;
                    } else m = 0, f = i + g.length, !j && b.start >= i && b.start <= f && (j = !0), j && b.end >= i && b.end <= f && (k = !0), i = f;
                    l || (g = h.pop());
                }
                return m;
            },
            selectionContainsContent: function(a) {
                var b = a.getSelection();
                if (!b || b.isCollapsed || !b.rangeCount) return !1;
                if ("" !== b.toString().trim()) return !0;
                var c = this.getSelectedParentElement(b.getRangeAt(0));
                return !(!c || !("img" === c.nodeName.toLowerCase() || 1 === c.nodeType && c.querySelector("img")));
            },
            selectionInContentEditableFalse: function(a) {
                var b, c = this.findMatchingSelectionParent(function(a) {
                    var c = a && a.getAttribute("contenteditable");
                    return "true" === c && (b = !0), "#text" !== a.nodeName && "false" === c;
                }, a);
                return !b && c;
            },
            getSelectionHtml: function(a) {
                var b, c, d, e = "", f = a.getSelection();
                if (f.rangeCount) {
                    for(d = a.createElement("div"), b = 0, c = f.rangeCount; c > b; b += 1)d.appendChild(f.getRangeAt(b).cloneContents());
                    e = d.innerHTML;
                }
                return e;
            },
            getCaretOffsets: function(a, b) {
                var c, d;
                return b || (b = window.getSelection().getRangeAt(0)), c = b.cloneRange(), d = b.cloneRange(), c.selectNodeContents(a), c.setEnd(b.endContainer, b.endOffset), d.selectNodeContents(a), d.setStart(b.endContainer, b.endOffset), {
                    left: c.toString().length,
                    right: d.toString().length
                };
            },
            rangeSelectsSingleNode: function(a) {
                var b = a.startContainer;
                return b === a.endContainer && b.hasChildNodes() && a.endOffset === a.startOffset + 1;
            },
            getSelectedParentElement: function(a) {
                return a ? this.rangeSelectsSingleNode(a) && 3 !== a.startContainer.childNodes[a.startOffset].nodeType ? a.startContainer.childNodes[a.startOffset] : 3 === a.startContainer.nodeType ? a.startContainer.parentNode : a.startContainer : null;
            },
            getSelectedElements: function(a) {
                var b, c, d, e = a.getSelection();
                if (!e.rangeCount || e.isCollapsed || !e.getRangeAt(0).commonAncestorContainer) return [];
                if (b = e.getRangeAt(0), 3 === b.commonAncestorContainer.nodeType) {
                    for(c = [], d = b.commonAncestorContainer; d.parentNode && 1 === d.parentNode.childNodes.length;)c.push(d.parentNode), d = d.parentNode;
                    return c;
                }
                return [].filter.call(b.commonAncestorContainer.getElementsByTagName("*"), function(a) {
                    return "function" == typeof e.containsNode ? e.containsNode(a, !0) : !0;
                });
            },
            selectNode: function(a, b) {
                var c = b.createRange();
                c.selectNodeContents(a), this.selectRange(b, c);
            },
            select: function(a, b, c, d, e) {
                var f = a.createRange();
                return f.setStart(b, c), d ? f.setEnd(d, e) : f.collapse(!0), this.selectRange(a, f), f;
            },
            clearSelection: function(a, b) {
                b ? a.getSelection().collapseToStart() : a.getSelection().collapseToEnd();
            },
            moveCursor: function(a, b, c) {
                this.select(a, b, c);
            },
            getSelectionRange: function(a) {
                var b = a.getSelection();
                return 0 === b.rangeCount ? null : b.getRangeAt(0);
            },
            selectRange: function(a, b) {
                var c = a.getSelection();
                c.removeAllRanges(), c.addRange(b);
            },
            getSelectionStart: function(a) {
                var b = a.getSelection().anchorNode, c = b && 3 === b.nodeType ? b.parentNode : b;
                return c;
            }
        };
        a.selection = c;
    }(), function() {
        function b(b, c) {
            return b ? b.some(function(b) {
                if ("function" != typeof b.getInteractionElements) return !1;
                var d = b.getInteractionElements();
                return d ? (Array.isArray(d) || (d = [
                    d
                ]), d.some(function(b) {
                    return a.util.isDescendant(b, c, !0);
                })) : !1;
            }) : !1;
        }
        var c = function(a) {
            this.base = a, this.options = this.base.options, this.events = [], this.disabledEvents = {}, this.customEvents = {}, this.listeners = {};
        };
        c.prototype = {
            InputEventOnContenteditableSupported: !a.util.isIE && !a.util.isEdge,
            attachDOMEvent: function(b, c, d, e) {
                var f = this.base.options.contentWindow, g = this.base.options.ownerDocument;
                b = a.util.isElement(b) || [
                    f,
                    g
                ].indexOf(b) > -1 ? [
                    b
                ] : b, Array.prototype.forEach.call(b, (function(a) {
                    a.addEventListener(c, d, e), this.events.push([
                        a,
                        c,
                        d,
                        e
                    ]);
                }).bind(this));
            },
            detachDOMEvent: function(b, c, d, e) {
                var f, g, h = this.base.options.contentWindow, i = this.base.options.ownerDocument;
                b && (b = a.util.isElement(b) || [
                    h,
                    i
                ].indexOf(b) > -1 ? [
                    b
                ] : b, Array.prototype.forEach.call(b, (function(a) {
                    f = this.indexOfListener(a, c, d, e), -1 !== f && (g = this.events.splice(f, 1)[0], g[0].removeEventListener(g[1], g[2], g[3]));
                }).bind(this)));
            },
            indexOfListener: function(a, b, c, d) {
                var e, f, g;
                for(e = 0, f = this.events.length; f > e; e += 1)if (g = this.events[e], g[0] === a && g[1] === b && g[2] === c && g[3] === d) return e;
                return -1;
            },
            detachAllDOMEvents: function() {
                for(var a = this.events.pop(); a;)a[0].removeEventListener(a[1], a[2], a[3]), a = this.events.pop();
            },
            detachAllEventsFromElement: function(a) {
                for(var b = this.events.filter(function(b) {
                    return b && b[0].getAttribute && b[0].getAttribute("medium-editor-index") === a.getAttribute("medium-editor-index");
                }), c = 0, d = b.length; d > c; c++){
                    var e = b[c];
                    this.detachDOMEvent(e[0], e[1], e[2], e[3]);
                }
            },
            attachAllEventsToElement: function(a) {
                this.listeners.editableInput && (this.contentCache[a.getAttribute("medium-editor-index")] = a.innerHTML), this.eventsCache && this.eventsCache.forEach(function(b) {
                    this.attachDOMEvent(a, b.name, b.handler.bind(this));
                }, this);
            },
            enableCustomEvent: function(a) {
                void 0 !== this.disabledEvents[a] && delete this.disabledEvents[a];
            },
            disableCustomEvent: function(a) {
                this.disabledEvents[a] = !0;
            },
            attachCustomEvent: function(a, b) {
                this.setupListener(a), this.customEvents[a] || (this.customEvents[a] = []), this.customEvents[a].push(b);
            },
            detachCustomEvent: function(a, b) {
                var c = this.indexOfCustomListener(a, b);
                -1 !== c && this.customEvents[a].splice(c, 1);
            },
            indexOfCustomListener: function(a, b) {
                return this.customEvents[a] && this.customEvents[a].length ? this.customEvents[a].indexOf(b) : -1;
            },
            detachAllCustomEvents: function() {
                this.customEvents = {};
            },
            triggerCustomEvent: function(a, b, c) {
                this.customEvents[a] && !this.disabledEvents[a] && this.customEvents[a].forEach(function(a) {
                    a(b, c);
                });
            },
            destroy: function() {
                this.detachAllDOMEvents(), this.detachAllCustomEvents(), this.detachExecCommand(), this.base.elements && this.base.elements.forEach(function(a) {
                    a.removeAttribute("data-medium-focused");
                });
            },
            attachToExecCommand: function() {
                this.execCommandListener || (this.execCommandListener = (function(a) {
                    this.handleDocumentExecCommand(a);
                }).bind(this), this.wrapExecCommand(), this.options.ownerDocument.execCommand.listeners.push(this.execCommandListener));
            },
            detachExecCommand: function() {
                var a = this.options.ownerDocument;
                if (this.execCommandListener && a.execCommand.listeners) {
                    var b = a.execCommand.listeners.indexOf(this.execCommandListener);
                    -1 !== b && a.execCommand.listeners.splice(b, 1), a.execCommand.listeners.length || this.unwrapExecCommand();
                }
            },
            wrapExecCommand: function() {
                var a = this.options.ownerDocument;
                if (!a.execCommand.listeners) {
                    var b = function(b, c) {
                        a.execCommand.listeners && a.execCommand.listeners.forEach(function(a) {
                            a({
                                command: b[0],
                                value: b[2],
                                args: b,
                                result: c
                            });
                        });
                    }, c = function() {
                        var c = a.execCommand.orig.apply(this, arguments);
                        if (!a.execCommand.listeners) return c;
                        var d = Array.prototype.slice.call(arguments);
                        return b(d, c), c;
                    };
                    c.orig = a.execCommand, c.listeners = [], c.callListeners = b, a.execCommand = c;
                }
            },
            unwrapExecCommand: function() {
                var a = this.options.ownerDocument;
                a.execCommand.orig && (a.execCommand = a.execCommand.orig);
            },
            setupListener: function(a) {
                if (!this.listeners[a]) {
                    switch(a){
                        case "externalInteraction":
                            this.attachDOMEvent(this.options.ownerDocument.body, "mousedown", this.handleBodyMousedown.bind(this), !0), this.attachDOMEvent(this.options.ownerDocument.body, "click", this.handleBodyClick.bind(this), !0), this.attachDOMEvent(this.options.ownerDocument.body, "focus", this.handleBodyFocus.bind(this), !0);
                            break;
                        case "blur":
                            this.setupListener("externalInteraction");
                            break;
                        case "focus":
                            this.setupListener("externalInteraction");
                            break;
                        case "editableInput":
                            this.contentCache = {}, this.base.elements.forEach(function(a) {
                                this.contentCache[a.getAttribute("medium-editor-index")] = a.innerHTML;
                            }, this), this.InputEventOnContenteditableSupported && this.attachToEachElement("input", this.handleInput), this.InputEventOnContenteditableSupported || (this.setupListener("editableKeypress"), this.keypressUpdateInput = !0, this.attachDOMEvent(document, "selectionchange", this.handleDocumentSelectionChange.bind(this)), this.attachToExecCommand());
                            break;
                        case "editableClick":
                            this.attachToEachElement("click", this.handleClick);
                            break;
                        case "editableBlur":
                            this.attachToEachElement("blur", this.handleBlur);
                            break;
                        case "editableKeypress":
                            this.attachToEachElement("keypress", this.handleKeypress);
                            break;
                        case "editableKeyup":
                            this.attachToEachElement("keyup", this.handleKeyup);
                            break;
                        case "editableKeydown":
                            this.attachToEachElement("keydown", this.handleKeydown);
                            break;
                        case "editableKeydownSpace":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownEnter":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownTab":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableKeydownDelete":
                            this.setupListener("editableKeydown");
                            break;
                        case "editableMouseover":
                            this.attachToEachElement("mouseover", this.handleMouseover);
                            break;
                        case "editableDrag":
                            this.attachToEachElement("dragover", this.handleDragging), this.attachToEachElement("dragleave", this.handleDragging);
                            break;
                        case "editableDrop":
                            this.attachToEachElement("drop", this.handleDrop);
                            break;
                        case "editablePaste":
                            this.attachToEachElement("paste", this.handlePaste);
                    }
                    this.listeners[a] = !0;
                }
            },
            attachToEachElement: function(a, b) {
                this.eventsCache || (this.eventsCache = []), this.base.elements.forEach(function(c) {
                    this.attachDOMEvent(c, a, b.bind(this));
                }, this), this.eventsCache.push({
                    name: a,
                    handler: b
                });
            },
            cleanupElement: function(a) {
                var b = a.getAttribute("medium-editor-index");
                b && (this.detachAllEventsFromElement(a), this.contentCache && delete this.contentCache[b]);
            },
            focusElement: function(a) {
                a.focus(), this.updateFocus(a, {
                    target: a,
                    type: "focus"
                });
            },
            updateFocus: function(c, d) {
                var e, f = this.base.getFocusedElement();
                f && "click" === d.type && this.lastMousedownTarget && (a.util.isDescendant(f, this.lastMousedownTarget, !0) || b(this.base.extensions, this.lastMousedownTarget)) && (e = f), e || this.base.elements.some(function(b) {
                    return !e && a.util.isDescendant(b, c, !0) && (e = b), !!e;
                }, this);
                var g = !a.util.isDescendant(f, c, !0) && !b(this.base.extensions, c);
                e !== f && (f && g && (f.removeAttribute("data-medium-focused"), this.triggerCustomEvent("blur", d, f)), e && (e.setAttribute("data-medium-focused", !0), this.triggerCustomEvent("focus", d, e))), g && this.triggerCustomEvent("externalInteraction", d);
            },
            updateInput: function(a, b) {
                if (this.contentCache) {
                    var c = a.getAttribute("medium-editor-index"), d = a.innerHTML;
                    d !== this.contentCache[c] && this.triggerCustomEvent("editableInput", b, a), this.contentCache[c] = d;
                }
            },
            handleDocumentSelectionChange: function(b) {
                if (b.currentTarget && b.currentTarget.activeElement) {
                    var c, d = b.currentTarget.activeElement;
                    this.base.elements.some(function(b) {
                        return a.util.isDescendant(b, d, !0) ? (c = b, !0) : !1;
                    }, this), c && this.updateInput(c, {
                        target: d,
                        currentTarget: c
                    });
                }
            },
            handleDocumentExecCommand: function() {
                var a = this.base.getFocusedElement();
                a && this.updateInput(a, {
                    target: a,
                    currentTarget: a
                });
            },
            handleBodyClick: function(a) {
                this.updateFocus(a.target, a);
            },
            handleBodyFocus: function(a) {
                this.updateFocus(a.target, a);
            },
            handleBodyMousedown: function(a) {
                this.lastMousedownTarget = a.target;
            },
            handleInput: function(a) {
                this.updateInput(a.currentTarget, a);
            },
            handleClick: function(a) {
                this.triggerCustomEvent("editableClick", a, a.currentTarget);
            },
            handleBlur: function(a) {
                this.triggerCustomEvent("editableBlur", a, a.currentTarget);
            },
            handleKeypress: function(a) {
                if (this.triggerCustomEvent("editableKeypress", a, a.currentTarget), this.keypressUpdateInput) {
                    var b = {
                        target: a.target,
                        currentTarget: a.currentTarget
                    };
                    setTimeout((function() {
                        this.updateInput(b.currentTarget, b);
                    }).bind(this), 0);
                }
            },
            handleKeyup: function(a) {
                this.triggerCustomEvent("editableKeyup", a, a.currentTarget);
            },
            handleMouseover: function(a) {
                this.triggerCustomEvent("editableMouseover", a, a.currentTarget);
            },
            handleDragging: function(a) {
                this.triggerCustomEvent("editableDrag", a, a.currentTarget);
            },
            handleDrop: function(a) {
                this.triggerCustomEvent("editableDrop", a, a.currentTarget);
            },
            handlePaste: function(a) {
                this.triggerCustomEvent("editablePaste", a, a.currentTarget);
            },
            handleKeydown: function(b) {
                return this.triggerCustomEvent("editableKeydown", b, b.currentTarget), a.util.isKey(b, a.util.keyCode.SPACE) ? this.triggerCustomEvent("editableKeydownSpace", b, b.currentTarget) : a.util.isKey(b, a.util.keyCode.ENTER) || b.ctrlKey && a.util.isKey(b, a.util.keyCode.M) ? this.triggerCustomEvent("editableKeydownEnter", b, b.currentTarget) : a.util.isKey(b, a.util.keyCode.TAB) ? this.triggerCustomEvent("editableKeydownTab", b, b.currentTarget) : a.util.isKey(b, [
                    a.util.keyCode.DELETE,
                    a.util.keyCode.BACKSPACE
                ]) ? this.triggerCustomEvent("editableKeydownDelete", b, b.currentTarget) : void 0;
            }
        }, a.Events = c;
    }(), function() {
        var b = a.Extension.extend({
            action: void 0,
            aria: void 0,
            tagNames: void 0,
            style: void 0,
            useQueryState: void 0,
            contentDefault: void 0,
            contentFA: void 0,
            classList: void 0,
            attrs: void 0,
            constructor: function(c) {
                b.isBuiltInButton(c) ? a.Extension.call(this, this.defaults[c]) : a.Extension.call(this, c);
            },
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.button = this.createButton(), this.on(this.button, "click", this.handleClick.bind(this));
            },
            getButton: function() {
                return this.button;
            },
            getAction: function() {
                return "function" == typeof this.action ? this.action(this.base.options) : this.action;
            },
            getAria: function() {
                return "function" == typeof this.aria ? this.aria(this.base.options) : this.aria;
            },
            getTagNames: function() {
                return "function" == typeof this.tagNames ? this.tagNames(this.base.options) : this.tagNames;
            },
            createButton: function() {
                var a = this.document.createElement("button"), b = this.contentDefault, c = this.getAria(), d = this.getEditorOption("buttonLabels");
                return a.classList.add("medium-editor-action"), a.classList.add("medium-editor-action-" + this.name), this.classList && this.classList.forEach(function(b) {
                    a.classList.add(b);
                }), a.setAttribute("data-action", this.getAction()), c && (a.setAttribute("title", c), a.setAttribute("aria-label", c)), this.attrs && Object.keys(this.attrs).forEach(function(b) {
                    a.setAttribute(b, this.attrs[b]);
                }, this), "fontawesome" === d && this.contentFA && (b = this.contentFA), a.innerHTML = b, a;
            },
            handleClick: function(a) {
                a.preventDefault(), a.stopPropagation();
                var b = this.getAction();
                b && this.execAction(b);
            },
            isActive: function() {
                return this.button.classList.contains(this.getEditorOption("activeButtonClass"));
            },
            setInactive: function() {
                this.button.classList.remove(this.getEditorOption("activeButtonClass")), delete this.knownState;
            },
            setActive: function() {
                this.button.classList.add(this.getEditorOption("activeButtonClass")), delete this.knownState;
            },
            queryCommandState: function() {
                var a = null;
                return this.useQueryState && (a = this.base.queryCommandState(this.getAction())), a;
            },
            isAlreadyApplied: function(a) {
                var b, c, d = !1, e = this.getTagNames();
                return this.knownState === !1 || this.knownState === !0 ? this.knownState : (e && e.length > 0 && (d = -1 !== e.indexOf(a.nodeName.toLowerCase())), !d && this.style && (b = this.style.value.split("|"), c = this.window.getComputedStyle(a, null).getPropertyValue(this.style.prop), b.forEach(function(a) {
                    this.knownState || (d = -1 !== c.indexOf(a), (d || "text-decoration" !== this.style.prop) && (this.knownState = d));
                }, this)), d);
            }
        });
        b.isBuiltInButton = function(b) {
            return "string" == typeof b && a.extensions.button.prototype.defaults.hasOwnProperty(b);
        }, a.extensions.button = b;
    }(), function() {
        a.extensions.button.prototype.defaults = {
            bold: {
                name: "bold",
                action: "bold",
                aria: "bold",
                tagNames: [
                    "b",
                    "strong"
                ],
                style: {
                    prop: "font-weight",
                    value: "700|bold"
                },
                useQueryState: !0,
                contentDefault: "<b>B</b>",
                contentFA: '<i class="fa fa-bold"></i>'
            },
            italic: {
                name: "italic",
                action: "italic",
                aria: "italic",
                tagNames: [
                    "i",
                    "em"
                ],
                style: {
                    prop: "font-style",
                    value: "italic"
                },
                useQueryState: !0,
                contentDefault: "<b><i>I</i></b>",
                contentFA: '<i class="fa fa-italic"></i>'
            },
            underline: {
                name: "underline",
                action: "underline",
                aria: "underline",
                tagNames: [
                    "u"
                ],
                style: {
                    prop: "text-decoration",
                    value: "underline"
                },
                useQueryState: !0,
                contentDefault: "<b><u>U</u></b>",
                contentFA: '<i class="fa fa-underline"></i>'
            },
            strikethrough: {
                name: "strikethrough",
                action: "strikethrough",
                aria: "strike through",
                tagNames: [
                    "strike"
                ],
                style: {
                    prop: "text-decoration",
                    value: "line-through"
                },
                useQueryState: !0,
                contentDefault: "<s>A</s>",
                contentFA: '<i class="fa fa-strikethrough"></i>'
            },
            superscript: {
                name: "superscript",
                action: "superscript",
                aria: "superscript",
                tagNames: [
                    "sup"
                ],
                contentDefault: "<b>x<sup>1</sup></b>",
                contentFA: '<i class="fa fa-superscript"></i>'
            },
            subscript: {
                name: "subscript",
                action: "subscript",
                aria: "subscript",
                tagNames: [
                    "sub"
                ],
                contentDefault: "<b>x<sub>1</sub></b>",
                contentFA: '<i class="fa fa-subscript"></i>'
            },
            image: {
                name: "image",
                action: "image",
                aria: "image",
                tagNames: [
                    "img"
                ],
                contentDefault: "<b>image</b>",
                contentFA: '<i class="fa fa-picture-o"></i>'
            },
            html: {
                name: "html",
                action: "html",
                aria: "evaluate html",
                tagNames: [
                    "iframe",
                    "object"
                ],
                contentDefault: "<b>html</b>",
                contentFA: '<i class="fa fa-code"></i>'
            },
            orderedlist: {
                name: "orderedlist",
                action: "insertorderedlist",
                aria: "ordered list",
                tagNames: [
                    "ol"
                ],
                useQueryState: !0,
                contentDefault: "<b>1.</b>",
                contentFA: '<i class="fa fa-list-ol"></i>'
            },
            unorderedlist: {
                name: "unorderedlist",
                action: "insertunorderedlist",
                aria: "unordered list",
                tagNames: [
                    "ul"
                ],
                useQueryState: !0,
                contentDefault: "<b>&bull;</b>",
                contentFA: '<i class="fa fa-list-ul"></i>'
            },
            indent: {
                name: "indent",
                action: "indent",
                aria: "indent",
                tagNames: [],
                contentDefault: "<b>&rarr;</b>",
                contentFA: '<i class="fa fa-indent"></i>'
            },
            outdent: {
                name: "outdent",
                action: "outdent",
                aria: "outdent",
                tagNames: [],
                contentDefault: "<b>&larr;</b>",
                contentFA: '<i class="fa fa-outdent"></i>'
            },
            justifyCenter: {
                name: "justifyCenter",
                action: "justifyCenter",
                aria: "center justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "center"
                },
                contentDefault: "<b>C</b>",
                contentFA: '<i class="fa fa-align-center"></i>'
            },
            justifyFull: {
                name: "justifyFull",
                action: "justifyFull",
                aria: "full justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "justify"
                },
                contentDefault: "<b>J</b>",
                contentFA: '<i class="fa fa-align-justify"></i>'
            },
            justifyLeft: {
                name: "justifyLeft",
                action: "justifyLeft",
                aria: "left justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "left"
                },
                contentDefault: "<b>L</b>",
                contentFA: '<i class="fa fa-align-left"></i>'
            },
            justifyRight: {
                name: "justifyRight",
                action: "justifyRight",
                aria: "right justify",
                tagNames: [],
                style: {
                    prop: "text-align",
                    value: "right"
                },
                contentDefault: "<b>R</b>",
                contentFA: '<i class="fa fa-align-right"></i>'
            },
            removeFormat: {
                name: "removeFormat",
                aria: "remove formatting",
                action: "removeFormat",
                contentDefault: "<b>X</b>",
                contentFA: '<i class="fa fa-eraser"></i>'
            },
            quote: {
                name: "quote",
                action: "append-blockquote",
                aria: "blockquote",
                tagNames: [
                    "blockquote"
                ],
                contentDefault: "<b>&ldquo;</b>",
                contentFA: '<i class="fa fa-quote-right"></i>'
            },
            pre: {
                name: "pre",
                action: "append-pre",
                aria: "preformatted text",
                tagNames: [
                    "pre"
                ],
                contentDefault: "<b>0101</b>",
                contentFA: '<i class="fa fa-code fa-lg"></i>'
            },
            h1: {
                name: "h1",
                action: "append-h1",
                aria: "header type one",
                tagNames: [
                    "h1"
                ],
                contentDefault: "<b>H1</b>",
                contentFA: '<i class="fa fa-header"><sup>1</sup>'
            },
            h2: {
                name: "h2",
                action: "append-h2",
                aria: "header type two",
                tagNames: [
                    "h2"
                ],
                contentDefault: "<b>H2</b>",
                contentFA: '<i class="fa fa-header"><sup>2</sup>'
            },
            h3: {
                name: "h3",
                action: "append-h3",
                aria: "header type three",
                tagNames: [
                    "h3"
                ],
                contentDefault: "<b>H3</b>",
                contentFA: '<i class="fa fa-header"><sup>3</sup>'
            },
            h4: {
                name: "h4",
                action: "append-h4",
                aria: "header type four",
                tagNames: [
                    "h4"
                ],
                contentDefault: "<b>H4</b>",
                contentFA: '<i class="fa fa-header"><sup>4</sup>'
            },
            h5: {
                name: "h5",
                action: "append-h5",
                aria: "header type five",
                tagNames: [
                    "h5"
                ],
                contentDefault: "<b>H5</b>",
                contentFA: '<i class="fa fa-header"><sup>5</sup>'
            },
            h6: {
                name: "h6",
                action: "append-h6",
                aria: "header type six",
                tagNames: [
                    "h6"
                ],
                contentDefault: "<b>H6</b>",
                contentFA: '<i class="fa fa-header"><sup>6</sup>'
            }
        };
    }(), function() {
        var b = a.extensions.button.extend({
            init: function() {
                a.extensions.button.prototype.init.apply(this, arguments);
            },
            formSaveLabel: "&#10003;",
            formCloseLabel: "&times;",
            activeClass: "medium-editor-toolbar-form-active",
            hasForm: !0,
            getForm: function() {},
            isDisplayed: function() {
                return this.hasForm ? this.getForm().classList.contains(this.activeClass) : !1;
            },
            showForm: function() {
                this.hasForm && this.getForm().classList.add(this.activeClass);
            },
            hideForm: function() {
                this.hasForm && this.getForm().classList.remove(this.activeClass);
            },
            showToolbarDefaultActions: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.showToolbarDefaultActions();
            },
            hideToolbarDefaultActions: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.hideToolbarDefaultActions();
            },
            setToolbarPosition: function() {
                var a = this.base.getExtensionByName("toolbar");
                a && a.setToolbarPosition();
            }
        });
        a.extensions.form = b;
    }(), function() {
        var b = a.extensions.form.extend({
            customClassOption: null,
            customClassOptionText: "Button",
            linkValidation: !1,
            placeholderText: "Paste or type a link",
            targetCheckbox: !1,
            targetCheckboxText: "Open in new window",
            name: "anchor",
            action: "createLink",
            aria: "link",
            tagNames: [
                "a"
            ],
            contentDefault: "<b>#</b>",
            contentFA: '<i class="fa fa-link"></i>',
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments), this.subscribe("editableKeydown", this.handleKeydown.bind(this));
            },
            handleClick: function(b) {
                b.preventDefault(), b.stopPropagation();
                var c = a.selection.getSelectionRange(this.document);
                return "a" === c.startContainer.nodeName.toLowerCase() || "a" === c.endContainer.nodeName.toLowerCase() || a.util.getClosestTag(a.selection.getSelectedParentElement(c), "a") ? this.execAction("unlink") : (this.isDisplayed() || this.showForm(), !1);
            },
            handleKeydown: function(b) {
                a.util.isKey(b, a.util.keyCode.K) && a.util.isMetaCtrlKey(b) && !b.shiftKey && this.handleClick(b);
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            getTemplate: function() {
                var a = [
                    '<input type="text" class="medium-editor-toolbar-input" placeholder="',
                    this.placeholderText,
                    '">'
                ];
                return a.push('<a href="#" class="medium-editor-toolbar-save">', "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : this.formSaveLabel, "</a>"), a.push('<a href="#" class="medium-editor-toolbar-close">', "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : this.formCloseLabel, "</a>"), this.targetCheckbox && a.push('<div class="medium-editor-toolbar-form-row">', '<input type="checkbox" class="medium-editor-toolbar-anchor-target" id="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">', '<label for="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">', this.targetCheckboxText, "</label>", "</div>"), this.customClassOption && a.push('<div class="medium-editor-toolbar-form-row">', '<input type="checkbox" class="medium-editor-toolbar-anchor-button">', "<label>", this.customClassOptionText, "</label>", "</div>"), a.join("");
            },
            isDisplayed: function() {
                return a.extensions.form.prototype.isDisplayed.apply(this);
            },
            hideForm: function() {
                a.extensions.form.prototype.hideForm.apply(this), this.getInput().value = "";
            },
            showForm: function(b) {
                var c = this.getInput(), d = this.getAnchorTargetCheckbox(), e = this.getAnchorButtonCheckbox();
                if (b = b || {
                    value: ""
                }, "string" == typeof b && (b = {
                    value: b
                }), this.base.saveSelection(), this.hideToolbarDefaultActions(), a.extensions.form.prototype.showForm.apply(this), this.setToolbarPosition(), c.value = b.value, c.focus(), d && (d.checked = "_blank" === b.target), e) {
                    var f = b.buttonClass ? b.buttonClass.split(" ") : [];
                    e.checked = -1 !== f.indexOf(this.customClassOption);
                }
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            getFormOpts: function() {
                var a = this.getAnchorTargetCheckbox(), b = this.getAnchorButtonCheckbox(), c = {
                    value: this.getInput().value.trim()
                };
                return this.linkValidation && (c.value = this.checkLinkFormat(c.value)), c.target = "_self", a && a.checked && (c.target = "_blank"), b && b.checked && (c.buttonClass = this.customClassOption), c;
            },
            doFormSave: function() {
                var a = this.getFormOpts();
                this.completeFormSave(a);
            },
            completeFormSave: function(a) {
                this.base.restoreSelection(), this.execAction(this.action, a), this.base.checkSelection();
            },
            ensureEncodedUri: function(a) {
                return a === decodeURI(a) ? encodeURI(a) : a;
            },
            ensureEncodedUriComponent: function(a) {
                return a === decodeURIComponent(a) ? encodeURIComponent(a) : a;
            },
            ensureEncodedParam: function(a) {
                var b = a.split("="), c = b[0], d = b[1];
                return c + (void 0 === d ? "" : "=" + this.ensureEncodedUriComponent(d));
            },
            ensureEncodedQuery: function(a) {
                return a.split("&").map(this.ensureEncodedParam.bind(this)).join("&");
            },
            checkLinkFormat: function(a) {
                var b = /^([a-z]+:)?\/\/|^(mailto|tel|maps):|^\#/i, c = b.test(a), d = "", e = /^\+?\s?\(?(?:\d\s?\-?\)?){3,20}$/, f = a.match(/^(.*?)(?:\?(.*?))?(?:#(.*))?$/), g = f[1], h = f[2], i = f[3];
                if (e.test(a)) return "tel:" + a;
                if (!c) {
                    var j = g.split("/")[0];
                    (j.match(/.+(\.|:).+/) || "localhost" === j) && (d = "http://");
                }
                return d + this.ensureEncodedUri(g) + (void 0 === h ? "" : "?" + this.ensureEncodedQuery(h)) + (void 0 === i ? "" : "#" + i);
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            attachFormEvents: function(a) {
                var b = a.querySelector(".medium-editor-toolbar-close"), c = a.querySelector(".medium-editor-toolbar-save"), d = a.querySelector(".medium-editor-toolbar-input");
                this.on(a, "click", this.handleFormClick.bind(this)), this.on(d, "keyup", this.handleTextboxKeyup.bind(this)), this.on(b, "click", this.handleCloseClick.bind(this)), this.on(c, "click", this.handleSaveClick.bind(this), !0);
            },
            createForm: function() {
                var a = this.document, b = a.createElement("div");
                return b.className = "medium-editor-toolbar-form", b.id = "medium-editor-toolbar-form-anchor-" + this.getEditorId(), b.innerHTML = this.getTemplate(), this.attachFormEvents(b), b;
            },
            getInput: function() {
                return this.getForm().querySelector("input.medium-editor-toolbar-input");
            },
            getAnchorTargetCheckbox: function() {
                return this.getForm().querySelector(".medium-editor-toolbar-anchor-target");
            },
            getAnchorButtonCheckbox: function() {
                return this.getForm().querySelector(".medium-editor-toolbar-anchor-button");
            },
            handleTextboxKeyup: function(b) {
                return b.keyCode === a.util.keyCode.ENTER ? (b.preventDefault(), void this.doFormSave()) : void (b.keyCode === a.util.keyCode.ESCAPE && (b.preventDefault(), this.doFormCancel()));
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.anchor = b;
    }(), function() {
        var b = a.Extension.extend({
            name: "anchor-preview",
            hideDelay: 500,
            previewValueSelector: "a",
            showWhenToolbarIsVisible: !1,
            showOnEmptyLinks: !0,
            init: function() {
                this.anchorPreview = this.createPreview(), this.getEditorOption("elementsContainer").appendChild(this.anchorPreview), this.attachToEditables();
            },
            getInteractionElements: function() {
                return this.getPreviewElement();
            },
            getPreviewElement: function() {
                return this.anchorPreview;
            },
            createPreview: function() {
                var a = this.document.createElement("div");
                return a.id = "medium-editor-anchor-preview-" + this.getEditorId(), a.className = "medium-editor-anchor-preview", a.innerHTML = this.getTemplate(), this.on(a, "click", this.handleClick.bind(this)), a;
            },
            getTemplate: function() {
                return '<div class="medium-editor-toolbar-anchor-preview" id="medium-editor-toolbar-anchor-preview">    <a class="medium-editor-toolbar-anchor-preview-inner"></a></div>';
            },
            destroy: function() {
                this.anchorPreview && (this.anchorPreview.parentNode && this.anchorPreview.parentNode.removeChild(this.anchorPreview), delete this.anchorPreview);
            },
            hidePreview: function() {
                this.anchorPreview && this.anchorPreview.classList.remove("medium-editor-anchor-preview-active"), this.activeAnchor = null;
            },
            showPreview: function(a) {
                return this.anchorPreview.classList.contains("medium-editor-anchor-preview-active") || a.getAttribute("data-disable-preview") ? !0 : (this.previewValueSelector && (this.anchorPreview.querySelector(this.previewValueSelector).textContent = a.attributes.href.value, this.anchorPreview.querySelector(this.previewValueSelector).href = a.attributes.href.value), this.anchorPreview.classList.add("medium-toolbar-arrow-over"), this.anchorPreview.classList.remove("medium-toolbar-arrow-under"), this.anchorPreview.classList.contains("medium-editor-anchor-preview-active") || this.anchorPreview.classList.add("medium-editor-anchor-preview-active"), this.activeAnchor = a, this.positionPreview(), this.attachPreviewHandlers(), this);
            },
            positionPreview: function(a) {
                a = a || this.activeAnchor;
                var b, c, d, e, f, g = this.window.innerWidth, h = this.anchorPreview.offsetHeight, i = a.getBoundingClientRect(), j = this.diffLeft, k = this.diffTop, l = this.getEditorOption("elementsContainer"), m = [
                    "absolute",
                    "fixed"
                ].indexOf(window.getComputedStyle(l).getPropertyValue("position")) > -1, n = {};
                b = this.anchorPreview.offsetWidth / 2;
                var o = this.base.getExtensionByName("toolbar");
                o && (j = o.diffLeft, k = o.diffTop), c = j - b, m ? (e = l.getBoundingClientRect(), [
                    "top",
                    "left"
                ].forEach(function(a) {
                    n[a] = i[a] - e[a];
                }), n.width = i.width, n.height = i.height, i = n, g = e.width, f = l.scrollTop) : f = this.window.pageYOffset, d = i.left + i.width / 2, f += h + i.top + i.height - k - this.anchorPreview.offsetHeight, this.anchorPreview.style.top = Math.round(f) + "px", this.anchorPreview.style.right = "initial", b > d ? (this.anchorPreview.style.left = c + b + "px", this.anchorPreview.style.right = "initial") : b > g - d ? (this.anchorPreview.style.left = "auto", this.anchorPreview.style.right = 0) : (this.anchorPreview.style.left = c + d + "px", this.anchorPreview.style.right = "initial");
            },
            attachToEditables: function() {
                this.subscribe("editableMouseover", this.handleEditableMouseover.bind(this)), this.subscribe("positionedToolbar", this.handlePositionedToolbar.bind(this));
            },
            handlePositionedToolbar: function() {
                this.showWhenToolbarIsVisible || this.hidePreview();
            },
            handleClick: function(a) {
                var b = this.base.getExtensionByName("anchor"), c = this.activeAnchor;
                b && c && (a.preventDefault(), this.base.selectElement(this.activeAnchor), this.base.delay((function() {
                    if (c) {
                        var a = {
                            value: c.attributes.href.value,
                            target: c.getAttribute("target"),
                            buttonClass: c.getAttribute("class")
                        };
                        b.showForm(a), c = null;
                    }
                }).bind(this))), this.hidePreview();
            },
            handleAnchorMouseout: function() {
                this.anchorToPreview = null, this.off(this.activeAnchor, "mouseout", this.instanceHandleAnchorMouseout), this.instanceHandleAnchorMouseout = null;
            },
            handleEditableMouseover: function(b) {
                var c = a.util.getClosestTag(b.target, "a");
                if (!1 !== c) {
                    if (!this.showOnEmptyLinks && (!/href=["']\S+["']/.test(c.outerHTML) || /href=["']#\S+["']/.test(c.outerHTML))) return !0;
                    var d = this.base.getExtensionByName("toolbar");
                    if (!this.showWhenToolbarIsVisible && d && d.isDisplayed && d.isDisplayed()) return !0;
                    this.activeAnchor && this.activeAnchor !== c && this.detachPreviewHandlers(), this.anchorToPreview = c, this.instanceHandleAnchorMouseout = this.handleAnchorMouseout.bind(this), this.on(this.anchorToPreview, "mouseout", this.instanceHandleAnchorMouseout), this.base.delay((function() {
                        this.anchorToPreview && this.showPreview(this.anchorToPreview);
                    }).bind(this));
                }
            },
            handlePreviewMouseover: function() {
                this.lastOver = (new Date).getTime(), this.hovering = !0;
            },
            handlePreviewMouseout: function(a) {
                a.relatedTarget && /anchor-preview/.test(a.relatedTarget.className) || (this.hovering = !1);
            },
            updatePreview: function() {
                if (this.hovering) return !0;
                var a = (new Date).getTime() - this.lastOver;
                a > this.hideDelay && this.detachPreviewHandlers();
            },
            detachPreviewHandlers: function() {
                clearInterval(this.intervalTimer), this.instanceHandlePreviewMouseover && (this.off(this.anchorPreview, "mouseover", this.instanceHandlePreviewMouseover), this.off(this.anchorPreview, "mouseout", this.instanceHandlePreviewMouseout), this.activeAnchor && (this.off(this.activeAnchor, "mouseover", this.instanceHandlePreviewMouseover), this.off(this.activeAnchor, "mouseout", this.instanceHandlePreviewMouseout))), this.hidePreview(), this.hovering = this.instanceHandlePreviewMouseover = this.instanceHandlePreviewMouseout = null;
            },
            attachPreviewHandlers: function() {
                this.lastOver = (new Date).getTime(), this.hovering = !0, this.instanceHandlePreviewMouseover = this.handlePreviewMouseover.bind(this), this.instanceHandlePreviewMouseout = this.handlePreviewMouseout.bind(this), this.intervalTimer = setInterval(this.updatePreview.bind(this), 200), this.on(this.anchorPreview, "mouseover", this.instanceHandlePreviewMouseover), this.on(this.anchorPreview, "mouseout", this.instanceHandlePreviewMouseout), this.on(this.activeAnchor, "mouseover", this.instanceHandlePreviewMouseover), this.on(this.activeAnchor, "mouseout", this.instanceHandlePreviewMouseout);
            }
        });
        a.extensions.anchorPreview = b;
    }(), function() {
        function b(b) {
            return !a.util.getClosestTag(b, "a");
        }
        var c, d, e, f, g;
        c = [
            " ",
            "	",
            "\n",
            "\r",
            "\xa0",
            "\u2000",
            "\u2001",
            "\u2002",
            "\u2003",
            "\u2028",
            "\u2029"
        ], d = "com|net|org|edu|gov|mil|aero|asia|biz|cat|coop|info|int|jobs|mobi|museum|name|post|pro|tel|travel|xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|ja|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw", e = "(((?:(https?://|ftps?://|nntp://)|www\\d{0,3}[.]|[a-z0-9.\\-]+[.](" + d + ")\\/)\\S+(?:[^\\s`!\\[\\]{};:'\".,?\xab\xbb\u201C\u201D\u2018\u2019])))|(([a-z0-9\\-]+\\.)?[a-z0-9\\-]+\\.(" + d + "))", f = new RegExp("^(" + d + ")$", "i"), g = new RegExp(e, "gi");
        var h = a.Extension.extend({
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.disableEventHandling = !1, this.subscribe("editableKeypress", this.onKeypress.bind(this)), this.subscribe("editableBlur", this.onBlur.bind(this)), this.document.execCommand("AutoUrlDetect", !1, !1);
            },
            isLastInstance: function() {
                for(var a = 0, b = 0; b < this.window._mediumEditors.length; b++){
                    var c = this.window._mediumEditors[b];
                    null !== c && void 0 !== c.getExtensionByName("autoLink") && a++;
                }
                return 1 === a;
            },
            destroy: function() {
                this.document.queryCommandSupported("AutoUrlDetect") && this.isLastInstance() && this.document.execCommand("AutoUrlDetect", !1, !0);
            },
            onBlur: function(a, b) {
                this.performLinking(b);
            },
            onKeypress: function(b) {
                this.disableEventHandling || a.util.isKey(b, [
                    a.util.keyCode.SPACE,
                    a.util.keyCode.ENTER
                ]) && (clearTimeout(this.performLinkingTimeout), this.performLinkingTimeout = setTimeout((function() {
                    try {
                        var a = this.base.exportSelection();
                        this.performLinking(b.target) && this.base.importSelection(a, !0);
                    } catch (c) {
                        window.console && window.console.error("Failed to perform linking", c), this.disableEventHandling = !0;
                    }
                }).bind(this), 0));
            },
            performLinking: function(b) {
                var c = a.util.splitByBlockElements(b), d = !1;
                0 === c.length && (c = [
                    b
                ]);
                for(var e = 0; e < c.length; e++)d = this.removeObsoleteAutoLinkSpans(c[e]) || d, d = this.performLinkingWithinElement(c[e]) || d;
                return this.base.events.updateInput(b, {
                    target: b,
                    currentTarget: b
                }), d;
            },
            removeObsoleteAutoLinkSpans: function(c) {
                if (!c || 3 === c.nodeType) return !1;
                for(var d = c.querySelectorAll('span[data-auto-link="true"]'), e = !1, f = 0; f < d.length; f++){
                    var g = d[f].textContent;
                    if (-1 === g.indexOf("://") && (g = a.util.ensureUrlHasProtocol(g)), d[f].getAttribute("data-href") !== g && b(d[f])) {
                        e = !0;
                        var h = g.replace(/\s+$/, "");
                        if (d[f].getAttribute("data-href") === h) {
                            var i = g.length - h.length, j = a.util.splitOffDOMTree(d[f], this.splitTextBeforeEnd(d[f], i));
                            d[f].parentNode.insertBefore(j, d[f].nextSibling);
                        } else a.util.unwrap(d[f], this.document);
                    }
                }
                return e;
            },
            splitTextBeforeEnd: function(a, b) {
                for(var c = this.document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null, !1), d = !0; d;)d = null !== c.lastChild();
                for(var e, f, g; b > 0 && null !== g;)e = c.currentNode, f = e.nodeValue, f.length > b ? (g = e.splitText(f.length - b), b = 0) : (g = c.previousNode(), b -= f.length);
                return g;
            },
            performLinkingWithinElement: function(b) {
                for(var c = this.findLinkableText(b), d = !1, e = 0; e < c.length; e++){
                    var f = a.util.findOrCreateMatchingTextNodes(this.document, b, c[e]);
                    this.shouldNotLink(f) || this.createAutoLink(f, c[e].href);
                }
                return d;
            },
            shouldNotLink: function(b) {
                for(var c = !1, d = 0; d < b.length && c === !1; d++)c = !!a.util.traverseUp(b[d], function(a) {
                    return "a" === a.nodeName.toLowerCase() || a.getAttribute && "true" === a.getAttribute("data-auto-link");
                });
                return c;
            },
            findLinkableText: function(a) {
                for(var b = a.textContent, d = null, e = []; null !== (d = g.exec(b));){
                    var h = !0, i = d.index + d[0].length;
                    h = !(0 !== d.index && -1 === c.indexOf(b[d.index - 1]) || i !== b.length && -1 === c.indexOf(b[i])), h = h && (-1 !== d[0].indexOf("/") || f.test(d[0].split(".").pop().split("?").shift())), h && e.push({
                        href: d[0],
                        start: d.index,
                        end: i
                    });
                }
                return e;
            },
            createAutoLink: function(b, c) {
                c = a.util.ensureUrlHasProtocol(c);
                var d = a.util.createLink(this.document, b, c, this.getEditorOption("targetBlank") ? "_blank" : null), e = this.document.createElement("span");
                for(e.setAttribute("data-auto-link", "true"), e.setAttribute("data-href", c), d.insertBefore(e, d.firstChild); d.childNodes.length > 1;)e.appendChild(d.childNodes[1]);
            }
        });
        a.extensions.autoLink = h;
    }(), function() {
        function b(b) {
            var d = a.util.getContainerEditorElement(b), e = Array.prototype.slice.call(d.parentElement.querySelectorAll("." + c));
            e.forEach(function(a) {
                a.classList.remove(c);
            });
        }
        var c = "medium-editor-dragover", d = a.Extension.extend({
            name: "fileDragging",
            allowedTypes: [
                "image"
            ],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableDrag", this.handleDrag.bind(this)), this.subscribe("editableDrop", this.handleDrop.bind(this));
            },
            handleDrag: function(a) {
                a.preventDefault(), a.dataTransfer.dropEffect = "copy";
                var d = a.target.classList ? a.target : a.target.parentElement;
                b(d), "dragover" === a.type && d.classList.add(c);
            },
            handleDrop: function(a) {
                a.preventDefault(), a.stopPropagation(), this.base.selectElement(a.target);
                var c = this.base.exportSelection();
                c.start = c.end, this.base.importSelection(c), a.dataTransfer.files && Array.prototype.slice.call(a.dataTransfer.files).forEach(function(a) {
                    this.isAllowedFile(a) && a.type.match("image") && this.insertImageFile(a);
                }, this), b(a.target);
            },
            isAllowedFile: function(a) {
                return this.allowedTypes.some(function(b) {
                    return !!a.type.match(b);
                });
            },
            insertImageFile: function(b) {
                if ("function" == typeof FileReader) {
                    var c = new FileReader;
                    c.readAsDataURL(b), c.addEventListener("load", (function(b) {
                        var c = this.document.createElement("img");
                        c.src = b.target.result, a.util.insertHTMLCommand(this.document, c.outerHTML);
                    }).bind(this));
                }
            }
        });
        a.extensions.fileDragging = d;
    }(), function() {
        var b = a.Extension.extend({
            name: "keyboard-commands",
            commands: [
                {
                    command: "bold",
                    key: "B",
                    meta: !0,
                    shift: !1,
                    alt: !1
                },
                {
                    command: "italic",
                    key: "I",
                    meta: !0,
                    shift: !1,
                    alt: !1
                },
                {
                    command: "underline",
                    key: "U",
                    meta: !0,
                    shift: !1,
                    alt: !1
                }
            ],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableKeydown", this.handleKeydown.bind(this)), this.keys = {}, this.commands.forEach(function(a) {
                    var b = a.key.charCodeAt(0);
                    this.keys[b] || (this.keys[b] = []), this.keys[b].push(a);
                }, this);
            },
            handleKeydown: function(b) {
                var c = a.util.getKeyCode(b);
                if (this.keys[c]) {
                    var d = a.util.isMetaCtrlKey(b), e = !!b.shiftKey, f = !!b.altKey;
                    this.keys[c].forEach(function(a) {
                        a.meta !== d || a.shift !== e || a.alt !== f && void 0 !== a.alt || (b.preventDefault(), b.stopPropagation(), "function" == typeof a.command ? a.command.apply(this) : !1 !== a.command && this.execAction(a.command));
                    }, this);
                }
            }
        });
        a.extensions.keyboardCommands = b;
    }(), function() {
        var b = a.extensions.form.extend({
            name: "fontname",
            action: "fontName",
            aria: "change font name",
            contentDefault: "&#xB1;",
            contentFA: '<i class="fa fa-font"></i>',
            fonts: [
                "",
                "Arial",
                "Verdana",
                "Times New Roman"
            ],
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments);
            },
            handleClick: function(a) {
                if (a.preventDefault(), a.stopPropagation(), !this.isDisplayed()) {
                    var b = this.document.queryCommandValue("fontName") + "";
                    this.showForm(b);
                }
                return !1;
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            isDisplayed: function() {
                return "block" === this.getForm().style.display;
            },
            hideForm: function() {
                this.getForm().style.display = "none", this.getSelect().value = "";
            },
            showForm: function(a) {
                var b = this.getSelect();
                this.base.saveSelection(), this.hideToolbarDefaultActions(), this.getForm().style.display = "block", this.setToolbarPosition(), b.value = a || "", b.focus();
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            doFormSave: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.clearFontName(), this.base.checkSelection();
            },
            createForm: function() {
                var a, b = this.document, c = b.createElement("div"), d = b.createElement("select"), e = b.createElement("a"), f = b.createElement("a");
                c.className = "medium-editor-toolbar-form", c.id = "medium-editor-toolbar-form-fontname-" + this.getEditorId(), this.on(c, "click", this.handleFormClick.bind(this));
                for(var g = 0; g < this.fonts.length; g++)a = b.createElement("option"), a.innerHTML = this.fonts[g], a.value = this.fonts[g], d.appendChild(a);
                return d.className = "medium-editor-toolbar-select", c.appendChild(d), this.on(d, "change", this.handleFontChange.bind(this)), f.setAttribute("href", "#"), f.className = "medium-editor-toobar-save", f.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : "&#10003;", c.appendChild(f), this.on(f, "click", this.handleSaveClick.bind(this), !0), e.setAttribute("href", "#"), e.className = "medium-editor-toobar-close", e.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : "&times;", c.appendChild(e), this.on(e, "click", this.handleCloseClick.bind(this)), c;
            },
            getSelect: function() {
                return this.getForm().querySelector("select.medium-editor-toolbar-select");
            },
            clearFontName: function() {
                a.selection.getSelectedElements(this.document).forEach(function(a) {
                    "font" === a.nodeName.toLowerCase() && a.hasAttribute("face") && a.removeAttribute("face");
                });
            },
            handleFontChange: function() {
                var a = this.getSelect().value;
                "" === a ? this.clearFontName() : this.execAction("fontName", {
                    value: a
                });
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.fontName = b;
    }(), function() {
        var b = a.extensions.form.extend({
            name: "fontsize",
            action: "fontSize",
            aria: "increase/decrease font size",
            contentDefault: "&#xB1;",
            contentFA: '<i class="fa fa-text-height"></i>',
            init: function() {
                a.extensions.form.prototype.init.apply(this, arguments);
            },
            handleClick: function(a) {
                if (a.preventDefault(), a.stopPropagation(), !this.isDisplayed()) {
                    var b = this.document.queryCommandValue("fontSize") + "";
                    this.showForm(b);
                }
                return !1;
            },
            getForm: function() {
                return this.form || (this.form = this.createForm()), this.form;
            },
            isDisplayed: function() {
                return "block" === this.getForm().style.display;
            },
            hideForm: function() {
                this.getForm().style.display = "none", this.getInput().value = "";
            },
            showForm: function(a) {
                var b = this.getInput();
                this.base.saveSelection(), this.hideToolbarDefaultActions(), this.getForm().style.display = "block", this.setToolbarPosition(), b.value = a || "", b.focus();
            },
            destroy: function() {
                return this.form ? (this.form.parentNode && this.form.parentNode.removeChild(this.form), void delete this.form) : !1;
            },
            doFormSave: function() {
                this.base.restoreSelection(), this.base.checkSelection();
            },
            doFormCancel: function() {
                this.base.restoreSelection(), this.clearFontSize(), this.base.checkSelection();
            },
            createForm: function() {
                var a = this.document, b = a.createElement("div"), c = a.createElement("input"), d = a.createElement("a"), e = a.createElement("a");
                return b.className = "medium-editor-toolbar-form", b.id = "medium-editor-toolbar-form-fontsize-" + this.getEditorId(), this.on(b, "click", this.handleFormClick.bind(this)), c.setAttribute("type", "range"), c.setAttribute("min", "1"), c.setAttribute("max", "7"), c.className = "medium-editor-toolbar-input", b.appendChild(c), this.on(c, "change", this.handleSliderChange.bind(this)), e.setAttribute("href", "#"), e.className = "medium-editor-toobar-save", e.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-check"></i>' : "&#10003;", b.appendChild(e), this.on(e, "click", this.handleSaveClick.bind(this), !0), d.setAttribute("href", "#"), d.className = "medium-editor-toobar-close", d.innerHTML = "fontawesome" === this.getEditorOption("buttonLabels") ? '<i class="fa fa-times"></i>' : "&times;", b.appendChild(d), this.on(d, "click", this.handleCloseClick.bind(this)), b;
            },
            getInput: function() {
                return this.getForm().querySelector("input.medium-editor-toolbar-input");
            },
            clearFontSize: function() {
                a.selection.getSelectedElements(this.document).forEach(function(a) {
                    "font" === a.nodeName.toLowerCase() && a.hasAttribute("size") && a.removeAttribute("size");
                });
            },
            handleSliderChange: function() {
                var a = this.getInput().value;
                "4" === a ? this.clearFontSize() : this.execAction("fontSize", {
                    value: a
                });
            },
            handleFormClick: function(a) {
                a.stopPropagation();
            },
            handleSaveClick: function(a) {
                a.preventDefault(), this.doFormSave();
            },
            handleCloseClick: function(a) {
                a.preventDefault(), this.doFormCancel();
            }
        });
        a.extensions.fontSize = b;
    }(), function() {
        function b() {
            return [
                [
                    new RegExp(/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/g),
                    ""
                ],
                [
                    new RegExp(/<!--StartFragment-->|<!--EndFragment-->/g),
                    ""
                ],
                [
                    new RegExp(/<br>$/i),
                    ""
                ],
                [
                    new RegExp(/<[^>]*docs-internal-guid[^>]*>/gi),
                    ""
                ],
                [
                    new RegExp(/<\/b>(<br[^>]*>)?$/gi),
                    ""
                ],
                [
                    new RegExp(/<span class="Apple-converted-space">\s+<\/span>/g),
                    " "
                ],
                [
                    new RegExp(/<br class="Apple-interchange-newline">/g),
                    "<br>"
                ],
                [
                    new RegExp(/<span[^>]*(font-style:italic;font-weight:(bold|700)|font-weight:(bold|700);font-style:italic)[^>]*>/gi),
                    '<span class="replace-with italic bold">'
                ],
                [
                    new RegExp(/<span[^>]*font-style:italic[^>]*>/gi),
                    '<span class="replace-with italic">'
                ],
                [
                    new RegExp(/<span[^>]*font-weight:(bold|700)[^>]*>/gi),
                    '<span class="replace-with bold">'
                ],
                [
                    new RegExp(/&lt;(\/?)(i|b|a)&gt;/gi),
                    "<$1$2>"
                ],
                [
                    new RegExp(/&lt;a(?:(?!href).)+href=(?:&quot;|&rdquo;|&ldquo;|"|“|”)(((?!&quot;|&rdquo;|&ldquo;|"|“|”).)*)(?:&quot;|&rdquo;|&ldquo;|"|“|”)(?:(?!&gt;).)*&gt;/gi),
                    '<a href="$1">'
                ],
                [
                    new RegExp(/<\/p>\n+/gi),
                    "</p>"
                ],
                [
                    new RegExp(/\n+<p/gi),
                    "<p"
                ],
                [
                    new RegExp(/<\/?o:[a-z]*>/gi),
                    ""
                ],
                [
                    new RegExp(/<!\[if !supportLists\]>(((?!<!).)*)<!\[endif]\>/gi),
                    "$1"
                ]
            ];
        }
        function c(a, b, c) {
            var d = a.clipboardData || b.clipboardData || c.dataTransfer, e = {};
            if (!d) return e;
            if (d.getData) {
                var f = d.getData("Text");
                f && f.length > 0 && (e["text/plain"] = f);
            }
            if (d.types) for(var g = 0; g < d.types.length; g++){
                var h = d.types[g];
                e[h] = d.getData(h);
            }
            return e;
        }
        var d = "%ME_PASTEBIN%", e = null, f = null, g = function(a) {
            a.stopPropagation();
        }, h = a.Extension.extend({
            forcePlainText: !0,
            cleanPastedHTML: !1,
            preCleanReplacements: [],
            cleanReplacements: [],
            cleanAttrs: [
                "class",
                "style",
                "dir"
            ],
            cleanTags: [
                "meta"
            ],
            unwrapTags: [],
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), (this.forcePlainText || this.cleanPastedHTML) && (this.subscribe("editableKeydown", this.handleKeydown.bind(this)), this.getEditorElements().forEach(function(a) {
                    this.on(a, "paste", this.handlePaste.bind(this));
                }, this), this.subscribe("addElement", this.handleAddElement.bind(this)));
            },
            handleAddElement: function(a, b) {
                this.on(b, "paste", this.handlePaste.bind(this));
            },
            destroy: function() {
                (this.forcePlainText || this.cleanPastedHTML) && this.removePasteBin();
            },
            handlePaste: function(a, b) {
                if (!a.defaultPrevented) {
                    var d = c(a, this.window, this.document), e = d["text/html"], f = d["text/plain"];
                    this.window.clipboardData && void 0 === a.clipboardData && !e && (e = f), (e || f) && (a.preventDefault(), this.doPaste(e, f, b));
                }
            },
            doPaste: function(b, c, d) {
                var e, f, g = "";
                if (this.cleanPastedHTML && b) return this.cleanPaste(b);
                if (c) {
                    if (this.getEditorOption("disableReturn") || d && d.getAttribute("data-disable-return")) g = a.util.htmlEntities(c);
                    else if (e = c.split(/[\r\n]+/g), e.length > 1) for(f = 0; f < e.length; f += 1)"" !== e[f] && (g += "<p>" + a.util.htmlEntities(e[f]) + "</p>");
                    else g = a.util.htmlEntities(e[0]);
                    a.util.insertHTMLCommand(this.document, g);
                }
            },
            handlePasteBinPaste: function(a) {
                if (a.defaultPrevented) return void this.removePasteBin();
                var b = c(a, this.window, this.document), d = b["text/html"], e = b["text/plain"], g = f;
                return !this.cleanPastedHTML || d ? (a.preventDefault(), this.removePasteBin(), this.doPaste(d, e, g), void this.trigger("editablePaste", {
                    currentTarget: g,
                    target: g
                }, g)) : void setTimeout((function() {
                    this.cleanPastedHTML && (d = this.getPasteBinHtml()), this.removePasteBin(), this.doPaste(d, e, g), this.trigger("editablePaste", {
                        currentTarget: g,
                        target: g
                    }, g);
                }).bind(this), 0);
            },
            handleKeydown: function(b, c) {
                a.util.isKey(b, a.util.keyCode.V) && a.util.isMetaCtrlKey(b) && (b.stopImmediatePropagation(), this.removePasteBin(), this.createPasteBin(c));
            },
            createPasteBin: function(b) {
                var c, h = a.selection.getSelectionRange(this.document), i = this.window.pageYOffset;
                f = b, h && (c = h.getClientRects(), i += c.length ? c[0].top : void 0 !== h.startContainer.getBoundingClientRect ? h.startContainer.getBoundingClientRect().top : h.getBoundingClientRect().top), e = h;
                var j = this.document.createElement("div");
                j.id = this.pasteBinId = "medium-editor-pastebin-" + +Date.now(), j.setAttribute("style", "border: 1px red solid; position: absolute; top: " + i + "px; width: 10px; height: 10px; overflow: hidden; opacity: 0"), j.setAttribute("contentEditable", !0), j.innerHTML = d, this.document.body.appendChild(j), this.on(j, "focus", g), this.on(j, "focusin", g), this.on(j, "focusout", g), j.focus(), a.selection.selectNode(j, this.document), this.boundHandlePaste || (this.boundHandlePaste = this.handlePasteBinPaste.bind(this)), this.on(j, "paste", this.boundHandlePaste);
            },
            removePasteBin: function() {
                null !== e && (a.selection.selectRange(this.document, e), e = null), null !== f && (f = null);
                var b = this.getPasteBin();
                b && b && (this.off(b, "focus", g), this.off(b, "focusin", g), this.off(b, "focusout", g), this.off(b, "paste", this.boundHandlePaste), b.parentElement.removeChild(b));
            },
            getPasteBin: function() {
                return this.document.getElementById(this.pasteBinId);
            },
            getPasteBinHtml: function() {
                var a = this.getPasteBin();
                if (!a) return !1;
                if (a.firstChild && "mcepastebin" === a.firstChild.id) return !1;
                var b = a.innerHTML;
                return b && b !== d ? b : !1;
            },
            cleanPaste: function(a) {
                var c, d, e, f, g = /<p|<br|<div/.test(a), h = [].concat(this.preCleanReplacements || [], b(), this.cleanReplacements || []);
                for(c = 0; c < h.length; c += 1)a = a.replace(h[c][0], h[c][1]);
                if (!g) return this.pasteHTML(a);
                for(e = this.document.createElement("div"), e.innerHTML = "<p>" + a.split("<br><br>").join("</p><p>") + "</p>", d = e.querySelectorAll("a,p,div,br"), c = 0; c < d.length; c += 1)switch(f = d[c], f.innerHTML = f.innerHTML.replace(/\n/gi, " "), f.nodeName.toLowerCase()){
                    case "p":
                    case "div":
                        this.filterCommonBlocks(f);
                        break;
                    case "br":
                        this.filterLineBreak(f);
                }
                this.pasteHTML(e.innerHTML);
            },
            pasteHTML: function(b, c) {
                c = a.util.defaults({}, c, {
                    cleanAttrs: this.cleanAttrs,
                    cleanTags: this.cleanTags,
                    unwrapTags: this.unwrapTags
                });
                var d, e, f, g, h = this.document.createDocumentFragment();
                for(h.appendChild(this.document.createElement("body")), g = h.querySelector("body"), g.innerHTML = b, this.cleanupSpans(g), d = g.querySelectorAll("*"), f = 0; f < d.length; f += 1)e = d[f], "a" === e.nodeName.toLowerCase() && this.getEditorOption("targetBlank") && a.util.setTargetBlank(e), a.util.cleanupAttrs(e, c.cleanAttrs), a.util.cleanupTags(e, c.cleanTags), a.util.unwrapTags(e, c.unwrapTags);
                a.util.insertHTMLCommand(this.document, g.innerHTML.replace(/&nbsp;/g, " "));
            },
            isCommonBlock: function(a) {
                return a && ("p" === a.nodeName.toLowerCase() || "div" === a.nodeName.toLowerCase());
            },
            filterCommonBlocks: function(a) {
                /^\s*$/.test(a.textContent) && a.parentNode && a.parentNode.removeChild(a);
            },
            filterLineBreak: function(a) {
                this.isCommonBlock(a.previousElementSibling) ? this.removeWithParent(a) : !this.isCommonBlock(a.parentNode) || a.parentNode.firstChild !== a && a.parentNode.lastChild !== a ? a.parentNode && 1 === a.parentNode.childElementCount && "" === a.parentNode.textContent && this.removeWithParent(a) : this.removeWithParent(a);
            },
            removeWithParent: function(a) {
                a && a.parentNode && (a.parentNode.parentNode && 1 === a.parentNode.childElementCount ? a.parentNode.parentNode.removeChild(a.parentNode) : a.parentNode.removeChild(a));
            },
            cleanupSpans: function(b) {
                var c, d, e, f = b.querySelectorAll(".replace-with"), g = function(a) {
                    return a && "#text" !== a.nodeName && "false" === a.getAttribute("contenteditable");
                };
                for(c = 0; c < f.length; c += 1)d = f[c], e = this.document.createElement(d.classList.contains("bold") ? "b" : "i"), d.classList.contains("bold") && d.classList.contains("italic") ? e.innerHTML = "<i>" + d.innerHTML + "</i>" : e.innerHTML = d.innerHTML, d.parentNode.replaceChild(e, d);
                for(f = b.querySelectorAll("span"), c = 0; c < f.length; c += 1){
                    if (d = f[c], a.util.traverseUp(d, g)) return !1;
                    a.util.unwrap(d, this.document);
                }
            }
        });
        a.extensions.paste = h;
    }(), function() {
        var b = a.Extension.extend({
            name: "placeholder",
            text: "Type your text",
            hideOnClick: !0,
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.initPlaceholders(), this.attachEventHandlers();
            },
            initPlaceholders: function() {
                this.getEditorElements().forEach(this.initElement, this);
            },
            handleAddElement: function(a, b) {
                this.initElement(b);
            },
            initElement: function(a) {
                a.getAttribute("data-placeholder") || a.setAttribute("data-placeholder", this.text), this.updatePlaceholder(a);
            },
            destroy: function() {
                this.getEditorElements().forEach(this.cleanupElement, this);
            },
            handleRemoveElement: function(a, b) {
                this.cleanupElement(b);
            },
            cleanupElement: function(a) {
                a.getAttribute("data-placeholder") === this.text && a.removeAttribute("data-placeholder");
            },
            showPlaceholder: function(b) {
                b && (a.util.isFF && 0 === b.childNodes.length ? (b.classList.add("medium-editor-placeholder-relative"), b.classList.remove("medium-editor-placeholder")) : (b.classList.add("medium-editor-placeholder"), b.classList.remove("medium-editor-placeholder-relative")));
            },
            hidePlaceholder: function(a) {
                a && (a.classList.remove("medium-editor-placeholder"), a.classList.remove("medium-editor-placeholder-relative"));
            },
            updatePlaceholder: function(a, b) {
                return a.querySelector("img, blockquote, ul, ol, table") || "" !== a.textContent.replace(/^\s+|\s+$/g, "") ? this.hidePlaceholder(a) : void (b || this.showPlaceholder(a));
            },
            attachEventHandlers: function() {
                this.hideOnClick && this.subscribe("focus", this.handleFocus.bind(this)), this.subscribe("editableInput", this.handleInput.bind(this)), this.subscribe("blur", this.handleBlur.bind(this)), this.subscribe("addElement", this.handleAddElement.bind(this)), this.subscribe("removeElement", this.handleRemoveElement.bind(this));
            },
            handleInput: function(a, b) {
                var c = this.hideOnClick && b === this.base.getFocusedElement();
                this.updatePlaceholder(b, c);
            },
            handleFocus: function(a, b) {
                this.hidePlaceholder(b);
            },
            handleBlur: function(a, b) {
                this.updatePlaceholder(b);
            }
        });
        a.extensions.placeholder = b;
    }(), function() {
        var b = a.Extension.extend({
            name: "toolbar",
            align: "center",
            allowMultiParagraphSelection: !0,
            buttons: [
                "bold",
                "italic",
                "underline",
                "anchor",
                "h2",
                "h3",
                "quote"
            ],
            diffLeft: 0,
            diffTop: -10,
            firstButtonClass: "medium-editor-button-first",
            lastButtonClass: "medium-editor-button-last",
            standardizeSelectionStart: !1,
            "static": !1,
            sticky: !1,
            stickyTopOffset: 0,
            updateOnEmptySelection: !1,
            relativeContainer: null,
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.initThrottledMethods(), this.relativeContainer ? this.relativeContainer.appendChild(this.getToolbarElement()) : this.getEditorOption("elementsContainer").appendChild(this.getToolbarElement());
            },
            forEachExtension: function(a, b) {
                return this.base.extensions.forEach(function(c) {
                    return c !== this ? a.apply(b || this, arguments) : void 0;
                }, this);
            },
            createToolbar: function() {
                var a = this.document.createElement("div");
                return a.id = "medium-editor-toolbar-" + this.getEditorId(), a.className = "medium-editor-toolbar", this["static"] ? a.className += " static-toolbar" : this.relativeContainer ? a.className += " medium-editor-relative-toolbar" : a.className += " medium-editor-stalker-toolbar", a.appendChild(this.createToolbarButtons()), this.forEachExtension(function(b) {
                    b.hasForm && a.appendChild(b.getForm());
                }), this.attachEventHandlers(), a;
            },
            createToolbarButtons: function() {
                var b, c, d, e, f, g, h = this.document.createElement("ul");
                return h.id = "medium-editor-toolbar-actions" + this.getEditorId(), h.className = "medium-editor-toolbar-actions", h.style.display = "block", this.buttons.forEach(function(d) {
                    "string" == typeof d ? (f = d, g = null) : (f = d.name, g = d), e = this.base.addBuiltInExtension(f, g), e && "function" == typeof e.getButton && (c = e.getButton(this.base), b = this.document.createElement("li"), a.util.isElement(c) ? b.appendChild(c) : b.innerHTML = c, h.appendChild(b));
                }, this), d = h.querySelectorAll("button"), d.length > 0 && (d[0].classList.add(this.firstButtonClass), d[d.length - 1].classList.add(this.lastButtonClass)), h;
            },
            destroy: function() {
                this.toolbar && (this.toolbar.parentNode && this.toolbar.parentNode.removeChild(this.toolbar), delete this.toolbar);
            },
            getInteractionElements: function() {
                return this.getToolbarElement();
            },
            getToolbarElement: function() {
                return this.toolbar || (this.toolbar = this.createToolbar()), this.toolbar;
            },
            getToolbarActionsElement: function() {
                return this.getToolbarElement().querySelector(".medium-editor-toolbar-actions");
            },
            initThrottledMethods: function() {
                this.throttledPositionToolbar = a.util.throttle((function() {
                    this.base.isActive && this.positionToolbarIfShown();
                }).bind(this));
            },
            attachEventHandlers: function() {
                this.subscribe("blur", this.handleBlur.bind(this)), this.subscribe("focus", this.handleFocus.bind(this)), this.subscribe("editableClick", this.handleEditableClick.bind(this)), this.subscribe("editableKeyup", this.handleEditableKeyup.bind(this)), this.on(this.document.documentElement, "mouseup", this.handleDocumentMouseup.bind(this)), this["static"] && this.sticky && this.on(this.window, "scroll", this.handleWindowScroll.bind(this), !0), this.on(this.window, "resize", this.handleWindowResize.bind(this));
            },
            handleWindowScroll: function() {
                this.positionToolbarIfShown();
            },
            handleWindowResize: function() {
                this.throttledPositionToolbar();
            },
            handleDocumentMouseup: function(b) {
                return b && b.target && a.util.isDescendant(this.getToolbarElement(), b.target) ? !1 : void this.checkState();
            },
            handleEditableClick: function() {
                setTimeout((function() {
                    this.checkState();
                }).bind(this), 0);
            },
            handleEditableKeyup: function() {
                this.checkState();
            },
            handleBlur: function() {
                clearTimeout(this.hideTimeout), clearTimeout(this.delayShowTimeout), this.hideTimeout = setTimeout((function() {
                    this.hideToolbar();
                }).bind(this), 1);
            },
            handleFocus: function() {
                this.checkState();
            },
            isDisplayed: function() {
                return this.getToolbarElement().classList.contains("medium-editor-toolbar-active");
            },
            showToolbar: function() {
                clearTimeout(this.hideTimeout), this.isDisplayed() || (this.getToolbarElement().classList.add("medium-editor-toolbar-active"), this.trigger("showToolbar", {}, this.base.getFocusedElement()));
            },
            hideToolbar: function() {
                this.isDisplayed() && (this.getToolbarElement().classList.remove("medium-editor-toolbar-active"), this.trigger("hideToolbar", {}, this.base.getFocusedElement()));
            },
            isToolbarDefaultActionsDisplayed: function() {
                return "block" === this.getToolbarActionsElement().style.display;
            },
            hideToolbarDefaultActions: function() {
                this.isToolbarDefaultActionsDisplayed() && (this.getToolbarActionsElement().style.display = "none");
            },
            showToolbarDefaultActions: function() {
                this.hideExtensionForms(), this.isToolbarDefaultActionsDisplayed() || (this.getToolbarActionsElement().style.display = "block"), this.delayShowTimeout = this.base.delay((function() {
                    this.showToolbar();
                }).bind(this));
            },
            hideExtensionForms: function() {
                this.forEachExtension(function(a) {
                    a.hasForm && a.isDisplayed() && a.hideForm();
                });
            },
            multipleBlockElementsSelected: function() {
                var b = /<[^\/>][^>]*><\/[^>]+>/gim, c = new RegExp("<(" + a.util.blockContainerElementNames.join("|") + ")[^>]*>", "g"), d = a.selection.getSelectionHtml(this.document).replace(b, ""), e = d.match(c);
                return !!e && e.length > 1;
            },
            modifySelection: function() {
                var b = this.window.getSelection(), c = b.getRangeAt(0);
                if (this.standardizeSelectionStart && c.startContainer.nodeValue && c.startOffset === c.startContainer.nodeValue.length) {
                    var d = a.util.findAdjacentTextNodeWithContent(a.selection.getSelectionElement(this.window), c.startContainer, this.document);
                    if (d) {
                        for(var e = 0; 0 === d.nodeValue.substr(e, 1).trim().length;)e += 1;
                        c = a.selection.select(this.document, d, e, c.endContainer, c.endOffset);
                    }
                }
            },
            checkState: function() {
                if (!this.base.preventSelectionUpdates) {
                    if (!this.base.getFocusedElement() || a.selection.selectionInContentEditableFalse(this.window)) return this.hideToolbar();
                    var b = a.selection.getSelectionElement(this.window);
                    return !b || -1 === this.getEditorElements().indexOf(b) || b.getAttribute("data-disable-toolbar") ? this.hideToolbar() : this.updateOnEmptySelection && this["static"] ? this.showAndUpdateToolbar() : !a.selection.selectionContainsContent(this.document) || this.allowMultiParagraphSelection === !1 && this.multipleBlockElementsSelected() ? this.hideToolbar() : void this.showAndUpdateToolbar();
                }
            },
            showAndUpdateToolbar: function() {
                this.modifySelection(), this.setToolbarButtonStates(), this.trigger("positionToolbar", {}, this.base.getFocusedElement()), this.showToolbarDefaultActions(), this.setToolbarPosition();
            },
            setToolbarButtonStates: function() {
                this.forEachExtension(function(a) {
                    "function" == typeof a.isActive && "function" == typeof a.setInactive && a.setInactive();
                }), this.checkActiveButtons();
            },
            checkActiveButtons: function() {
                var b, c = [], d = null, e = a.selection.getSelectionRange(this.document), f = function(a) {
                    "function" == typeof a.checkState ? a.checkState(b) : "function" == typeof a.isActive && "function" == typeof a.isAlreadyApplied && "function" == typeof a.setActive && !a.isActive() && a.isAlreadyApplied(b) && a.setActive();
                };
                if (e && (this.forEachExtension(function(a) {
                    return "function" == typeof a.queryCommandState && (d = a.queryCommandState(), null !== d) ? void (d && "function" == typeof a.setActive && a.setActive()) : void c.push(a);
                }), b = a.selection.getSelectedParentElement(e), this.getEditorElements().some(function(c) {
                    return a.util.isDescendant(c, b, !0);
                }))) for(; b && (c.forEach(f), !a.util.isMediumEditorElement(b));)b = b.parentNode;
            },
            positionToolbarIfShown: function() {
                this.isDisplayed() && this.setToolbarPosition();
            },
            setToolbarPosition: function() {
                var a = this.base.getFocusedElement(), b = this.window.getSelection();
                return a ? void (!this["static"] && b.isCollapsed || (this.showToolbar(), this.relativeContainer || (this["static"] ? this.positionStaticToolbar(a) : this.positionToolbar(b)), this.trigger("positionedToolbar", {}, this.base.getFocusedElement()))) : this;
            },
            positionStaticToolbar: function(a) {
                this.getToolbarElement().style.left = "0";
                var b, c = this.document.documentElement && this.document.documentElement.scrollTop || this.document.body.scrollTop, d = this.window.innerWidth, e = this.getToolbarElement(), f = a.getBoundingClientRect(), g = f.top + c, h = f.left + f.width / 2, i = e.offsetHeight, j = e.offsetWidth, k = j / 2;
                switch(this.sticky ? c > g + a.offsetHeight - i - this.stickyTopOffset ? (e.style.top = g + a.offsetHeight - i + "px", e.classList.remove("medium-editor-sticky-toolbar")) : c > g - i - this.stickyTopOffset ? (e.classList.add("medium-editor-sticky-toolbar"), e.style.top = this.stickyTopOffset + "px") : (e.classList.remove("medium-editor-sticky-toolbar"), e.style.top = g - i + "px") : e.style.top = g - i + "px", this.align){
                    case "left":
                        b = f.left;
                        break;
                    case "right":
                        b = f.right - j;
                        break;
                    case "center":
                        b = h - k;
                }
                0 > b ? b = 0 : b + j > d && (b = d - Math.ceil(j) - 1), e.style.left = b + "px";
            },
            positionToolbar: function(a) {
                this.getToolbarElement().style.left = "0", this.getToolbarElement().style.right = "initial";
                var b = a.getRangeAt(0), c = b.getBoundingClientRect();
                (!c || 0 === c.height && 0 === c.width && b.startContainer === b.endContainer) && (c = 1 === b.startContainer.nodeType && b.startContainer.querySelector("img") ? b.startContainer.querySelector("img").getBoundingClientRect() : b.startContainer.getBoundingClientRect());
                var d, e, f = this.window.innerWidth, g = this.getToolbarElement(), h = g.offsetHeight, i = g.offsetWidth, j = i / 2, k = 50, l = this.diffLeft - j, m = this.getEditorOption("elementsContainer"), n = [
                    "absolute",
                    "fixed"
                ].indexOf(window.getComputedStyle(m).getPropertyValue("position")) > -1, o = {}, p = {};
                n ? (e = m.getBoundingClientRect(), [
                    "top",
                    "left"
                ].forEach(function(a) {
                    p[a] = c[a] - e[a];
                }), p.width = c.width, p.height = c.height, c = p, f = e.width, o.top = m.scrollTop) : o.top = this.window.pageYOffset, d = c.left + c.width / 2, o.top += c.top - h, c.top < k ? (g.classList.add("medium-toolbar-arrow-over"), g.classList.remove("medium-toolbar-arrow-under"), o.top += k + c.height - this.diffTop) : (g.classList.add("medium-toolbar-arrow-under"), g.classList.remove("medium-toolbar-arrow-over"), o.top += this.diffTop), j > d ? (o.left = l + j, o.right = "initial") : j > f - d ? (o.left = "auto", o.right = 0) : (o.left = l + d, o.right = "initial"), [
                    "top",
                    "left",
                    "right"
                ].forEach(function(a) {
                    g.style[a] = o[a] + (isNaN(o[a]) ? "" : "px");
                });
            }
        });
        a.extensions.toolbar = b;
    }(), function() {
        var b = a.Extension.extend({
            init: function() {
                a.Extension.prototype.init.apply(this, arguments), this.subscribe("editableDrag", this.handleDrag.bind(this)), this.subscribe("editableDrop", this.handleDrop.bind(this));
            },
            handleDrag: function(a) {
                var b = "medium-editor-dragover";
                a.preventDefault(), a.dataTransfer.dropEffect = "copy", "dragover" === a.type ? a.target.classList.add(b) : "dragleave" === a.type && a.target.classList.remove(b);
            },
            handleDrop: function(b) {
                var c, d = "medium-editor-dragover";
                b.preventDefault(), b.stopPropagation(), b.dataTransfer.files && (c = Array.prototype.slice.call(b.dataTransfer.files, 0), c.some((function(b) {
                    if (b.type.match("image")) {
                        var c, d;
                        c = new FileReader, c.readAsDataURL(b), d = "medium-img-" + +new Date, a.util.insertHTMLCommand(this.document, '<img class="medium-editor-image-loading" id="' + d + '" />'), c.onload = (function() {
                            var a = this.document.getElementById(d);
                            a && (a.removeAttribute("id"), a.removeAttribute("class"), a.src = c.result);
                        }).bind(this);
                    }
                }).bind(this))), b.target.classList.remove(d);
            }
        });
        a.extensions.imageDragging = b;
    }(), function() {
        function b(b) {
            var c = a.selection.getSelectionStart(this.options.ownerDocument), d = c.textContent, e = a.selection.getCaretOffsets(c);
            (void 0 === d[e.left - 1] || "" === d[e.left - 1].trim() || void 0 !== d[e.left] && "" === d[e.left].trim()) && b.preventDefault();
        }
        function c(b, c) {
            if (this.options.disableReturn || c.getAttribute("data-disable-return")) b.preventDefault();
            else if (this.options.disableDoubleReturn || c.getAttribute("data-disable-double-return")) {
                var d = a.selection.getSelectionStart(this.options.ownerDocument);
                (d && "" === d.textContent.trim() && "li" !== d.nodeName.toLowerCase() || d.previousElementSibling && "br" !== d.previousElementSibling.nodeName.toLowerCase() && "" === d.previousElementSibling.textContent.trim()) && b.preventDefault();
            }
        }
        function d(b) {
            var c = a.selection.getSelectionStart(this.options.ownerDocument), d = c && c.nodeName.toLowerCase();
            "pre" === d && (b.preventDefault(), a.util.insertHTMLCommand(this.options.ownerDocument, "    ")), a.util.isListItem(c) && (b.preventDefault(), b.shiftKey ? this.options.ownerDocument.execCommand("outdent", !1, null) : this.options.ownerDocument.execCommand("indent", !1, null));
        }
        function e(b) {
            var c, d = a.selection.getSelectionStart(this.options.ownerDocument), e = d.nodeName.toLowerCase(), f = /^(\s+|<br\/?>)?$/i, g = /h\d/i;
            a.util.isKey(b, [
                a.util.keyCode.BACKSPACE,
                a.util.keyCode.ENTER
            ]) && d.previousElementSibling && g.test(e) && 0 === a.selection.getCaretOffsets(d).left ? a.util.isKey(b, a.util.keyCode.BACKSPACE) && f.test(d.previousElementSibling.innerHTML) ? (d.previousElementSibling.parentNode.removeChild(d.previousElementSibling), b.preventDefault()) : !this.options.disableDoubleReturn && a.util.isKey(b, a.util.keyCode.ENTER) && (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.previousElementSibling.parentNode.insertBefore(c, d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.DELETE) && d.nextElementSibling && d.previousElementSibling && !g.test(e) && f.test(d.innerHTML) && g.test(d.nextElementSibling.nodeName.toLowerCase()) ? (a.selection.moveCursor(this.options.ownerDocument, d.nextElementSibling), d.previousElementSibling.parentNode.removeChild(d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && "li" === e && f.test(d.innerHTML) && !d.previousElementSibling && !d.parentElement.previousElementSibling && d.nextElementSibling && "li" === d.nextElementSibling.nodeName.toLowerCase() ? (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.parentElement.parentElement.insertBefore(c, d.parentElement), a.selection.moveCursor(this.options.ownerDocument, c), d.parentElement.removeChild(d), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && a.util.getClosestTag(d, "blockquote") !== !1 && 0 === a.selection.getCaretOffsets(d).left ? (b.preventDefault(), a.util.execFormatBlock(this.options.ownerDocument, "p")) : a.util.isKey(b, a.util.keyCode.ENTER) && a.util.getClosestTag(d, "blockquote") !== !1 && 0 === a.selection.getCaretOffsets(d).right ? (c = this.options.ownerDocument.createElement("p"), c.innerHTML = "<br>", d.parentElement.insertBefore(c, d.nextSibling), a.selection.moveCursor(this.options.ownerDocument, c), b.preventDefault()) : a.util.isKey(b, a.util.keyCode.BACKSPACE) && a.util.isMediumEditorElement(d.parentElement) && !d.previousElementSibling && d.nextElementSibling && f.test(d.innerHTML) && (b.preventDefault(), a.selection.moveCursor(this.options.ownerDocument, d.nextSibling), d.parentElement.removeChild(d));
        }
        function f(b) {
            var c, d = a.selection.getSelectionStart(this.options.ownerDocument);
            d && (a.util.isMediumEditorElement(d) && 0 === d.children.length && !a.util.isBlockContainer(d) && this.options.ownerDocument.execCommand("formatBlock", !1, "p"), !a.util.isKey(b, a.util.keyCode.ENTER) || a.util.isListItem(d) || a.util.isBlockContainer(d) || (c = d.nodeName.toLowerCase(), "a" === c ? this.options.ownerDocument.execCommand("unlink", !1, null) : b.shiftKey || b.ctrlKey || this.options.ownerDocument.execCommand("formatBlock", !1, "p")));
        }
        function g(a, b) {
            var c = b.parentNode.querySelector('textarea[medium-editor-textarea-id="' + b.getAttribute("medium-editor-textarea-id") + '"]');
            c && (c.value = b.innerHTML.trim());
        }
        function h(a) {
            a._mediumEditors || (a._mediumEditors = [
                null
            ]), this.id || (this.id = a._mediumEditors.length), a._mediumEditors[this.id] = this;
        }
        function i(a) {
            a._mediumEditors && a._mediumEditors[this.id] && (a._mediumEditors[this.id] = null);
        }
        function j(b, c, d) {
            var e = [];
            if (b || (b = []), "string" == typeof b && (b = c.querySelectorAll(b)), a.util.isElement(b) && (b = [
                b
            ]), d) for(var f = 0; f < b.length; f++){
                var g = b[f];
                !a.util.isElement(g) || g.getAttribute("data-medium-editor-element") || g.getAttribute("medium-editor-textarea-id") || e.push(g);
            }
            else e = Array.prototype.slice.apply(b);
            return e;
        }
        function k(a) {
            var b = a.parentNode.querySelector('textarea[medium-editor-textarea-id="' + a.getAttribute("medium-editor-textarea-id") + '"]');
            b && (b.classList.remove("medium-editor-hidden"), b.removeAttribute("medium-editor-textarea-id")), a.parentNode && a.parentNode.removeChild(a);
        }
        function l(a, b) {
            return Object.keys(b).forEach(function(c) {
                void 0 === a[c] && (a[c] = b[c]);
            }), a;
        }
        function m(a, b, c) {
            var d = {
                window: c.options.contentWindow,
                document: c.options.ownerDocument,
                base: c
            };
            return a = l(a, d), "function" == typeof a.init && a.init(), a.name || (a.name = b), a;
        }
        function n() {
            return this.elements.every(function(a) {
                return !!a.getAttribute("data-disable-toolbar");
            }) ? !1 : this.options.toolbar !== !1;
        }
        function o() {
            return n.call(this) ? this.options.anchorPreview !== !1 : !1;
        }
        function p() {
            return this.options.placeholder !== !1;
        }
        function q() {
            return this.options.autoLink !== !1;
        }
        function r() {
            return this.options.imageDragging !== !1;
        }
        function s() {
            return this.options.keyboardCommands !== !1;
        }
        function t() {
            return !this.options.extensions.imageDragging;
        }
        function u(a) {
            for(var b = this.options.ownerDocument.createElement("div"), c = Date.now(), d = "medium-editor-" + c, e = a.attributes; this.options.ownerDocument.getElementById(d);)c++, d = "medium-editor-" + c;
            b.className = a.className, b.id = d, b.innerHTML = a.value, a.setAttribute("medium-editor-textarea-id", d);
            for(var f = 0, g = e.length; g > f; f++)b.hasAttribute(e[f].nodeName) || b.setAttribute(e[f].nodeName, e[f].value);
            return a.form && this.on(a.form, "reset", (function(a) {
                a.defaultPrevented || this.resetContent(this.options.ownerDocument.getElementById(d));
            }).bind(this)), a.classList.add("medium-editor-hidden"), a.parentNode.insertBefore(b, a), b;
        }
        function v(b, d) {
            if (!b.getAttribute("data-medium-editor-element")) {
                "textarea" === b.nodeName.toLowerCase() && (b = u.call(this, b), this.instanceHandleEditableInput || (this.instanceHandleEditableInput = g.bind(this), this.subscribe("editableInput", this.instanceHandleEditableInput))), this.options.disableEditing || b.getAttribute("data-disable-editing") || (b.setAttribute("contentEditable", !0), b.setAttribute("spellcheck", this.options.spellcheck)), this.instanceHandleEditableKeydownEnter || (b.getAttribute("data-disable-return") || b.getAttribute("data-disable-double-return")) && (this.instanceHandleEditableKeydownEnter = c.bind(this), this.subscribe("editableKeydownEnter", this.instanceHandleEditableKeydownEnter)), this.options.disableReturn || b.getAttribute("data-disable-return") || this.on(b, "keyup", f.bind(this));
                var e = a.util.guid();
                b.setAttribute("data-medium-editor-element", !0), b.classList.add("medium-editor-element"), b.setAttribute("role", "textbox"), b.setAttribute("aria-multiline", !0), b.setAttribute("data-medium-editor-editor-index", d), b.setAttribute("medium-editor-index", e), B[e] = b.innerHTML, this.events.attachAllEventsToElement(b);
            }
            return b;
        }
        function w() {
            this.subscribe("editableKeydownTab", d.bind(this)), this.subscribe("editableKeydownDelete", e.bind(this)), this.subscribe("editableKeydownEnter", e.bind(this)), this.options.disableExtraSpaces && this.subscribe("editableKeydownSpace", b.bind(this)), this.instanceHandleEditableKeydownEnter || (this.options.disableReturn || this.options.disableDoubleReturn) && (this.instanceHandleEditableKeydownEnter = c.bind(this), this.subscribe("editableKeydownEnter", this.instanceHandleEditableKeydownEnter));
        }
        function x() {
            if (this.extensions = [], Object.keys(this.options.extensions).forEach(function(a) {
                "toolbar" !== a && this.options.extensions[a] && this.extensions.push(m(this.options.extensions[a], a, this));
            }, this), t.call(this)) {
                var b = this.options.fileDragging;
                b || (b = {}, r.call(this) || (b.allowedTypes = [])), this.addBuiltInExtension("fileDragging", b);
            }
            var c = {
                paste: !0,
                "anchor-preview": o.call(this),
                autoLink: q.call(this),
                keyboardCommands: s.call(this),
                placeholder: p.call(this)
            };
            Object.keys(c).forEach(function(a) {
                c[a] && this.addBuiltInExtension(a);
            }, this);
            var d = this.options.extensions.toolbar;
            if (!d && n.call(this)) {
                var e = a.util.extend({}, this.options.toolbar, {
                    allowMultiParagraphSelection: this.options.allowMultiParagraphSelection
                });
                d = new a.extensions.toolbar(e);
            }
            d && this.extensions.push(m(d, "toolbar", this));
        }
        function y(b, c) {
            var d = [
                [
                    "allowMultiParagraphSelection",
                    "toolbar.allowMultiParagraphSelection"
                ]
            ];
            return c && d.forEach(function(b) {
                c.hasOwnProperty(b[0]) && void 0 !== c[b[0]] && a.util.deprecated(b[0], b[1], "v6.0.0");
            }), a.util.defaults({}, c, b);
        }
        function z(b, c) {
            var d, e, f = /^append-(.+)$/gi, g = /justify([A-Za-z]*)$/g;
            if (d = f.exec(b)) return a.util.execFormatBlock(this.options.ownerDocument, d[1]);
            if ("fontSize" === b) return c.size && a.util.deprecated(".size option for fontSize command", ".value", "6.0.0"), e = c.value || c.size, this.options.ownerDocument.execCommand("fontSize", !1, e);
            if ("fontName" === b) return c.name && a.util.deprecated(".name option for fontName command", ".value", "6.0.0"), e = c.value || c.name, this.options.ownerDocument.execCommand("fontName", !1, e);
            if ("createLink" === b) return this.createLink(c);
            if ("image" === b) {
                var h = this.options.contentWindow.getSelection().toString().trim();
                return this.options.ownerDocument.execCommand("insertImage", !1, h);
            }
            if ("html" === b) {
                var i = this.options.contentWindow.getSelection().toString().trim();
                return a.util.insertHTMLCommand(this.options.ownerDocument, i);
            }
            if (g.exec(b)) {
                var j = this.options.ownerDocument.execCommand(b, !1, null), k = a.selection.getSelectedParentElement(a.selection.getSelectionRange(this.options.ownerDocument));
                return k && A.call(this, a.util.getTopBlockContainer(k)), j;
            }
            return e = c && c.value, this.options.ownerDocument.execCommand(b, !1, e);
        }
        function A(b) {
            if (b) {
                var c, d = Array.prototype.slice.call(b.childNodes).filter(function(a) {
                    var b = "div" === a.nodeName.toLowerCase();
                    return b && !c && (c = a.style.textAlign), b;
                });
                d.length && (this.saveSelection(), d.forEach(function(b) {
                    if (b.style.textAlign === c) {
                        var d = b.lastChild;
                        if (d) {
                            a.util.unwrap(b, this.options.ownerDocument);
                            var e = this.options.ownerDocument.createElement("BR");
                            d.parentNode.insertBefore(e, d.nextSibling);
                        }
                    }
                }, this), b.style.textAlign = c, this.restoreSelection());
            }
        }
        var B = {};
        a.prototype = {
            init: function(a, b) {
                return this.options = y.call(this, this.defaults, b), this.origElements = a, this.options.elementsContainer || (this.options.elementsContainer = this.options.ownerDocument.body), this.setup();
            },
            setup: function() {
                this.isActive || (h.call(this, this.options.contentWindow), this.events = new a.Events(this), this.elements = [], this.addElements(this.origElements), 0 !== this.elements.length && (this.isActive = !0, x.call(this), w.call(this)));
            },
            destroy: function() {
                this.isActive && (this.isActive = !1, this.extensions.forEach(function(a) {
                    "function" == typeof a.destroy && a.destroy();
                }, this), this.events.destroy(), this.elements.forEach(function(a) {
                    this.options.spellcheck && (a.innerHTML = a.innerHTML), a.removeAttribute("contentEditable"), a.removeAttribute("spellcheck"), a.removeAttribute("data-medium-editor-element"), a.classList.remove("medium-editor-element"), a.removeAttribute("role"), a.removeAttribute("aria-multiline"), a.removeAttribute("medium-editor-index"), a.removeAttribute("data-medium-editor-editor-index"), a.getAttribute("medium-editor-textarea-id") && k(a);
                }, this), this.elements = [], this.instanceHandleEditableKeydownEnter = null, this.instanceHandleEditableInput = null, i.call(this, this.options.contentWindow));
            },
            on: function(a, b, c, d) {
                return this.events.attachDOMEvent(a, b, c, d), this;
            },
            off: function(a, b, c, d) {
                return this.events.detachDOMEvent(a, b, c, d), this;
            },
            subscribe: function(a, b) {
                return this.events.attachCustomEvent(a, b), this;
            },
            unsubscribe: function(a, b) {
                return this.events.detachCustomEvent(a, b), this;
            },
            trigger: function(a, b, c) {
                return this.events.triggerCustomEvent(a, b, c), this;
            },
            delay: function(a) {
                var b = this;
                return setTimeout(function() {
                    b.isActive && a();
                }, this.options.delay);
            },
            serialize: function() {
                var a, b, c = {}, d = this.elements.length;
                for(a = 0; d > a; a += 1)b = "" !== this.elements[a].id ? this.elements[a].id : "element-" + a, c[b] = {
                    value: this.elements[a].innerHTML.trim()
                };
                return c;
            },
            getExtensionByName: function(a) {
                var b;
                return this.extensions && this.extensions.length && this.extensions.some(function(c) {
                    return c.name === a ? (b = c, !0) : !1;
                }), b;
            },
            addBuiltInExtension: function(b, c) {
                var d, e = this.getExtensionByName(b);
                if (e) return e;
                switch(b){
                    case "anchor":
                        d = a.util.extend({}, this.options.anchor, c), e = new a.extensions.anchor(d);
                        break;
                    case "anchor-preview":
                        e = new a.extensions.anchorPreview(this.options.anchorPreview);
                        break;
                    case "autoLink":
                        e = new a.extensions.autoLink;
                        break;
                    case "fileDragging":
                        e = new a.extensions.fileDragging(c);
                        break;
                    case "fontname":
                        e = new a.extensions.fontName(this.options.fontName);
                        break;
                    case "fontsize":
                        e = new a.extensions.fontSize(c);
                        break;
                    case "keyboardCommands":
                        e = new a.extensions.keyboardCommands(this.options.keyboardCommands);
                        break;
                    case "paste":
                        e = new a.extensions.paste(this.options.paste);
                        break;
                    case "placeholder":
                        e = new a.extensions.placeholder(this.options.placeholder);
                        break;
                    default:
                        a.extensions.button.isBuiltInButton(b) && (c ? (d = a.util.defaults({}, c, a.extensions.button.prototype.defaults[b]), e = new a.extensions.button(d)) : e = new a.extensions.button(b));
                }
                return e && this.extensions.push(m(e, b, this)), e;
            },
            stopSelectionUpdates: function() {
                this.preventSelectionUpdates = !0;
            },
            startSelectionUpdates: function() {
                this.preventSelectionUpdates = !1;
            },
            checkSelection: function() {
                var a = this.getExtensionByName("toolbar");
                return a && a.checkState(), this;
            },
            queryCommandState: function(a) {
                var b, c = /^full-(.+)$/gi, d = null;
                b = c.exec(a), b && (a = b[1]);
                try {
                    d = this.options.ownerDocument.queryCommandState(a);
                } catch (e) {
                    d = null;
                }
                return d;
            },
            execAction: function(b, c) {
                var d, e, f = /^full-(.+)$/gi;
                return d = f.exec(b), d ? (this.saveSelection(), this.selectAllContents(), e = z.call(this, d[1], c), this.restoreSelection()) : e = z.call(this, b, c), "insertunorderedlist" !== b && "insertorderedlist" !== b || a.util.cleanListDOM(this.options.ownerDocument, this.getSelectedParentElement()), this.checkSelection(), e;
            },
            getSelectedParentElement: function(b) {
                return void 0 === b && (b = this.options.contentWindow.getSelection().getRangeAt(0)), a.selection.getSelectedParentElement(b);
            },
            selectAllContents: function() {
                var b = a.selection.getSelectionElement(this.options.contentWindow);
                if (b) {
                    for(; 1 === b.children.length;)b = b.children[0];
                    this.selectElement(b);
                }
            },
            selectElement: function(b) {
                a.selection.selectNode(b, this.options.ownerDocument);
                var c = a.selection.getSelectionElement(this.options.contentWindow);
                c && this.events.focusElement(c);
            },
            getFocusedElement: function() {
                var a;
                return this.elements.some(function(b) {
                    return !a && b.getAttribute("data-medium-focused") && (a = b), !!a;
                }, this), a;
            },
            exportSelection: function() {
                var b = a.selection.getSelectionElement(this.options.contentWindow), c = this.elements.indexOf(b), d = null;
                return c >= 0 && (d = a.selection.exportSelection(b, this.options.ownerDocument)), null !== d && 0 !== c && (d.editableElementIndex = c), d;
            },
            saveSelection: function() {
                this.selectionState = this.exportSelection();
            },
            importSelection: function(b, c) {
                if (b) {
                    var d = this.elements[b.editableElementIndex || 0];
                    a.selection.importSelection(b, d, this.options.ownerDocument, c);
                }
            },
            restoreSelection: function() {
                this.importSelection(this.selectionState);
            },
            createLink: function(b) {
                var c, d = a.selection.getSelectionElement(this.options.contentWindow), e = {};
                if (-1 !== this.elements.indexOf(d)) {
                    try {
                        if (this.events.disableCustomEvent("editableInput"), b.url && a.util.deprecated(".url option for createLink", ".value", "6.0.0"), c = b.url || b.value, c && c.trim().length > 0) {
                            var f = this.options.contentWindow.getSelection();
                            if (f) {
                                var g, h, i, j, k = f.getRangeAt(0), l = k.commonAncestorContainer;
                                if (3 === k.endContainer.nodeType && 3 !== k.startContainer.nodeType && 0 === k.startOffset && k.startContainer.firstChild === k.endContainer && (l = k.endContainer), h = a.util.getClosestBlockContainer(k.startContainer), i = a.util.getClosestBlockContainer(k.endContainer), 3 !== l.nodeType && 0 !== l.textContent.length && h === i) {
                                    var m = h || d, n = this.options.ownerDocument.createDocumentFragment();
                                    this.execAction("unlink"), g = this.exportSelection(), n.appendChild(m.cloneNode(!0)), d === m ? a.selection.select(this.options.ownerDocument, m.firstChild, 0, m.lastChild, 3 === m.lastChild.nodeType ? m.lastChild.nodeValue.length : m.lastChild.childNodes.length) : a.selection.select(this.options.ownerDocument, m, 0, m, m.childNodes.length);
                                    var o = this.exportSelection();
                                    j = a.util.findOrCreateMatchingTextNodes(this.options.ownerDocument, n, {
                                        start: g.start - o.start,
                                        end: g.end - o.start,
                                        editableElementIndex: g.editableElementIndex
                                    }), 0 === j.length && (n = this.options.ownerDocument.createDocumentFragment(), n.appendChild(l.cloneNode(!0)), j = [
                                        n.firstChild.firstChild,
                                        n.firstChild.lastChild
                                    ]), a.util.createLink(this.options.ownerDocument, j, c.trim());
                                    var p = (n.firstChild.innerHTML.match(/^\s+/) || [
                                        ""
                                    ])[0].length;
                                    a.util.insertHTMLCommand(this.options.ownerDocument, n.firstChild.innerHTML.replace(/^\s+/, "")), g.start -= p, g.end -= p, this.importSelection(g);
                                } else this.options.ownerDocument.execCommand("createLink", !1, c);
                                this.options.targetBlank || "_blank" === b.target ? a.util.setTargetBlank(a.selection.getSelectionStart(this.options.ownerDocument), c) : a.util.removeTargetBlank(a.selection.getSelectionStart(this.options.ownerDocument), c), b.buttonClass && a.util.addClassToAnchors(a.selection.getSelectionStart(this.options.ownerDocument), b.buttonClass);
                            }
                        }
                        if (this.options.targetBlank || "_blank" === b.target || b.buttonClass) {
                            e = this.options.ownerDocument.createEvent("HTMLEvents"), e.initEvent("input", !0, !0, this.options.contentWindow);
                            for(var q = 0, r = this.elements.length; r > q; q += 1)this.elements[q].dispatchEvent(e);
                        }
                    } finally{
                        this.events.enableCustomEvent("editableInput");
                    }
                    this.events.triggerCustomEvent("editableInput", e, d);
                }
            },
            cleanPaste: function(a) {
                this.getExtensionByName("paste").cleanPaste(a);
            },
            pasteHTML: function(a, b) {
                this.getExtensionByName("paste").pasteHTML(a, b);
            },
            setContent: function(a, b) {
                if (b = b || 0, this.elements[b]) {
                    var c = this.elements[b];
                    c.innerHTML = a, this.checkContentChanged(c);
                }
            },
            getContent: function(a) {
                return a = a || 0, this.elements[a] ? this.elements[a].innerHTML.trim() : null;
            },
            checkContentChanged: function(b) {
                b = b || a.selection.getSelectionElement(this.options.contentWindow), this.events.updateInput(b, {
                    target: b,
                    currentTarget: b
                });
            },
            resetContent: function(a) {
                if (a) {
                    var b = this.elements.indexOf(a);
                    return void (-1 !== b && this.setContent(B[a.getAttribute("medium-editor-index")], b));
                }
                this.elements.forEach(function(a, b) {
                    this.setContent(B[a.getAttribute("medium-editor-index")], b);
                }, this);
            },
            addElements: function(a) {
                var b = j(a, this.options.ownerDocument, !0);
                return 0 === b.length ? !1 : void b.forEach(function(a) {
                    a = v.call(this, a, this.id), this.elements.push(a), this.trigger("addElement", {
                        target: a,
                        currentTarget: a
                    }, a);
                }, this);
            },
            removeElements: function(a) {
                var b = j(a, this.options.ownerDocument), c = b.map(function(a) {
                    return a.getAttribute("medium-editor-textarea-id") && a.parentNode ? a.parentNode.querySelector('div[medium-editor-textarea-id="' + a.getAttribute("medium-editor-textarea-id") + '"]') : a;
                });
                this.elements = this.elements.filter(function(a) {
                    return -1 !== c.indexOf(a) ? (this.events.cleanupElement(a), a.getAttribute("medium-editor-textarea-id") && k(a), this.trigger("removeElement", {
                        target: a,
                        currentTarget: a
                    }, a), !1) : !0;
                }, this);
            }
        }, a.getEditorFromElement = function(a) {
            var b = a.getAttribute("data-medium-editor-editor-index"), c = a && a.ownerDocument && (a.ownerDocument.defaultView || a.ownerDocument.parentWindow);
            return c && c._mediumEditors && c._mediumEditors[b] ? c._mediumEditors[b] : null;
        };
    }(), function() {
        a.prototype.defaults = {
            activeButtonClass: "medium-editor-button-active",
            buttonLabels: !1,
            delay: 0,
            disableReturn: !1,
            disableDoubleReturn: !1,
            disableExtraSpaces: !1,
            disableEditing: !1,
            autoLink: !1,
            elementsContainer: !1,
            contentWindow: window,
            ownerDocument: document,
            targetBlank: !1,
            extensions: {},
            spellcheck: !0
        };
    }(), a.parseVersionString = function(a) {
        var b = a.split("-"), c = b[0].split("."), d = b.length > 1 ? b[1] : "";
        return {
            major: parseInt(c[0], 10),
            minor: parseInt(c[1], 10),
            revision: parseInt(c[2], 10),
            preRelease: d,
            toString: function() {
                return [
                    c[0],
                    c[1],
                    c[2]
                ].join(".") + (d ? "-" + d : "");
            }
        };
    }, a.version = a.parseVersionString.call(this, "5.23.3"), a;
}());



class $91b592b47f6f2020$export$39bcc3f08a9b5fa4 {
}
$91b592b47f6f2020$export$39bcc3f08a9b5fa4.MEDIUM_EDITOR_OPTIONS = {
    autoLink: true
};


// Copyright (C) Konrad Gadzinowski
// Copyright (C) Konrad Gadzinowski
class $bd98c7125df1feb2$export$d26bcf891bc220f6 {
    static toSafe(value) {
        try {
            if (!value) return 0;
            if ($bd98c7125df1feb2$export$d26bcf891bc220f6.isString(value)) value = parseFloat(value);
            value = value * 100;
            value = Math.round(value);
        } catch (error) {
            return 0;
        }
        return value;
    }
    static toReadable(safeValue, defaultValue = 0) {
        try {
            if (!safeValue) return defaultValue;
            if ($bd98c7125df1feb2$export$d26bcf891bc220f6.isString(safeValue)) safeValue = parseFloat(safeValue);
            safeValue = safeValue / 100;
        } catch (error) {
            return defaultValue;
        }
        return safeValue;
    }
    static isString(value) {
        return typeof value === "string" || value instanceof String;
    }
}


class $2e60e98948ab7fe8$export$b733e092f9f44b2c {
    static addCommaAtThousands(price) {
        if (!price) return null;
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    static showPriceAsText(price, currencyCode, hideTrailingZeros) {
        let priceText = "-";
        if (price === null || price === undefined) return priceText;
        price = (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(price);
        priceText = parseFloat(price.toString()).toFixed(2);
        if (hideTrailingZeros) priceText = priceText.replace(/\.00$/, "");
        priceText = $2e60e98948ab7fe8$export$b733e092f9f44b2c.addCommaAtThousands(priceText);
        if (currencyCode !== "") {
            if (!currencyCode) currencyCode = "USD";
            currencyCode = currencyCode.toUpperCase();
            let currencies = $2e60e98948ab7fe8$export$b733e092f9f44b2c.getCurrencies();
            for (let currency of currencies)if (currency.code == currencyCode) {
                if (currency.isSymbolInFront) priceText = currency.symbol + priceText;
                else priceText = priceText + currency.symbol;
                break;
            }
        }
        return priceText;
    }
    static showPriceAsShortText(price, currencyCode) {
        let priceText = "-";
        if (price === null || price === undefined) return priceText;
        price = Math.abs(price);
        price = (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(price);
        if (price < 1000) priceText = Math.round(price).toString();
        else if (price < 1000000) {
            price = price / 1000;
            priceText = Math.round(price).toString() + "k";
        } else if (price < 1000000000) {
            price = price / 1000000;
            priceText = Math.round(price).toString() + "M";
        } else if (price < 1000000000000) {
            price = price / 1000000000;
            priceText = Math.round(price).toString() + "B";
        } else priceText = "$$$";
        if (!currencyCode) currencyCode = "USD";
        currencyCode = currencyCode.toUpperCase();
        let currencies = $2e60e98948ab7fe8$export$b733e092f9f44b2c.getCurrencies();
        for (let currency of currencies)if (currency.code == currencyCode) {
            if (currency.isSymbolInFront) priceText = currency.symbol + priceText;
            else priceText = priceText + currency.symbol;
            break;
        }
        return priceText;
    }
    constructor(code, countryCode2Letters, symbol, name, isSymbolInFront){
        this.code = code.toUpperCase();
        this.countryCode2Letters = countryCode2Letters;
        this.symbol = symbol;
        this.name = name;
        this.isSymbolInFront = isSymbolInFront;
    }
}
$2e60e98948ab7fe8$export$b733e092f9f44b2c.USD = "USD";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR = "EUR";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.AUD = "AUD";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.GBP = "GBP";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.NZD = "NZD";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.PLN = "PLN";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.CAD = "CAD";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.JPY = "JPY";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.CZK = "CZK";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.DKK = "DKK";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.HUF = "HUF";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.RON = "RON";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.SEK = "SEK";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.CHF = "CHF";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.NOK = "NOK";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.TRY = "TRY";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.MXN = "MXN";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.THB = "THB";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.SGD = "SGD";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.AED = "AED";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.MYR = "MYR";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.ISK = "ISK";
$2e60e98948ab7fe8$export$b733e092f9f44b2c.getCurrencies = ()=>{
    const currencies = [];
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.USD, "US", "$", "United States Dollar", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "EU", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "AT", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "BE", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "BG", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "HR", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "CY", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "EE", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "FI", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "FR", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "DE", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "GR", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "IE", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "IT", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "LV", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "LT", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "LU", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "MT", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "NL", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "PT", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "SK", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "SI", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.EUR, "ES", "\u20AC", "Euro", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.AED, "AE", "\u062F.\u0625", "United Arab Emirates Dirham", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.AUD, "AU", "A$", "Australian Dollar", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.CAD, "CA", "C$", "Canadian Dollar", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.CHF, "CH", "CHF", "Swiss Franc", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.CZK, "CZ", "K\u010D", "Czech Koruna", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.DKK, "DK", "kr", "Danish Krone", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.GBP, "GB", "\xa3", "Pound Sterling", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.HUF, "HU", "Ft", "Hungarian Forint", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.JPY, "JP", "\xa5", "Japanese Yen", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.MXN, "MX", "Mex$", "Mexican Peso", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.MYR, "MY", "RM", "Malaysian Ringgit", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.NOK, "NO", "kr", "Norwegian Krone", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.NZD, "NZ", "NZ$", "New Zealand Dollar", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.PLN, "PL", "z\u0142", "Polish Z\u0142oty", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.RON, "RO", "lei", "Romanian Leu", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.SEK, "SE", "kr", "Swedish Krona", false));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.SGD, "SG", "SG$", "Singapore Dollar", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.THB, "TH", "\u0E3F", "Thai Baht", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.TRY, "TR", "\u20BA", "Turkish Lira", true));
    currencies.push(new $2e60e98948ab7fe8$export$b733e092f9f44b2c($2e60e98948ab7fe8$export$b733e092f9f44b2c.ISK, "IS", "kr", "Icelandic Kr\xf3na", false));
    return currencies;
};
$2e60e98948ab7fe8$export$b733e092f9f44b2c.findByCode = (code)=>$2e60e98948ab7fe8$export$b733e092f9f44b2c.getCurrencies().find((currency)=>currency.code == code);



const $0d5a54daf7f434ab$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$0d5a54daf7f434ab$export$c169aefb7330cccb["open"] = "0";
$0d5a54daf7f434ab$export$c169aefb7330cccb["close"] = "1";
$0d5a54daf7f434ab$export$c169aefb7330cccb["ping"] = "2";
$0d5a54daf7f434ab$export$c169aefb7330cccb["pong"] = "3";
$0d5a54daf7f434ab$export$c169aefb7330cccb["message"] = "4";
$0d5a54daf7f434ab$export$c169aefb7330cccb["upgrade"] = "5";
$0d5a54daf7f434ab$export$c169aefb7330cccb["noop"] = "6";
const $0d5a54daf7f434ab$export$47791e8004edd485 = Object.create(null);
Object.keys($0d5a54daf7f434ab$export$c169aefb7330cccb).forEach((key)=>{
    $0d5a54daf7f434ab$export$47791e8004edd485[$0d5a54daf7f434ab$export$c169aefb7330cccb[key]] = key;
});
const $0d5a54daf7f434ab$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $82628f88cbdd5714$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $82628f88cbdd5714$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $82628f88cbdd5714$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $82628f88cbdd5714$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($82628f88cbdd5714$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $82628f88cbdd5714$var$encodeBlobAsBase64(data, callback);
    } else if ($82628f88cbdd5714$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $82628f88cbdd5714$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $82628f88cbdd5714$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $0d5a54daf7f434ab$export$c169aefb7330cccb)[type] + (data || ""));
};
const $82628f88cbdd5714$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $82628f88cbdd5714$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $82628f88cbdd5714$var$TEXT_ENCODER;
function $82628f88cbdd5714$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($82628f88cbdd5714$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($82628f88cbdd5714$var$toArray).then(callback);
    else if ($82628f88cbdd5714$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $82628f88cbdd5714$var$isView(packet.data))) return callback($82628f88cbdd5714$var$toArray(packet.data));
    $82628f88cbdd5714$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$82628f88cbdd5714$var$TEXT_ENCODER) $82628f88cbdd5714$var$TEXT_ENCODER = new TextEncoder();
        callback($82628f88cbdd5714$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $250821739d28bc01$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $250821739d28bc01$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $250821739d28bc01$var$chars.length; i++)$250821739d28bc01$var$lookup[$250821739d28bc01$var$chars.charCodeAt(i)] = i;
const $250821739d28bc01$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $250821739d28bc01$var$chars[bytes[i] >> 2];
        base64 += $250821739d28bc01$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $250821739d28bc01$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $250821739d28bc01$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $250821739d28bc01$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $250821739d28bc01$var$lookup[base64.charCodeAt(i)];
        encoded2 = $250821739d28bc01$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $250821739d28bc01$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $250821739d28bc01$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $e49a80042ca676c9$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $e49a80042ca676c9$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $e49a80042ca676c9$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $e49a80042ca676c9$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $0d5a54daf7f434ab$export$47791e8004edd485)[type];
    if (!packetType) return 0, $0d5a54daf7f434ab$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $0d5a54daf7f434ab$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $0d5a54daf7f434ab$export$47791e8004edd485)[type]
    };
};
const $e49a80042ca676c9$var$decodeBase64Packet = (data, binaryType)=>{
    if ($e49a80042ca676c9$var$withNativeArrayBuffer) {
        const decoded = (0, $250821739d28bc01$export$2f872c0f2117be69)(data);
        return $e49a80042ca676c9$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $e49a80042ca676c9$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $771902fae9440987$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $771902fae9440987$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $82628f88cbdd5714$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($771902fae9440987$var$SEPARATOR));
        });
    });
};
const $771902fae9440987$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($771902fae9440987$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $e49a80042ca676c9$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $771902fae9440987$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $82628f88cbdd5714$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $771902fae9440987$var$TEXT_DECODER;
function $771902fae9440987$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $771902fae9440987$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $771902fae9440987$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$771902fae9440987$var$TEXT_DECODER) $771902fae9440987$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($771902fae9440987$var$totalLength(chunks) < 1) break;
                    const header = $771902fae9440987$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($771902fae9440987$var$totalLength(chunks) < 2) break;
                    const headerArray = $771902fae9440987$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($771902fae9440987$var$totalLength(chunks) < 8) break;
                    const headerArray = $771902fae9440987$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $0d5a54daf7f434ab$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($771902fae9440987$var$totalLength(chunks) < expectedLength) break;
                    const data = $771902fae9440987$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $e49a80042ca676c9$export$4647901878f33f31)(isBinary ? data : $771902fae9440987$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $0d5a54daf7f434ab$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $771902fae9440987$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $6d7d66b5580ede39$export$4293555f241ae35a(obj) {
    if (obj) return $6d7d66b5580ede39$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $6d7d66b5580ede39$var$mixin(obj) {
    for(var key in $6d7d66b5580ede39$export$4293555f241ae35a.prototype)obj[key] = $6d7d66b5580ede39$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.on = $6d7d66b5580ede39$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.off = $6d7d66b5580ede39$export$4293555f241ae35a.prototype.removeListener = $6d7d66b5580ede39$export$4293555f241ae35a.prototype.removeAllListeners = $6d7d66b5580ede39$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$6d7d66b5580ede39$export$4293555f241ae35a.prototype.emitReserved = $6d7d66b5580ede39$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $6d7d66b5580ede39$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $132d05bbd0736734$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $132d05bbd0736734$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $132d05bbd0736734$export$790dcbc41e2d75d5 = "arraybuffer";
function $132d05bbd0736734$export$19413efcf2fac759() {}


function $7ad315268ee82991$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $7ad315268ee82991$var$NATIVE_SET_TIMEOUT = (0, $132d05bbd0736734$export$394f9358f6231289).setTimeout;
const $7ad315268ee82991$var$NATIVE_CLEAR_TIMEOUT = (0, $132d05bbd0736734$export$394f9358f6231289).clearTimeout;
function $7ad315268ee82991$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $7ad315268ee82991$var$NATIVE_SET_TIMEOUT.bind((0, $132d05bbd0736734$export$394f9358f6231289));
        obj.clearTimeoutFn = $7ad315268ee82991$var$NATIVE_CLEAR_TIMEOUT.bind((0, $132d05bbd0736734$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $132d05bbd0736734$export$394f9358f6231289).setTimeout.bind((0, $132d05bbd0736734$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $132d05bbd0736734$export$394f9358f6231289).clearTimeout.bind((0, $132d05bbd0736734$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $7ad315268ee82991$var$BASE64_OVERHEAD = 1.33;
function $7ad315268ee82991$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $7ad315268ee82991$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $7ad315268ee82991$var$BASE64_OVERHEAD);
}
function $7ad315268ee82991$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $7ad315268ee82991$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $bd8e0c05955f5bcd$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $bd8e0c05955f5bcd$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $822e7deb44bffc97$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $822e7deb44bffc97$export$86495b081fef8e52 extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $822e7deb44bffc97$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $e49a80042ca676c9$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $bd8e0c05955f5bcd$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $7ad315268ee82991$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
}




class $46b2fcdf9f33afd3$export$265ee5eefd4c309b extends (0, $822e7deb44bffc97$export$86495b081fef8e52) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $771902fae9440987$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $771902fae9440987$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $7ad315268ee82991$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    constructor(){
        super(...arguments);
        this._polling = false;
    }
}





// imported from https://github.com/component/has-cors
let $4fe86dcd018b5f4e$var$value = false;
try {
    $4fe86dcd018b5f4e$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $4fe86dcd018b5f4e$export$5235bbd4a1ef06e = $4fe86dcd018b5f4e$var$value;


function $7c15466098a5cb07$var$empty() {}
class $7c15466098a5cb07$export$c959f2344155d309 extends (0, $46b2fcdf9f33afd3$export$265ee5eefd4c309b) {
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
}
class $7c15466098a5cb07$export$7fa6c5b6f8193917 extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $7ad315268ee82991$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $7c15466098a5cb07$export$7fa6c5b6f8193917.requestsCount++;
            $7c15466098a5cb07$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $7c15466098a5cb07$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $7c15466098a5cb07$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $7ad315268ee82991$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
}
$7c15466098a5cb07$export$7fa6c5b6f8193917.requestsCount = 0;
$7c15466098a5cb07$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $7c15466098a5cb07$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $132d05bbd0736734$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $7c15466098a5cb07$var$unloadHandler, false);
    }
}
function $7c15466098a5cb07$var$unloadHandler() {
    for(let i in $7c15466098a5cb07$export$7fa6c5b6f8193917.requests)if ($7c15466098a5cb07$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $7c15466098a5cb07$export$7fa6c5b6f8193917.requests[i].abort();
}
const $7c15466098a5cb07$var$hasXHR2 = function() {
    const xhr = $7c15466098a5cb07$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $7c15466098a5cb07$export$a2d42eb087c10497 extends $7c15466098a5cb07$export$c959f2344155d309 {
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $7c15466098a5cb07$export$7fa6c5b6f8193917($7c15466098a5cb07$var$newRequest, this.uri(), opts);
    }
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $7c15466098a5cb07$var$hasXHR2 && !forceBase64;
    }
}
function $7c15466098a5cb07$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $4fe86dcd018b5f4e$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $132d05bbd0736734$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $74c810196130009f$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $74c810196130009f$export$570bf71d2367e261 extends (0, $822e7deb44bffc97$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $74c810196130009f$var$isReactNative ? {} : (0, $7ad315268ee82991$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $82628f88cbdd5714$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $132d05bbd0736734$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $7ad315268ee82991$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $74c810196130009f$var$WebSocketCtor = (0, $132d05bbd0736734$export$394f9358f6231289).WebSocket || (0, $132d05bbd0736734$export$394f9358f6231289).MozWebSocket;
class $74c810196130009f$export$911baa0677ac404c extends $74c810196130009f$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$74c810196130009f$var$isReactNative ? protocols ? new $74c810196130009f$var$WebSocketCtor(uri, protocols) : new $74c810196130009f$var$WebSocketCtor(uri) : new $74c810196130009f$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $f7521e0e686c1478$export$961c930859384407 extends (0, $822e7deb44bffc97$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $771902fae9440987$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $771902fae9440987$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $132d05bbd0736734$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $f45d0a1b1cb34135$export$46dec00755c1153b = {
    websocket: (0, $74c810196130009f$export$911baa0677ac404c),
    webtransport: (0, $f7521e0e686c1478$export$961c930859384407),
    polling: (0, $7c15466098a5cb07$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $5373ca927e4f7844$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $5373ca927e4f7844$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $5373ca927e4f7844$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $5373ca927e4f7844$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$5373ca927e4f7844$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $5373ca927e4f7844$var$pathNames(uri, uri["path"]);
    uri.queryKey = $5373ca927e4f7844$var$queryKey(uri, uri["query"]);
    return uri;
}
function $5373ca927e4f7844$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $5373ca927e4f7844$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $1f528c17d280bed3$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $1f528c17d280bed3$var$OFFLINE_EVENT_LISTENERS = [];
if ($1f528c17d280bed3$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $1f528c17d280bed3$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $1f528c17d280bed3$export$3874118029a0ee0d extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $771902fae9440987$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $1f528c17d280bed3$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $1f528c17d280bed3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $7ad315268ee82991$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $132d05bbd0736734$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $1f528c17d280bed3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($1f528c17d280bed3$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $1f528c17d280bed3$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $1f528c17d280bed3$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $132d05bbd0736734$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $5373ca927e4f7844$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $5373ca927e4f7844$export$98e6a39c04603d36)(opts.host).host;
        (0, $7ad315268ee82991$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $bd8e0c05955f5bcd$export$2f872c0f2117be69)(this.opts.query);
        if ($1f528c17d280bed3$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $1f528c17d280bed3$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $132d05bbd0736734$export$19413efcf2fac759)();
        this._open();
    }
}
$1f528c17d280bed3$export$3874118029a0ee0d.protocol = (0, $771902fae9440987$export$a51d6b395ff4c65a);
class $1f528c17d280bed3$export$cc521fcb1004e85c extends $1f528c17d280bed3$export$3874118029a0ee0d {
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $1f528c17d280bed3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $1f528c17d280bed3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
}
class $1f528c17d280bed3$export$4798917dbf149b79 extends $1f528c17d280bed3$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $f45d0a1b1cb34135$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $2e1019751d5e46cc$export$1e7deca84b429035 extends (0, $46b2fcdf9f33afd3$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $c15e952a209f8863$export$a51d6b395ff4c65a = (0, $1f528c17d280bed3$export$4798917dbf149b79).protocol;


function $2ac25ba393f49414$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $5373ca927e4f7844$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $fa90c058a54747ab$exports = {};

$parcel$export($fa90c058a54747ab$exports, "protocol", function () { return $fa90c058a54747ab$export$a51d6b395ff4c65a; });
$parcel$export($fa90c058a54747ab$exports, "PacketType", function () { return $fa90c058a54747ab$export$84d4095e16c6fc19; });
$parcel$export($fa90c058a54747ab$exports, "Encoder", function () { return $fa90c058a54747ab$export$a50aceb0e02a00aa; });
$parcel$export($fa90c058a54747ab$exports, "Decoder", function () { return $fa90c058a54747ab$export$f9de6ca0bc043724; });
$parcel$export($fa90c058a54747ab$exports, "isPacketValid", function () { return $fa90c058a54747ab$export$1a38ed17dcb5458e; });

const $4187c46690d62dc0$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4187c46690d62dc0$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4187c46690d62dc0$var$toString = Object.prototype.toString;
const $4187c46690d62dc0$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4187c46690d62dc0$var$toString.call(Blob) === "[object BlobConstructor]";
const $4187c46690d62dc0$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4187c46690d62dc0$var$toString.call(File) === "[object FileConstructor]";
function $4187c46690d62dc0$export$37488ff1135b1696(obj) {
    return $4187c46690d62dc0$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4187c46690d62dc0$var$isView(obj)) || $4187c46690d62dc0$var$withNativeBlob && obj instanceof Blob || $4187c46690d62dc0$var$withNativeFile && obj instanceof File;
}
function $4187c46690d62dc0$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4187c46690d62dc0$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4187c46690d62dc0$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4187c46690d62dc0$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4187c46690d62dc0$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $623a9b1f40c928f3$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $623a9b1f40c928f3$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $623a9b1f40c928f3$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $4187c46690d62dc0$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $623a9b1f40c928f3$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $623a9b1f40c928f3$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $623a9b1f40c928f3$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $623a9b1f40c928f3$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $623a9b1f40c928f3$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $623a9b1f40c928f3$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $623a9b1f40c928f3$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $fa90c058a54747ab$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $fa90c058a54747ab$export$a51d6b395ff4c65a = 5;
var $fa90c058a54747ab$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($fa90c058a54747ab$export$84d4095e16c6fc19 || ($fa90c058a54747ab$export$84d4095e16c6fc19 = {}));
class $fa90c058a54747ab$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $fa90c058a54747ab$export$84d4095e16c6fc19.EVENT || obj.type === $fa90c058a54747ab$export$84d4095e16c6fc19.ACK) {
            if ((0, $4187c46690d62dc0$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $fa90c058a54747ab$export$84d4095e16c6fc19.EVENT ? $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_EVENT : $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $623a9b1f40c928f3$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
class $fa90c058a54747ab$export$f9de6ca0bc043724 extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $fa90c058a54747ab$export$84d4095e16c6fc19.EVENT : $fa90c058a54747ab$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $fa90c058a54747ab$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $4187c46690d62dc0$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($fa90c058a54747ab$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            const n = Number(buf);
            if (!$fa90c058a54747ab$var$isInteger(n) || n < 0) throw new Error("Illegal attachments");
            else if (n > this.opts.maxAttachments) throw new Error("too many attachments");
            p.attachments = n;
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($fa90c058a54747ab$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $fa90c058a54747ab$export$84d4095e16c6fc19.CONNECT:
                return $fa90c058a54747ab$var$isObject(payload);
            case $fa90c058a54747ab$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $fa90c058a54747ab$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $fa90c058a54747ab$var$isObject(payload);
            case $fa90c058a54747ab$export$84d4095e16c6fc19.EVENT:
            case $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $fa90c058a54747ab$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $fa90c058a54747ab$export$84d4095e16c6fc19.ACK:
            case $fa90c058a54747ab$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: undefined,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $fa90c058a54747ab$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $623a9b1f40c928f3$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}
function $fa90c058a54747ab$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $fa90c058a54747ab$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $fa90c058a54747ab$var$isAckIdValid(id) {
    return id === undefined || $fa90c058a54747ab$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $fa90c058a54747ab$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $fa90c058a54747ab$var$isDataValid(type, payload) {
    switch(type){
        case $fa90c058a54747ab$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $fa90c058a54747ab$var$isObject(payload);
        case $fa90c058a54747ab$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $fa90c058a54747ab$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $fa90c058a54747ab$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $fa90c058a54747ab$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $fa90c058a54747ab$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $fa90c058a54747ab$var$isObject(payload);
        default:
            return false;
    }
}
function $fa90c058a54747ab$export$1a38ed17dcb5458e(packet) {
    return $fa90c058a54747ab$var$isNamespaceValid(packet.nsp) && $fa90c058a54747ab$var$isAckIdValid(packet.id) && $fa90c058a54747ab$var$isDataValid(packet.type, packet.data);
}


function $4f4732ca5340476a$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $dcdb2c7469d88d16$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $dcdb2c7469d88d16$export$4798917dbf149b79 extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $4f4732ca5340476a$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $4f4732ca5340476a$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $4f4732ca5340476a$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $4f4732ca5340476a$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($dcdb2c7469d88d16$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $fa90c058a54747ab$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $fa90c058a54747ab$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).EVENT:
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).ACK:
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $fa90c058a54747ab$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $fa90c058a54747ab$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $fa90c058a54747ab$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $e328e38244d30aa4$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $e328e38244d30aa4$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $e328e38244d30aa4$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $e328e38244d30aa4$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $e328e38244d30aa4$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $e328e38244d30aa4$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $ac4f09bf8f0448a5$export$d0d38e7dec7a1a61 extends (0, $6d7d66b5580ede39$export$4293555f241ae35a) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $1f528c17d280bed3$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $4f4732ca5340476a$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $4f4732ca5340476a$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $132d05bbd0736734$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $dcdb2c7469d88d16$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $7ad315268ee82991$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $e328e38244d30aa4$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $fa90c058a54747ab$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}





/**
 * Managers cache.
 */ const $0a6c8936eefe0a99$var$cache = {};
function $0a6c8936eefe0a99$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $2ac25ba393f49414$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $0a6c8936eefe0a99$var$cache[id] && path in $0a6c8936eefe0a99$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $ac4f09bf8f0448a5$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$0a6c8936eefe0a99$var$cache[id]) $0a6c8936eefe0a99$var$cache[id] = new (0, $ac4f09bf8f0448a5$export$d0d38e7dec7a1a61)(source, opts);
        io = $0a6c8936eefe0a99$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($0a6c8936eefe0a99$export$841407ceb083bd74, {
    Manager: $ac4f09bf8f0448a5$export$d0d38e7dec7a1a61,
    Socket: $dcdb2c7469d88d16$export$4798917dbf149b79,
    io: $0a6c8936eefe0a99$export$841407ceb083bd74,
    connect: $0a6c8936eefe0a99$export$841407ceb083bd74
});


class $16521f78b103838e$export$4bbaa2811faa41de {
}
$16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_DELAY_MS = 1000;
$16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_DELAY_MAX_MS = 5000;
$16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_ATTEMPTS = Infinity;
$16521f78b103838e$export$4bbaa2811faa41de.socket = null;
$16521f78b103838e$export$4bbaa2811faa41de.connectionListeners = [];
$16521f78b103838e$export$4bbaa2811faa41de.initialize = ()=>{
    if ($16521f78b103838e$export$4bbaa2811faa41de.socket) return;
    const socket = (0, $0a6c8936eefe0a99$export$841407ceb083bd74)({
        transports: [
            "websocket"
        ],
        reconnection: true,
        reconnectionAttempts: $16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_ATTEMPTS,
        reconnectionDelay: $16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_DELAY_MS,
        reconnectionDelayMax: $16521f78b103838e$export$4bbaa2811faa41de.RECONNECTION_DELAY_MAX_MS
    });
    $16521f78b103838e$export$4bbaa2811faa41de.socket = socket;
    socket.on("connect", ()=>$16521f78b103838e$export$4bbaa2811faa41de.notifyConnectionChange(true));
    socket.on("disconnect", (reason)=>{
        $16521f78b103838e$export$4bbaa2811faa41de.notifyConnectionChange(false);
        if (reason === "io server disconnect") // Reconnect
        socket.connect();
    });
};
$16521f78b103838e$export$4bbaa2811faa41de.on = (event, callback)=>{
    var _SocketClient_socket;
    (_SocketClient_socket = $16521f78b103838e$export$4bbaa2811faa41de.socket) === null || _SocketClient_socket === void 0 ? void 0 : _SocketClient_socket.on(event, callback);
};
$16521f78b103838e$export$4bbaa2811faa41de.off = (event, callback)=>{
    var _SocketClient_socket;
    (_SocketClient_socket = $16521f78b103838e$export$4bbaa2811faa41de.socket) === null || _SocketClient_socket === void 0 ? void 0 : _SocketClient_socket.off(event, callback);
};
$16521f78b103838e$export$4bbaa2811faa41de.emit = (event, data)=>{
    var _SocketClient_socket;
    (_SocketClient_socket = $16521f78b103838e$export$4bbaa2811faa41de.socket) === null || _SocketClient_socket === void 0 ? void 0 : _SocketClient_socket.emit(event, data);
};
$16521f78b103838e$export$4bbaa2811faa41de.isConnected = ()=>{
    var _SocketClient_socket;
    var _SocketClient_socket_connected;
    return (_SocketClient_socket_connected = (_SocketClient_socket = $16521f78b103838e$export$4bbaa2811faa41de.socket) === null || _SocketClient_socket === void 0 ? void 0 : _SocketClient_socket.connected) !== null && _SocketClient_socket_connected !== void 0 ? _SocketClient_socket_connected : false;
};
$16521f78b103838e$export$4bbaa2811faa41de.onConnectionChange = (callback)=>{
    $16521f78b103838e$export$4bbaa2811faa41de.connectionListeners.push(callback);
};
$16521f78b103838e$export$4bbaa2811faa41de.offConnectionChange = (callback)=>{
    $16521f78b103838e$export$4bbaa2811faa41de.connectionListeners = $16521f78b103838e$export$4bbaa2811faa41de.connectionListeners.filter((listener)=>listener !== callback);
};
$16521f78b103838e$export$4bbaa2811faa41de.notifyConnectionChange = (connected)=>{
    for (const listener of $16521f78b103838e$export$4bbaa2811faa41de.connectionListeners)listener(connected);
};


var $af3e60c4682271e9$export$bdfa458742e675ed;
(function(SocketEvents) {
    SocketEvents["MenuGenerationStatus"] = "menu:generation:status";
    SocketEvents["OrderNew"] = "order:new";
    SocketEvents["OrderPending"] = "order:pending";
    SocketEvents["OrderUpdated"] = "order:updated";
    SocketEvents["OrderJoin"] = "order:join";
    SocketEvents["OrderAccept"] = "order:accept";
    SocketEvents["OrderReject"] = "order:reject";
    SocketEvents["OrderDone"] = "order:done";
    SocketEvents["OrderInProgress"] = "order:in-progress";
    SocketEvents["OrderRefund"] = "order:refund";
    SocketEvents["OrderRefundFailed"] = "order:refund-failed";
})($af3e60c4682271e9$export$bdfa458742e675ed || ($af3e60c4682271e9$export$bdfa458742e675ed = {}));




var $c26f41c501210151$export$b3cca15178f70d5;
(function(DishFeeType) {
    DishFeeType["Fixed"] = "fixed";
    DishFeeType["Percentage"] = "percentage";
})($c26f41c501210151$export$b3cca15178f70d5 || ($c26f41c501210151$export$b3cca15178f70d5 = {}));
class $c26f41c501210151$export$d9b273488cd8ce6f {
    constructor(menuData){
        this.formatPrice = (readableAmount)=>{
            return (0, $2e60e98948ab7fe8$export$b733e092f9f44b2c).showPriceAsText((0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(readableAmount), this.menuData.currency, true);
        };
        this.isFeeApplicable = (fee, deliveryMethod)=>{
            if (deliveryMethod) return fee.deliveryMethods.includes(deliveryMethod);
            const areAllDeliveryMethodsSupported = this.menuData.deliveryMethods.every((method)=>fee.deliveryMethods.includes(method));
            return areAllDeliveryMethodsSupported;
        };
        this.getApplicableFees = (dish, deliveryMethod)=>{
            var _dish_fees;
            return ((_dish_fees = dish.fees) !== null && _dish_fees !== void 0 ? _dish_fees : []).filter((fee)=>this.isFeeApplicable(fee, deliveryMethod));
        };
        this.getItemApplicableFees = (item, deliveryMethod)=>{
            const halves = this.getHalfAndHalfDishes(item);
            if (halves) return $c26f41c501210151$export$d9b273488cd8ce6f.dedupeByName([
                ...this.getApplicableFees(halves[0], deliveryMethod),
                ...this.getApplicableFees(halves[1], deliveryMethod)
            ]);
            var _item_dishId;
            const dish = this.menuData.dishes[(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""];
            return dish ? this.getApplicableFees(dish, deliveryMethod) : [];
        };
        this.getItemFeeUnitAmountSafe = (item, fee)=>fee.type === "fixed" ? (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(fee.price) : Math.round(this.getItemUnitPriceSafe(item) * fee.percentage / $c26f41c501210151$export$d9b273488cd8ce6f.PERCENT_DIVISOR);
        this.getItemFeeLineAmount = (item, fee, count)=>(0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(this.getItemFeeUnitAmountSafe(item, fee) * count);
        this.getItemKey = (item)=>{
            var _item_dishId;
            return item.halfAndHalf ? `${$c26f41c501210151$export$d9b273488cd8ce6f.HALF_AND_HALF_KEY_PREFIX}${[
                ...item.halfAndHalf
            ].sort().join("+")}${this.getAddonsSignature(item)}` : `${(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""}${this.getAddonsSignature(item)}`;
        };
        this.getAddonsSignature = (item)=>{
            var _item_addons;
            const addons = (_item_addons = item.addons) !== null && _item_addons !== void 0 ? _item_addons : [];
            if (addons.length === 0) return "";
            const parts = addons.map((addon)=>`${addon.name}~${addon.price}~${addon.quantity}`).sort();
            return `|${parts.join(",")}`;
        };
        this.getItemAddons = (item)=>{
            var _item_addons;
            return (_item_addons = item.addons) !== null && _item_addons !== void 0 ? _item_addons : [];
        };
        this.getAddonLineAmount = (addon)=>(0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable((0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(addon.price) * addon.quantity);
        this.getDishAddons = (dishId)=>{
            var _this_menuData_dishes_dishId;
            var _this_menuData_dishes_dishId_addons;
            return (_this_menuData_dishes_dishId_addons = (_this_menuData_dishes_dishId = this.menuData.dishes[dishId]) === null || _this_menuData_dishes_dishId === void 0 ? void 0 : _this_menuData_dishes_dishId.addons) !== null && _this_menuData_dishes_dishId_addons !== void 0 ? _this_menuData_dishes_dishId_addons : [];
        };
        this.getCategoryAddons = (dishId)=>{
            var _this_menuData_dishes_dishId;
            var _this_menuData_dishes_dishId_categoryAddons;
            return (_this_menuData_dishes_dishId_categoryAddons = (_this_menuData_dishes_dishId = this.menuData.dishes[dishId]) === null || _this_menuData_dishes_dishId === void 0 ? void 0 : _this_menuData_dishes_dishId.categoryAddons) !== null && _this_menuData_dishes_dishId_categoryAddons !== void 0 ? _this_menuData_dishes_dishId_categoryAddons : [];
        };
        this.dishHasAddons = (dishId)=>this.getDishAddons(dishId).length > 0 || this.getCategoryAddons(dishId).length > 0;
        this.getHalfAndHalfDishAddons = (firstDishId, secondDishId)=>$c26f41c501210151$export$d9b273488cd8ce6f.dedupeByName([
                ...this.getDishAddons(firstDishId),
                ...this.getDishAddons(secondDishId)
            ]);
        this.getHalfAndHalfCategoryAddons = (firstDishId, secondDishId)=>$c26f41c501210151$export$d9b273488cd8ce6f.dedupeByName([
                ...this.getCategoryAddons(firstDishId),
                ...this.getCategoryAddons(secondDishId)
            ]);
        this.halfAndHalfHasAddons = (firstDishId, secondDishId)=>this.getHalfAndHalfDishAddons(firstDishId, secondDishId).length > 0 || this.getHalfAndHalfCategoryAddons(firstDishId, secondDishId).length > 0;
        this.getAddonsPerUnitSafe = (item)=>{
            var _item_addons;
            return ((_item_addons = item.addons) !== null && _item_addons !== void 0 ? _item_addons : []).reduce((sum, addon)=>sum + (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(addon.price) * addon.quantity, 0);
        };
        this.getHalfAndHalfDishes = (item)=>{
            if (!item.halfAndHalf) return null;
            const firstDish = this.menuData.dishes[item.halfAndHalf[0]];
            const secondDish = this.menuData.dishes[item.halfAndHalf[1]];
            if (!firstDish || !secondDish) return null;
            return [
                firstDish,
                secondDish
            ];
        };
        this.getItemName = (item)=>{
            var _this_menuData_dishes_;
            const halves = this.getHalfAndHalfDishes(item);
            if (halves) return `1/2 ${halves[0].name} + 1/2 ${halves[1].name}`;
            var _item_dishId, _this_menuData_dishes__name;
            return (_this_menuData_dishes__name = (_this_menuData_dishes_ = this.menuData.dishes[(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""]) === null || _this_menuData_dishes_ === void 0 ? void 0 : _this_menuData_dishes_.name) !== null && _this_menuData_dishes__name !== void 0 ? _this_menuData_dishes__name : "";
        };
        this.getItemUnitPriceSafe = (item)=>{
            var _this_menuData_dishes_;
            const halves = this.getHalfAndHalfDishes(item);
            if (halves) return Math.round((0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(halves[0].price) / $c26f41c501210151$export$d9b273488cd8ce6f.HALF_DIVISOR) + Math.round((0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(halves[1].price) / $c26f41c501210151$export$d9b273488cd8ce6f.HALF_DIVISOR);
            var _item_dishId, _this_menuData_dishes__price;
            return (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe((_this_menuData_dishes__price = (_this_menuData_dishes_ = this.menuData.dishes[(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""]) === null || _this_menuData_dishes_ === void 0 ? void 0 : _this_menuData_dishes_.price) !== null && _this_menuData_dishes__price !== void 0 ? _this_menuData_dishes__price : 0);
        };
        this.getItemUnitPrice = (item)=>(0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(this.getItemUnitPriceSafe(item));
        this.isItemAvailable = (item)=>{
            if (item.halfAndHalf) {
                const halves = this.getHalfAndHalfDishes(item);
                return !!halves && halves[0].available !== false && halves[1].available !== false;
            }
            var _item_dishId;
            const dish = this.menuData.dishes[(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""];
            return !!dish && dish.available !== false;
        };
        this.itemExists = (item)=>{
            var _item_dishId;
            return item.halfAndHalf ? !!this.getHalfAndHalfDishes(item) : !!this.menuData.dishes[(_item_dishId = item.dishId) !== null && _item_dishId !== void 0 ? _item_dishId : ""];
        };
        this.getItemLineTotalSafe = (item, deliveryMethod)=>{
            if (!this.itemExists(item)) return 0;
            let lineSafe = this.getItemUnitPriceSafe(item) * item.count;
            for (const fee of this.getItemApplicableFees(item, deliveryMethod))lineSafe += this.getItemFeeUnitAmountSafe(item, fee) * item.count;
            return lineSafe + this.getAddonsPerUnitSafe(item) * item.count;
        };
        this.getItemLineTotal = (item, deliveryMethod)=>(0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(this.getItemLineTotalSafe(item, deliveryMethod));
        this.getSubtotal = (basket, deliveryMethod)=>{
            let subtotalSafe = 0;
            for (const item of basket.items)subtotalSafe += this.getItemLineTotalSafe(item, deliveryMethod);
            return (0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toReadable(subtotalSafe);
        };
        this.getStorageKey = ()=>$c26f41c501210151$export$d9b273488cd8ce6f.getStorageKeyFor(this.menuData.storeKey);
        this.load = ()=>{
            try {
                const storageKey = this.getStorageKey();
                const raw = localStorage.getItem(storageKey);
                if (!raw) return {
                    items: []
                };
                const parsed = JSON.parse(raw);
                if (!parsed || !Array.isArray(parsed.items)) return {
                    items: []
                };
                const items = parsed.items.filter((item)=>item && Number(item.count) > 0).map((item)=>this.normalizeStoredItem(item)).filter((item)=>item !== null && this.itemExists(item));
                return {
                    items: items
                };
            } catch (error) {
                return {
                    items: []
                };
            }
        };
        this.normalizeStoredAddons = (rawAddons)=>{
            if (!Array.isArray(rawAddons)) return [];
            return rawAddons.filter((addon)=>addon && typeof addon.name === "string" && Number(addon.quantity) > 0).map((addon)=>({
                    name: addon.name,
                    price: Number(addon.price) || 0,
                    quantity: Math.max(1, Math.floor(Number(addon.quantity)))
                }));
        };
        this.normalizeStoredItem = (item)=>{
            const count = Math.floor(Number(item.count));
            const addons = this.normalizeStoredAddons(item.addons);
            if (Array.isArray(item.halfAndHalf) && item.halfAndHalf.length === 2 && typeof item.halfAndHalf[0] === "string" && typeof item.halfAndHalf[1] === "string") return {
                halfAndHalf: [
                    item.halfAndHalf[0],
                    item.halfAndHalf[1]
                ],
                count: count,
                ...addons.length > 0 && {
                    addons: addons
                }
            };
            if (typeof item.dishId === "string") return {
                dishId: item.dishId,
                count: count,
                ...addons.length > 0 && {
                    addons: addons
                }
            };
            return null;
        };
        this.save = (basket)=>{
            const storageKey = this.getStorageKey();
            localStorage.setItem(storageKey, JSON.stringify(basket));
        };
        this.menuData = menuData;
    }
}
$c26f41c501210151$export$d9b273488cd8ce6f.PERCENT_DIVISOR = 100;
$c26f41c501210151$export$d9b273488cd8ce6f.HALF_DIVISOR = 2;
$c26f41c501210151$export$d9b273488cd8ce6f.HALF_AND_HALF_KEY_PREFIX = "hh:";
$c26f41c501210151$export$d9b273488cd8ce6f.dedupeByName = (entries)=>{
    const seen = new Set();
    return entries.filter((entry)=>{
        if (seen.has(entry.name)) return false;
        seen.add(entry.name);
        return true;
    });
};
$c26f41c501210151$export$d9b273488cd8ce6f.getStorageKeyFor = (storeKey)=>`restanaut-basket-${storeKey}`;


class $c1f3774614d137bd$export$b63289fbda65eed1 {
    constructor(){
        this.translations = {};
        this.fetchTranslations = async (id)=>{
            try {
                const response = await fetch(`/api/v1/${$c1f3774614d137bd$export$b63289fbda65eed1.getLocationCode()}/translation/${id}`);
                if (!response.ok) return;
                this.translations = await response.json();
            } catch  {
            // Ignore network errors; caller may retry later
            }
        };
        this.isEmpty = ()=>Object.keys(this.translations).length === 0;
        this.t = (key)=>{
            var _this_translations_key;
            return (_this_translations_key = this.translations[key]) !== null && _this_translations_key !== void 0 ? _this_translations_key : key;
        };
    }
}
$c1f3774614d137bd$export$b63289fbda65eed1.DEFAULT_LOCATION = "en";
$c1f3774614d137bd$export$b63289fbda65eed1.getLocationCode = ()=>window.location.pathname.split("/")[1] || $c1f3774614d137bd$export$b63289fbda65eed1.DEFAULT_LOCATION;


class $c681d84e804ccd9c$export$42a146b10ea741e8 {
    constructor(){
        this.categoryCounter = 0;
        this.foodCounter = 0;
        this.sizeCounter = 0;
        this.feeCounter = 0;
        this.currencyCode = "";
        this.languageCode = "";
        this.restaurantKey = "";
        this.selectedFiles = [];
        this.currentMode = $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS;
        this.wasMenuCreated = false;
        this.isCreatingMenu = false;
        this.pendingDeleteEl = null;
        this.deleteModal = null;
        this.feeModal = null;
        this.pendingFeeParentEl = null;
        this.pendingFeeEditEl = null;
        this.addonsModal = null;
        this.pendingAddonsEl = null;
        this.createBtnOriginalHTML = "";
        this.ocrCountdownTimer = null;
        this.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
        this.t = (key)=>this.translation.t(key);
        this.getPageId = ()=>"menu-editor-panel";
        this.execute = async (pjax)=>{
            this.pjax = pjax;
            await this.translation.fetchTranslations($c681d84e804ccd9c$export$42a146b10ea741e8.TRANSLATION_ID);
            const manualPanel = document.querySelector('[data-menu-panel="manual"]');
            var _manualPanel_dataset_currencyCode;
            this.currencyCode = (_manualPanel_dataset_currencyCode = manualPanel === null || manualPanel === void 0 ? void 0 : manualPanel.dataset.currencyCode) !== null && _manualPanel_dataset_currencyCode !== void 0 ? _manualPanel_dataset_currencyCode : "";
            var _manualPanel_dataset_languageCode;
            this.languageCode = (_manualPanel_dataset_languageCode = manualPanel === null || manualPanel === void 0 ? void 0 : manualPanel.dataset.languageCode) !== null && _manualPanel_dataset_languageCode !== void 0 ? _manualPanel_dataset_languageCode : "";
            var _manualPanel_dataset_restaurantKey;
            this.restaurantKey = (_manualPanel_dataset_restaurantKey = manualPanel === null || manualPanel === void 0 ? void 0 : manualPanel.dataset.restaurantKey) !== null && _manualPanel_dataset_restaurantKey !== void 0 ? _manualPanel_dataset_restaurantKey : "";
            this.wasMenuCreated = (manualPanel === null || manualPanel === void 0 ? void 0 : manualPanel.dataset.wasMenuCreated) === "true";
            this.setupModeToggle();
            this.setupFormSubmit();
            this.setupDropzone();
            this.setupCreateBtn();
            this.setupDeleteModal();
            this.setupFeeModal();
            this.setupAddonsModal();
            this.setupAddCategory();
            this.preRenderMenu();
            this.initOcrState();
            this.setupRichText("introduction");
            this.setupRichText("endnotes");
            (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).MenuGenerationStatus, this.onMenuGenerationStatus);
        };
        this.updateHeaderText = ()=>{
            const mode = this.currentMode;
            document.querySelectorAll("[data-menu-title]").forEach((el)=>{
                el.classList.toggle("d-none", el.dataset.menuTitle !== mode);
            });
            document.querySelectorAll("[data-menu-subtitle]").forEach((el)=>{
                el.classList.toggle("d-none", el.dataset.menuSubtitle !== mode);
            });
            document.querySelectorAll("[data-menu-toggle-label]").forEach((el)=>{
                el.classList.toggle("d-none", el.dataset.menuToggleLabel !== mode);
            });
        };
        this.setupModeToggle = ()=>{
            const toggleBtn = document.querySelector("[data-menu-mode-toggle]");
            if (!toggleBtn) return;
            toggleBtn.addEventListener("click", ()=>{
                this.currentMode = this.currentMode === $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS ? $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_MANUAL : $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS;
                document.querySelectorAll("[data-menu-panel]").forEach((panel)=>{
                    panel.style.display = panel.dataset.menuPanel === this.currentMode ? "" : "none";
                });
                this.updateHeaderText();
            });
        };
        this.onFilesSelected = (files, createBtn, content, filesView, filesLabel, dropzone)=>{
            if (!files || files.length === 0) return;
            const imageFiles = Array.from(files).filter((file)=>file.type.startsWith("image/"));
            if (imageFiles.length === 0) return;
            this.selectedFiles = imageFiles;
            createBtn.disabled = false;
            content === null || content === void 0 ? void 0 : content.classList.add("d-none");
            filesView === null || filesView === void 0 ? void 0 : filesView.classList.remove("d-none");
            if (filesLabel) filesLabel.textContent = `${imageFiles.length} ${imageFiles.length > 1 ? this.t("files selected") : this.t("file selected")}`;
            dropzone.classList.add($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HAS_FILES);
        };
        this.setDropzoneLoading = (loading)=>{
            const dropzone = document.querySelector("[data-menu-dropzone]");
            if (!dropzone) return;
            const input = dropzone.querySelector(".menu-dropzone-input");
            const content = dropzone.querySelector(".menu-dropzone-content");
            const filesView = dropzone.querySelector("[data-menu-dropzone-files]");
            const loadingEl = dropzone.querySelector("[data-menu-dropzone-loading]");
            if (loading) {
                if (input) input.disabled = true;
                content === null || content === void 0 ? void 0 : content.classList.add("d-none");
                filesView === null || filesView === void 0 ? void 0 : filesView.classList.add("d-none");
                loadingEl === null || loadingEl === void 0 ? void 0 : loadingEl.classList.remove("d-none");
            } else {
                if (input) input.disabled = false;
                loadingEl === null || loadingEl === void 0 ? void 0 : loadingEl.classList.add("d-none");
                const hasFiles = this.selectedFiles.length > 0;
                content === null || content === void 0 ? void 0 : content.classList.toggle("d-none", hasFiles);
                filesView === null || filesView === void 0 ? void 0 : filesView.classList.toggle("d-none", !hasFiles);
                if (!hasFiles) dropzone.classList.remove($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HAS_FILES);
            }
        };
        this.setupDropzone = ()=>{
            const dropzone = document.querySelector("[data-menu-dropzone]");
            const input = dropzone === null || dropzone === void 0 ? void 0 : dropzone.querySelector(".menu-dropzone-input");
            const createBtn = document.querySelector("[data-menu-create-btn]");
            const content = dropzone === null || dropzone === void 0 ? void 0 : dropzone.querySelector(".menu-dropzone-content");
            const filesView = dropzone === null || dropzone === void 0 ? void 0 : dropzone.querySelector("[data-menu-dropzone-files]");
            const filesLabel = dropzone === null || dropzone === void 0 ? void 0 : dropzone.querySelector("[data-menu-files-label]");
            if (!dropzone || !input || !createBtn) return;
            input.addEventListener("change", ()=>this.onFilesSelected(input.files, createBtn, content, filesView, filesLabel, dropzone));
            dropzone.addEventListener("dragover", (event)=>{
                if (this.isCreatingMenu) return;
                event.preventDefault();
                dropzone.classList.add($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_DRAG_OVER);
            });
            dropzone.addEventListener("dragleave", ()=>dropzone.classList.remove($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_DRAG_OVER));
            dropzone.addEventListener("drop", (event)=>{
                var _event_dataTransfer;
                event.preventDefault();
                dropzone.classList.remove($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_DRAG_OVER);
                if (this.isCreatingMenu) return;
                var _event_dataTransfer_files;
                this.onFilesSelected((_event_dataTransfer_files = (_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.files) !== null && _event_dataTransfer_files !== void 0 ? _event_dataTransfer_files : null, createBtn, content, filesView, filesLabel, dropzone);
            });
        };
        this.setupCreateBtn = ()=>{
            const createBtn = document.querySelector("[data-menu-create-btn]");
            const errorEl = document.querySelector("[data-menu-create-error]");
            if (!createBtn) return;
            this.createBtnOriginalHTML = createBtn.innerHTML;
            createBtn.addEventListener("click", async ()=>{
                var _document_querySelector;
                if (this.isCreatingMenu || this.selectedFiles.length === 0) return;
                this.isCreatingMenu = true;
                this.setDropzoneLoading(true);
                const toggleBtn = document.querySelector("[data-menu-mode-toggle]");
                const originalInnerHTML = createBtn.innerHTML;
                createBtn.disabled = true;
                if (toggleBtn) toggleBtn.disabled = true;
                createBtn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>${this.t("Processing...")}`;
                errorEl === null || errorEl === void 0 ? void 0 : errorEl.classList.add("d-none");
                const formData = new FormData();
                for (const file of this.selectedFiles)formData.append("files", file);
                const csrfToken = (_document_querySelector = document.querySelector('input[name="_csrf"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value;
                if (csrfToken) formData.append("_csrf", csrfToken);
                try {
                    const response = await fetch(`/api/v1/menu/generate/${this.restaurantKey}`, {
                        method: "POST",
                        body: formData
                    });
                    if (response.ok) return;
                    const data = await response.json().catch(()=>({}));
                    if (errorEl) {
                        var _data_error;
                        errorEl.textContent = (_data_error = data.error) !== null && _data_error !== void 0 ? _data_error : this.t("Failed to generate menu");
                        errorEl.classList.remove("d-none");
                    }
                } catch  {
                    if (errorEl) {
                        errorEl.textContent = this.t("Failed to generate menu. Please try again.");
                        errorEl.classList.remove("d-none");
                    }
                }
                this.isCreatingMenu = false;
                this.setDropzoneLoading(false);
                createBtn.disabled = false;
                createBtn.innerHTML = originalInnerHTML;
                if (toggleBtn) toggleBtn.disabled = false;
            });
        };
        this.setupRichText = (noteKey)=>{
            const noteBody = document.querySelector(`[data-menu-note="${noteKey}"]`);
            const richText = noteBody === null || noteBody === void 0 ? void 0 : noteBody.querySelector("[data-menu-field]");
            if (!richText) return;
            new (0, (/*@__PURE__*/$parcel$interopDefault($9b19a0a83ad61f86$exports)))(richText, {
                ...(0, $91b592b47f6f2020$export$39bcc3f08a9b5fa4).MEDIUM_EDITOR_OPTIONS,
                placeholder: {
                    text: this.t("Type your text")
                }
            });
        };
        this.setupDeleteModal = ()=>{
            var _document_getElementById;
            const modalEl = document.getElementById("menu-delete-modal");
            if (!modalEl) return;
            this.deleteModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            (_document_getElementById = document.getElementById("menu-delete-confirm-btn")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener("click", ()=>{
                var _this_pendingDeleteEl, _this_deleteModal;
                (_this_pendingDeleteEl = this.pendingDeleteEl) === null || _this_pendingDeleteEl === void 0 ? void 0 : _this_pendingDeleteEl.remove();
                this.pendingDeleteEl = null;
                (_this_deleteModal = this.deleteModal) === null || _this_deleteModal === void 0 ? void 0 : _this_deleteModal.hide();
            });
        };
        this.confirmDelete = (targetEl)=>{
            var _this_deleteModal;
            this.pendingDeleteEl = targetEl;
            (_this_deleteModal = this.deleteModal) === null || _this_deleteModal === void 0 ? void 0 : _this_deleteModal.show();
        };
        this.setupAddCategory = ()=>{
            const addCategoryBtn = document.querySelector('[data-menu-action="add-category"]');
            addCategoryBtn === null || addCategoryBtn === void 0 ? void 0 : addCategoryBtn.addEventListener("click", ()=>this.addCategory());
        };
        this.addCategory = (initialData)=>{
            const container = document.getElementById("menu-categories");
            if (!container) return;
            const categoryId = ++this.categoryCounter;
            const categoryEl = document.createElement("div");
            categoryEl.className = "menu-category";
            categoryEl.dataset.categoryId = String(categoryId);
            categoryEl.innerHTML = this.buildCategoryHtml(categoryId);
            container.appendChild(categoryEl);
            this.setupCategory(categoryEl);
            if (initialData) {
                const titleEl = categoryEl.querySelector(".menu-category-title");
                if (titleEl) titleEl.textContent = initialData.name;
                if (initialData.description) {
                    const descriptionEl = categoryEl.querySelector(".menu-category-description");
                    const addDescriptionBtn = categoryEl.querySelector('[data-menu-action="add-category-description"]');
                    descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.classList.remove("d-none");
                    if (descriptionEl) descriptionEl.textContent = initialData.description;
                    addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.classList.add("d-none");
                }
                const feesContainer = categoryEl.querySelector("[data-fees-container]");
                var _initialData_fees, _fee_deliveryMethods;
                for (const fee of (_initialData_fees = initialData.fees) !== null && _initialData_fees !== void 0 ? _initialData_fees : [])if (feesContainer) this.addFeePill(feesContainer, fee.name, fee.type, fee.price, fee.percentage, (_fee_deliveryMethods = fee.deliveryMethods) !== null && _fee_deliveryMethods !== void 0 ? _fee_deliveryMethods : [], []);
                var _initialData_dishes;
                for (const dish of (_initialData_dishes = initialData.dishes) !== null && _initialData_dishes !== void 0 ? _initialData_dishes : [])this.addFoodItem(categoryEl, String(categoryId), dish);
                if (initialData.halfAndHalf === true) {
                    const toggleBtn = categoryEl.querySelector('[data-menu-action="toggle-half-and-half"]');
                    this.markHalfAndHalf(categoryEl, categoryEl.querySelector(".menu-category-fees"), toggleBtn);
                }
                if (Array.isArray(initialData.addons) && initialData.addons.length > 0) this.applyAddonsToElement(categoryEl, initialData.addons);
                if (initialData.enabled === false) {
                    const markBtn = categoryEl.querySelector('[data-menu-action="mark-category-unavailable"]');
                    this.markUnavailable(categoryEl, categoryEl.querySelector(".menu-category-fees"), markBtn);
                }
            } else {
                const title = categoryEl.querySelector(".menu-category-title");
                title === null || title === void 0 ? void 0 : title.focus();
            }
        };
        this.buildCategoryHtml = (categoryId)=>`
    <div class="menu-category-row">
      <div class="menu-category-title" contenteditable="true" data-placeholder="${this.t("Category Title")}"></div>
      <div class="dropdown">
        <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" aria-expanded="false">+</button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><button class="dropdown-item" data-menu-action="add-category-description">${this.t("Description")}</button></li>
          <li><button class="dropdown-item" data-menu-action="add-category-fee">${this.t("Fee")}</button></li>
          <li><button class="dropdown-item" data-menu-action="edit-addons">${this.t("Add-ons")}</button></li>
          <li><button class="dropdown-item" data-menu-action="toggle-half-and-half">${this.t("Allow ordering half and half")}</button></li>
          <li><button class="dropdown-item" data-menu-action="mark-category-unavailable">${this.t("Mark unavailable")}</button></li>
          <li><hr class="dropdown-divider" /></li>
          <li><button class="dropdown-item text-danger" data-menu-action="delete-category">${this.t("Delete")}</button></li>
        </ul>
      </div>
    </div>
    <div class="menu-category-description d-none" contenteditable="true" data-placeholder="${this.t("Add a description\u2026")}"></div>
    <div class="menu-category-fees" data-fees-container></div>
    <div class="menu-food-items" data-food-container="${categoryId}"></div>
    <div class="btn btn-sm btn-outline-secondary" data-menu-action="add-food">${this.t("+ Add Item")}</div>
  `;
        this.setupCategory = (categoryEl)=>{
            var _categoryEl_querySelector, _categoryEl_querySelector1, _categoryEl_querySelector2;
            const categoryId = categoryEl.dataset.categoryId;
            const title = categoryEl.querySelector(".menu-category-title");
            const description = categoryEl.querySelector(".menu-category-description");
            const addFoodBtn = categoryEl.querySelector('[data-menu-action="add-food"]');
            title.addEventListener("keydown", (event)=>{
                if (event.key === "Enter") {
                    event.preventDefault();
                    title.blur();
                }
            });
            const addDescriptionBtn = categoryEl.querySelector('[data-menu-action="add-category-description"]');
            if (!description.classList.contains("d-none")) addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.classList.add("d-none");
            addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.addEventListener("click", ()=>{
                description.classList.remove("d-none");
                description.focus();
                addDescriptionBtn.classList.add("d-none");
            });
            (_categoryEl_querySelector = categoryEl.querySelector('[data-menu-action="delete-category"]')) === null || _categoryEl_querySelector === void 0 ? void 0 : _categoryEl_querySelector.addEventListener("click", ()=>{
                this.confirmDelete(categoryEl);
            });
            (_categoryEl_querySelector1 = categoryEl.querySelector('[data-menu-action="add-category-fee"]')) === null || _categoryEl_querySelector1 === void 0 ? void 0 : _categoryEl_querySelector1.addEventListener("click", ()=>{
                this.openAddFeeModal(categoryEl);
            });
            const markCategoryUnavailableBtn = categoryEl.querySelector('[data-menu-action="mark-category-unavailable"]');
            markCategoryUnavailableBtn === null || markCategoryUnavailableBtn === void 0 ? void 0 : markCategoryUnavailableBtn.addEventListener("click", ()=>{
                this.markUnavailable(categoryEl, categoryEl.querySelector(".menu-category-fees"), markCategoryUnavailableBtn);
            });
            const toggleHalfAndHalfBtn = categoryEl.querySelector('[data-menu-action="toggle-half-and-half"]');
            toggleHalfAndHalfBtn === null || toggleHalfAndHalfBtn === void 0 ? void 0 : toggleHalfAndHalfBtn.addEventListener("click", ()=>{
                this.markHalfAndHalf(categoryEl, categoryEl.querySelector(".menu-category-fees"), toggleHalfAndHalfBtn);
            });
            (_categoryEl_querySelector2 = categoryEl.querySelector('[data-menu-action="edit-addons"]')) === null || _categoryEl_querySelector2 === void 0 ? void 0 : _categoryEl_querySelector2.addEventListener("click", ()=>{
                this.openAddonsModal(categoryEl);
            });
            addFoodBtn.addEventListener("click", ()=>this.addFoodItem(categoryEl, categoryId));
        };
        this.addFoodItem = (categoryEl, categoryId, initialData)=>{
            const container = categoryEl.querySelector(`[data-food-container="${categoryId}"]`);
            if (!container) return;
            const foodId = ++this.foodCounter;
            const foodItemEl = document.createElement("div");
            foodItemEl.className = "menu-food-item";
            foodItemEl.dataset.foodId = String(foodId);
            foodItemEl.innerHTML = this.buildFoodHtml(foodId);
            container.appendChild(foodItemEl);
            this.setupFoodItem(foodItemEl);
            if (initialData) {
                var _initialData_sizes;
                const titleEl = foodItemEl.querySelector(".menu-food-title");
                if (titleEl) titleEl.textContent = initialData.name;
                if (initialData.description) {
                    const descriptionEl = foodItemEl.querySelector(".menu-food-description");
                    const addDescriptionBtn = foodItemEl.querySelector('[data-menu-action="add-food-description"]');
                    descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.classList.remove("d-none");
                    if (descriptionEl) descriptionEl.textContent = initialData.description;
                    addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.classList.add("d-none");
                }
                const isSinglePrice = ((_initialData_sizes = initialData.sizes) === null || _initialData_sizes === void 0 ? void 0 : _initialData_sizes.length) === 1 && initialData.sizes[0].name === "";
                var _initialData_sizes1;
                if (isSinglePrice) {
                    const price = initialData.sizes[0].price;
                    const priceDisplay = foodItemEl.querySelector(".menu-price-display");
                    const priceInput = foodItemEl.querySelector(".menu-price-input");
                    if (priceDisplay) priceDisplay.textContent = price.toFixed($c681d84e804ccd9c$export$42a146b10ea741e8.PRICE_DECIMAL_PLACES);
                    if (priceInput) priceInput.value = String(price);
                } else for (const size of (_initialData_sizes1 = initialData.sizes) !== null && _initialData_sizes1 !== void 0 ? _initialData_sizes1 : [])this.addSize(foodItemEl, size);
                const feesContainer = foodItemEl.querySelector("[data-fees-container]");
                var _initialData_fees, _fee_deliveryMethods, _fee_sizes;
                for (const fee of (_initialData_fees = initialData.fees) !== null && _initialData_fees !== void 0 ? _initialData_fees : [])if (feesContainer) this.addFeePill(feesContainer, fee.name, fee.type, fee.price, fee.percentage, (_fee_deliveryMethods = fee.deliveryMethods) !== null && _fee_deliveryMethods !== void 0 ? _fee_deliveryMethods : [], (_fee_sizes = fee.sizes) !== null && _fee_sizes !== void 0 ? _fee_sizes : []);
                if (initialData.enabled === false) {
                    const markBtn = foodItemEl.querySelector('[data-menu-action="mark-food-unavailable"]');
                    this.markUnavailable(foodItemEl, foodItemEl.querySelector(".menu-food-fees"), markBtn);
                }
                if (Array.isArray(initialData.addons) && initialData.addons.length > 0) this.applyAddonsToElement(foodItemEl, initialData.addons);
            } else {
                const title = foodItemEl.querySelector(".menu-food-title");
                title === null || title === void 0 ? void 0 : title.focus();
            }
        };
        this.buildFoodHtml = (foodId)=>`
    <div class="menu-food-row">
      <div class="menu-food-left">
        <div class="menu-food-title" contenteditable="true" data-placeholder="${this.t("Item Title")}"></div>
        <div class="menu-food-description d-none" contenteditable="true" data-placeholder="${this.t("Add a description\u2026")}"></div>
        <div class="menu-food-fees" data-fees-container></div>
      </div>
      <div class="menu-food-center">
        <span class="menu-price-display">0.00</span>
        <input type="number" class="menu-price-input form-control form-control-sm d-none" min="0" step="0.01" value="0" />
        <div class="menu-food-sizes d-none">
          <div class="menu-food-sizes-scroll"></div>
        </div>
      </div>
      <div class="dropdown">
        <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" aria-expanded="false">+</button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><button class="dropdown-item" data-menu-action="add-food-size">${this.t("Size")}</button></li>
          <li><button class="dropdown-item" data-menu-action="add-food-description">${this.t("Description")}</button></li>
          <li><button class="dropdown-item" data-menu-action="add-food-fee">${this.t("Fee")}</button></li>
          <li><button class="dropdown-item" data-menu-action="edit-addons">${this.t("Add-ons")}</button></li>
          <li><button class="dropdown-item" data-menu-action="mark-food-unavailable">${this.t("Mark unavailable")}</button></li>
          <li><hr class="dropdown-divider" /></li>
          <li><button class="dropdown-item text-danger" data-menu-action="delete-food">${this.t("Delete")}</button></li>
        </ul>
      </div>
    </div>
  `;
        this.setupFoodItem = (foodItemEl)=>{
            var _foodItemEl_querySelector, _foodItemEl_querySelector1, _foodItemEl_querySelector2, _foodItemEl_querySelector3;
            const title = foodItemEl.querySelector(".menu-food-title");
            const priceDisplay = foodItemEl.querySelector(".menu-price-display");
            const priceInput = foodItemEl.querySelector(".menu-price-input");
            const description = foodItemEl.querySelector(".menu-food-description");
            title.addEventListener("keydown", (event)=>{
                if (event.key === "Enter") {
                    event.preventDefault();
                    title.blur();
                }
            });
            priceDisplay.addEventListener("click", ()=>{
                priceDisplay.classList.add("d-none");
                priceInput.classList.remove("d-none");
                priceInput.focus();
                priceInput.select();
            });
            priceInput.addEventListener("blur", ()=>{
                priceDisplay.textContent = parseFloat(priceInput.value || $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE).toFixed($c681d84e804ccd9c$export$42a146b10ea741e8.PRICE_DECIMAL_PLACES);
                priceInput.classList.add("d-none");
                priceDisplay.classList.remove("d-none");
            });
            priceInput.addEventListener("keydown", (event)=>{
                if (event.key === "Enter") priceInput.blur();
            });
            const addDescriptionBtn = foodItemEl.querySelector('[data-menu-action="add-food-description"]');
            if (!description.classList.contains("d-none")) addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.classList.add("d-none");
            addDescriptionBtn === null || addDescriptionBtn === void 0 ? void 0 : addDescriptionBtn.addEventListener("click", ()=>{
                description.classList.remove("d-none");
                description.focus();
                addDescriptionBtn.classList.add("d-none");
            });
            (_foodItemEl_querySelector = foodItemEl.querySelector('[data-menu-action="add-food-size"]')) === null || _foodItemEl_querySelector === void 0 ? void 0 : _foodItemEl_querySelector.addEventListener("click", ()=>{
                const scroll = foodItemEl.querySelector(".menu-food-sizes-scroll");
                const isFirstSize = scroll.querySelectorAll(".menu-food-size").length === 0;
                this.addSize(foodItemEl);
                if (isFirstSize) {
                    const firstSizeEl = scroll.querySelector(".menu-food-size");
                    const firstSizePriceDisplay = firstSizeEl === null || firstSizeEl === void 0 ? void 0 : firstSizeEl.querySelector(".menu-food-size-price-display");
                    const firstSizePriceInput = firstSizeEl === null || firstSizeEl === void 0 ? void 0 : firstSizeEl.querySelector(".menu-food-size-price-input");
                    if (firstSizePriceDisplay) firstSizePriceDisplay.textContent = priceDisplay.textContent;
                    if (firstSizePriceInput) firstSizePriceInput.value = priceInput.value;
                    this.addSize(foodItemEl);
                }
            });
            (_foodItemEl_querySelector1 = foodItemEl.querySelector('[data-menu-action="add-food-fee"]')) === null || _foodItemEl_querySelector1 === void 0 ? void 0 : _foodItemEl_querySelector1.addEventListener("click", ()=>{
                this.openAddFeeModal(foodItemEl);
            });
            (_foodItemEl_querySelector2 = foodItemEl.querySelector('[data-menu-action="edit-addons"]')) === null || _foodItemEl_querySelector2 === void 0 ? void 0 : _foodItemEl_querySelector2.addEventListener("click", ()=>{
                this.openAddonsModal(foodItemEl);
            });
            const markFoodUnavailableBtn = foodItemEl.querySelector('[data-menu-action="mark-food-unavailable"]');
            markFoodUnavailableBtn === null || markFoodUnavailableBtn === void 0 ? void 0 : markFoodUnavailableBtn.addEventListener("click", ()=>{
                this.markUnavailable(foodItemEl, foodItemEl.querySelector(".menu-food-fees"), markFoodUnavailableBtn);
            });
            (_foodItemEl_querySelector3 = foodItemEl.querySelector('[data-menu-action="delete-food"]')) === null || _foodItemEl_querySelector3 === void 0 ? void 0 : _foodItemEl_querySelector3.addEventListener("click", ()=>{
                this.confirmDelete(foodItemEl);
            });
        };
        this.markUnavailable = (rootEl, feesContainer, markActionEl)=>{
            var _pillEl_querySelector;
            if (!feesContainer || rootEl.classList.contains($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE)) return;
            rootEl.classList.add($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE);
            markActionEl === null || markActionEl === void 0 ? void 0 : markActionEl.classList.add("d-none");
            const pillEl = document.createElement("span");
            pillEl.className = "menu-unavailable-pill";
            pillEl.dataset.unavailablePill = "true";
            pillEl.innerHTML = `<span>${this.t("Unavailable")}</span><i class="bi bi-x-lg"></i>`;
            feesContainer.insertBefore(pillEl, feesContainer.firstChild);
            (_pillEl_querySelector = pillEl.querySelector("i")) === null || _pillEl_querySelector === void 0 ? void 0 : _pillEl_querySelector.addEventListener("click", ()=>{
                rootEl.classList.remove($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE);
                markActionEl === null || markActionEl === void 0 ? void 0 : markActionEl.classList.remove("d-none");
                pillEl.remove();
            });
        };
        this.markHalfAndHalf = (categoryEl, feesContainer, toggleActionEl)=>{
            var _pillEl_querySelector;
            if (!feesContainer || categoryEl.classList.contains($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HALF_AND_HALF)) return;
            categoryEl.classList.add($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HALF_AND_HALF);
            toggleActionEl === null || toggleActionEl === void 0 ? void 0 : toggleActionEl.classList.add("d-none");
            const pillEl = document.createElement("span");
            pillEl.className = "menu-halfhalf-pill";
            pillEl.dataset.halfhalfPill = "true";
            pillEl.innerHTML = `<span>${this.t("Can order half and half")}</span><i class="bi bi-x-lg"></i>`;
            feesContainer.insertBefore(pillEl, feesContainer.firstChild);
            (_pillEl_querySelector = pillEl.querySelector("i")) === null || _pillEl_querySelector === void 0 ? void 0 : _pillEl_querySelector.addEventListener("click", ()=>{
                categoryEl.classList.remove($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HALF_AND_HALF);
                toggleActionEl === null || toggleActionEl === void 0 ? void 0 : toggleActionEl.classList.remove("d-none");
                pillEl.remove();
            });
        };
        this.switchToSizeMode = (foodItemEl)=>{
            var _foodItemEl_querySelector, _foodItemEl_querySelector1, _foodItemEl_querySelector2;
            (_foodItemEl_querySelector = foodItemEl.querySelector(".menu-price-display")) === null || _foodItemEl_querySelector === void 0 ? void 0 : _foodItemEl_querySelector.classList.add("d-none");
            (_foodItemEl_querySelector1 = foodItemEl.querySelector(".menu-price-input")) === null || _foodItemEl_querySelector1 === void 0 ? void 0 : _foodItemEl_querySelector1.classList.add("d-none");
            (_foodItemEl_querySelector2 = foodItemEl.querySelector(".menu-food-sizes")) === null || _foodItemEl_querySelector2 === void 0 ? void 0 : _foodItemEl_querySelector2.classList.remove("d-none");
        };
        this.revertToSinglePrice = (foodItemEl)=>{
            var _foodItemEl_querySelector, _foodItemEl_querySelector1;
            (_foodItemEl_querySelector = foodItemEl.querySelector(".menu-food-sizes")) === null || _foodItemEl_querySelector === void 0 ? void 0 : _foodItemEl_querySelector.classList.add("d-none");
            (_foodItemEl_querySelector1 = foodItemEl.querySelector(".menu-price-display")) === null || _foodItemEl_querySelector1 === void 0 ? void 0 : _foodItemEl_querySelector1.classList.remove("d-none");
        };
        this.addSize = (foodItemEl, initialData)=>{
            var _sizeEl_querySelector;
            const scroll = foodItemEl.querySelector(".menu-food-sizes-scroll");
            const sizeId = ++this.sizeCounter;
            const sizeEl = document.createElement("div");
            sizeEl.className = "menu-food-size";
            sizeEl.dataset.sizeId = String(sizeId);
            sizeEl.innerHTML = this.buildSizeHtml();
            scroll.appendChild(sizeEl);
            if (scroll.querySelectorAll(".menu-food-size").length === 1) this.switchToSizeMode(foodItemEl);
            this.setupSize(sizeEl, foodItemEl);
            if (initialData) {
                const titleEl = sizeEl.querySelector(".menu-food-size-title");
                const priceDisplay = sizeEl.querySelector(".menu-food-size-price-display");
                const priceInput = sizeEl.querySelector(".menu-food-size-price-input");
                if (titleEl) titleEl.textContent = initialData.name;
                if (priceDisplay) priceDisplay.textContent = initialData.price.toFixed($c681d84e804ccd9c$export$42a146b10ea741e8.PRICE_DECIMAL_PLACES);
                if (priceInput) priceInput.value = String(initialData.price);
            } else (_sizeEl_querySelector = sizeEl.querySelector(".menu-food-size-title")) === null || _sizeEl_querySelector === void 0 ? void 0 : _sizeEl_querySelector.focus();
        };
        this.buildSizeHtml = ()=>`
    <div class="menu-food-size-header">
      <div class="menu-food-size-title" contenteditable="true" data-placeholder="${this.t("Size")}"></div>
      <i class="menu-food-size-remove bi bi-trash text-danger"></i>
    </div>
    <div class="menu-food-size-price-display">0</div>
    <input type="number" class="menu-food-size-price-input form-control form-control-sm d-none" min="0" step="0.01" value="0" />
  `;
        this.setupSize = (sizeEl, foodItemEl)=>{
            const title = sizeEl.querySelector(".menu-food-size-title");
            const priceDisplay = sizeEl.querySelector(".menu-food-size-price-display");
            const priceInput = sizeEl.querySelector(".menu-food-size-price-input");
            const removeBtn = sizeEl.querySelector(".menu-food-size-remove");
            title.addEventListener("keydown", (event)=>{
                if (event.key === "Enter") {
                    event.preventDefault();
                    title.blur();
                }
            });
            title.addEventListener("input", ()=>{
                var _title_textContent;
                if ((_title_textContent = title.textContent) === null || _title_textContent === void 0 ? void 0 : _title_textContent.trim()) title.classList.remove("is-invalid");
            });
            priceDisplay.addEventListener("click", ()=>{
                priceDisplay.classList.add("d-none");
                priceInput.classList.remove("d-none");
                priceInput.focus();
                priceInput.select();
            });
            priceInput.addEventListener("blur", ()=>{
                priceDisplay.textContent = parseFloat(priceInput.value || $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE).toFixed($c681d84e804ccd9c$export$42a146b10ea741e8.PRICE_DECIMAL_PLACES);
                priceInput.classList.add("d-none");
                priceDisplay.classList.remove("d-none");
            });
            priceInput.addEventListener("keydown", (event)=>{
                if (event.key === "Enter") priceInput.blur();
            });
            removeBtn.addEventListener("click", ()=>{
                const scroll = foodItemEl.querySelector(".menu-food-sizes-scroll");
                sizeEl.remove();
                const remainingSizes = scroll.querySelectorAll(".menu-food-size");
                if (remainingSizes.length <= 1) {
                    if (remainingSizes.length === 1) {
                        const lastPriceDisplay = remainingSizes[0].querySelector(".menu-food-size-price-display");
                        const lastPriceInput = remainingSizes[0].querySelector(".menu-food-size-price-input");
                        const singlePriceDisplay = foodItemEl.querySelector(".menu-price-display");
                        const singlePriceInput = foodItemEl.querySelector(".menu-price-input");
                        if (singlePriceDisplay && lastPriceDisplay) singlePriceDisplay.textContent = lastPriceDisplay.textContent;
                        if (singlePriceInput && lastPriceInput) singlePriceInput.value = lastPriceInput.value;
                        remainingSizes[0].remove();
                    }
                    this.revertToSinglePrice(foodItemEl);
                }
            });
        };
        this.setupFormSubmit = ()=>{
            const form = document.getElementById("menu-editor-form");
            const menuDataInput = document.getElementById("menu-data-input");
            if (!form || !menuDataInput) return;
            form.addEventListener("submit", (event)=>{
                if (!this.validateSizeLabels()) {
                    event.preventDefault();
                    return;
                }
                menuDataInput.value = JSON.stringify(this.serializeMenu());
                const submitButtons = form.querySelectorAll("button[type=submit]");
                for (const button of submitButtons){
                    button.type = "button";
                    button.disabled = true;
                }
            });
        };
        this.validateSizeLabels = ()=>{
            const sizeTitles = document.querySelectorAll(".menu-food-size .menu-food-size-title");
            let firstInvalid = null;
            for (const title of sizeTitles){
                var _title_textContent;
                var _title_textContent_trim;
                const isEmpty = ((_title_textContent_trim = (_title_textContent = title.textContent) === null || _title_textContent === void 0 ? void 0 : _title_textContent.trim()) !== null && _title_textContent_trim !== void 0 ? _title_textContent_trim : "") === "";
                title.classList.toggle("is-invalid", isEmpty);
                if (isEmpty && !firstInvalid) firstInvalid = title;
            }
            if (firstInvalid) {
                firstInvalid.scrollIntoView({
                    block: "center",
                    behavior: "smooth"
                });
                firstInvalid.focus();
                return false;
            }
            return true;
        };
        this.serializeMenu = ()=>{
            var _document_querySelector, _document_querySelector1;
            const categoriesContainer = document.getElementById("menu-categories");
            var _document_querySelector_innerHTML;
            const intro = (_document_querySelector_innerHTML = (_document_querySelector = document.querySelector('[data-menu-note="introduction"] [data-menu-field]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.innerHTML) !== null && _document_querySelector_innerHTML !== void 0 ? _document_querySelector_innerHTML : "";
            var _document_querySelector_innerHTML1;
            const endNotes = (_document_querySelector_innerHTML1 = (_document_querySelector1 = document.querySelector('[data-menu-note="endnotes"] [data-menu-field]')) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.innerHTML) !== null && _document_querySelector_innerHTML1 !== void 0 ? _document_querySelector_innerHTML1 : "";
            var _categoriesContainer_querySelectorAll;
            const categories = Array.from((_categoriesContainer_querySelectorAll = categoriesContainer === null || categoriesContainer === void 0 ? void 0 : categoriesContainer.querySelectorAll(".menu-category")) !== null && _categoriesContainer_querySelectorAll !== void 0 ? _categoriesContainer_querySelectorAll : []).map((categoryEl, categoryIndex)=>this.serializeCategory(categoryEl, categoryIndex));
            return {
                name: "Menu",
                language: this.languageCode,
                currency: this.currencyCode,
                intro: intro,
                endNotes: endNotes,
                categories: categories
            };
        };
        this.serializeCategory = (categoryEl, categoryIndex)=>{
            var _categoryEl_querySelector_textContent, _categoryEl_querySelector, _categoryEl_querySelector_textContent1, _categoryEl_querySelector1, _categoryEl_querySelector2;
            var _categoryEl_querySelector_textContent_trim;
            const name = (_categoryEl_querySelector_textContent_trim = (_categoryEl_querySelector = categoryEl.querySelector(".menu-category-title")) === null || _categoryEl_querySelector === void 0 ? void 0 : (_categoryEl_querySelector_textContent = _categoryEl_querySelector.textContent) === null || _categoryEl_querySelector_textContent === void 0 ? void 0 : _categoryEl_querySelector_textContent.trim()) !== null && _categoryEl_querySelector_textContent_trim !== void 0 ? _categoryEl_querySelector_textContent_trim : "";
            var _categoryEl_querySelector_textContent_trim1;
            const description = (_categoryEl_querySelector_textContent_trim1 = (_categoryEl_querySelector1 = categoryEl.querySelector(".menu-category-description")) === null || _categoryEl_querySelector1 === void 0 ? void 0 : (_categoryEl_querySelector_textContent1 = _categoryEl_querySelector1.textContent) === null || _categoryEl_querySelector_textContent1 === void 0 ? void 0 : _categoryEl_querySelector_textContent1.trim()) !== null && _categoryEl_querySelector_textContent_trim1 !== void 0 ? _categoryEl_querySelector_textContent_trim1 : "";
            var _categoryEl_querySelector_querySelectorAll;
            const fees = Array.from((_categoryEl_querySelector_querySelectorAll = (_categoryEl_querySelector2 = categoryEl.querySelector(".menu-category-fees")) === null || _categoryEl_querySelector2 === void 0 ? void 0 : _categoryEl_querySelector2.querySelectorAll(".menu-fee-pill")) !== null && _categoryEl_querySelector_querySelectorAll !== void 0 ? _categoryEl_querySelector_querySelectorAll : []).map((feeEl)=>this.serializeFee(feeEl));
            const dishes = Array.from(categoryEl.querySelectorAll(".menu-food-item")).map((foodEl, dishIndex)=>this.serializeDish(foodEl, dishIndex));
            const enabled = !categoryEl.classList.contains($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE);
            const halfAndHalf = categoryEl.classList.contains($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HALF_AND_HALF);
            const addons = this.parseAddons(categoryEl);
            return {
                name: name,
                description: description,
                order: categoryIndex,
                enabled: enabled,
                halfAndHalf: halfAndHalf,
                addons: addons,
                fees: fees,
                dishes: dishes
            };
        };
        this.serializeDish = (foodEl, dishIndex)=>{
            var _foodEl_querySelector_textContent, _foodEl_querySelector, _foodEl_querySelector_textContent1, _foodEl_querySelector1, _foodEl_querySelector2, _foodEl_querySelector3;
            var _foodEl_querySelector_textContent_trim;
            const name = (_foodEl_querySelector_textContent_trim = (_foodEl_querySelector = foodEl.querySelector(".menu-food-title")) === null || _foodEl_querySelector === void 0 ? void 0 : (_foodEl_querySelector_textContent = _foodEl_querySelector.textContent) === null || _foodEl_querySelector_textContent === void 0 ? void 0 : _foodEl_querySelector_textContent.trim()) !== null && _foodEl_querySelector_textContent_trim !== void 0 ? _foodEl_querySelector_textContent_trim : "";
            var _foodEl_querySelector_textContent_trim1;
            const description = (_foodEl_querySelector_textContent_trim1 = (_foodEl_querySelector1 = foodEl.querySelector(".menu-food-description")) === null || _foodEl_querySelector1 === void 0 ? void 0 : (_foodEl_querySelector_textContent1 = _foodEl_querySelector1.textContent) === null || _foodEl_querySelector_textContent1 === void 0 ? void 0 : _foodEl_querySelector_textContent1.trim()) !== null && _foodEl_querySelector_textContent_trim1 !== void 0 ? _foodEl_querySelector_textContent_trim1 : "";
            const sizeElements = Array.from(foodEl.querySelectorAll(".menu-food-size"));
            const sizes = sizeElements.length > 0 ? sizeElements.map((sizeEl, sizeIndex)=>{
                var _sizeEl_querySelector_textContent, _sizeEl_querySelector, _sizeEl_querySelector1;
                var _sizeEl_querySelector_textContent_trim;
                const sizeName = (_sizeEl_querySelector_textContent_trim = (_sizeEl_querySelector = sizeEl.querySelector(".menu-food-size-title")) === null || _sizeEl_querySelector === void 0 ? void 0 : (_sizeEl_querySelector_textContent = _sizeEl_querySelector.textContent) === null || _sizeEl_querySelector_textContent === void 0 ? void 0 : _sizeEl_querySelector_textContent.trim()) !== null && _sizeEl_querySelector_textContent_trim !== void 0 ? _sizeEl_querySelector_textContent_trim : "";
                const sizePrice = parseFloat(((_sizeEl_querySelector1 = sizeEl.querySelector(".menu-food-size-price-input")) === null || _sizeEl_querySelector1 === void 0 ? void 0 : _sizeEl_querySelector1.value) || $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE);
                return {
                    name: sizeName,
                    price: sizePrice,
                    order: sizeIndex
                };
            }) : [
                {
                    name: "",
                    price: parseFloat(((_foodEl_querySelector2 = foodEl.querySelector(".menu-price-input")) === null || _foodEl_querySelector2 === void 0 ? void 0 : _foodEl_querySelector2.value) || $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE),
                    order: 0
                }
            ];
            var _foodEl_querySelector_querySelectorAll;
            const fees = Array.from((_foodEl_querySelector_querySelectorAll = (_foodEl_querySelector3 = foodEl.querySelector(".menu-food-fees")) === null || _foodEl_querySelector3 === void 0 ? void 0 : _foodEl_querySelector3.querySelectorAll(".menu-fee-pill")) !== null && _foodEl_querySelector_querySelectorAll !== void 0 ? _foodEl_querySelector_querySelectorAll : []).map((feeEl)=>{
                var _feeEl_dataset_feeSizeIndexes;
                const sizeIndexes = ((_feeEl_dataset_feeSizeIndexes = feeEl.dataset.feeSizeIndexes) !== null && _feeEl_dataset_feeSizeIndexes !== void 0 ? _feeEl_dataset_feeSizeIndexes : "").split(",").filter(Boolean).map(Number);
                return {
                    ...this.serializeFee(feeEl),
                    sizes: sizeIndexes
                };
            });
            const enabled = !foodEl.classList.contains($c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE);
            const addons = this.parseAddons(foodEl);
            return {
                name: name,
                description: description,
                order: dishIndex,
                enabled: enabled,
                addons: addons,
                sizes: sizes,
                fees: fees
            };
        };
        this.serializeFee = (feeEl)=>{
            var _feeEl_dataset_feeName, _feeEl_dataset_feePrice, _feeEl_dataset_feePercentage, _feeEl_dataset_feeType, _feeEl_dataset_feeDeliveryMethods;
            return {
                name: (_feeEl_dataset_feeName = feeEl.dataset.feeName) !== null && _feeEl_dataset_feeName !== void 0 ? _feeEl_dataset_feeName : "",
                price: parseFloat((_feeEl_dataset_feePrice = feeEl.dataset.feePrice) !== null && _feeEl_dataset_feePrice !== void 0 ? _feeEl_dataset_feePrice : $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE),
                percentage: parseFloat((_feeEl_dataset_feePercentage = feeEl.dataset.feePercentage) !== null && _feeEl_dataset_feePercentage !== void 0 ? _feeEl_dataset_feePercentage : $c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE),
                type: (_feeEl_dataset_feeType = feeEl.dataset.feeType) !== null && _feeEl_dataset_feeType !== void 0 ? _feeEl_dataset_feeType : (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed,
                deliveryMethods: ((_feeEl_dataset_feeDeliveryMethods = feeEl.dataset.feeDeliveryMethods) !== null && _feeEl_dataset_feeDeliveryMethods !== void 0 ? _feeEl_dataset_feeDeliveryMethods : "").split(",").filter(Boolean)
            };
        };
        this.setupFeeModal = ()=>{
            var _document_getElementById;
            const modalEl = document.getElementById("menu-fee-modal");
            if (!modalEl) return;
            this.feeModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            const typeSelect = document.getElementById("menu-fee-type");
            const priceGroup = document.getElementById("menu-fee-price-group");
            const percentageGroup = document.getElementById("menu-fee-percentage-group");
            typeSelect === null || typeSelect === void 0 ? void 0 : typeSelect.addEventListener("change", ()=>{
                if (typeSelect.value === (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed) {
                    priceGroup.classList.remove("d-none");
                    percentageGroup.classList.add("d-none");
                } else {
                    priceGroup.classList.add("d-none");
                    percentageGroup.classList.remove("d-none");
                }
            });
            (_document_getElementById = document.getElementById("menu-fee-confirm-btn")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener("click", ()=>{
                var _this_feeModal;
                const nameInput = document.getElementById("menu-fee-name");
                const name = nameInput.value.trim();
                if (!name) {
                    nameInput.focus();
                    return;
                }
                const type = typeSelect.value;
                const price = parseFloat(document.getElementById("menu-fee-price").value || "0");
                const percentage = parseFloat(document.getElementById("menu-fee-percentage").value || "0");
                const deliveryMethods = Array.from(document.querySelectorAll(".menu-fee-method-checkbox:checked")).map((checkbox)=>checkbox.value);
                const sizeIndexes = Array.from(document.querySelectorAll(".menu-fee-size-checkbox:checked")).map((checkbox)=>parseInt(checkbox.value, 10));
                if (this.pendingFeeEditEl) {
                    this.pendingFeeEditEl.dataset.feeName = name;
                    this.pendingFeeEditEl.dataset.feeType = type;
                    this.pendingFeeEditEl.dataset.feePrice = String(price);
                    this.pendingFeeEditEl.dataset.feePercentage = String(percentage);
                    this.pendingFeeEditEl.dataset.feeDeliveryMethods = deliveryMethods.join(",");
                    this.pendingFeeEditEl.dataset.feeSizeIndexes = sizeIndexes.join(",");
                    const labelEl = this.pendingFeeEditEl.querySelector(".menu-fee-label");
                    if (labelEl) labelEl.textContent = this.buildFeeLabelText(name, type, price, percentage);
                } else if (this.pendingFeeParentEl) {
                    const feesContainer = this.pendingFeeParentEl.querySelector("[data-fees-container]");
                    if (!feesContainer) return;
                    this.addFeePill(feesContainer, name, type, price, percentage, deliveryMethods, sizeIndexes);
                }
                this.pendingFeeParentEl = null;
                this.pendingFeeEditEl = null;
                (_this_feeModal = this.feeModal) === null || _this_feeModal === void 0 ? void 0 : _this_feeModal.hide();
            });
        };
        this.openAddFeeModal = (parentEl)=>{
            var _document_getElementById, _document_getElementById1, _this_feeModal;
            this.pendingFeeParentEl = parentEl;
            this.pendingFeeEditEl = null;
            document.getElementById("menu-fee-name").value = "";
            const typeSelect = document.getElementById("menu-fee-type");
            typeSelect.value = (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed;
            document.getElementById("menu-fee-price").value = "0";
            document.getElementById("menu-fee-percentage").value = "0";
            document.querySelectorAll(".menu-fee-method-checkbox").forEach((checkbox)=>{
                checkbox.checked = false;
            });
            (_document_getElementById = document.getElementById("menu-fee-price-group")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.remove("d-none");
            (_document_getElementById1 = document.getElementById("menu-fee-percentage-group")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.add("d-none");
            const foodItemEl = parentEl.classList.contains("menu-food-item") ? parentEl : null;
            const sizeLabels = foodItemEl ? this.getSizeLabels(foodItemEl) : [];
            const sizesGroup = document.getElementById("menu-fee-sizes-group");
            if (foodItemEl && sizeLabels.length >= $c681d84e804ccd9c$export$42a146b10ea741e8.MIN_SIZES_FOR_FEE_SELECTION) {
                this.populateSizesCheckboxes(sizeLabels, []);
                sizesGroup.classList.remove("d-none");
            } else sizesGroup.classList.add("d-none");
            const modalTitle = document.getElementById("menu-fee-modal-title");
            if (modalTitle) modalTitle.textContent = this.t("Add fee");
            const confirmBtn = document.getElementById("menu-fee-confirm-btn");
            if (confirmBtn) confirmBtn.textContent = this.t("Add");
            (_this_feeModal = this.feeModal) === null || _this_feeModal === void 0 ? void 0 : _this_feeModal.show();
        };
        this.openEditFeeModal = (feeEl)=>{
            var _this_feeModal;
            this.pendingFeeEditEl = feeEl;
            this.pendingFeeParentEl = null;
            var _feeEl_dataset_feeType;
            const type = (_feeEl_dataset_feeType = feeEl.dataset.feeType) !== null && _feeEl_dataset_feeType !== void 0 ? _feeEl_dataset_feeType : (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed;
            var _feeEl_dataset_feeDeliveryMethods;
            const deliveryMethods = ((_feeEl_dataset_feeDeliveryMethods = feeEl.dataset.feeDeliveryMethods) !== null && _feeEl_dataset_feeDeliveryMethods !== void 0 ? _feeEl_dataset_feeDeliveryMethods : "").split(",").filter(Boolean);
            var _feeEl_dataset_feeSizeIndexes;
            const selectedSizeIndexes = ((_feeEl_dataset_feeSizeIndexes = feeEl.dataset.feeSizeIndexes) !== null && _feeEl_dataset_feeSizeIndexes !== void 0 ? _feeEl_dataset_feeSizeIndexes : "").split(",").filter(Boolean).map(Number);
            var _feeEl_dataset_feeName;
            document.getElementById("menu-fee-name").value = (_feeEl_dataset_feeName = feeEl.dataset.feeName) !== null && _feeEl_dataset_feeName !== void 0 ? _feeEl_dataset_feeName : "";
            const typeSelect = document.getElementById("menu-fee-type");
            typeSelect.value = type;
            var _feeEl_dataset_feePrice;
            document.getElementById("menu-fee-price").value = (_feeEl_dataset_feePrice = feeEl.dataset.feePrice) !== null && _feeEl_dataset_feePrice !== void 0 ? _feeEl_dataset_feePrice : "0";
            var _feeEl_dataset_feePercentage;
            document.getElementById("menu-fee-percentage").value = (_feeEl_dataset_feePercentage = feeEl.dataset.feePercentage) !== null && _feeEl_dataset_feePercentage !== void 0 ? _feeEl_dataset_feePercentage : "0";
            if (type === (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed) {
                var _document_getElementById, _document_getElementById1;
                (_document_getElementById = document.getElementById("menu-fee-price-group")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.remove("d-none");
                (_document_getElementById1 = document.getElementById("menu-fee-percentage-group")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.add("d-none");
            } else {
                var _document_getElementById2, _document_getElementById3;
                (_document_getElementById2 = document.getElementById("menu-fee-price-group")) === null || _document_getElementById2 === void 0 ? void 0 : _document_getElementById2.classList.add("d-none");
                (_document_getElementById3 = document.getElementById("menu-fee-percentage-group")) === null || _document_getElementById3 === void 0 ? void 0 : _document_getElementById3.classList.remove("d-none");
            }
            document.querySelectorAll(".menu-fee-method-checkbox").forEach((checkbox)=>{
                checkbox.checked = deliveryMethods.includes(checkbox.value);
            });
            const foodItemEl = feeEl.closest(".menu-food-item");
            const sizeLabels = foodItemEl ? this.getSizeLabels(foodItemEl) : [];
            const sizesGroup = document.getElementById("menu-fee-sizes-group");
            if (foodItemEl && sizeLabels.length >= $c681d84e804ccd9c$export$42a146b10ea741e8.MIN_SIZES_FOR_FEE_SELECTION) {
                this.populateSizesCheckboxes(sizeLabels, selectedSizeIndexes);
                sizesGroup.classList.remove("d-none");
            } else sizesGroup.classList.add("d-none");
            const modalTitle = document.getElementById("menu-fee-modal-title");
            if (modalTitle) modalTitle.textContent = this.t("Edit fee");
            const confirmBtn = document.getElementById("menu-fee-confirm-btn");
            if (confirmBtn) confirmBtn.textContent = this.t("Save");
            (_this_feeModal = this.feeModal) === null || _this_feeModal === void 0 ? void 0 : _this_feeModal.show();
        };
        this.getSizeLabels = (foodItemEl)=>Array.from(foodItemEl.querySelectorAll(".menu-food-size-title")).map((titleEl, index)=>{
                var _titleEl_textContent;
                return ((_titleEl_textContent = titleEl.textContent) === null || _titleEl_textContent === void 0 ? void 0 : _titleEl_textContent.trim()) || `${this.t("Size")} ${index + 1}`;
            });
        this.populateSizesCheckboxes = (labels, selectedIndexes)=>{
            const container = document.getElementById("menu-fee-sizes-checkboxes");
            container.innerHTML = labels.map((label, index)=>`
      <div class="form-check">
        <input class="form-check-input menu-fee-size-checkbox" type="checkbox"
               id="menu-fee-size-${index}" value="${index}" ${selectedIndexes.includes(index) ? "checked" : ""} />
        <label class="form-check-label" for="menu-fee-size-${index}">${label}</label>
      </div>
    `).join("");
        };
        this.buildFeePillHtml = (label)=>`
    <span class="menu-fee-label">${label}</span>
    <i class="menu-fee-edit bi bi-pencil-fill"></i>
  `;
        this.setupFeePill = (feeEl)=>{
            var _feeEl_querySelector;
            (_feeEl_querySelector = feeEl.querySelector(".menu-fee-edit")) === null || _feeEl_querySelector === void 0 ? void 0 : _feeEl_querySelector.addEventListener("click", ()=>{
                this.openEditFeeModal(feeEl);
            });
        };
        this.buildFeeLabelText = (name, type, price, percentage)=>type === (0, $c26f41c501210151$export$b3cca15178f70d5).Fixed ? `${name} ${(0, $2e60e98948ab7fe8$export$b733e092f9f44b2c).showPriceAsText((0, $bd98c7125df1feb2$export$d26bcf891bc220f6).toSafe(price), this.currencyCode)}` : `${name} ${percentage}%`;
        this.setupAddonsModal = ()=>{
            var _document_getElementById, _document_getElementById1;
            const modalEl = document.getElementById("menu-addons-modal");
            if (!modalEl) return;
            this.addonsModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            (_document_getElementById = document.getElementById("menu-addon-add-row")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener("click", ()=>this.addAddonRow());
            (_document_getElementById1 = document.getElementById("menu-addons-save-btn")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.addEventListener("click", ()=>{
                var _this_addonsModal;
                if (this.pendingAddonsEl) this.applyAddonsToElement(this.pendingAddonsEl, this.collectAddonsFromModal());
                this.pendingAddonsEl = null;
                (_this_addonsModal = this.addonsModal) === null || _this_addonsModal === void 0 ? void 0 : _this_addonsModal.hide();
            });
        };
        this.openAddonsModal = (targetEl)=>{
            var _this_addonsModal;
            this.pendingAddonsEl = targetEl;
            const rowsContainer = document.getElementById("menu-addons-rows");
            if (rowsContainer) rowsContainer.innerHTML = "";
            for (const addon of this.parseAddons(targetEl))this.addAddonRow(addon);
            this.updateAddonsEmptyHint();
            (_this_addonsModal = this.addonsModal) === null || _this_addonsModal === void 0 ? void 0 : _this_addonsModal.show();
        };
        this.buildAddonRowHtml = ()=>`
    <div class="row g-2 align-items-end">
      <div class="col-12 col-sm">
        <label class="form-label small mb-1">${this.t("Name")}</label>
        <input type="text" class="form-control form-control-sm" data-addon-name />
      </div>
      <div class="col-6 col-sm-3">
        <label class="form-label small mb-1">${this.t("Price")}</label>
        <input type="number" min="0" step="0.01" class="form-control form-control-sm" data-addon-price value="0" />
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-danger" data-addon-remove title="${this.t("Remove")}"><i class="bi bi-trash3"></i></button>
      </div>
    </div>
  `;
        this.addAddonRow = (addon)=>{
            var _rowEl_querySelector;
            const rowsContainer = document.getElementById("menu-addons-rows");
            if (!rowsContainer) return;
            const rowEl = document.createElement("div");
            rowEl.className = "menu-addon-row border rounded p-2";
            rowEl.dataset.addonRow = "true";
            rowEl.innerHTML = this.buildAddonRowHtml();
            rowsContainer.appendChild(rowEl);
            if (addon) {
                rowEl.querySelector("[data-addon-name]").value = addon.name;
                rowEl.querySelector("[data-addon-price]").value = String(addon.price);
            }
            (_rowEl_querySelector = rowEl.querySelector("[data-addon-remove]")) === null || _rowEl_querySelector === void 0 ? void 0 : _rowEl_querySelector.addEventListener("click", ()=>{
                rowEl.remove();
                this.updateAddonsEmptyHint();
            });
            this.updateAddonsEmptyHint();
        };
        this.collectAddonsFromModal = ()=>{
            const rows = Array.from(document.querySelectorAll("#menu-addons-rows [data-addon-row]"));
            const addons = [];
            for (const rowEl of rows){
                var _rowEl_querySelector, _rowEl_querySelector1;
                var _rowEl_querySelector_value_trim;
                const name = (_rowEl_querySelector_value_trim = (_rowEl_querySelector = rowEl.querySelector("[data-addon-name]")) === null || _rowEl_querySelector === void 0 ? void 0 : _rowEl_querySelector.value.trim()) !== null && _rowEl_querySelector_value_trim !== void 0 ? _rowEl_querySelector_value_trim : "";
                if (!name) continue;
                const price = Math.max(0, parseFloat(((_rowEl_querySelector1 = rowEl.querySelector("[data-addon-price]")) === null || _rowEl_querySelector1 === void 0 ? void 0 : _rowEl_querySelector1.value) || "0") || 0);
                addons.push({
                    name: name,
                    price: price
                });
            }
            return addons;
        };
        this.updateAddonsEmptyHint = ()=>{
            var _document_getElementById;
            const rowsContainer = document.getElementById("menu-addons-rows");
            var _rowsContainer_querySelectorAll_length;
            const hasRows = ((_rowsContainer_querySelectorAll_length = rowsContainer === null || rowsContainer === void 0 ? void 0 : rowsContainer.querySelectorAll("[data-addon-row]").length) !== null && _rowsContainer_querySelectorAll_length !== void 0 ? _rowsContainer_querySelectorAll_length : 0) > 0;
            (_document_getElementById = document.getElementById("menu-addons-empty")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle("d-none", hasRows);
        };
        this.parseAddons = (targetEl)=>{
            try {
                var _targetEl_dataset_addons;
                const parsed = JSON.parse((_targetEl_dataset_addons = targetEl.dataset.addons) !== null && _targetEl_dataset_addons !== void 0 ? _targetEl_dataset_addons : "[]");
                return Array.isArray(parsed) ? parsed : [];
            } catch  {
                return [];
            }
        };
        this.applyAddonsToElement = (targetEl, addons)=>{
            var _feesContainer_querySelector, _pillEl_querySelector;
            const feesContainer = targetEl.classList.contains("menu-food-item") ? targetEl.querySelector(".menu-food-fees") : targetEl.querySelector(".menu-category-fees");
            feesContainer === null || feesContainer === void 0 ? void 0 : (_feesContainer_querySelector = feesContainer.querySelector("[data-addons-pill]")) === null || _feesContainer_querySelector === void 0 ? void 0 : _feesContainer_querySelector.remove();
            if (addons.length === 0) {
                delete targetEl.dataset.addons;
                return;
            }
            targetEl.dataset.addons = JSON.stringify(addons);
            if (!feesContainer) return;
            const pillEl = document.createElement("span");
            pillEl.className = "menu-addons-pill";
            pillEl.dataset.addonsPill = "true";
            pillEl.innerHTML = `<span>${this.t("Add-ons")}</span><i class="menu-fee-edit bi bi-pencil-fill"></i>`;
            feesContainer.appendChild(pillEl);
            (_pillEl_querySelector = pillEl.querySelector(".menu-fee-edit")) === null || _pillEl_querySelector === void 0 ? void 0 : _pillEl_querySelector.addEventListener("click", ()=>this.openAddonsModal(targetEl));
        };
        this.addFeePill = (feesContainer, name, type, price, percentage, deliveryMethods, sizeIndexes)=>{
            const feeEl = document.createElement("span");
            feeEl.className = "menu-fee-pill";
            feeEl.dataset.feeId = String(++this.feeCounter);
            feeEl.dataset.feeName = name;
            feeEl.dataset.feeType = type;
            feeEl.dataset.feePrice = String(price);
            feeEl.dataset.feePercentage = String(percentage);
            feeEl.dataset.feeDeliveryMethods = deliveryMethods.join(",");
            feeEl.dataset.feeSizeIndexes = sizeIndexes.join(",");
            feeEl.innerHTML = this.buildFeePillHtml(this.buildFeeLabelText(name, type, price, percentage));
            feesContainer.appendChild(feeEl);
            this.setupFeePill(feeEl);
        };
        this.initOcrState = ()=>{
            const photosPanel = document.querySelector('[data-menu-panel="photos"]');
            if (!photosPanel) return;
            const isOcrRunning = photosPanel.dataset.ocrRunning === "true";
            var _photosPanel_dataset_menuOcrError;
            const menuOcrError = (_photosPanel_dataset_menuOcrError = photosPanel.dataset.menuOcrError) !== null && _photosPanel_dataset_menuOcrError !== void 0 ? _photosPanel_dataset_menuOcrError : "";
            if (isOcrRunning) {
                this.isCreatingMenu = true;
                this.setDropzoneLoading(true);
                this.currentMode = $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS;
                const toggleBtn = document.querySelector("[data-menu-mode-toggle]");
                if (toggleBtn) toggleBtn.disabled = true;
                document.querySelectorAll("[data-menu-panel]").forEach((panel)=>{
                    panel.style.display = panel.dataset.menuPanel === $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS ? "" : "none";
                });
                const createBtn = document.querySelector("[data-menu-create-btn]");
                if (createBtn) {
                    createBtn.disabled = true;
                    createBtn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>${this.t("Processing...")}`;
                }
                this.startOcrCountdown(photosPanel);
            } else if (menuOcrError) {
                const errorEl = document.querySelector("[data-menu-create-error]");
                if (errorEl) {
                    errorEl.textContent = this.t("Menu generation failed. Please try again.");
                    errorEl.classList.remove("d-none");
                }
            }
        };
        this.startOcrCountdown = (photosPanel)=>{
            const alertEl = document.querySelector("[data-menu-generation-alert]");
            const remainingSeconds = Number(photosPanel.dataset.ocrRemainingSeconds);
            if (!alertEl || !Number.isFinite(remainingSeconds) || remainingSeconds <= 0) return;
            const deadline = Date.now() + remainingSeconds * $c681d84e804ccd9c$export$42a146b10ea741e8.MS_IN_SECOND;
            const updateAlert = ()=>{
                const secondsLeft = Math.max(0, Math.ceil((deadline - Date.now()) / $c681d84e804ccd9c$export$42a146b10ea741e8.MS_IN_SECOND));
                alertEl.textContent = this.t("Menu generation is in progress. It should be over in {seconds} seconds.").replace("{seconds}", String(secondsLeft));
                if (secondsLeft <= 0) {
                    this.stopOcrCountdown();
                    this.pjax.loadUrl(window.location.href);
                }
            };
            alertEl.classList.remove("d-none");
            updateAlert();
            this.ocrCountdownTimer = window.setInterval(updateAlert, $c681d84e804ccd9c$export$42a146b10ea741e8.MS_IN_SECOND);
        };
        this.stopOcrCountdown = ()=>{
            var _document_querySelector;
            if (this.ocrCountdownTimer !== null) {
                window.clearInterval(this.ocrCountdownTimer);
                this.ocrCountdownTimer = null;
            }
            (_document_querySelector = document.querySelector("[data-menu-generation-alert]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("d-none");
        };
        this.preRenderMenu = ()=>{
            const scriptEl = document.getElementById("menu-data");
            if (!scriptEl) return;
            let menu;
            try {
                var _scriptEl_textContent;
                menu = JSON.parse((_scriptEl_textContent = scriptEl.textContent) !== null && _scriptEl_textContent !== void 0 ? _scriptEl_textContent : "");
            } catch  {
                return;
            }
            const introEl = document.querySelector('[data-menu-note="introduction"] [data-menu-field]');
            if (introEl && menu.intro) introEl.innerHTML = menu.intro;
            const endNotesEl = document.querySelector('[data-menu-note="endnotes"] [data-menu-field]');
            if (endNotesEl && menu.endNotes) endNotesEl.innerHTML = menu.endNotes;
            var _menu_categories;
            for (const category of (_menu_categories = menu.categories) !== null && _menu_categories !== void 0 ? _menu_categories : [])this.addCategory(category);
            if (this.wasMenuCreated) {
                this.currentMode = $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_MANUAL;
                document.querySelectorAll("[data-menu-panel]").forEach((panel)=>{
                    panel.style.display = panel.dataset.menuPanel === $c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_MANUAL ? "" : "none";
                });
                this.updateHeaderText();
            }
        };
        this.onMenuGenerationStatus = (data)=>{
            if (data.success) {
                window.location.reload();
                return;
            }
            this.isCreatingMenu = false;
            this.selectedFiles = [];
            this.setDropzoneLoading(false);
            this.stopOcrCountdown();
            const createBtn = document.querySelector("[data-menu-create-btn]");
            const toggleBtn = document.querySelector("[data-menu-mode-toggle]");
            if (createBtn) {
                createBtn.disabled = true;
                createBtn.innerHTML = this.createBtnOriginalHTML;
            }
            if (toggleBtn) toggleBtn.disabled = false;
            const errorEl = document.querySelector("[data-menu-create-error]");
            if (errorEl) {
                errorEl.textContent = this.t("Menu generation failed. Please try again.");
                errorEl.classList.remove("d-none");
            }
        };
        this.onPageClose = ()=>{
            (0, $16521f78b103838e$export$4bbaa2811faa41de).off((0, $af3e60c4682271e9$export$bdfa458742e675ed).MenuGenerationStatus, this.onMenuGenerationStatus);
            this.stopOcrCountdown();
        };
    }
}
$c681d84e804ccd9c$export$42a146b10ea741e8.TRANSLATION_ID = "MenuEditorPanel";
$c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_PHOTOS = "photos";
$c681d84e804ccd9c$export$42a146b10ea741e8.MENU_MODE_MANUAL = "manual";
$c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HAS_FILES = "has-files";
$c681d84e804ccd9c$export$42a146b10ea741e8.CSS_DRAG_OVER = "drag-over";
$c681d84e804ccd9c$export$42a146b10ea741e8.CSS_UNAVAILABLE = "is-unavailable";
$c681d84e804ccd9c$export$42a146b10ea741e8.CSS_HALF_AND_HALF = "can-order-half-and-half";
$c681d84e804ccd9c$export$42a146b10ea741e8.PRICE_DECIMAL_PLACES = 2;
$c681d84e804ccd9c$export$42a146b10ea741e8.DEFAULT_PRICE = "0";
$c681d84e804ccd9c$export$42a146b10ea741e8.MIN_SIZES_FOR_FEE_SELECTION = 2;
$c681d84e804ccd9c$export$42a146b10ea741e8.MS_IN_SECOND = 1000;


// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved

class $b5d852b3bcb6d8e7$export$1a2d016bdbb8b398 {
    constructor(){
        this.removeModal = null;
        this.getPageId = ()=>"team-invite-panel";
        this.execute = ()=>{
            this.setupRemoveModal();
        };
        this.onPageClose = ()=>{};
        this.setupRemoveModal = ()=>{
            const modalEl = document.getElementById("team-remove-member-modal");
            if (!modalEl) return;
            this.removeModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            document.querySelectorAll("[data-action='remove-team-member']").forEach((btn)=>{
                btn.addEventListener("click", ()=>{
                    var _this_removeModal;
                    var _btn_dataset_id;
                    const id = (_btn_dataset_id = btn.dataset.id) !== null && _btn_dataset_id !== void 0 ? _btn_dataset_id : "";
                    var _btn_dataset_email;
                    const email = (_btn_dataset_email = btn.dataset.email) !== null && _btn_dataset_email !== void 0 ? _btn_dataset_email : "";
                    const idInput = modalEl.querySelector("input[name='id']");
                    if (idInput) idInput.value = id;
                    const textEl = document.getElementById("team-remove-member-text");
                    if (textEl) {
                        var _textEl_dataset_confirmPrefix;
                        const prefix = (_textEl_dataset_confirmPrefix = textEl.dataset.confirmPrefix) !== null && _textEl_dataset_confirmPrefix !== void 0 ? _textEl_dataset_confirmPrefix : "Are you sure you want to remove";
                        var _textEl_dataset_confirmSuffix;
                        const suffix = (_textEl_dataset_confirmSuffix = textEl.dataset.confirmSuffix) !== null && _textEl_dataset_confirmSuffix !== void 0 ? _textEl_dataset_confirmSuffix : "from your team?";
                        textEl.textContent = `${prefix} ${email} ${suffix}`;
                    }
                    (_this_removeModal = this.removeModal) === null || _this_removeModal === void 0 ? void 0 : _this_removeModal.show();
                });
            });
        };
    }
}





class $da9f2f80f7f34750$export$4f4ee9834b214a1e {
    constructor(){
        this.deliveryToDoors = null;
        this.deliveryToTable = null;
        this.eatInPlacesSection = null;
        this.areasSection = null;
        this.areasInput = null;
        this.areasListElement = null;
        this.areasEmptyElement = null;
        this.areas = [];
        this.currency = "";
        this.areaModal = null;
        this.map = null;
        this.maplibre = null;
        this.restaurantLocation = null;
        this.editIndex = -1;
        this.isDrawing = false;
        this.draftPoints = [];
        this.polygonPoints = [];
        this.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
        this.t = (key)=>this.translation.t(key);
        this.getPageId = ()=>"delivery-options-panel";
        this.execute = async ()=>{
            var _this_areasSection, _this_deliveryToDoors, _this_deliveryToTable;
            this.deliveryToDoors = document.getElementById("deliveryToDoors");
            this.deliveryToTable = document.getElementById("deliveryToTable");
            this.eatInPlacesSection = document.querySelector("[data-eatin-places-section]");
            this.areasSection = document.querySelector("[data-delivery-areas-section]");
            this.areasInput = document.querySelector("[data-delivery-areas-input]");
            this.areasListElement = document.querySelector("[data-delivery-areas-list]");
            this.areasEmptyElement = document.querySelector("[data-delivery-areas-empty]");
            var _this_areasSection_dataset_currency;
            this.currency = (_this_areasSection_dataset_currency = (_this_areasSection = this.areasSection) === null || _this_areasSection === void 0 ? void 0 : _this_areasSection.dataset.currency) !== null && _this_areasSection_dataset_currency !== void 0 ? _this_areasSection_dataset_currency : "";
            (_this_deliveryToDoors = this.deliveryToDoors) === null || _this_deliveryToDoors === void 0 ? void 0 : _this_deliveryToDoors.addEventListener("change", this.toggleAreasSection);
            (_this_deliveryToTable = this.deliveryToTable) === null || _this_deliveryToTable === void 0 ? void 0 : _this_deliveryToTable.addEventListener("change", this.toggleEatInPlacesSection);
            if (!this.areasSection) return;
            await this.translation.fetchTranslations($da9f2f80f7f34750$export$4f4ee9834b214a1e.TRANSLATION_ID);
            try {
                var _this_areasInput;
                this.areas = JSON.parse(((_this_areasInput = this.areasInput) === null || _this_areasInput === void 0 ? void 0 : _this_areasInput.value) || "[]");
            } catch (error) {
                this.areas = [];
            }
            this.setupModal();
            this.renderAreas();
        };
        this.onPageClose = ()=>{
            var _this_map;
            (_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.remove();
            this.map = null;
            this.areaModal = null;
            this.restaurantLocation = null;
        };
        this.toggleAreasSection = ()=>{
            var _this_deliveryToDoors, _this_areasSection;
            const isDeliveryEnabled = !!((_this_deliveryToDoors = this.deliveryToDoors) === null || _this_deliveryToDoors === void 0 ? void 0 : _this_deliveryToDoors.checked);
            (_this_areasSection = this.areasSection) === null || _this_areasSection === void 0 ? void 0 : _this_areasSection.classList.toggle("d-none", !isDeliveryEnabled);
        };
        this.toggleEatInPlacesSection = ()=>{
            var _this_deliveryToTable, _this_eatInPlacesSection;
            const isEatInEnabled = !!((_this_deliveryToTable = this.deliveryToTable) === null || _this_deliveryToTable === void 0 ? void 0 : _this_deliveryToTable.checked);
            (_this_eatInPlacesSection = this.eatInPlacesSection) === null || _this_eatInPlacesSection === void 0 ? void 0 : _this_eatInPlacesSection.classList.toggle("d-none", !isEatInEnabled);
        };
        this.syncAreasInput = ()=>{
            if (this.areasInput) this.areasInput.value = JSON.stringify(this.areas);
        };
        this.getAreaColor = (index)=>$da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS[index % $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS.length];
        this.escapeHtml = (text)=>{
            const helperElement = document.createElement("div");
            helperElement.textContent = text;
            return helperElement.innerHTML;
        };
        this.renderAreas = ()=>{
            var _this_areasEmptyElement;
            if (!this.areasListElement) return;
            (_this_areasEmptyElement = this.areasEmptyElement) === null || _this_areasEmptyElement === void 0 ? void 0 : _this_areasEmptyElement.classList.toggle("d-none", this.areas.length > 0);
            const rows = this.areas.map((area, index)=>{
                var _area_name;
                const color = this.getAreaColor(index);
                const name = ((_area_name = area.name) === null || _area_name === void 0 ? void 0 : _area_name.trim()) ? this.escapeHtml(area.name) : `${this.t("Delivery area")} ${index + 1}`;
                const cost = `${(Number(area.deliveryCost) || 0).toFixed(2)} ${this.currency}`;
                return `
        <div class="d-flex align-items-center gap-2 border rounded p-2 mb-2">
          <span class="delivery-area-swatch" style="background:${color}33;border-color:${color}"></span>
          <div class="flex-grow-1">
            <div class="fw-semibold">${name}</div>
            <div class="text-muted small"><i class="bi bi-pentagon me-1"></i>${this.t("Zone mapped")}</div>
          </div>
          <div class="fw-semibold text-nowrap">${cost}</div>
          <button type="button" class="btn btn-outline-secondary btn-sm" data-area-edit="${index}" title="${this.t("Edit area")}" aria-label="${this.t("Edit area")}">
            <i class="bi bi-pencil"></i>
          </button>
          <button type="button" class="btn btn-outline-danger btn-sm" data-area-delete="${index}" title="${this.t("Remove area")}" aria-label="${this.t("Remove area")}">
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      `;
            });
            this.areasListElement.innerHTML = rows.join("");
            for (const button of this.areasListElement.querySelectorAll("[data-area-edit]"))button.addEventListener("click", ()=>this.openAreaModal(Number(button.dataset.areaEdit)));
            for (const button of this.areasListElement.querySelectorAll("[data-area-delete]"))button.addEventListener("click", ()=>{
                this.areas.splice(Number(button.dataset.areaDelete), 1);
                this.syncAreasInput();
                this.renderAreas();
            });
        };
        this.setupModal = ()=>{
            var _document_querySelector, _document_querySelector1, _document_querySelector2;
            const modalElement = document.getElementById("delivery-area-modal");
            if (!modalElement) return;
            this.areaModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalElement);
            modalElement.addEventListener("shown.bs.modal", ()=>{
                var _this_map;
                return (_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.resize();
            });
            (_document_querySelector = document.querySelector("[data-delivery-area-add]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener("click", ()=>this.openAreaModal(-1));
            (_document_querySelector1 = document.querySelector("[data-delivery-area-draw]")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.addEventListener("click", this.startDrawing);
            (_document_querySelector2 = document.querySelector("[data-delivery-area-save]")) === null || _document_querySelector2 === void 0 ? void 0 : _document_querySelector2.addEventListener("click", this.saveArea);
        };
        this.openAreaModal = async (index)=>{
            var _this_areaModal;
            this.editIndex = index;
            const isEditing = index > -1;
            const area = isEditing ? this.areas[index] : null;
            const titleElement = document.querySelector("[data-delivery-area-modal-title]");
            if (titleElement) titleElement.textContent = isEditing ? this.t("Edit delivery area") : this.t("Add delivery area");
            const nameInput = document.querySelector("[data-delivery-area-name]");
            const costInput = document.querySelector("[data-delivery-area-cost]");
            var _area_name;
            if (nameInput) nameInput.value = (_area_name = area === null || area === void 0 ? void 0 : area.name) !== null && _area_name !== void 0 ? _area_name : "";
            if (costInput) costInput.value = area ? String(area.deliveryCost) : "";
            this.isDrawing = false;
            this.draftPoints = [];
            var _area_polygon;
            this.polygonPoints = ((_area_polygon = area === null || area === void 0 ? void 0 : area.polygon) !== null && _area_polygon !== void 0 ? _area_polygon : []).map(([lat, lng])=>[
                    lng,
                    lat
                ]);
            (_this_areaModal = this.areaModal) === null || _this_areaModal === void 0 ? void 0 : _this_areaModal.show();
            await this.initializeMap();
            this.applyAreaColorToMap(this.getAreaColor(isEditing ? index : this.areas.length));
            this.updateMapSources();
            this.updateDrawState();
            if (isEditing) this.focusPolygon();
            else {
                this.focusRestaurant();
                if (this.map) this.startDrawing();
            }
        };
        this.initializeMap = async ()=>{
            var _this_areasSection, _this_areasSection1;
            if (this.map) return;
            const mapContainer = document.querySelector("[data-delivery-area-map]");
            if (!mapContainer) return;
            const maplibreModule = await (parcelRequire("bUxFU"));
            var _maplibreModule_default;
            this.maplibre = (_maplibreModule_default = maplibreModule.default) !== null && _maplibreModule_default !== void 0 ? _maplibreModule_default : maplibreModule;
            var _this_areasSection_dataset_centerLatitude;
            const centerLatitude = parseFloat((_this_areasSection_dataset_centerLatitude = (_this_areasSection = this.areasSection) === null || _this_areasSection === void 0 ? void 0 : _this_areasSection.dataset.centerLatitude) !== null && _this_areasSection_dataset_centerLatitude !== void 0 ? _this_areasSection_dataset_centerLatitude : "");
            var _this_areasSection_dataset_centerLongitude;
            const centerLongitude = parseFloat((_this_areasSection_dataset_centerLongitude = (_this_areasSection1 = this.areasSection) === null || _this_areasSection1 === void 0 ? void 0 : _this_areasSection1.dataset.centerLongitude) !== null && _this_areasSection_dataset_centerLongitude !== void 0 ? _this_areasSection_dataset_centerLongitude : "");
            const hasCenter = Number.isFinite(centerLatitude) && Number.isFinite(centerLongitude);
            this.map = new this.maplibre.Map({
                container: mapContainer,
                style: mapContainer.dataset.mapStyle || $da9f2f80f7f34750$export$4f4ee9834b214a1e.DEFAULT_MAP_STYLE_URL,
                center: hasCenter ? [
                    centerLongitude,
                    centerLatitude
                ] : [
                    0,
                    20
                ],
                zoom: hasCenter ? $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_ZOOM : $da9f2f80f7f34750$export$4f4ee9834b214a1e.WORLD_ZOOM
            });
            this.map.addControl(new this.maplibre.NavigationControl());
            if (hasCenter) {
                this.restaurantLocation = [
                    centerLongitude,
                    centerLatitude
                ];
                new this.maplibre.Marker({
                    color: $da9f2f80f7f34750$export$4f4ee9834b214a1e.RESTAURANT_MARKER_COLOR
                }).setLngLat(this.restaurantLocation).addTo(this.map);
            }
            await new Promise((resolve)=>this.map.on("load", resolve));
            const emptyGeoJson = {
                type: "FeatureCollection",
                features: []
            };
            this.map.addSource("delivery-area", {
                type: "geojson",
                data: emptyGeoJson
            });
            this.map.addSource("delivery-area-draft", {
                type: "geojson",
                data: emptyGeoJson
            });
            this.map.addLayer({
                id: "delivery-area-fill",
                type: "fill",
                source: "delivery-area",
                paint: {
                    "fill-color": $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS[0],
                    "fill-opacity": $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_FILL_OPACITY
                }
            });
            this.map.addLayer({
                id: "delivery-area-outline",
                type: "line",
                source: "delivery-area",
                paint: {
                    "line-color": $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS[0],
                    "line-width": 2
                }
            });
            this.map.addLayer({
                id: "delivery-area-draft-line",
                type: "line",
                source: "delivery-area-draft",
                filter: [
                    "==",
                    "$type",
                    "LineString"
                ],
                paint: {
                    "line-color": $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS[0],
                    "line-width": 2,
                    "line-dasharray": [
                        2,
                        1
                    ]
                }
            });
            this.map.addLayer({
                id: "delivery-area-draft-points",
                type: "circle",
                source: "delivery-area-draft",
                filter: [
                    "==",
                    "$type",
                    "Point"
                ],
                paint: {
                    "circle-radius": 5,
                    "circle-color": "#ffffff",
                    "circle-stroke-color": $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS[0],
                    "circle-stroke-width": 2
                }
            });
            this.map.on("click", this.onMapClick);
            this.map.resize();
        };
        this.onMapClick = (event)=>{
            if (!this.isDrawing) return;
            const clickedPoint = [
                event.lngLat.lng,
                event.lngLat.lat
            ];
            if (this.draftPoints.length >= $da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS) {
                const firstPointPixels = this.map.project(this.draftPoints[0]);
                const distancePixels = Math.hypot(firstPointPixels.x - event.point.x, firstPointPixels.y - event.point.y);
                if (distancePixels <= $da9f2f80f7f34750$export$4f4ee9834b214a1e.CLOSE_POLYGON_THRESHOLD_PX) {
                    this.finishDrawing();
                    return;
                }
            }
            this.draftPoints.push(clickedPoint);
            this.updateMapSources();
        };
        this.startDrawing = ()=>{
            var _document_querySelector;
            this.isDrawing = true;
            this.draftPoints = [];
            this.polygonPoints = [];
            this.map.getCanvas().style.cursor = "crosshair";
            (_document_querySelector = document.querySelector("[data-delivery-area-hint]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("d-none");
            this.updateMapSources();
            this.updateDrawState();
        };
        this.finishDrawing = ()=>{
            var _document_querySelector;
            this.polygonPoints = this.draftPoints;
            this.draftPoints = [];
            this.isDrawing = false;
            this.map.getCanvas().style.cursor = "";
            (_document_querySelector = document.querySelector("[data-delivery-area-hint]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("d-none");
            this.updateMapSources();
            this.updateDrawState();
        };
        this.updateMapSources = ()=>{
            var _this_map;
            if (!((_this_map = this.map) === null || _this_map === void 0 ? void 0 : _this_map.getSource("delivery-area"))) return;
            const polygonFeatures = this.polygonPoints.length >= $da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS ? [
                {
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            [
                                ...this.polygonPoints,
                                this.polygonPoints[0]
                            ]
                        ]
                    }
                }
            ] : [];
            this.map.getSource("delivery-area").setData({
                type: "FeatureCollection",
                features: polygonFeatures
            });
            const draftFeatures = this.draftPoints.map((point)=>({
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "Point",
                        coordinates: point
                    }
                }));
            if (this.draftPoints.length >= 2) draftFeatures.push({
                type: "Feature",
                properties: {},
                geometry: {
                    type: "LineString",
                    coordinates: this.draftPoints
                }
            });
            this.map.getSource("delivery-area-draft").setData({
                type: "FeatureCollection",
                features: draftFeatures
            });
        };
        this.focusPolygon = ()=>{
            if (!this.map || this.polygonPoints.length < $da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS) return;
            const bounds = new this.maplibre.LngLatBounds(this.polygonPoints[0], this.polygonPoints[0]);
            for (const point of this.polygonPoints)bounds.extend(point);
            this.map.fitBounds(bounds, {
                padding: $da9f2f80f7f34750$export$4f4ee9834b214a1e.FIT_BOUNDS_PADDING_PX,
                animate: false
            });
        };
        this.focusRestaurant = ()=>{
            if (!this.map || !this.restaurantLocation) return;
            this.map.jumpTo({
                center: this.restaurantLocation,
                zoom: $da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_ZOOM
            });
        };
        this.applyAreaColorToMap = (color)=>{
            if (!this.map) return;
            this.map.setPaintProperty("delivery-area-fill", "fill-color", color);
            this.map.setPaintProperty("delivery-area-outline", "line-color", color);
            this.map.setPaintProperty("delivery-area-draft-line", "line-color", color);
            this.map.setPaintProperty("delivery-area-draft-points", "circle-stroke-color", color);
        };
        this.updateDrawState = ()=>{
            const stateElement = document.querySelector("[data-delivery-area-state]");
            const saveButton = document.querySelector("[data-delivery-area-save]");
            const hasPolygon = this.polygonPoints.length >= $da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS;
            if (stateElement) stateElement.innerHTML = hasPolygon ? `<i class="bi bi-check-circle-fill text-success me-1"></i>${this.t("Area drawn")}` : `<i class="bi bi-info-circle me-1"></i>${this.t("Draw an area to continue")}`;
            if (saveButton) saveButton.disabled = !hasPolygon;
        };
        this.saveArea = ()=>{
            var _nameInput_value, _this_areaModal;
            if (this.polygonPoints.length < $da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS) return;
            const nameInput = document.querySelector("[data-delivery-area-name]");
            const costInput = document.querySelector("[data-delivery-area-cost]");
            var _nameInput_value_trim, _costInput_value;
            const area = {
                name: (_nameInput_value_trim = nameInput === null || nameInput === void 0 ? void 0 : (_nameInput_value = nameInput.value) === null || _nameInput_value === void 0 ? void 0 : _nameInput_value.trim()) !== null && _nameInput_value_trim !== void 0 ? _nameInput_value_trim : "",
                deliveryCost: Math.max(0, parseFloat((_costInput_value = costInput === null || costInput === void 0 ? void 0 : costInput.value) !== null && _costInput_value !== void 0 ? _costInput_value : "") || 0),
                polygon: this.polygonPoints.map(([lng, lat])=>[
                        lat,
                        lng
                    ])
            };
            if (this.editIndex > -1) this.areas[this.editIndex] = area;
            else this.areas.push(area);
            this.syncAreasInput();
            this.renderAreas();
            (_this_areaModal = this.areaModal) === null || _this_areaModal === void 0 ? void 0 : _this_areaModal.hide();
        };
    }
}
$da9f2f80f7f34750$export$4f4ee9834b214a1e.TRANSLATION_ID = "PanelDeliveryOptions";
$da9f2f80f7f34750$export$4f4ee9834b214a1e.DEFAULT_MAP_STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";
$da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_COLORS = [
    "#f26125",
    "#1f7fb8",
    "#1c7e1f",
    "#c8a24a",
    "#6f42c1",
    "#e83e8c"
];
$da9f2f80f7f34750$export$4f4ee9834b214a1e.RESTAURANT_MARKER_COLOR = "#f26125";
$da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_FILL_OPACITY = 0.18;
$da9f2f80f7f34750$export$4f4ee9834b214a1e.MIN_POLYGON_POINTS = 3;
$da9f2f80f7f34750$export$4f4ee9834b214a1e.CLOSE_POLYGON_THRESHOLD_PX = 14;
$da9f2f80f7f34750$export$4f4ee9834b214a1e.AREA_ZOOM = 12;
$da9f2f80f7f34750$export$4f4ee9834b214a1e.WORLD_ZOOM = 1;
$da9f2f80f7f34750$export$4f4ee9834b214a1e.FIT_BOUNDS_PADDING_PX = 40;


class $1018f4a3afef5808$export$4d39be767278cf3e {
    constructor(){
        this.countrySelect = null;
        this.stateSelect = null;
        this.wasUsaBefore = false;
        this.getPageId = ()=>"publish-panel";
        this.execute = ()=>{
            var _this_countrySelect, _this_countrySelect1;
            const invoiceForm = document.getElementById("invoice-form");
            this.countrySelect = invoiceForm === null || invoiceForm === void 0 ? void 0 : invoiceForm.querySelector('select[name="country"]');
            this.stateSelect = invoiceForm === null || invoiceForm === void 0 ? void 0 : invoiceForm.querySelector('select[name="state"]');
            this.wasUsaBefore = ((_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value) === "US";
            this.setupStateSelect();
            (_this_countrySelect1 = this.countrySelect) === null || _this_countrySelect1 === void 0 ? void 0 : _this_countrySelect1.addEventListener("change", ()=>{
                this.setupStateSelect();
            });
        };
        this.setupStateSelect = ()=>{
            var _this_countrySelect;
            const selectedCountryCode = (_this_countrySelect = this.countrySelect) === null || _this_countrySelect === void 0 ? void 0 : _this_countrySelect.value;
            const isUsaNow = selectedCountryCode === "US";
            if (isUsaNow) {
                var _this_stateSelect_parentElement_classList, _this_stateSelect_parentElement, _this_stateSelect;
                if (!this.wasUsaBefore) {
                    this.stateSelect.value = "";
                    this.stateSelect.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
                (_this_stateSelect = this.stateSelect) === null || _this_stateSelect === void 0 ? void 0 : (_this_stateSelect_parentElement = _this_stateSelect.parentElement) === null || _this_stateSelect_parentElement === void 0 ? void 0 : (_this_stateSelect_parentElement_classList = _this_stateSelect_parentElement.classList) === null || _this_stateSelect_parentElement_classList === void 0 ? void 0 : _this_stateSelect_parentElement_classList.remove("d-none");
            } else {
                var _this_stateSelect_parentElement_classList1, _this_stateSelect_parentElement1, _this_stateSelect1;
                (_this_stateSelect1 = this.stateSelect) === null || _this_stateSelect1 === void 0 ? void 0 : (_this_stateSelect_parentElement1 = _this_stateSelect1.parentElement) === null || _this_stateSelect_parentElement1 === void 0 ? void 0 : (_this_stateSelect_parentElement_classList1 = _this_stateSelect_parentElement1.classList) === null || _this_stateSelect_parentElement_classList1 === void 0 ? void 0 : _this_stateSelect_parentElement_classList1.add("d-none");
                if (this.stateSelect) this.stateSelect.value = "WY" // Select any valid option, it won't get saved anyway
                ;
            }
            this.wasUsaBefore = isUsaNow;
        };
        this.onPageClose = ()=>{};
    }
}


class $c44d3dba511247a0$export$5dfad489588434f3 {
    constructor(){
        this.reloadTimer = null;
        this.getPageId = ()=>"activated-panel";
        this.execute = (pjax)=>{
            this.pjax = pjax;
            const panelEl = document.querySelector("[data-activated-panel]");
            if (!panelEl) return;
            const loadNumber = this.getLoadNumber();
            this.revealSupportIfStalled(panelEl, loadNumber);
            this.scheduleReload(loadNumber);
        };
        this.getLoadNumber = ()=>{
            const params = new URLSearchParams(window.location.search);
            var _params_get;
            return parseInt((_params_get = params.get($c44d3dba511247a0$export$5dfad489588434f3.ATTEMPT_PARAM)) !== null && _params_get !== void 0 ? _params_get : String($c44d3dba511247a0$export$5dfad489588434f3.FIRST_LOAD), 10);
        };
        this.revealSupportIfStalled = (panelEl, loadNumber)=>{
            const reloadsSoFar = loadNumber - $c44d3dba511247a0$export$5dfad489588434f3.FIRST_LOAD;
            if (reloadsSoFar >= $c44d3dba511247a0$export$5dfad489588434f3.RELOADS_BEFORE_SUPPORT) {
                const supportEl = panelEl.querySelector("[data-activated-support]");
                supportEl === null || supportEl === void 0 ? void 0 : supportEl.classList.remove("d-none");
            }
        };
        this.scheduleReload = (loadNumber)=>{
            this.reloadTimer = window.setTimeout(()=>{
                const url = new URL(window.location.href);
                url.searchParams.set($c44d3dba511247a0$export$5dfad489588434f3.ATTEMPT_PARAM, String(loadNumber + 1));
                this.pjax.loadUrl(url.pathname + url.search);
            }, $c44d3dba511247a0$export$5dfad489588434f3.REFRESH_INTERVAL_MS);
        };
        this.onPageClose = ()=>{
            if (this.reloadTimer !== null) {
                window.clearTimeout(this.reloadTimer);
                this.reloadTimer = null;
            }
        };
    }
}
$c44d3dba511247a0$export$5dfad489588434f3.REFRESH_INTERVAL_MS = 5000;
$c44d3dba511247a0$export$5dfad489588434f3.RELOADS_BEFORE_SUPPORT = 3;
$c44d3dba511247a0$export$5dfad489588434f3.ATTEMPT_PARAM = "attempt";
$c44d3dba511247a0$export$5dfad489588434f3.FIRST_LOAD = 1;






var $f0ffcdf5c347f6b9$export$9e3c356f6d97643f;
(function(AppRole) {
    AppRole["Visitor"] = "Visitor";
})($f0ffcdf5c347f6b9$export$9e3c356f6d97643f || ($f0ffcdf5c347f6b9$export$9e3c356f6d97643f = {}));
var $f0ffcdf5c347f6b9$export$1386bc4d8d71ebec;
(function(ProfessionType) {
    ProfessionType["Developer"] = "Developer";
    ProfessionType["Designer"] = "Designer";
    ProfessionType["Translator"] = "Translator";
    ProfessionType["Tester"] = "Tester";
    ProfessionType["Other"] = "Other";
})($f0ffcdf5c347f6b9$export$1386bc4d8d71ebec || ($f0ffcdf5c347f6b9$export$1386bc4d8d71ebec = {}));
var $f0ffcdf5c347f6b9$export$999f810846f9d31d;
(function(PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["Canceled"] = "Canceled";
})($f0ffcdf5c347f6b9$export$999f810846f9d31d || ($f0ffcdf5c347f6b9$export$999f810846f9d31d = {}));
var $f0ffcdf5c347f6b9$export$439d2d6c03747598;
(function(PaymentType) {
    PaymentType["OneTime"] = "OneTime";
    PaymentType["Recurring"] = "Recurring";
})($f0ffcdf5c347f6b9$export$439d2d6c03747598 || ($f0ffcdf5c347f6b9$export$439d2d6c03747598 = {}));
var $f0ffcdf5c347f6b9$export$c9f880587597a98;
(function(ClientStatus) {
    ClientStatus["Live"] = "Live";
})($f0ffcdf5c347f6b9$export$c9f880587597a98 || ($f0ffcdf5c347f6b9$export$c9f880587597a98 = {}));
var $f0ffcdf5c347f6b9$export$16981152cbf68a9b;
(function(SetupStatus) {
    SetupStatus["SelectPlan"] = "selectPlan";
    SetupStatus["OpeningHours"] = "openingHours";
    SetupStatus["DeliveryOptions"] = "deliveryOptions";
    SetupStatus["MenuSetup"] = "menuSetup";
    SetupStatus["TeamInvite"] = "teamInvite";
    SetupStatus["Publish"] = "publish";
    SetupStatus["Live"] = "Live";
})($f0ffcdf5c347f6b9$export$16981152cbf68a9b || ($f0ffcdf5c347f6b9$export$16981152cbf68a9b = {}));
var $f0ffcdf5c347f6b9$export$91759cc98505c3c8;
(function(SubscriptionInterval) {
    SubscriptionInterval["Week"] = "week";
    SubscriptionInterval["Month"] = "month";
    SubscriptionInterval["Year"] = "year";
})($f0ffcdf5c347f6b9$export$91759cc98505c3c8 || ($f0ffcdf5c347f6b9$export$91759cc98505c3c8 = {}));
var $f0ffcdf5c347f6b9$export$4b89a5159a986d4;
(function(SubscriptionStatus) {
    SubscriptionStatus["Pending"] = "Pending";
    SubscriptionStatus["Active"] = "Active";
    SubscriptionStatus["NotPaid"] = "NotPaid";
    SubscriptionStatus["Ended"] = "Ended";
})($f0ffcdf5c347f6b9$export$4b89a5159a986d4 || ($f0ffcdf5c347f6b9$export$4b89a5159a986d4 = {}));
var $f0ffcdf5c347f6b9$export$3e2662c8515ffb10;
(function(LicenseType) {
    LicenseType["Starter"] = "starter";
    LicenseType["Basic"] = "basic";
    LicenseType["Business"] = "business";
})($f0ffcdf5c347f6b9$export$3e2662c8515ffb10 || ($f0ffcdf5c347f6b9$export$3e2662c8515ffb10 = {}));
var $f0ffcdf5c347f6b9$export$917a0a970d86a2f4;
(function(FoodOrderDeliveryType) {
    FoodOrderDeliveryType["Delivery"] = "delivery";
    FoodOrderDeliveryType["PickUp"] = "pickUp";
    FoodOrderDeliveryType["Table"] = "table";
})($f0ffcdf5c347f6b9$export$917a0a970d86a2f4 || ($f0ffcdf5c347f6b9$export$917a0a970d86a2f4 = {}));
var $f0ffcdf5c347f6b9$export$39cf77305ce6ffd2;
(function(EatInPlaceType) {
    EatInPlaceType["Counter"] = "counter";
    EatInPlaceType["Table"] = "table";
    EatInPlaceType["Room"] = "room";
    EatInPlaceType["ParkingSpot"] = "parkingSpot";
})($f0ffcdf5c347f6b9$export$39cf77305ce6ffd2 || ($f0ffcdf5c347f6b9$export$39cf77305ce6ffd2 = {}));
var $f0ffcdf5c347f6b9$export$7cc899d74e71bd80;
(function(StorePageType) {
    StorePageType["Main"] = "main";
    StorePageType["Contact"] = "contact";
    StorePageType["Custom"] = "custom";
})($f0ffcdf5c347f6b9$export$7cc899d74e71bd80 || ($f0ffcdf5c347f6b9$export$7cc899d74e71bd80 = {}));
var $f0ffcdf5c347f6b9$export$a691f97523943f98;
(function(UserStoreRole) {
    UserStoreRole["Owner"] = "Owner";
    UserStoreRole["Employee"] = "Employee";
})($f0ffcdf5c347f6b9$export$a691f97523943f98 || ($f0ffcdf5c347f6b9$export$a691f97523943f98 = {}));
var $f0ffcdf5c347f6b9$export$261ee49921a64ba1;
(function(FoodOrderStatus) {
    FoodOrderStatus["Pending"] = "pending";
    FoodOrderStatus["Accepted"] = "accepted";
    FoodOrderStatus["Rejected"] = "rejected";
    FoodOrderStatus["Done"] = "done";
})($f0ffcdf5c347f6b9$export$261ee49921a64ba1 || ($f0ffcdf5c347f6b9$export$261ee49921a64ba1 = {}));
var $f0ffcdf5c347f6b9$export$34b52ce9cfcb0a39;
(function(PaymentMethod) {
    PaymentMethod["Cash"] = "cash";
    PaymentMethod["Card"] = "card";
    PaymentMethod["Blik"] = "blik";
    PaymentMethod["Online"] = "online";
})($f0ffcdf5c347f6b9$export$34b52ce9cfcb0a39 || ($f0ffcdf5c347f6b9$export$34b52ce9cfcb0a39 = {}));
var $f0ffcdf5c347f6b9$export$77de14a781ca4626;
(function(RefundFailureReason) {
    RefundFailureReason["InsufficientFunds"] = "insufficientFunds";
    RefundFailureReason["Unknown"] = "unknown";
})($f0ffcdf5c347f6b9$export$77de14a781ca4626 || ($f0ffcdf5c347f6b9$export$77de14a781ca4626 = {}));
var $f0ffcdf5c347f6b9$export$3a5700ebb40e6b98;
(function(FoodOrderPaymentStatus) {
    FoodOrderPaymentStatus["NotRequired"] = "notRequired";
    FoodOrderPaymentStatus["Pending"] = "pending";
    FoodOrderPaymentStatus["Paid"] = "paid";
    FoodOrderPaymentStatus["Failed"] = "failed";
    FoodOrderPaymentStatus["Refunded"] = "refunded";
})($f0ffcdf5c347f6b9$export$3a5700ebb40e6b98 || ($f0ffcdf5c347f6b9$export$3a5700ebb40e6b98 = {}));
var $f0ffcdf5c347f6b9$export$53cea11cbac66584;
(function(BlogLanguage) {
    BlogLanguage["English"] = "en";
    BlogLanguage["Spanish"] = "es";
    BlogLanguage["Polish"] = "pl";
})($f0ffcdf5c347f6b9$export$53cea11cbac66584 || ($f0ffcdf5c347f6b9$export$53cea11cbac66584 = {}));


// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved
const $fcfba78c953af7c1$export$6d3c090e66a883b1 = ()=>undefined;



/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $f7a5b7f58ca24e89$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $f7a5b7f58ca24e89$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $f7a5b7f58ca24e89$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $f7a5b7f58ca24e89$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $f7a5b7f58ca24e89$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f7a5b7f58ca24e89$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $f7a5b7f58ca24e89$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $f7a5b7f58ca24e89$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($f7a5b7f58ca24e89$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $f7a5b7f58ca24e89$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $f7a5b7f58ca24e89$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $f7a5b7f58ca24e89$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $f7a5b7f58ca24e89$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $f7a5b7f58ca24e89$var$stringToByteArray$1(str);
    return $f7a5b7f58ca24e89$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $f7a5b7f58ca24e89$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $f7a5b7f58ca24e89$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $f7a5b7f58ca24e89$export$c62426fdd000a97e = function(str) {
    try {
        return $f7a5b7f58ca24e89$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $f7a5b7f58ca24e89$export$6c40052bed430212(value) {
    return $f7a5b7f58ca24e89$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $f7a5b7f58ca24e89$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$f7a5b7f58ca24e89$var$isValidKey(prop)) continue;
        target[prop] = $f7a5b7f58ca24e89$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $f7a5b7f58ca24e89$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $f7a5b7f58ca24e89$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f7a5b7f58ca24e89$var$getDefaultsFromGlobal = ()=>$f7a5b7f58ca24e89$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $f7a5b7f58ca24e89$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $4f2b320d6577794c$exports === "undefined" || typeof $4f2b320d6577794c$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $f7a5b7f58ca24e89$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $f7a5b7f58ca24e89$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $f7a5b7f58ca24e89$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $fcfba78c953af7c1$export$6d3c090e66a883b1)() || $f7a5b7f58ca24e89$var$getDefaultsFromGlobal() || $f7a5b7f58ca24e89$var$getDefaultsFromEnvVariable() || $f7a5b7f58ca24e89$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $f7a5b7f58ca24e89$export$9c11895284c8adad = (productName)=>{
    var _getDefaults_emulatorHosts, _getDefaults;
    return (_getDefaults = $f7a5b7f58ca24e89$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : (_getDefaults_emulatorHosts = _getDefaults.emulatorHosts) === null || _getDefaults_emulatorHosts === void 0 ? void 0 : _getDefaults_emulatorHosts[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $f7a5b7f58ca24e89$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $f7a5b7f58ca24e89$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $f7a5b7f58ca24e89$export$3dfb6827a9f89756 = ()=>{
    var _getDefaults;
    return (_getDefaults = $f7a5b7f58ca24e89$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $f7a5b7f58ca24e89$export$5539a1a3afe87d6 = (name)=>{
    var _getDefaults;
    return (_getDefaults = $f7a5b7f58ca24e89$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $f7a5b7f58ca24e89$export$85f6557964517f1a {
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f7a5b7f58ca24e89$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $f7a5b7f58ca24e89$export$4b5284a3025a455(JSON.stringify(header)),
        $f7a5b7f58ca24e89$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $f7a5b7f58ca24e89$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $f7a5b7f58ca24e89$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($f7a5b7f58ca24e89$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $f7a5b7f58ca24e89$export$8ee0fc9ee280b4ee() {
    var _getDefaults;
    const forceEnvironment = (_getDefaults = $f7a5b7f58ca24e89$export$212bb2fc580a90a8()) === null || _getDefaults === void 0 ? void 0 : _getDefaults.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $f7a5b7f58ca24e89$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $f7a5b7f58ca24e89$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $f7a5b7f58ca24e89$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $f7a5b7f58ca24e89$export$ad9e9b75cb9fb797() {
    return typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers";
}
function $f7a5b7f58ca24e89$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $f7a5b7f58ca24e89$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $f7a5b7f58ca24e89$export$f2f6a8999f8ebd30() {
    return $f7a5b7f58ca24e89$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $f7a5b7f58ca24e89$export$7e7b1a9668aaed8() {
    const ua = $f7a5b7f58ca24e89$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $f7a5b7f58ca24e89$export$202944b2d2824246() {
    return $f7a5b7f58ca24e89$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $f7a5b7f58ca24e89$export$5d1d834fbbf8bab7() {
    return $f7a5b7f58ca24e89$export$588c7fdda06fbb0a.NODE_CLIENT === true || $f7a5b7f58ca24e89$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $f7a5b7f58ca24e89$export$95df08bae54cb4df() {
    return !$f7a5b7f58ca24e89$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/** Returns true if we are running in Safari or WebKit */ function $f7a5b7f58ca24e89$export$ef10bcfb06572016() {
    return !$f7a5b7f58ca24e89$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes("Safari") || navigator.userAgent.includes("WebKit")) && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $f7a5b7f58ca24e89$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $f7a5b7f58ca24e89$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _request_error;
                reject(((_request_error = request.error) === null || _request_error === void 0 ? void 0 : _request_error.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $f7a5b7f58ca24e89$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $f7a5b7f58ca24e89$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $f7a5b7f58ca24e89$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $f7a5b7f58ca24e89$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $f7a5b7f58ca24e89$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f7a5b7f58ca24e89$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $f7a5b7f58ca24e89$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $f7a5b7f58ca24e89$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $f7a5b7f58ca24e89$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $f7a5b7f58ca24e89$var$replaceTemplate(template, data) {
    return template.replace($f7a5b7f58ca24e89$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $f7a5b7f58ca24e89$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $f7a5b7f58ca24e89$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $f7a5b7f58ca24e89$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f7a5b7f58ca24e89$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $f7a5b7f58ca24e89$export$c5a53ce6a17cf18d($f7a5b7f58ca24e89$export$c62426fdd000a97e(parts[0]) || "");
        claims = $f7a5b7f58ca24e89$export$c5a53ce6a17cf18d($f7a5b7f58ca24e89$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f7a5b7f58ca24e89$export$5f870fcca7ae6a88 = function(token) {
    const claims = $f7a5b7f58ca24e89$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f7a5b7f58ca24e89$export$701c661ec91095f2 = function(token) {
    const claims = $f7a5b7f58ca24e89$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f7a5b7f58ca24e89$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $f7a5b7f58ca24e89$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $f7a5b7f58ca24e89$export$fc970ed23da99565 = function(token) {
    const claims = $f7a5b7f58ca24e89$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f7a5b7f58ca24e89$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $f7a5b7f58ca24e89$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $f7a5b7f58ca24e89$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $f7a5b7f58ca24e89$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $f7a5b7f58ca24e89$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($f7a5b7f58ca24e89$var$isObject(aProp) && $f7a5b7f58ca24e89$var$isObject(bProp)) {
            if (!$f7a5b7f58ca24e89$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $f7a5b7f58ca24e89$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $f7a5b7f58ca24e89$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $f7a5b7f58ca24e89$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $f7a5b7f58ca24e89$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $f7a5b7f58ca24e89$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $f7a5b7f58ca24e89$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $f7a5b7f58ca24e89$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $f7a5b7f58ca24e89$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $f7a5b7f58ca24e89$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $f7a5b7f58ca24e89$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($f7a5b7f58ca24e89$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $f7a5b7f58ca24e89$var$noop;
        if (observer.error === undefined) observer.error = $f7a5b7f58ca24e89$var$noop;
        if (observer.complete === undefined) observer.complete = $f7a5b7f58ca24e89$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f7a5b7f58ca24e89$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $f7a5b7f58ca24e89$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $f7a5b7f58ca24e89$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $f7a5b7f58ca24e89$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $f7a5b7f58ca24e89$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $f7a5b7f58ca24e89$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($f7a5b7f58ca24e89$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $f7a5b7f58ca24e89$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($f7a5b7f58ca24e89$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $f7a5b7f58ca24e89$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($f7a5b7f58ca24e89$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $f7a5b7f58ca24e89$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $f7a5b7f58ca24e89$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $f7a5b7f58ca24e89$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $f7a5b7f58ca24e89$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $f7a5b7f58ca24e89$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $f7a5b7f58ca24e89$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $f7a5b7f58ca24e89$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $f7a5b7f58ca24e89$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $f7a5b7f58ca24e89$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $f7a5b7f58ca24e89$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $f7a5b7f58ca24e89$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($f7a5b7f58ca24e89$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $f7a5b7f58ca24e89$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $f7a5b7f58ca24e89$var$indicator(i);
}
function $f7a5b7f58ca24e89$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f7a5b7f58ca24e89$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $f7a5b7f58ca24e89$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith("http://") || url.startsWith("https://") ? new URL(url).hostname : url;
        return host.endsWith(".cloudworkstations.dev");
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $f7a5b7f58ca24e89$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: "include"
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $f7a5b7f58ca24e89$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
    return hexHash;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $18c346d4e76738d6$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $18c346d4e76738d6$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $f7a5b7f58ca24e89$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        var _options_optional;
        const optional = (_options_optional = options === null || options === void 0 ? void 0 : options.optional) !== null && _options_optional !== void 0 ? _options_optional : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($18c346d4e76738d6$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        var _this_onInitCallbacks_get;
        const existingCallbacks = (_this_onInitCallbacks_get = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _this_onInitCallbacks_get !== void 0 ? _this_onInitCallbacks_get : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $18c346d4e76738d6$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $18c346d4e76738d6$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $18c346d4e76738d6$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $18c346d4e76738d6$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $18c346d4e76738d6$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $18c346d4e76738d6$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $3cc646e7ca1c27cd$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $3cc646e7ca1c27cd$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($3cc646e7ca1c27cd$export$243e62d78d3b544d || ($3cc646e7ca1c27cd$export$243e62d78d3b544d = {}));
const $3cc646e7ca1c27cd$var$levelStringToEnum = {
    "debug": $3cc646e7ca1c27cd$export$243e62d78d3b544d.DEBUG,
    "verbose": $3cc646e7ca1c27cd$export$243e62d78d3b544d.VERBOSE,
    "info": $3cc646e7ca1c27cd$export$243e62d78d3b544d.INFO,
    "warn": $3cc646e7ca1c27cd$export$243e62d78d3b544d.WARN,
    "error": $3cc646e7ca1c27cd$export$243e62d78d3b544d.ERROR,
    "silent": $3cc646e7ca1c27cd$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $3cc646e7ca1c27cd$var$defaultLogLevel = $3cc646e7ca1c27cd$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $3cc646e7ca1c27cd$var$ConsoleMethod = {
    [$3cc646e7ca1c27cd$export$243e62d78d3b544d.DEBUG]: "log",
    [$3cc646e7ca1c27cd$export$243e62d78d3b544d.VERBOSE]: "log",
    [$3cc646e7ca1c27cd$export$243e62d78d3b544d.INFO]: "info",
    [$3cc646e7ca1c27cd$export$243e62d78d3b544d.WARN]: "warn",
    [$3cc646e7ca1c27cd$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $3cc646e7ca1c27cd$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $3cc646e7ca1c27cd$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $3cc646e7ca1c27cd$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $3cc646e7ca1c27cd$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $3cc646e7ca1c27cd$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $3cc646e7ca1c27cd$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $3cc646e7ca1c27cd$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $3cc646e7ca1c27cd$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $3cc646e7ca1c27cd$var$instances.push(this);
    }
}
function $3cc646e7ca1c27cd$export$c622e99c0ce7b1c9(level) {
    $3cc646e7ca1c27cd$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $3cc646e7ca1c27cd$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $3cc646e7ca1c27cd$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $3cc646e7ca1c27cd$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $3cc646e7ca1c27cd$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $b4c19d3700b9ac49$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b4c19d3700b9ac49$var$idbProxyableTypes;
let $b4c19d3700b9ac49$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b4c19d3700b9ac49$var$getIdbProxyableTypes() {
    return $b4c19d3700b9ac49$var$idbProxyableTypes || ($b4c19d3700b9ac49$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b4c19d3700b9ac49$var$getCursorAdvanceMethods() {
    return $b4c19d3700b9ac49$var$cursorAdvanceMethods || ($b4c19d3700b9ac49$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b4c19d3700b9ac49$var$cursorRequestMap = new WeakMap();
const $b4c19d3700b9ac49$var$transactionDoneMap = new WeakMap();
const $b4c19d3700b9ac49$var$transactionStoreNamesMap = new WeakMap();
const $b4c19d3700b9ac49$var$transformCache = new WeakMap();
const $b4c19d3700b9ac49$export$407448d2b89b1813 = new WeakMap();
function $b4c19d3700b9ac49$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($b4c19d3700b9ac49$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $b4c19d3700b9ac49$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b4c19d3700b9ac49$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $b4c19d3700b9ac49$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b4c19d3700b9ac49$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $b4c19d3700b9ac49$var$transactionDoneMap.set(tx, done);
}
let $b4c19d3700b9ac49$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $b4c19d3700b9ac49$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $b4c19d3700b9ac49$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b4c19d3700b9ac49$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $b4c19d3700b9ac49$export$43caf9889c228507(callback) {
    $b4c19d3700b9ac49$var$idbProxyTraps = callback($b4c19d3700b9ac49$var$idbProxyTraps);
}
function $b4c19d3700b9ac49$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($b4c19d3700b9ac49$export$3b14a55fb2447963(this), storeNames, ...args);
        $b4c19d3700b9ac49$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $b4c19d3700b9ac49$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b4c19d3700b9ac49$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b4c19d3700b9ac49$export$3b14a55fb2447963(this), args);
        return $b4c19d3700b9ac49$export$efccba1c4a2ef57b($b4c19d3700b9ac49$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b4c19d3700b9ac49$export$efccba1c4a2ef57b(func.apply($b4c19d3700b9ac49$export$3b14a55fb2447963(this), args));
    };
}
function $b4c19d3700b9ac49$var$transformCachableValue(value) {
    if (typeof value === "function") return $b4c19d3700b9ac49$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b4c19d3700b9ac49$var$cacheDonePromiseForTransaction(value);
    if ($b4c19d3700b9ac49$export$23f2a1d2818174ef(value, $b4c19d3700b9ac49$var$getIdbProxyableTypes())) return new Proxy(value, $b4c19d3700b9ac49$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b4c19d3700b9ac49$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b4c19d3700b9ac49$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b4c19d3700b9ac49$var$transformCache.has(value)) return $b4c19d3700b9ac49$var$transformCache.get(value);
    const newValue = $b4c19d3700b9ac49$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b4c19d3700b9ac49$var$transformCache.set(value, newValue);
        $b4c19d3700b9ac49$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $b4c19d3700b9ac49$export$3b14a55fb2447963 = (value)=>$b4c19d3700b9ac49$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $91cfbbb1f21a7978$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $b4c19d3700b9ac49$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $b4c19d3700b9ac49$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $b4c19d3700b9ac49$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $91cfbbb1f21a7978$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $b4c19d3700b9ac49$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $91cfbbb1f21a7978$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $91cfbbb1f21a7978$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $91cfbbb1f21a7978$var$cachedMethods = new Map();
function $91cfbbb1f21a7978$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($91cfbbb1f21a7978$var$cachedMethods.get(prop)) return $91cfbbb1f21a7978$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $91cfbbb1f21a7978$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $91cfbbb1f21a7978$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $91cfbbb1f21a7978$var$cachedMethods.set(prop, method);
    return method;
}
(0, $b4c19d3700b9ac49$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$91cfbbb1f21a7978$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$91cfbbb1f21a7978$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $50998f1e63817c97$var$PlatformLoggerServiceImpl {
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($50998f1e63817c97$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
    constructor(container){
        this.container = container;
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $50998f1e63817c97$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $50998f1e63817c97$var$name$q = "@firebase/app";
const $50998f1e63817c97$var$version$1 = "0.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $50998f1e63817c97$var$logger = new (0, $3cc646e7ca1c27cd$export$efa9a398d6368992)("@firebase/app");
const $50998f1e63817c97$var$name$p = "@firebase/app-compat";
const $50998f1e63817c97$var$name$o = "@firebase/analytics-compat";
const $50998f1e63817c97$var$name$n = "@firebase/analytics";
const $50998f1e63817c97$var$name$m = "@firebase/app-check-compat";
const $50998f1e63817c97$var$name$l = "@firebase/app-check";
const $50998f1e63817c97$var$name$k = "@firebase/auth";
const $50998f1e63817c97$var$name$j = "@firebase/auth-compat";
const $50998f1e63817c97$var$name$i = "@firebase/database";
const $50998f1e63817c97$var$name$h = "@firebase/data-connect";
const $50998f1e63817c97$var$name$g = "@firebase/database-compat";
const $50998f1e63817c97$var$name$f = "@firebase/functions";
const $50998f1e63817c97$var$name$e = "@firebase/functions-compat";
const $50998f1e63817c97$var$name$d = "@firebase/installations";
const $50998f1e63817c97$var$name$c = "@firebase/installations-compat";
const $50998f1e63817c97$var$name$b = "@firebase/messaging";
const $50998f1e63817c97$var$name$a = "@firebase/messaging-compat";
const $50998f1e63817c97$var$name$9 = "@firebase/performance";
const $50998f1e63817c97$var$name$8 = "@firebase/performance-compat";
const $50998f1e63817c97$var$name$7 = "@firebase/remote-config";
const $50998f1e63817c97$var$name$6 = "@firebase/remote-config-compat";
const $50998f1e63817c97$var$name$5 = "@firebase/storage";
const $50998f1e63817c97$var$name$4 = "@firebase/storage-compat";
const $50998f1e63817c97$var$name$3 = "@firebase/firestore";
const $50998f1e63817c97$var$name$2 = "@firebase/ai";
const $50998f1e63817c97$var$name$1 = "@firebase/firestore-compat";
const $50998f1e63817c97$var$name = "firebase";
const $50998f1e63817c97$var$version = "12.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $50998f1e63817c97$export$9f30fa0c10967f7f = "[DEFAULT]";
const $50998f1e63817c97$var$PLATFORM_LOG_STRING = {
    [$50998f1e63817c97$var$name$q]: "fire-core",
    [$50998f1e63817c97$var$name$p]: "fire-core-compat",
    [$50998f1e63817c97$var$name$n]: "fire-analytics",
    [$50998f1e63817c97$var$name$o]: "fire-analytics-compat",
    [$50998f1e63817c97$var$name$l]: "fire-app-check",
    [$50998f1e63817c97$var$name$m]: "fire-app-check-compat",
    [$50998f1e63817c97$var$name$k]: "fire-auth",
    [$50998f1e63817c97$var$name$j]: "fire-auth-compat",
    [$50998f1e63817c97$var$name$i]: "fire-rtdb",
    [$50998f1e63817c97$var$name$h]: "fire-data-connect",
    [$50998f1e63817c97$var$name$g]: "fire-rtdb-compat",
    [$50998f1e63817c97$var$name$f]: "fire-fn",
    [$50998f1e63817c97$var$name$e]: "fire-fn-compat",
    [$50998f1e63817c97$var$name$d]: "fire-iid",
    [$50998f1e63817c97$var$name$c]: "fire-iid-compat",
    [$50998f1e63817c97$var$name$b]: "fire-fcm",
    [$50998f1e63817c97$var$name$a]: "fire-fcm-compat",
    [$50998f1e63817c97$var$name$9]: "fire-perf",
    [$50998f1e63817c97$var$name$8]: "fire-perf-compat",
    [$50998f1e63817c97$var$name$7]: "fire-rc",
    [$50998f1e63817c97$var$name$6]: "fire-rc-compat",
    [$50998f1e63817c97$var$name$5]: "fire-gcs",
    [$50998f1e63817c97$var$name$4]: "fire-gcs-compat",
    [$50998f1e63817c97$var$name$3]: "fire-fst",
    [$50998f1e63817c97$var$name$1]: "fire-fst-compat",
    [$50998f1e63817c97$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$50998f1e63817c97$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $50998f1e63817c97$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $50998f1e63817c97$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $50998f1e63817c97$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $50998f1e63817c97$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $50998f1e63817c97$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $50998f1e63817c97$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $50998f1e63817c97$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($50998f1e63817c97$export$9566bce3835c0f28.has(componentName)) {
        $50998f1e63817c97$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $50998f1e63817c97$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $50998f1e63817c97$export$b4e3c36c855b14b5.values())$50998f1e63817c97$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $50998f1e63817c97$export$fb03ad8d3d5c5f76.values())$50998f1e63817c97$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $50998f1e63817c97$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $50998f1e63817c97$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $50998f1e63817c97$export$9f30fa0c10967f7f) {
    $50998f1e63817c97$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $50998f1e63817c97$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $50998f1e63817c97$export$38e311c93c671bec(obj) {
    if ($50998f1e63817c97$export$110778f8e98b8257(obj)) return false;
    return "authIdToken" in obj || "appCheckToken" in obj || "releaseOnDeref" in obj || "automaticDataCollectionEnabled" in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $50998f1e63817c97$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $50998f1e63817c97$export$3685d89b9c3cdfaf() {
    $50998f1e63817c97$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $50998f1e63817c97$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $50998f1e63817c97$var$ERROR_FACTORY = new (0, $f7a5b7f58ca24e89$export$3fa6e1b18a3b2d40)("app", "Firebase", $50998f1e63817c97$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $50998f1e63817c97$var$FirebaseAppImpl {
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $50998f1e63817c97$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $50998f1e63817c97$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $f7a5b7f58ca24e89$export$c62426fdd000a97e)(base64Token.split(".")[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $50998f1e63817c97$var$FirebaseServerAppImpl extends $50998f1e63817c97$var$FirebaseAppImpl {
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $50998f1e63817c97$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $50998f1e63817c97$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $50998f1e63817c97$var$validateTokenTTL(this._serverConfig.authIdToken, "authIdToken");
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $50998f1e63817c97$var$validateTokenTTL(this._serverConfig.appCheckToken, "appCheckToken");
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $50998f1e63817c97$export$d29d5299a7137abc($50998f1e63817c97$var$name$q, $50998f1e63817c97$var$version$1, "serverapp");
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $50998f1e63817c97$export$31499a9cd224b78c = $50998f1e63817c97$var$version;
function $50998f1e63817c97$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $50998f1e63817c97$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== "string" || !name) throw $50998f1e63817c97$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $f7a5b7f58ca24e89$export$3dfb6827a9f89756)());
    if (!options) throw $50998f1e63817c97$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $50998f1e63817c97$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $f7a5b7f58ca24e89$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $f7a5b7f58ca24e89$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $50998f1e63817c97$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $18c346d4e76738d6$export$436a80eea5d5c0c5)(name);
    for (const component of $50998f1e63817c97$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $50998f1e63817c97$var$FirebaseAppImpl(options, config, container);
    $50998f1e63817c97$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $50998f1e63817c97$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $f7a5b7f58ca24e89$export$4e09c449d6c407f7)() && !(0, $f7a5b7f58ca24e89$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $50998f1e63817c97$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($50998f1e63817c97$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($50998f1e63817c97$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $f7a5b7f58ca24e89$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $50998f1e63817c97$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $50998f1e63817c97$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $50998f1e63817c97$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $18c346d4e76738d6$export$436a80eea5d5c0c5)(nameString);
    for (const component of $50998f1e63817c97$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $50998f1e63817c97$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $50998f1e63817c97$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $50998f1e63817c97$export$f9962582c9e66d99(name = $50998f1e63817c97$export$9f30fa0c10967f7f) {
    const app = $50998f1e63817c97$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $50998f1e63817c97$export$9f30fa0c10967f7f && (0, $f7a5b7f58ca24e89$export$3dfb6827a9f89756)()) return $50998f1e63817c97$export$c55cfd413944906d();
    if (!app) throw $50998f1e63817c97$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $50998f1e63817c97$export$68ddedf7d44b3bdf() {
    return Array.from($50998f1e63817c97$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $50998f1e63817c97$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($50998f1e63817c97$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $50998f1e63817c97$export$b4e3c36c855b14b5.delete(name);
    } else if ($50998f1e63817c97$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $50998f1e63817c97$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $50998f1e63817c97$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _PLATFORM_LOG_STRING_libraryKeyOrName;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_PLATFORM_LOG_STRING_libraryKeyOrName = $50998f1e63817c97$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _PLATFORM_LOG_STRING_libraryKeyOrName !== void 0 ? _PLATFORM_LOG_STRING_libraryKeyOrName : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $50998f1e63817c97$var$logger.warn(warning.join(" "));
        return;
    }
    $50998f1e63817c97$export$c930050e7bb63965(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $50998f1e63817c97$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $50998f1e63817c97$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $3cc646e7ca1c27cd$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $50998f1e63817c97$export$c622e99c0ce7b1c9(logLevel) {
    (0, $3cc646e7ca1c27cd$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $50998f1e63817c97$var$DB_NAME = "firebase-heartbeat-database";
const $50998f1e63817c97$var$DB_VERSION = 1;
const $50998f1e63817c97$var$STORE_NAME = "firebase-heartbeat-store";
let $50998f1e63817c97$var$dbPromise = null;
function $50998f1e63817c97$var$getDbPromise() {
    if (!$50998f1e63817c97$var$dbPromise) $50998f1e63817c97$var$dbPromise = (0, $91cfbbb1f21a7978$export$ca0ed41b1a2af7e)($50998f1e63817c97$var$DB_NAME, $50998f1e63817c97$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($50998f1e63817c97$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $50998f1e63817c97$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $50998f1e63817c97$var$dbPromise;
}
async function $50998f1e63817c97$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $50998f1e63817c97$var$getDbPromise();
        const tx = db.transaction($50998f1e63817c97$var$STORE_NAME);
        const result = await tx.objectStore($50998f1e63817c97$var$STORE_NAME).get($50998f1e63817c97$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $f7a5b7f58ca24e89$export$dd24e9cd51226c56)) $50998f1e63817c97$var$logger.warn(e.message);
        else {
            const idbGetError = $50998f1e63817c97$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $50998f1e63817c97$var$logger.warn(idbGetError.message);
        }
    }
}
async function $50998f1e63817c97$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $50998f1e63817c97$var$getDbPromise();
        const tx = db.transaction($50998f1e63817c97$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($50998f1e63817c97$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $50998f1e63817c97$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $f7a5b7f58ca24e89$export$dd24e9cd51226c56)) $50998f1e63817c97$var$logger.warn(e.message);
        else {
            const idbGetError = $50998f1e63817c97$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $50998f1e63817c97$var$logger.warn(idbGetError.message);
        }
    }
}
function $50998f1e63817c97$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $50998f1e63817c97$var$MAX_HEADER_BYTES = 1024;
const $50998f1e63817c97$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $50998f1e63817c97$var$HeartbeatServiceImpl {
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            var _this__heartbeatsCache;
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $50998f1e63817c97$var$getUTCDateString();
            if (((_this__heartbeatsCache = this._heartbeatsCache) === null || _this__heartbeatsCache === void 0 ? void 0 : _this__heartbeatsCache.heartbeats) == null) {
                var _this__heartbeatsCache1;
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_this__heartbeatsCache1 = this._heartbeatsCache) === null || _this__heartbeatsCache1 === void 0 ? void 0 : _this__heartbeatsCache1.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $50998f1e63817c97$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $50998f1e63817c97$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $50998f1e63817c97$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            var _this__heartbeatsCache;
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_this__heartbeatsCache = this._heartbeatsCache) === null || _this__heartbeatsCache === void 0 ? void 0 : _this__heartbeatsCache.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $50998f1e63817c97$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $50998f1e63817c97$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $f7a5b7f58ca24e89$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $50998f1e63817c97$var$logger.warn(e);
            return "";
        }
    }
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $50998f1e63817c97$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
}
function $50998f1e63817c97$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $50998f1e63817c97$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $50998f1e63817c97$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($50998f1e63817c97$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($50998f1e63817c97$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $50998f1e63817c97$var$HeartbeatStorageImpl {
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $f7a5b7f58ca24e89$export$3865db50535c2055)()) return false;
        else return (0, $f7a5b7f58ca24e89$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $50998f1e63817c97$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            var _heartbeatsObject_lastSentHeartbeatDate;
            return $50998f1e63817c97$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_heartbeatsObject_lastSentHeartbeatDate = heartbeatsObject.lastSentHeartbeatDate) !== null && _heartbeatsObject_lastSentHeartbeatDate !== void 0 ? _heartbeatsObject_lastSentHeartbeatDate : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            var _heartbeatsObject_lastSentHeartbeatDate;
            return $50998f1e63817c97$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_heartbeatsObject_lastSentHeartbeatDate = heartbeatsObject.lastSentHeartbeatDate) !== null && _heartbeatsObject_lastSentHeartbeatDate !== void 0 ? _heartbeatsObject_lastSentHeartbeatDate : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $50998f1e63817c97$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $f7a5b7f58ca24e89$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $50998f1e63817c97$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $50998f1e63817c97$var$registerCoreComponents(variant) {
    $50998f1e63817c97$export$c930050e7bb63965(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)("platform-logger", (container)=>new $50998f1e63817c97$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $50998f1e63817c97$export$c930050e7bb63965(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)("heartbeat", (container)=>new $50998f1e63817c97$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $50998f1e63817c97$export$d29d5299a7137abc($50998f1e63817c97$var$name$q, $50998f1e63817c97$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $50998f1e63817c97$export$d29d5299a7137abc($50998f1e63817c97$var$name$q, $50998f1e63817c97$var$version$1, "esm2020");
    // Register platform SDK identifier (no version).
    $50998f1e63817c97$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $50998f1e63817c97$var$registerCoreComponents("");





const $040f18e6b86cd1ff$var$name = "@firebase/installations";
const $040f18e6b86cd1ff$var$version = "0.6.22";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$PENDING_TIMEOUT_MS = 10000;
const $040f18e6b86cd1ff$var$PACKAGE_VERSION = `w:${$040f18e6b86cd1ff$var$version}`;
const $040f18e6b86cd1ff$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $040f18e6b86cd1ff$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $040f18e6b86cd1ff$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $040f18e6b86cd1ff$var$SERVICE = "installations";
const $040f18e6b86cd1ff$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $040f18e6b86cd1ff$var$ERROR_FACTORY = new (0, $f7a5b7f58ca24e89$export$3fa6e1b18a3b2d40)($040f18e6b86cd1ff$var$SERVICE, $040f18e6b86cd1ff$var$SERVICE_NAME, $040f18e6b86cd1ff$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $040f18e6b86cd1ff$var$isServerError(error) {
    return error instanceof (0, $f7a5b7f58ca24e89$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $040f18e6b86cd1ff$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$040f18e6b86cd1ff$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $040f18e6b86cd1ff$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $040f18e6b86cd1ff$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $040f18e6b86cd1ff$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $040f18e6b86cd1ff$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $040f18e6b86cd1ff$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $040f18e6b86cd1ff$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $040f18e6b86cd1ff$var$getHeaders(appConfig);
    headers.append("Authorization", $040f18e6b86cd1ff$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $040f18e6b86cd1ff$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $040f18e6b86cd1ff$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $040f18e6b86cd1ff$var$getAuthorizationHeader(refreshToken) {
    return `${$040f18e6b86cd1ff$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $040f18e6b86cd1ff$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $040f18e6b86cd1ff$var$getInstallationsEndpoint(appConfig);
    const headers = $040f18e6b86cd1ff$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $040f18e6b86cd1ff$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $040f18e6b86cd1ff$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $040f18e6b86cd1ff$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $040f18e6b86cd1ff$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $040f18e6b86cd1ff$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $040f18e6b86cd1ff$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $040f18e6b86cd1ff$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $040f18e6b86cd1ff$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $040f18e6b86cd1ff$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $040f18e6b86cd1ff$var$encode(fidByteArray);
        return $040f18e6b86cd1ff$var$VALID_FID_PATTERN.test(fid) ? fid : $040f18e6b86cd1ff$var$INVALID_FID;
    } catch  {
        // FID generation errored
        return $040f18e6b86cd1ff$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $040f18e6b86cd1ff$var$encode(fidByteArray) {
    const b64String = $040f18e6b86cd1ff$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $040f18e6b86cd1ff$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $040f18e6b86cd1ff$var$fidChanged(appConfig, fid) {
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    $040f18e6b86cd1ff$var$callFidChangeCallbacks(key, fid);
    $040f18e6b86cd1ff$var$broadcastFidChange(key, fid);
}
function $040f18e6b86cd1ff$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $040f18e6b86cd1ff$var$getBroadcastChannel();
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    let callbackSet = $040f18e6b86cd1ff$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $040f18e6b86cd1ff$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $040f18e6b86cd1ff$var$removeCallback(appConfig, callback) {
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    const callbackSet = $040f18e6b86cd1ff$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $040f18e6b86cd1ff$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $040f18e6b86cd1ff$var$closeBroadcastChannel();
}
function $040f18e6b86cd1ff$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $040f18e6b86cd1ff$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $040f18e6b86cd1ff$var$broadcastFidChange(key, fid) {
    const channel = $040f18e6b86cd1ff$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $040f18e6b86cd1ff$var$closeBroadcastChannel();
}
let $040f18e6b86cd1ff$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $040f18e6b86cd1ff$var$getBroadcastChannel() {
    if (!$040f18e6b86cd1ff$var$broadcastChannel && "BroadcastChannel" in self) {
        $040f18e6b86cd1ff$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $040f18e6b86cd1ff$var$broadcastChannel.onmessage = (e)=>{
            $040f18e6b86cd1ff$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $040f18e6b86cd1ff$var$broadcastChannel;
}
function $040f18e6b86cd1ff$var$closeBroadcastChannel() {
    if ($040f18e6b86cd1ff$var$fidChangeCallbacks.size === 0 && $040f18e6b86cd1ff$var$broadcastChannel) {
        $040f18e6b86cd1ff$var$broadcastChannel.close();
        $040f18e6b86cd1ff$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$DATABASE_NAME = "firebase-installations-database";
const $040f18e6b86cd1ff$var$DATABASE_VERSION = 1;
const $040f18e6b86cd1ff$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $040f18e6b86cd1ff$var$dbPromise = null;
function $040f18e6b86cd1ff$var$getDbPromise() {
    if (!$040f18e6b86cd1ff$var$dbPromise) $040f18e6b86cd1ff$var$dbPromise = (0, $91cfbbb1f21a7978$export$ca0ed41b1a2af7e)($040f18e6b86cd1ff$var$DATABASE_NAME, $040f18e6b86cd1ff$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($040f18e6b86cd1ff$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $040f18e6b86cd1ff$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $040f18e6b86cd1ff$var$set(appConfig, value) {
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    const db = await $040f18e6b86cd1ff$var$getDbPromise();
    const tx = db.transaction($040f18e6b86cd1ff$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($040f18e6b86cd1ff$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $040f18e6b86cd1ff$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $040f18e6b86cd1ff$var$remove(appConfig) {
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    const db = await $040f18e6b86cd1ff$var$getDbPromise();
    const tx = db.transaction($040f18e6b86cd1ff$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($040f18e6b86cd1ff$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $040f18e6b86cd1ff$var$update(appConfig, updateFn) {
    const key = $040f18e6b86cd1ff$var$getKey(appConfig);
    const db = await $040f18e6b86cd1ff$var$getDbPromise();
    const tx = db.transaction($040f18e6b86cd1ff$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($040f18e6b86cd1ff$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $040f18e6b86cd1ff$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $040f18e6b86cd1ff$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $040f18e6b86cd1ff$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $040f18e6b86cd1ff$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $040f18e6b86cd1ff$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $040f18e6b86cd1ff$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $040f18e6b86cd1ff$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $040f18e6b86cd1ff$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $040f18e6b86cd1ff$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $040f18e6b86cd1ff$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($040f18e6b86cd1ff$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $040f18e6b86cd1ff$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $040f18e6b86cd1ff$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $040f18e6b86cd1ff$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $040f18e6b86cd1ff$var$createInstallationRequest(installations, installationEntry);
        return $040f18e6b86cd1ff$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($040f18e6b86cd1ff$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $040f18e6b86cd1ff$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $040f18e6b86cd1ff$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $040f18e6b86cd1ff$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $040f18e6b86cd1ff$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $040f18e6b86cd1ff$var$sleep(100);
        entry = await $040f18e6b86cd1ff$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $040f18e6b86cd1ff$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $040f18e6b86cd1ff$var$updateInstallationRequest(appConfig) {
    return $040f18e6b86cd1ff$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $040f18e6b86cd1ff$var$clearTimedOutRequest(oldEntry);
    });
}
function $040f18e6b86cd1ff$var$clearTimedOutRequest(entry) {
    if ($040f18e6b86cd1ff$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $040f18e6b86cd1ff$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $040f18e6b86cd1ff$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $040f18e6b86cd1ff$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $040f18e6b86cd1ff$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $040f18e6b86cd1ff$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $040f18e6b86cd1ff$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $040f18e6b86cd1ff$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $040f18e6b86cd1ff$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $040f18e6b86cd1ff$var$getErrorFromResponse("Generate Auth Token", response);
}
function $040f18e6b86cd1ff$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$040f18e6b86cd1ff$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $040f18e6b86cd1ff$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $040f18e6b86cd1ff$var$update(installations.appConfig, (oldEntry)=>{
        if (!$040f18e6b86cd1ff$var$isEntryRegistered(oldEntry)) throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $040f18e6b86cd1ff$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $040f18e6b86cd1ff$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $040f18e6b86cd1ff$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $040f18e6b86cd1ff$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $040f18e6b86cd1ff$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $040f18e6b86cd1ff$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $040f18e6b86cd1ff$var$sleep(100);
        entry = await $040f18e6b86cd1ff$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $040f18e6b86cd1ff$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $040f18e6b86cd1ff$var$updateAuthTokenRequest(appConfig) {
    return $040f18e6b86cd1ff$var$update(appConfig, (oldEntry)=>{
        if (!$040f18e6b86cd1ff$var$isEntryRegistered(oldEntry)) throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($040f18e6b86cd1ff$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return {
            ...oldEntry,
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        };
        return oldEntry;
    });
}
async function $040f18e6b86cd1ff$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $040f18e6b86cd1ff$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = {
            ...installationEntry,
            authToken: authToken
        };
        await $040f18e6b86cd1ff$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($040f18e6b86cd1ff$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $040f18e6b86cd1ff$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = {
                ...installationEntry,
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            };
            await $040f18e6b86cd1ff$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $040f18e6b86cd1ff$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $040f18e6b86cd1ff$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$040f18e6b86cd1ff$var$isAuthTokenExpired(authToken);
}
function $040f18e6b86cd1ff$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $040f18e6b86cd1ff$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $040f18e6b86cd1ff$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return {
        ...oldEntry,
        authToken: inProgressAuthToken
    };
}
function $040f18e6b86cd1ff$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $040f18e6b86cd1ff$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $040f18e6b86cd1ff$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $040f18e6b86cd1ff$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $040f18e6b86cd1ff$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $040f18e6b86cd1ff$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $040f18e6b86cd1ff$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $040f18e6b86cd1ff$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $040f18e6b86cd1ff$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $040f18e6b86cd1ff$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $040f18e6b86cd1ff$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $040f18e6b86cd1ff$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $040f18e6b86cd1ff$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $040f18e6b86cd1ff$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $040f18e6b86cd1ff$var$getErrorFromResponse("Delete Installation", response);
}
function $040f18e6b86cd1ff$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$040f18e6b86cd1ff$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $040f18e6b86cd1ff$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $040f18e6b86cd1ff$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $040f18e6b86cd1ff$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $040f18e6b86cd1ff$var$deleteInstallationRequest(appConfig, entry);
                await $040f18e6b86cd1ff$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $040f18e6b86cd1ff$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $040f18e6b86cd1ff$var$addCallback(appConfig, callback);
    return ()=>{
        $040f18e6b86cd1ff$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $040f18e6b86cd1ff$export$9bfc115e43431ff5(app = (0, $50998f1e63817c97$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $50998f1e63817c97$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $040f18e6b86cd1ff$var$extractAppConfig(app) {
    if (!app || !app.options) throw $040f18e6b86cd1ff$var$getMissingValueError("App Configuration");
    if (!app.name) throw $040f18e6b86cd1ff$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $040f18e6b86cd1ff$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $040f18e6b86cd1ff$var$getMissingValueError(valueName) {
    return $040f18e6b86cd1ff$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $040f18e6b86cd1ff$var$INSTALLATIONS_NAME = "installations";
const $040f18e6b86cd1ff$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $040f18e6b86cd1ff$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $040f18e6b86cd1ff$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $50998f1e63817c97$export$fa0d6da0f5838f50)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $040f18e6b86cd1ff$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $50998f1e63817c97$export$fa0d6da0f5838f50)(app, $040f18e6b86cd1ff$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$040f18e6b86cd1ff$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$040f18e6b86cd1ff$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $040f18e6b86cd1ff$var$registerInstallations() {
    (0, $50998f1e63817c97$export$c930050e7bb63965)(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)($040f18e6b86cd1ff$var$INSTALLATIONS_NAME, $040f18e6b86cd1ff$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $50998f1e63817c97$export$c930050e7bb63965)(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)($040f18e6b86cd1ff$var$INSTALLATIONS_NAME_INTERNAL, $040f18e6b86cd1ff$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $040f18e6b86cd1ff$var$registerInstallations();
(0, $50998f1e63817c97$export$d29d5299a7137abc)($040f18e6b86cd1ff$var$name, $040f18e6b86cd1ff$var$version);
// BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
(0, $50998f1e63817c97$export$d29d5299a7137abc)($040f18e6b86cd1ff$var$name, $040f18e6b86cd1ff$var$version, "esm2020");






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
const $4bcd2bcdfcaa5f94$var$DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
const $4bcd2bcdfcaa5f94$var$DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
const $4bcd2bcdfcaa5f94$var$ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
const $4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
const $4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
const $4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
/** Set to '1' if Analytics is enabled for the campaign */ const $4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
const $4bcd2bcdfcaa5f94$var$DEFAULT_REGISTRATION_TIMEOUT = 10000;
var $4bcd2bcdfcaa5f94$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($4bcd2bcdfcaa5f94$var$MessageType$1 || ($4bcd2bcdfcaa5f94$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $4bcd2bcdfcaa5f94$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
    MessageType["FID_REGISTERED"] = "fid-registered";
})($4bcd2bcdfcaa5f94$var$MessageType || ($4bcd2bcdfcaa5f94$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bcd2bcdfcaa5f94$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $4bcd2bcdfcaa5f94$var$base64ToArray(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$OLD_DB_NAME = "fcm_token_details_db";
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $4bcd2bcdfcaa5f94$var$OLD_DB_VERSION = 5;
const $4bcd2bcdfcaa5f94$var$OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
async function $4bcd2bcdfcaa5f94$var$migrateOldDatabase(senderId) {
    if ("databases" in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($4bcd2bcdfcaa5f94$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $91cfbbb1f21a7978$export$ca0ed41b1a2af7e)($4bcd2bcdfcaa5f94$var$OLD_DB_NAME, $4bcd2bcdfcaa5f94$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($4bcd2bcdfcaa5f94$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($4bcd2bcdfcaa5f94$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index("fcmSenderId").get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                var _oldDetails_createTime;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_oldDetails_createTime = oldDetails.createTime) !== null && _oldDetails_createTime !== void 0 ? _oldDetails_createTime : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.auth),
                        p256dh: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.auth),
                        p256dh: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $4bcd2bcdfcaa5f94$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $91cfbbb1f21a7978$export$9d6df0ac66a98bb2)($4bcd2bcdfcaa5f94$var$OLD_DB_NAME);
    await (0, $91cfbbb1f21a7978$export$9d6df0ac66a98bb2)("fcm_vapid_details_db");
    await (0, $91cfbbb1f21a7978$export$9d6df0ac66a98bb2)("undefined");
    return $4bcd2bcdfcaa5f94$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $4bcd2bcdfcaa5f94$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: "This method is available in a Window context.",
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: "This method is available in a service worker context.",
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: "The notification permission was not granted and dismissed instead.",
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: "The notification permission was not granted and blocked instead.",
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: "We are unable to register the default service worker. {$browserErrorMessage}",
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: "A problem occurred while subscribing the user to FCM: {$errorInfo}",
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: "FCM returned no token when subscribing the user to push.",
    ["fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ ]: "A problem occurred while creating an FCM registration via FID: {$errorInfo}",
    ["fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ ]: "A problem occurred while unregistering the FCM registration via FID: {$errorInfo}",
    ["fid-registration-idb-schema-unavailable" /* ErrorCode.FID_REGISTRATION_IDB_SCHEMA_UNAVAILABLE */ ]: "Unable to read or persist FID registration metadata because the messaging IndexedDB schema is unavailable (for example, the database could not be upgraded to the latest version).",
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: "A problem occurred while updating the user from FCM: {$errorInfo}",
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: "FCM returned no token when updating the user to push.",
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: "The input to setBackgroundMessageHandler() must be a function.",
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: "The public VAPID key must be a string.",
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used.",
    ["invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ ]: "No onRegistered callback handler was provided or registered. Implement onRegistered() before register()."
};
const $4bcd2bcdfcaa5f94$var$ERROR_FACTORY = new (0, $f7a5b7f58ca24e89$export$3fa6e1b18a3b2d40)("messaging", "Messaging", $4bcd2bcdfcaa5f94$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$DATABASE_NAME = "firebase-messaging-database";
const $4bcd2bcdfcaa5f94$var$DATABASE_VERSION = 2;
const $4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME = "firebase-messaging-store";
const $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME = "firebase-messaging-fid-registration-store";
const $4bcd2bcdfcaa5f94$var$defaultIdb = {
    openDB: $91cfbbb1f21a7978$export$ca0ed41b1a2af7e,
    deleteDB: $91cfbbb1f21a7978$export$9d6df0ac66a98bb2
};
let $4bcd2bcdfcaa5f94$var$idbImpl = $4bcd2bcdfcaa5f94$var$defaultIdb;
// Open v2, but fall back to v1 if upgrade/open fails. Cache as `unknown` and guard store access.
let $4bcd2bcdfcaa5f94$var$dbPromise = null;
function $4bcd2bcdfcaa5f94$var$migrateMessagingDb(upgradeDb, oldVersion, targetSchemaVersion) {
    // Intentional fall-through for v2: run all intermediate migrations.
    // eslint-disable-next-line default-case
    switch(oldVersion){
        case 0:
            upgradeDb.createObjectStore($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME);
            if (targetSchemaVersion === 1) break;
        // fall through
        case 1:
            if (targetSchemaVersion === 2) upgradeDb.createObjectStore($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME);
    }
}
function $4bcd2bcdfcaa5f94$var$createOpenDbOptions(targetSchemaVersion) {
    return {
        upgrade: (upgradeDb, oldVersion)=>{
            $4bcd2bcdfcaa5f94$var$migrateMessagingDb(upgradeDb, oldVersion, targetSchemaVersion);
        },
        blocked: ()=>{
        /* no-op */ },
        blocking: (_currentVersion, _blockedVersion, event)=>{
            var _event_target;
            $4bcd2bcdfcaa5f94$var$dbPromise = null;
            (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.close();
        },
        terminated: ()=>{
            $4bcd2bcdfcaa5f94$var$dbPromise = null;
        }
    };
}
function $4bcd2bcdfcaa5f94$var$getDbPromise() {
    if (!$4bcd2bcdfcaa5f94$var$dbPromise) {
        const openLatest = $4bcd2bcdfcaa5f94$var$idbImpl.openDB($4bcd2bcdfcaa5f94$var$DATABASE_NAME, $4bcd2bcdfcaa5f94$var$DATABASE_VERSION, $4bcd2bcdfcaa5f94$var$createOpenDbOptions(2));
        // Assign synchronously to avoid concurrent openDB() calls.
        $4bcd2bcdfcaa5f94$var$dbPromise = openLatest.catch(()=>$4bcd2bcdfcaa5f94$var$idbImpl.openDB($4bcd2bcdfcaa5f94$var$DATABASE_NAME, $4bcd2bcdfcaa5f94$var$DATABASE_VERSION - 1, $4bcd2bcdfcaa5f94$var$createOpenDbOptions(1)));
    }
    return $4bcd2bcdfcaa5f94$var$dbPromise;
}
function $4bcd2bcdfcaa5f94$var$hasObjectStore(db, storeName) {
    return db.objectStoreNames.contains(storeName);
}
function $4bcd2bcdfcaa5f94$var$assertFidRegistrationObjectStore(db) {
    if (!$4bcd2bcdfcaa5f94$var$hasObjectStore(db, $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME)) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-idb-schema-unavailable" /* ErrorCode.FID_REGISTRATION_IDB_SCHEMA_UNAVAILABLE */ );
}
async function $4bcd2bcdfcaa5f94$var$dbGet(firebaseDependencies) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    const tokenDetails = await db.transaction($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME).objectStore($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        const oldTokenDetails = await $4bcd2bcdfcaa5f94$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $4bcd2bcdfcaa5f94$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
async function $4bcd2bcdfcaa5f94$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    const stores = [
        $4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME
    ];
    const hasFidStore = $4bcd2bcdfcaa5f94$var$hasObjectStore(db, $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME);
    if (hasFidStore) stores.push($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME);
    const tx = db.transaction(stores, "readwrite");
    await tx.objectStore($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME).put(tokenDetails, key);
    if (hasFidStore) await tx.objectStore($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME).delete(key);
    await tx.done;
    return tokenDetails;
}
async function $4bcd2bcdfcaa5f94$var$dbRemove(firebaseDependencies) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    const tx = db.transaction($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
async function $4bcd2bcdfcaa5f94$var$dbGetFidRegistration(firebaseDependencies) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    $4bcd2bcdfcaa5f94$var$assertFidRegistrationObjectStore(db);
    return await db.transaction($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME).objectStore($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME).get(key);
}
async function $4bcd2bcdfcaa5f94$var$dbSetFidRegistration(firebaseDependencies, details) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    $4bcd2bcdfcaa5f94$var$assertFidRegistrationObjectStore(db);
    const tx = db.transaction([
        $4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME,
        $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME
    ], "readwrite");
    await tx.objectStore($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME).put(details, key);
    await tx.objectStore($4bcd2bcdfcaa5f94$var$TOKEN_OBJECT_STORE_NAME).delete(key);
    await tx.done;
    return details;
}
async function $4bcd2bcdfcaa5f94$var$dbRemoveFidRegistration(firebaseDependencies) {
    const key = $4bcd2bcdfcaa5f94$var$getKey(firebaseDependencies);
    const db = await $4bcd2bcdfcaa5f94$var$getDbPromise();
    $4bcd2bcdfcaa5f94$var$assertFidRegistrationObjectStore(db);
    const tx = db.transaction($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($4bcd2bcdfcaa5f94$var$FID_REGISTRATION_OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $4bcd2bcdfcaa5f94$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
const $4bcd2bcdfcaa5f94$var$name = "@firebase/messaging";
const $4bcd2bcdfcaa5f94$var$version = "0.13.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Max attempts (initial fetch + retries) when CreateRegistration `fetch()` throws. */ const $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FETCH_MAX_ATTEMPTS = 3;
/** Base delay in ms; backoff is `BASE * 2^attempt` after each failed attempt. */ const $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FETCH_BASE_BACKOFF_MS = 1000;
async function $4bcd2bcdfcaa5f94$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $4bcd2bcdfcaa5f94$var$getHeaders(firebaseDependencies);
    const body = $4bcd2bcdfcaa5f94$var$getBody(subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ false);
    const subscribeOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($4bcd2bcdfcaa5f94$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $4bcd2bcdfcaa5f94$var$requestCreateRegistration(firebaseDependencies, subscriptionOptions) {
    var _responseData_error;
    const headers = await $4bcd2bcdfcaa5f94$var$getHeaders(firebaseDependencies);
    const body = $4bcd2bcdfcaa5f94$var$getBody(subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ true);
    const subscribeOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    let response;
    try {
        response = await $4bcd2bcdfcaa5f94$var$fetchWithExponentialRetry(()=>fetch($4bcd2bcdfcaa5f94$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions), $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FETCH_MAX_ATTEMPTS, $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FETCH_BASE_BACKOFF_MS);
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (response.ok) {
        const responseFid = await $4bcd2bcdfcaa5f94$var$parseCreateRegistrationSuccessFid(response);
        return {
            responseFid: responseFid
        };
    }
    // `fetch()` succeeded, but the backend returned a non-2xx response.
    // Best-effort parse the body to extract `error.message`, but always fail with
    // `FID_REGISTRATION_FAILED` to keep the error surface uniform.
    // Best-effort extraction of error details; the main signal is response.ok / status.
    let responseData;
    try {
        responseData = await response.json();
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: response.statusText
        });
    }
    var _responseData_error_message;
    const message = (_responseData_error_message = (_responseData_error = responseData.error) === null || _responseData_error === void 0 ? void 0 : _responseData_error.message) !== null && _responseData_error_message !== void 0 ? _responseData_error_message : response.statusText;
    throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: message
    });
}
/**
 * Deletes an FCM Web registration via DeleteRegistration using the Firebase Installation ID (FID).
 */ async function $4bcd2bcdfcaa5f94$var$requestDeleteRegistration(firebaseDependencies, fid) {
    const headers = await $4bcd2bcdfcaa5f94$var$getHeaders(firebaseDependencies);
    const options = {
        method: "DELETE",
        headers: headers
    };
    let response;
    try {
        response = await fetch(`${$4bcd2bcdfcaa5f94$var$getEndpoint(firebaseDependencies.appConfig)}/${fid}`, options);
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (response.ok) return;
    // Best-effort parse error details; surface uniform error code.
    try {
        var _responseData_error;
        const responseData = await response.json();
        var _responseData_error_message;
        const message = (_responseData_error_message = (_responseData_error = responseData.error) === null || _responseData_error === void 0 ? void 0 : _responseData_error.message) !== null && _responseData_error_message !== void 0 ? _responseData_error_message : response.statusText;
        throw message;
    } catch (err) {
        // If parsing failed, fall back to status text.
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ , {
            errorInfo: typeof err === "string" && err || response.statusText || (err === null || err === void 0 ? void 0 : err.toString())
        });
    }
}
/**
 * Parses a successful CreateRegistration body. The backend must return JSON with a non-empty
 * string `name`: a resource name `projects/{projectId}/registrations/{fid}`
 */ async function $4bcd2bcdfcaa5f94$var$parseCreateRegistrationSuccessFid(response) {
    const text = await response.text();
    if (!text.trim()) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: "CreateRegistration succeeded but response body is empty"
    });
    let data;
    try {
        data = JSON.parse(text);
    } catch  {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: "CreateRegistration succeeded but response body is not valid JSON"
        });
    }
    const name = data.name;
    if (typeof name !== "string" || name.length === 0) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: "CreateRegistration succeeded but response did not include a non-empty name"
    });
    return $4bcd2bcdfcaa5f94$var$parseFidFromRegistrationResourceName(name);
}
const $4bcd2bcdfcaa5f94$var$REGISTRATIONS_NAME_SEGMENT = "/registrations/";
/** Extracts the Firebase Installation ID from CreateRegistration `name` (resource path). */ function $4bcd2bcdfcaa5f94$var$parseFidFromRegistrationResourceName(name) {
    const segmentIndex = name.indexOf($4bcd2bcdfcaa5f94$var$REGISTRATIONS_NAME_SEGMENT);
    if (segmentIndex !== -1) {
        const fid = name.slice(segmentIndex + $4bcd2bcdfcaa5f94$var$REGISTRATIONS_NAME_SEGMENT.length);
        if (fid.length > 0) return fid;
    }
    throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: "CreateRegistration succeeded but response name is not a valid registration resource name"
    });
}
async function $4bcd2bcdfcaa5f94$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $4bcd2bcdfcaa5f94$var$getHeaders(firebaseDependencies);
    const body = $4bcd2bcdfcaa5f94$var$getBody(tokenDetails.subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ false);
    const updateOptions = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$4bcd2bcdfcaa5f94$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $4bcd2bcdfcaa5f94$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $4bcd2bcdfcaa5f94$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: "DELETE",
        headers: headers
    };
    try {
        const response = await fetch(`${$4bcd2bcdfcaa5f94$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
/**
 * Re-runs `operation` when it throws, with exponential backoff between attempts.
 * Rethrows the last error if all attempts fail.
 */ async function $4bcd2bcdfcaa5f94$var$fetchWithExponentialRetry(operation, maxAttempts, baseBackoffMs) {
    let lastError;
    for(let attempt = 0; attempt < maxAttempts; attempt++)try {
        return await operation();
    } catch (err) {
        lastError = err;
        if (attempt < maxAttempts - 1) {
            const delayMs = baseBackoffMs * Math.pow(2, attempt);
            await new Promise((resolve)=>setTimeout(resolve, delayMs));
        }
    }
    throw lastError;
}
function $4bcd2bcdfcaa5f94$var$getEndpoint({ projectId: projectId }) {
    return `${$4bcd2bcdfcaa5f94$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $4bcd2bcdfcaa5f94$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": appConfig.apiKey,
        "x-goog-firebase-installations-auth": `FIS ${authToken}`
    });
}
/**
 * Hostname for the registering web client (e.g. `www.example.com`), or the app name
 * (`appNameFallback`) when the scope cannot be resolved (e.g. some test environments).
 */ function $4bcd2bcdfcaa5f94$var$getRegistrationOrigin(swScope, appNameFallback) {
    var _self_location;
    try {
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(swScope)) return new URL(swScope).host;
    } catch  {
    // Fall through to relative-scope handling.
    }
    try {
        var _self_location1;
        if (typeof self !== "undefined" && ((_self_location1 = self.location) === null || _self_location1 === void 0 ? void 0 : _self_location1.href)) return new URL(swScope, self.location.origin).host;
    } catch  {
    // Fall through.
    }
    if (typeof self !== "undefined" && ((_self_location = self.location) === null || _self_location === void 0 ? void 0 : _self_location.host)) return self.location.host;
    return appNameFallback;
}
function $4bcd2bcdfcaa5f94$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey, swScope: swScope }, appNameFallback, includeSdkVersion) {
    const body = {
        web: {
            origin: $4bcd2bcdfcaa5f94$var$getRegistrationOrigin(swScope, appNameFallback),
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (includeSdkVersion) // eslint-disable-next-line camelcase
    body.fcm_sdk_version = $4bcd2bcdfcaa5f94$var$version;
    if (vapidKey !== $4bcd2bcdfcaa5f94$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $4bcd2bcdfcaa5f94$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $4bcd2bcdfcaa5f94$var$getTokenInternal(messaging) {
    const pushSubscription = await $4bcd2bcdfcaa5f94$var$getPushSubscription$1(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $4bcd2bcdfcaa5f94$var$arrayToBase64(pushSubscription.getKey("auth")),
        p256dh: $4bcd2bcdfcaa5f94$var$arrayToBase64(pushSubscription.getKey("p256dh"))
    };
    const tokenDetails = await $4bcd2bcdfcaa5f94$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $4bcd2bcdfcaa5f94$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$4bcd2bcdfcaa5f94$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $4bcd2bcdfcaa5f94$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $4bcd2bcdfcaa5f94$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $4bcd2bcdfcaa5f94$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $4bcd2bcdfcaa5f94$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * Legacy getToken() path: there is a token row in IndexedDB. Revoke it with FCM, drop the row, and
 * clear any leftover FID registration metadata (apps may mix APIs).
 */ async function $4bcd2bcdfcaa5f94$var$revokeLegacyFcmTokenAndClearCaches(messaging, tokenDetails) {
    await $4bcd2bcdfcaa5f94$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    await $4bcd2bcdfcaa5f94$var$dbRemove(messaging.firebaseDependencies);
    await $4bcd2bcdfcaa5f94$var$removeFidRegistrationBestEffort(messaging.firebaseDependencies);
}
/**
 * No legacy token row: the client may only have FID-based registration (register() flow). If so,
 * delete that registration on the server, always scrub local FID metadata, then surface
 * onUnregistered when we actually had an FID.
 */ async function $4bcd2bcdfcaa5f94$var$revokeFidRegistrationIfStored(messaging) {
    const stored = await $4bcd2bcdfcaa5f94$var$dbGetFidRegistration(messaging.firebaseDependencies).catch(()=>undefined);
    const fid = stored === null || stored === void 0 ? void 0 : stored.fid;
    if (fid) await $4bcd2bcdfcaa5f94$var$requestDeleteRegistration(messaging.firebaseDependencies, fid);
    await $4bcd2bcdfcaa5f94$var$removeFidRegistrationBestEffort(messaging.firebaseDependencies);
    if (fid) $4bcd2bcdfcaa5f94$var$notifyOnUnregistered(messaging, fid);
}
/**
 * Revokes the app's FCM registration: legacy token (getToken/deleteToken) and/or FID-based
 * registration (register/unregister), clears local caches, notifies onUnregistered when a stored
 * FID existed, then unsubscribes the push subscription when present.
 */ async function $4bcd2bcdfcaa5f94$var$revokeRegistrationInternal(messaging) {
    const tokenDetails = await $4bcd2bcdfcaa5f94$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) await $4bcd2bcdfcaa5f94$var$revokeLegacyFcmTokenAndClearCaches(messaging, tokenDetails);
    else await $4bcd2bcdfcaa5f94$var$revokeFidRegistrationIfStored(messaging);
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $4bcd2bcdfcaa5f94$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $4bcd2bcdfcaa5f94$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = {
            ...tokenDetails,
            token: updatedToken,
            createTime: Date.now()
        };
        await $4bcd2bcdfcaa5f94$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        throw e;
    }
}
async function $4bcd2bcdfcaa5f94$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $4bcd2bcdfcaa5f94$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $4bcd2bcdfcaa5f94$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $4bcd2bcdfcaa5f94$var$getPushSubscription$1(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $4bcd2bcdfcaa5f94$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $4bcd2bcdfcaa5f94$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/** Clears FID registration metadata; apps may mix legacy getToken() with FID register/unregister. */ async function $4bcd2bcdfcaa5f94$var$removeFidRegistrationBestEffort(firebaseDependencies) {
    try {
        await $4bcd2bcdfcaa5f94$var$dbRemoveFidRegistration(firebaseDependencies);
    } catch  {
    // Ignore.
    }
}
function $4bcd2bcdfcaa5f94$var$notifyOnRegistered(messaging, fid) {
    const handler = messaging.onRegisteredHandler;
    if (!handler) return;
    if (typeof handler === "function") handler(fid);
    else handler.next(fid);
}
function $4bcd2bcdfcaa5f94$var$notifyOnUnregistered(messaging, fid) {
    const handler = messaging.onUnregisteredHandler;
    if (!handler) return;
    if (typeof handler === "function") handler(fid);
    else handler.next(fid);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($4bcd2bcdfcaa5f94$var$DEFAULT_SW_PATH, {
            scope: $4bcd2bcdfcaa5f94$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
        await $4bcd2bcdfcaa5f94$var$waitForRegistrationActive(messaging.swRegistration);
    } catch (e) {
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * Waits for registration to become active. MDN documentation claims that
 * a service worker registration should be ready to use after awaiting
 * navigator.serviceWorker.register() but that doesn't seem to be the case in
 * practice, causing the SDK to throw errors when calling
 * swRegistration.pushManager.subscribe() too soon after register(). The only
 * solution seems to be waiting for the service worker registration `state`
 * to become "active".
 */ async function $4bcd2bcdfcaa5f94$var$waitForRegistrationActive(registration) {
    return new Promise((resolve, reject)=>{
        const rejectTimeout = setTimeout(()=>reject(new Error(`Service worker not registered after ${$4bcd2bcdfcaa5f94$var$DEFAULT_REGISTRATION_TIMEOUT} ms`)), $4bcd2bcdfcaa5f94$var$DEFAULT_REGISTRATION_TIMEOUT);
        const incomingSw = registration.installing || registration.waiting;
        if (registration.active) {
            clearTimeout(rejectTimeout);
            resolve();
        } else if (incomingSw) incomingSw.onstatechange = (ev)=>{
            var _ev_target;
            if (((_ev_target = ev.target) === null || _ev_target === void 0 ? void 0 : _ev_target.state) === "activated") {
                incomingSw.onstatechange = null;
                clearTimeout(rejectTimeout);
                resolve();
            }
        };
        else {
            clearTimeout(rejectTimeout);
            reject(new Error("No incoming service worker found."));
        }
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $4bcd2bcdfcaa5f94$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $4bcd2bcdfcaa5f94$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Retries when CreateRegistration echoes an FID that does not match Installations.getId(). */ const $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS = 3;
/**
 * For the new FID-based register path:
 * - Create (or refresh) an FCM Web registration in the backend via CreateRegistration.
 * - Use the FIS auth token produced by the installations instance (implicitly associated with FID).
 * - CreateRegistration must echo the installation in `name` (e.g.
 *   `projects/{projectId}/registrations/{fid}`); it must match `expectedFid` from
 *   Installations.getId(). On mismatch we refresh the auth token and retry, then fail with
 *   `fid-registration-failed`.
 */ async function $4bcd2bcdfcaa5f94$var$registerFcmRegistrationWithFid(messaging, expectedFid) {
    const pushSubscription = await $4bcd2bcdfcaa5f94$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $4bcd2bcdfcaa5f94$var$arrayToBase64(pushSubscription.getKey("auth")),
        p256dh: $4bcd2bcdfcaa5f94$var$arrayToBase64(pushSubscription.getKey("p256dh"))
    };
    const installations = messaging.firebaseDependencies.installations;
    for(let attempt = 0; attempt < $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS; attempt++){
        const { responseFid: responseFid } = await $4bcd2bcdfcaa5f94$var$requestCreateRegistration(messaging.firebaseDependencies, subscriptionOptions);
        if (responseFid === expectedFid) return;
        // If CreateRegistration echoes an unexpected FID, the FIS auth token used for the request may
        // be stale relative to the installation the backend associates with the call. Force-refresh
        // the token before retrying so the next attempt uses credentials aligned with Installations.
        if (attempt < $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS - 1) await installations.getToken(true);
    }
    throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: "CreateRegistration response FID does not match Firebase Installation ID"
    });
}
async function $4bcd2bcdfcaa5f94$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    // Chrome/Firefox require applicationServerKey to be of type Uint8Array.
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // `PushManager.subscribe` expects a `BufferSource`; `base64ToArray` produces a typed array.
        // Cast to satisfy the lib typing differences across TS DOM versions.
        applicationServerKey: $4bcd2bcdfcaa5f94$var$base64ToArray(vapidKey)
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_REFRESH_MS = 604800000; // 7 days
/**
 * Registers the app instance with FCM using its Firebase Installation ID (FID). The FID is
 * delivered via the `onRegistered` callback. Call this to establish an FID-based identity.
 * Once `onRegistered` provides an FID, instruct your backend to remove any legacy token
 * previously associated with this instance. The backend send API supports FID as a target.
 *
 * When called multiple times, `onRegistered` is invoked on each call with the current FID.
 * Backend registration sync runs on first register, when the FID changes, or on weekly refresh.
 *
 * @param messaging - The MessagingService instance.
 * @param options - Optional. Same options as getToken (vapidKey, serviceWorkerRegistration).
 */ async function $4bcd2bcdfcaa5f94$var$register$1(messaging, options) {
    if (!navigator) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    if (!messaging.onRegisteredHandler) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ );
    await $4bcd2bcdfcaa5f94$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $4bcd2bcdfcaa5f94$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    // Keep the queue alive after a failed register() so future calls can retry.
    const prev = messaging._registerNotifyChain.catch(()=>{});
    messaging._registerNotifyChain = prev.then(async ()=>{
        const fid = await messaging.firebaseDependencies.installations.getId();
        const stored = await $4bcd2bcdfcaa5f94$var$dbGetFidRegistration(messaging.firebaseDependencies);
        const now = Date.now();
        const shouldRefresh = !stored || stored.fid !== fid || now >= stored.lastRegisterTime + $4bcd2bcdfcaa5f94$var$FID_REGISTRATION_REFRESH_MS;
        if (shouldRefresh) {
            await $4bcd2bcdfcaa5f94$var$registerFcmRegistrationWithFid(messaging, fid);
            await $4bcd2bcdfcaa5f94$var$dbSetFidRegistration(messaging.firebaseDependencies, {
                fid: fid,
                lastRegisterTime: now,
                vapidKey: messaging.vapidKey
            });
        }
        const handler = messaging.onRegisteredHandler;
        if (!handler) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ );
        $4bcd2bcdfcaa5f94$var$notifyOnRegistered(messaging, fid);
    });
    return messaging._registerNotifyChain;
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * When the Firebase Installation ID changes, re-run `register()` so FCM registration and
 * onRegistered run for the new FID. No-op if no onRegistered handler is set or the app
 * instance was never registered with FCM.
 */ function $4bcd2bcdfcaa5f94$var$subscribeFidChangeRegistration(messaging, installations) {
    return (0, $040f18e6b86cd1ff$export$ceb4c11381bc36e8)(installations, ()=>{
        (async ()=>{
            if (!messaging.onRegisteredHandler) return;
            const stored = await $4bcd2bcdfcaa5f94$var$dbGetFidRegistration(messaging.firebaseDependencies);
            if (!stored) return;
            await $4bcd2bcdfcaa5f94$var$register$1(messaging).catch(()=>{
            // Best-effort: permission may be revoked or SW unavailable after FID rotation.
            });
        })();
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bcd2bcdfcaa5f94$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $4bcd2bcdfcaa5f94$var$propagateNotificationPayload(payload, internalPayload);
    $4bcd2bcdfcaa5f94$var$propagateDataPayload(payload, internalPayload);
    $4bcd2bcdfcaa5f94$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $4bcd2bcdfcaa5f94$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $4bcd2bcdfcaa5f94$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $4bcd2bcdfcaa5f94$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _messagePayloadInternal_notification, _messagePayloadInternal_fcmOptions, _messagePayloadInternal_notification1, _messagePayloadInternal_fcmOptions1;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_messagePayloadInternal_notification = messagePayloadInternal.notification) === null || _messagePayloadInternal_notification === void 0 ? void 0 : _messagePayloadInternal_notification.click_action)) return;
    payload.fcmOptions = {};
    var _messagePayloadInternal_fcmOptions_link;
    const link = (_messagePayloadInternal_fcmOptions_link = (_messagePayloadInternal_fcmOptions = messagePayloadInternal.fcmOptions) === null || _messagePayloadInternal_fcmOptions === void 0 ? void 0 : _messagePayloadInternal_fcmOptions.link) !== null && _messagePayloadInternal_fcmOptions_link !== void 0 ? _messagePayloadInternal_fcmOptions_link : (_messagePayloadInternal_notification1 = messagePayloadInternal.notification) === null || _messagePayloadInternal_notification1 === void 0 ? void 0 : _messagePayloadInternal_notification1.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_messagePayloadInternal_fcmOptions1 = messagePayloadInternal.fcmOptions) === null || _messagePayloadInternal_fcmOptions1 === void 0 ? void 0 : _messagePayloadInternal_fcmOptions1.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bcd2bcdfcaa5f94$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === "object" && !!data && $4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $4bcd2bcdfcaa5f94$var$_mergeStrings("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function $4bcd2bcdfcaa5f94$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bcd2bcdfcaa5f94$var$extractAppConfig(app) {
    if (!app || !app.options) throw $4bcd2bcdfcaa5f94$var$getMissingValueError("App Configuration Object");
    if (!app.name) throw $4bcd2bcdfcaa5f94$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId",
        "messagingSenderId"
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $4bcd2bcdfcaa5f94$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $4bcd2bcdfcaa5f94$var$getMissingValueError(valueName) {
    return $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4bcd2bcdfcaa5f94$var$MessagingService {
    _delete() {
        if (this._fidChangeUnsubscribe) {
            this._fidChangeUnsubscribe();
            this._fidChangeUnsubscribe = null;
        }
        if (this.logQueue.state === "scheduled") clearTimeout(this.logQueue.timerId);
        this.logQueue = {
            state: "stopped"
        };
        return Promise.resolve();
    }
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        /** Observer for the event that the app instance is registered with FCM via Firebase Installation ID (FID). */ this.onRegisteredHandler = null;
        /** Observer for the event that the app instance is unregistered from FCM (FID no longer active). */ this.onUnregisteredHandler = null;
        /**
         * Serializes the FID get + compare + notify step so concurrent register() calls
         * do not race each other.
         */ this._registerNotifyChain = Promise.resolve();
        /** Unsubscribe from Installations `onIdChange` when messaging is deleted. */ this._fidChangeUnsubscribe = null;
        this.logEvents = [];
        /**
         * Single source of truth for the logging loop lifecycle.
         *
         * `scheduled` holds the active timer id; `flushing` indicates an async dispatch
         * is in progress (prevents duplicate starts); `stopped` means idle.
         */ this.logQueue = {
            state: "stopped"
        };
        const appConfig = $4bcd2bcdfcaa5f94$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$getToken$1(messaging, options) {
    if (!navigator) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $4bcd2bcdfcaa5f94$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $4bcd2bcdfcaa5f94$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $4bcd2bcdfcaa5f94$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$logToScion(messaging, messageType, data) {
    const eventType = $4bcd2bcdfcaa5f94$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $4bcd2bcdfcaa5f94$var$getEventType(messageType) {
    switch(messageType){
        case $4bcd2bcdfcaa5f94$var$MessageType.NOTIFICATION_CLICKED:
            return "notification_open";
        case $4bcd2bcdfcaa5f94$var$MessageType.PUSH_RECEIVED:
            return "notification_foreground";
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $4bcd2bcdfcaa5f94$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === "function") messaging.onMessageHandler($4bcd2bcdfcaa5f94$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($4bcd2bcdfcaa5f94$var$externalizePayload(internalPayload));
    }
    if (messaging.onRegisteredHandler && internalPayload.messageType === $4bcd2bcdfcaa5f94$var$MessageType.FID_REGISTERED) {
        const fid = internalPayload.fid;
        if (typeof messaging.onRegisteredHandler === "function") messaging.onRegisteredHandler(fid);
        else messaging.onRegisteredHandler.next(fid);
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($4bcd2bcdfcaa5f94$var$isConsoleMessage(dataPayload) && dataPayload[$4bcd2bcdfcaa5f94$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1") await $4bcd2bcdfcaa5f94$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bcd2bcdfcaa5f94$var$WindowMessagingFactory = (container)=>{
    const messaging = new $4bcd2bcdfcaa5f94$var$MessagingService(container.getProvider("app").getImmediate(), container.getProvider("installations-internal").getImmediate(), container.getProvider("analytics-internal"));
    navigator.serviceWorker.addEventListener("message", (e)=>$4bcd2bcdfcaa5f94$var$messageEventListener(messaging, e));
    messaging._fidChangeUnsubscribe = $4bcd2bcdfcaa5f94$var$subscribeFidChangeRegistration(messaging, container.getProvider("installations").getImmediate());
    return messaging;
};
const $4bcd2bcdfcaa5f94$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider("messaging").getImmediate();
    const messagingInternal = {
        getToken: (options)=>$4bcd2bcdfcaa5f94$var$getToken$1(messaging, options),
        register: (options)=>$4bcd2bcdfcaa5f94$var$register$1(messaging, options)
    };
    return messagingInternal;
};
function $4bcd2bcdfcaa5f94$var$registerMessagingInWindow() {
    (0, $50998f1e63817c97$export$c930050e7bb63965)(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)("messaging", $4bcd2bcdfcaa5f94$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $50998f1e63817c97$export$c930050e7bb63965)(new (0, $18c346d4e76738d6$export$16fa2f45be04daa8)("messaging-internal", $4bcd2bcdfcaa5f94$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $50998f1e63817c97$export$d29d5299a7137abc)($4bcd2bcdfcaa5f94$var$name, $4bcd2bcdfcaa5f94$var$version);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $50998f1e63817c97$export$d29d5299a7137abc)($4bcd2bcdfcaa5f94$var$name, $4bcd2bcdfcaa5f94$var$version, "esm2020");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $4bcd2bcdfcaa5f94$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $f7a5b7f58ca24e89$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== "undefined" && (0, $f7a5b7f58ca24e89$export$3865db50535c2055)() && (0, $f7a5b7f58ca24e89$export$f172b7eb6cf60599)() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $4bcd2bcdfcaa5f94$var$deleteToken$1(messaging) {
    if (!navigator) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $4bcd2bcdfcaa5f94$var$registerDefaultSw(messaging);
    return $4bcd2bcdfcaa5f94$var$revokeRegistrationInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4bcd2bcdfcaa5f94$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Subscribes to an event that the app instance is registered with FCM via Firebase Installation ID (FID).
 * Use the FID passed to the callback to upload it to your application server.
 *
 * @param messaging - The {@link MessagingService} instance.
 * @param nextOrObserver - A function or observer object called when an FID is registered.
 * @returns Unsubscribe function to stop listening.
 */ function $4bcd2bcdfcaa5f94$var$onRegistered$1(messaging, nextOrObserver) {
    messaging.onRegisteredHandler = nextOrObserver;
    return ()=>{
        if (messaging.onRegisteredHandler === nextOrObserver) messaging.onRegisteredHandler = null;
    };
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Subscribes to an event that the app instance is unregistered from FCM so the FID is no longer active.
 * Use this to notify your backend to remove this FID to prevent 404 errors on send.
 *
 * @param messaging - The {@link MessagingService} instance.
 * @param nextOrObserver - A function or observer object called with the unregistered FID.
 * @returns Unsubscribe function to stop listening.
 */ function $4bcd2bcdfcaa5f94$var$onUnregistered$1(messaging, nextOrObserver) {
    messaging.onUnregisteredHandler = nextOrObserver;
    return ()=>{
        if (messaging.onUnregisteredHandler === nextOrObserver) messaging.onUnregisteredHandler = null;
    };
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unregisters the app instance from FCM by deleting its FID-based registration.
 *
 * On success, triggers the `onUnregistered` callback (if set) with the unregistered FID.
 *
 * @param messaging - The MessagingService instance.
 */ async function $4bcd2bcdfcaa5f94$var$unregister$1(messaging) {
    if (!navigator) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    // Prefer the last successfully registered FID from local metadata when available.
    const stored = await $4bcd2bcdfcaa5f94$var$dbGetFidRegistration(messaging.firebaseDependencies).catch(()=>undefined);
    var _stored_fid;
    const fid = (_stored_fid = stored === null || stored === void 0 ? void 0 : stored.fid) !== null && _stored_fid !== void 0 ? _stored_fid : await messaging.firebaseDependencies.installations.getId();
    await $4bcd2bcdfcaa5f94$var$requestDeleteRegistration(messaging.firebaseDependencies, fid);
    // Best-effort local cleanup; still resolve even if schema is unavailable.
    try {
        await $4bcd2bcdfcaa5f94$var$dbRemoveFidRegistration(messaging.firebaseDependencies);
    } catch  {
    // Ignore.
    }
    // Best-effort cleanup of legacy token details created via getToken().
    try {
        await $4bcd2bcdfcaa5f94$var$dbRemove(messaging.firebaseDependencies);
    } catch  {
    // Ignore.
    }
    const handler = messaging.onUnregisteredHandler;
    if (!handler) return;
    if (typeof handler === "function") handler(fid);
    else handler.next(fid);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $4bcd2bcdfcaa5f94$export$f74c3c76482a8451(app = (0, $50998f1e63817c97$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $4bcd2bcdfcaa5f94$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $4bcd2bcdfcaa5f94$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $50998f1e63817c97$export$fa0d6da0f5838f50)((0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(app), "messaging").getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @deprecated Use {@link register} together with {@link onRegistered} for Firebase
 * Installation ID-based messaging instead of retrieving an FCM registration token with this API.
 *
 * @public
 */ async function $4bcd2bcdfcaa5f94$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * If there is no legacy registration token but the client has FID-based registration metadata
 * (from {@link register}), this deletes that registration on the server, clears local metadata, and
 * invokes {@link onUnregistered} with the removed FID when successful.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @deprecated Use {@link onUnregistered} to observe when the client is no longer
 * registered and update your backend accordingly, instead of explicitly deleting the
 * registration token with this API.
 *
 * @public
 */ function $4bcd2bcdfcaa5f94$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $4bcd2bcdfcaa5f94$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * Registers the app instance with FCM using its Firebase Installation ID (FID). The FID is
 * delivered via the {@link onRegistered} callback, not as a return value. Call this to establish
 * an FID-based identity; once {@link onRegistered} provides an FID, instruct your backend to
 * remove any legacy token previously associated with this instance. The backend send API
 * supports FID as a target.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Optional. VAPID key and/or service worker registration (same as getToken).
 * @returns Promise that resolves when registration has been initiated; FID is delivered via onRegistered.
 *
 * @public
 */ async function $4bcd2bcdfcaa5f94$export$6503ec6e8aabbaf(messaging, options) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$register$1(messaging, options);
}
/**
 * Unregisters the app instance from FCM by deleting its FID-based registration.
 * On success, triggers {@link onUnregistered} (if registered) with the unregistered FID.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @public
 */ async function $4bcd2bcdfcaa5f94$export$d07f55d4c15c0440(messaging) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$unregister$1(messaging);
}
/**
 * Subscribes to an event that the app instance is registered with FCM via Firebase Installation ID (FID).
 * Use the FID passed to the callback to upload it to your application server. When you receive an FID
 * after calling {@link register}, instruct your backend to remove any legacy token for this instance.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - A function or observer object called when an FID is registered.
 * @returns Unsubscribe function to stop listening.
 *
 * @public
 */ function $4bcd2bcdfcaa5f94$export$e7432746460ffc3a(messaging, nextOrObserver) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$onRegistered$1(messaging, nextOrObserver);
}
/**
 * Subscribes to an event that the app instance is unregistered from FCM (FID no longer active).
 * Use this to notify your backend to remove this FID to prevent 404 errors on send.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - A function or observer object called with the unregistered FID.
 * @returns Unsubscribe function to stop listening.
 *
 * @public
 */ function $4bcd2bcdfcaa5f94$export$efa97a7b26a0147f(messaging, nextOrObserver) {
    messaging = (0, $f7a5b7f58ca24e89$export$4befe9b5fa509a1b)(messaging);
    return $4bcd2bcdfcaa5f94$var$onUnregistered$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $4bcd2bcdfcaa5f94$var$registerMessagingInWindow();





var $1090dd1b43a691d6$var$name = "firebase";
var $1090dd1b43a691d6$var$version = "12.15.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $50998f1e63817c97$export$d29d5299a7137abc)($1090dd1b43a691d6$var$name, $1090dd1b43a691d6$var$version, "app");


class $538dced1b795f5a6$export$8f83d3f28eb09744 {
}
$538dced1b795f5a6$export$8f83d3f28eb09744.SERVICE_WORKER_URL = "/firebase-messaging-sw.js";
$538dced1b795f5a6$export$8f83d3f28eb09744.FIREBASE_APP_NAME = "restanaut";
$538dced1b795f5a6$export$8f83d3f28eb09744.setup = async ()=>{
    try {
        var _document_querySelector;
        if (!("serviceWorker" in navigator) || !("Notification" in window) || !("PushManager" in window)) return;
        const response = await fetch("/api/v1/push/config");
        if (!response.ok) return;
        const { enabled: enabled, config: config, vapidKey: vapidKey } = await response.json();
        if (!enabled || !(config === null || config === void 0 ? void 0 : config.apiKey) || !vapidKey) return;
        if (!await (0, $4bcd2bcdfcaa5f94$export$48c17662a6902497)()) return;
        if (Notification.permission === "denied") return;
        if (Notification.permission === "default") {
            const permission = await Notification.requestPermission();
            if (permission !== "granted") return;
        }
        const registration = await navigator.serviceWorker.register($538dced1b795f5a6$export$8f83d3f28eb09744.SERVICE_WORKER_URL);
        var _getApps_find;
        const app = (_getApps_find = (0, $50998f1e63817c97$export$68ddedf7d44b3bdf)().find((existing)=>existing.name === $538dced1b795f5a6$export$8f83d3f28eb09744.FIREBASE_APP_NAME)) !== null && _getApps_find !== void 0 ? _getApps_find : (0, $50998f1e63817c97$export$c55cfd413944906d)(config, $538dced1b795f5a6$export$8f83d3f28eb09744.FIREBASE_APP_NAME);
        const messaging = (0, $4bcd2bcdfcaa5f94$export$f74c3c76482a8451)(app);
        const token = await (0, $4bcd2bcdfcaa5f94$export$257b2d10b709d8ef)(messaging, {
            vapidKey: vapidKey,
            serviceWorkerRegistration: registration
        });
        if (!token) return;
        var _document_querySelector_value;
        const csrf = (_document_querySelector_value = (_document_querySelector = document.querySelector('input[name="_csrf"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value) !== null && _document_querySelector_value !== void 0 ? _document_querySelector_value : "";
        await fetch("/api/v1/push/register", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrf
            },
            body: JSON.stringify({
                token: token
            })
        });
    } catch (error) {
    // Best-effort: ignore push setup failures so they never disrupt the orders page.
    }
};


// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved
class $007892703817a59c$export$df13b27c19527dbe {
}
$007892703817a59c$export$df13b27c19527dbe.STORAGE_KEY = "orders-sound-alarm";
$007892703817a59c$export$df13b27c19527dbe.CSS_ICON_ON = "bi-bell-fill";
$007892703817a59c$export$df13b27c19527dbe.CSS_ICON_OFF = "bi-bell-slash";
// On by default: only an explicit opt-out disables it.
$007892703817a59c$export$df13b27c19527dbe.isEnabled = ()=>localStorage.getItem($007892703817a59c$export$df13b27c19527dbe.STORAGE_KEY) !== "false";
$007892703817a59c$export$df13b27c19527dbe.setEnabled = (enabled)=>{
    localStorage.setItem($007892703817a59c$export$df13b27c19527dbe.STORAGE_KEY, enabled ? "true" : "false");
};
$007892703817a59c$export$df13b27c19527dbe.syncButton = (button)=>{
    const enabled = $007892703817a59c$export$df13b27c19527dbe.isEnabled();
    const icon = button.querySelector("i");
    icon === null || icon === void 0 ? void 0 : icon.classList.toggle($007892703817a59c$export$df13b27c19527dbe.CSS_ICON_ON, enabled);
    icon === null || icon === void 0 ? void 0 : icon.classList.toggle($007892703817a59c$export$df13b27c19527dbe.CSS_ICON_OFF, !enabled);
    button.setAttribute("aria-pressed", enabled ? "true" : "false");
};


class $08d160a8fb1a6d7d$export$13b67c67e6b8b746 {
    constructor(){
        this.pwaDeferredPrompt = null;
        this.rejectModal = null;
        this.pendingRejectOrderId = null;
        this.acceptModal = null;
        this.pendingAcceptOrderId = null;
        this.refundModal = null;
        this.pendingRefundOrderId = null;
        this.orderUpdatedHandler = null;
        this.orderNewHandler = null;
        this.orderPendingHandler = null;
        this.connectionChangeHandler = null;
        this.getPageId = ()=>"page-orders";
        this.execute = ()=>{
            this.pageEl = document.querySelector("[data-orders-page]");
            if (!this.pageEl) return;
            this.baseUrl = `/${this.pageEl.dataset.locationCode}/orders/${this.pageEl.dataset.restaurantKey}`;
            this.setupWelcomeModal();
            this.setupUpgradeModal();
            this.setupDeliveryMethodsModal();
            this.setupRejectModal();
            this.setupAcceptModal();
            this.setupRefundModal();
            this.setupOrderCards();
            this.setupBackButton();
            this.setupActionButtons();
            this.restoreUrlState();
            this.setupSocketListeners();
            this.setupConnectionStatus();
            this.setupPwaBar();
            this.setupSoundAlarm();
            (0, $538dced1b795f5a6$export$8f83d3f28eb09744).setup();
        };
        this.setupSoundAlarm = ()=>{
            this.pageEl.addEventListener("click", (event)=>{
                var _event_target;
                const toggle = (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.closest("[data-sound-alarm-toggle]");
                if (!toggle) return;
                (0, $007892703817a59c$export$df13b27c19527dbe).setEnabled(!(0, $007892703817a59c$export$df13b27c19527dbe).isEnabled());
                (0, $007892703817a59c$export$df13b27c19527dbe).syncButton(toggle);
            });
        };
        this.syncSoundAlarmButton = ()=>{
            const toggle = this.pageEl.querySelector("[data-sound-alarm-toggle]");
            if (toggle) (0, $007892703817a59c$export$df13b27c19527dbe).syncButton(toggle);
        };
        this.setupPwaBar = ()=>{
            var _bar_querySelector;
            const bar = this.pageEl.querySelector("[data-orders-pwa-bar]");
            if (!bar) return;
            // Hide in the installed PWA (iOS standalone isn't covered by the CSS display-mode media query).
            const isStandalone = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
            if (isStandalone) {
                bar.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
                return;
            }
            const dismissedAt = localStorage.getItem($08d160a8fb1a6d7d$export$13b67c67e6b8b746.PWA_BAR_DISMISS_KEY);
            if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < $08d160a8fb1a6d7d$export$13b67c67e6b8b746.PWA_BAR_DISMISS_MS) {
                bar.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
                return;
            }
            const installBtn = bar.querySelector("[data-pwa-install-btn]");
            // The whole bar stays hidden until the app is actually installable, so the message never
            // shows without a working Install button.
            window.addEventListener("beforeinstallprompt", (event)=>{
                event.preventDefault();
                this.pwaDeferredPrompt = event;
                bar.classList.remove($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
                installBtn === null || installBtn === void 0 ? void 0 : installBtn.classList.remove($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
            });
            installBtn === null || installBtn === void 0 ? void 0 : installBtn.addEventListener("click", async ()=>{
                if (!this.pwaDeferredPrompt) return;
                this.pwaDeferredPrompt.prompt();
                await this.pwaDeferredPrompt.userChoice;
                this.pwaDeferredPrompt = null;
                bar.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
            });
            (_bar_querySelector = bar.querySelector("[data-pwa-bar-close]")) === null || _bar_querySelector === void 0 ? void 0 : _bar_querySelector.addEventListener("click", ()=>{
                bar.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN);
                localStorage.setItem($08d160a8fb1a6d7d$export$13b67c67e6b8b746.PWA_BAR_DISMISS_KEY, String(Date.now()));
            });
        };
        this.restoreUrlState = ()=>{
            const params = new URLSearchParams(window.location.search);
            const orderId = params.get("orderId");
            if (orderId) {
                const detailBody = this.pageEl.querySelector("[data-orders-detail-body]");
                const preRendered = detailBody === null || detailBody === void 0 ? void 0 : detailBody.querySelector("[data-order-detail]");
                if (preRendered) {
                    this.highlightCard(orderId);
                    this.pageEl.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ORDER_SELECTED);
                    this.syncSoundAlarmButton();
                } else this.selectOrder(orderId);
            }
        };
        this.updateUrlParam = (key, value)=>{
            const params = new URLSearchParams(window.location.search);
            if (value === null) params.delete(key);
            else params.set(key, value);
            const search = params.toString();
            history.replaceState(null, "", search ? `${window.location.pathname}?${search}` : window.location.pathname);
        };
        this.setupWelcomeModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-welcome-modal]");
            if (!modalEl) return;
            const modal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            modal.show();
            const copyBtn = modalEl.querySelector("[data-copy-url]");
            copyBtn === null || copyBtn === void 0 ? void 0 : copyBtn.addEventListener("click", ()=>{
                (0, $a30b3a9a137baaed$export$1d8a493107fb4b3a).toClipboard(copyBtn.dataset.copyUrl);
            });
        };
        this.setupUpgradeModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-upgrade-modal]");
            if (!modalEl) return;
            const modal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            modal.show();
        };
        this.setupDeliveryMethodsModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-delivery-methods-modal]");
            if (!modalEl) return;
            const modal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            modal.show();
        };
        this.setupRejectModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-reject-modal]");
            if (!modalEl) return;
            this.rejectModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            const otherField = modalEl.querySelector("[data-reject-other-field]");
            const otherInput = modalEl.querySelector("[name='rejectReasonOther']");
            const radios = modalEl.querySelectorAll("[data-reject-reason-radio]");
            for (const radio of radios)radio.addEventListener("change", ()=>{
                const isOther = radio.dataset.isOther === "true";
                otherField === null || otherField === void 0 ? void 0 : otherField.classList.toggle($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN, !isOther);
                if (!isOther) otherInput === null || otherInput === void 0 ? void 0 : otherInput.classList.remove("is-invalid");
            });
            otherInput === null || otherInput === void 0 ? void 0 : otherInput.addEventListener("input", ()=>otherInput.classList.remove("is-invalid"));
            const confirmBtn = modalEl.querySelector("[data-reject-confirm]");
            confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.addEventListener("click", ()=>{
                const selectedRadio = modalEl.querySelector("input[name='rejectReason']:checked");
                const isOther = (selectedRadio === null || selectedRadio === void 0 ? void 0 : selectedRadio.dataset.isOther) === "true";
                if (isOther) {
                    if (!(otherInput === null || otherInput === void 0 ? void 0 : otherInput.value.trim())) {
                        otherInput === null || otherInput === void 0 ? void 0 : otherInput.classList.add("is-invalid");
                        return;
                    }
                }
                const reason = isOther ? otherInput.value.trim() : selectedRadio === null || selectedRadio === void 0 ? void 0 : selectedRadio.value;
                const orderId = this.pendingRejectOrderId;
                this.rejectModal.hide();
                this.pendingRejectOrderId = null;
                if (!orderId) return;
                this.rejectOrder(orderId, reason);
            });
            this.submitModalOnEnter(modalEl, confirmBtn);
        };
        this.submitModalOnEnter = (modalEl, confirmBtn)=>{
            modalEl.addEventListener("keydown", (event)=>{
                const keyboardEvent = event;
                if (keyboardEvent.key !== "Enter") return;
                const target = keyboardEvent.target;
                if (target.tagName === "BUTTON" || target.tagName === "A" || target.tagName === "TEXTAREA") return;
                keyboardEvent.preventDefault();
                confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.click();
            });
        };
        this.updateRejectReasonVisibility = (isDelivery)=>{
            var _this_pageEl;
            const modalEl = (_this_pageEl = this.pageEl) === null || _this_pageEl === void 0 ? void 0 : _this_pageEl.querySelector("[data-reject-modal]");
            if (!modalEl) return;
            const deliveryOnlyRows = modalEl.querySelectorAll("[data-reject-reason-row][data-delivery-only='true']");
            for (const row of deliveryOnlyRows){
                row.classList.toggle($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN, !isDelivery);
                const radio = row.querySelector("input[name='rejectReason']");
                if (radio && !isDelivery && radio.checked) {
                    radio.checked = false;
                    const firstRadio = modalEl.querySelector("input[name='rejectReason']");
                    if (firstRadio) firstRadio.checked = true;
                }
            }
        };
        this.setupAcceptModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-accept-modal]");
            if (!modalEl) return;
            this.acceptModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            const waitingInput = modalEl.querySelector("[name='waitingTimeMin']");
            const presets = modalEl.querySelectorAll("[data-waiting-time-preset]");
            for (const btn of presets)btn.addEventListener("click", ()=>{
                const waitingTimeMin = parseInt(btn.dataset.waitingTimePreset, 10);
                const orderId = this.pendingAcceptOrderId;
                this.acceptModal.hide();
                this.pendingAcceptOrderId = null;
                if (!orderId) return;
                this.acceptOrder(orderId, waitingTimeMin);
            });
            waitingInput === null || waitingInput === void 0 ? void 0 : waitingInput.addEventListener("input", ()=>waitingInput.classList.remove("is-invalid"));
            const confirmBtn = modalEl.querySelector("[data-accept-confirm]");
            confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.addEventListener("click", ()=>{
                const waitingTimeMin = parseInt(waitingInput === null || waitingInput === void 0 ? void 0 : waitingInput.value, 10);
                if (!(waitingInput === null || waitingInput === void 0 ? void 0 : waitingInput.value.trim()) || isNaN(waitingTimeMin) || waitingTimeMin < 1) {
                    waitingInput === null || waitingInput === void 0 ? void 0 : waitingInput.classList.add("is-invalid");
                    return;
                }
                const orderId = this.pendingAcceptOrderId;
                this.acceptModal.hide();
                this.pendingAcceptOrderId = null;
                if (!orderId) return;
                this.acceptOrder(orderId, waitingTimeMin);
            });
            this.submitModalOnEnter(modalEl, confirmBtn);
        };
        this.setupRefundModal = ()=>{
            const modalEl = this.pageEl.querySelector("[data-refund-modal]");
            if (!modalEl) return;
            this.refundModal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            const confirmBtn = modalEl.querySelector("[data-refund-confirm]");
            confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.addEventListener("click", ()=>{
                const orderId = this.pendingRefundOrderId;
                this.refundModal.hide();
                this.pendingRefundOrderId = null;
                if (!orderId) return;
                this.refundOrder(orderId);
            });
            this.submitModalOnEnter(modalEl, confirmBtn);
        };
        this.setupDropdowns = ()=>{
            const toggles = this.pageEl.querySelectorAll("[data-order-actions-toggle]");
            for (const toggle of toggles)(0, $d9aa5c6b16d90faa$export$931cbfb6bfb85fc).getOrCreateInstance(toggle);
        };
        this.highlightCard = (orderId)=>{
            const allCards = this.pageEl.querySelectorAll("[data-order-id]");
            for (const card of allCards){
                const el = card;
                if (el.dataset.orderAction) continue;
                el.classList.toggle($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ACTIVE, el.dataset.orderId === orderId);
            }
        };
        this.setupOrderCards = ()=>{
            const cards = this.pageEl.querySelectorAll("[data-order-id]");
            for (const card of cards){
                const el = card;
                if (el.dataset.orderAction) continue;
                el.addEventListener("click", ()=>this.selectOrder(el.dataset.orderId));
            }
        };
        this.selectOrder = async (orderId)=>{
            this.highlightCard(orderId);
            this.updateUrlParam("orderId", orderId);
            this.pageEl.classList.add($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ORDER_SELECTED);
            const detailBody = this.pageEl.querySelector("[data-orders-detail-body]");
            if (!detailBody) return;
            try {
                const response = await fetch(`${this.baseUrl}/details?id=${encodeURIComponent(orderId)}`);
                if (!response.ok) return;
                detailBody.innerHTML = await response.text();
                this.setupActionButtons();
                this.syncSoundAlarmButton();
                this.updateConnectionStatus((0, $16521f78b103838e$export$4bbaa2811faa41de).isConnected());
            } catch  {
            // Network error. Leave existing content
            }
        };
        this.setupBackButton = ()=>{
            const backBtn = this.pageEl.querySelector("[data-orders-back]");
            backBtn === null || backBtn === void 0 ? void 0 : backBtn.addEventListener("click", ()=>{
                this.pageEl.classList.remove($08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ORDER_SELECTED);
                this.updateUrlParam("orderId", null);
            });
        };
        this.setupActionButtons = ()=>{
            const actionButtons = this.pageEl.querySelectorAll("[data-order-action]");
            for (const btn of actionButtons)btn.addEventListener("click", ()=>{
                const el = btn;
                const action = el.dataset.orderAction;
                const orderId = el.dataset.orderId;
                if (action === "reject") {
                    var _this_rejectModal;
                    this.pendingRejectOrderId = orderId;
                    const isDeliveryType = el.dataset.orderDeliveryType === (0, $f0ffcdf5c347f6b9$export$917a0a970d86a2f4).Delivery;
                    this.updateRejectReasonVisibility(isDeliveryType);
                    (_this_rejectModal = this.rejectModal) === null || _this_rejectModal === void 0 ? void 0 : _this_rejectModal.show();
                    return;
                }
                if (action === "accept") {
                    var _this_acceptModal;
                    this.pendingAcceptOrderId = orderId;
                    (_this_acceptModal = this.acceptModal) === null || _this_acceptModal === void 0 ? void 0 : _this_acceptModal.show();
                    return;
                }
                if (action === "done") {
                    (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderDone, {
                        orderId: orderId
                    });
                    return;
                }
                if (action === "in-progress") {
                    (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderInProgress, {
                        orderId: orderId
                    });
                    return;
                }
                if (action === "refund") {
                    var _this_refundModal;
                    this.pendingRefundOrderId = orderId;
                    (_this_refundModal = this.refundModal) === null || _this_refundModal === void 0 ? void 0 : _this_refundModal.show();
                    return;
                }
            });
            this.setupDropdowns();
        };
        this.acceptOrder = (orderId, waitingTimeMin)=>{
            (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderAccept, {
                orderId: orderId,
                waitingTimeMin: waitingTimeMin
            });
        };
        this.rejectOrder = (orderId, reason)=>{
            (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderReject, {
                orderId: orderId,
                reason: reason
            });
        };
        this.refundOrder = (orderId)=>{
            (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderRefund, {
                orderId: orderId
            });
        };
        this.setupSocketListeners = ()=>{
            const onOrderUpdated = async (data)=>{
                await this.refreshList();
                const currentOrderId = new URLSearchParams(window.location.search).get("orderId");
                if (currentOrderId && currentOrderId === data.orderId) await this.selectOrder(currentOrderId);
            };
            (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderUpdated, onOrderUpdated);
            this.orderUpdatedHandler = onOrderUpdated;
            const onOrderNew = async ()=>{
                const pageParam = new URLSearchParams(window.location.search).get("page");
                const isOnFirstPage = !pageParam || pageParam === "1";
                if (!isOnFirstPage) return;
                await this.refreshList();
            };
            (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderNew, onOrderNew);
            this.orderNewHandler = onOrderNew;
            const onOrderPending = async ()=>{
                await this.refreshList();
            };
            (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderPending, onOrderPending);
            this.orderPendingHandler = onOrderPending;
        };
        this.setupConnectionStatus = ()=>{
            this.updateConnectionStatus((0, $16521f78b103838e$export$4bbaa2811faa41de).isConnected());
            const onConnectionChange = (connected)=>this.updateConnectionStatus(connected);
            (0, $16521f78b103838e$export$4bbaa2811faa41de).onConnectionChange(onConnectionChange);
            this.connectionChangeHandler = onConnectionChange;
        };
        this.updateConnectionStatus = (connected)=>{
            const statusEl = this.pageEl.querySelector("[data-connection-status]");
            if (!statusEl) return;
            statusEl.classList.toggle("connected", connected);
            statusEl.classList.toggle("disconnected", !connected);
            const labelEl = statusEl.querySelector("[data-connection-label]");
            if (!labelEl) return;
            labelEl.textContent = connected ? statusEl.dataset.labelConnected : statusEl.dataset.labelDisconnected;
        };
        this.fixPaginatorLinks = ()=>{
            for (const link of this.pageEl.querySelectorAll(".pagination a.page-link[href]")){
                const linkUrl = new URL(link.href, window.location.origin);
                linkUrl.pathname = window.location.pathname;
                link.href = `${linkUrl.pathname}${linkUrl.search}`;
            }
        };
        this.refreshList = async ()=>{
            try {
                const response = await fetch(`${this.baseUrl}/list${window.location.search}`);
                if (!response.ok) return;
                const listPanel = this.pageEl.querySelector("[data-orders-list-panel]");
                if (!listPanel) return;
                listPanel.outerHTML = await response.text();
                this.fixPaginatorLinks();
                this.setupOrderCards();
                const params = new URLSearchParams(window.location.search);
                const currentOrderId = params.get("orderId");
                if (currentOrderId) this.highlightCard(currentOrderId);
            } catch  {
            // Network error - leave existing content
            }
        };
        this.onPageClose = ()=>{
            if (this.orderUpdatedHandler) (0, $16521f78b103838e$export$4bbaa2811faa41de).off((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderUpdated, this.orderUpdatedHandler);
            if (this.orderNewHandler) (0, $16521f78b103838e$export$4bbaa2811faa41de).off((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderNew, this.orderNewHandler);
            if (this.orderPendingHandler) (0, $16521f78b103838e$export$4bbaa2811faa41de).off((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderPending, this.orderPendingHandler);
            if (this.connectionChangeHandler) (0, $16521f78b103838e$export$4bbaa2811faa41de).offConnectionChange(this.connectionChangeHandler);
        };
    }
}
$08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ACTIVE = "active";
$08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_HIDDEN = "d-none";
$08d160a8fb1a6d7d$export$13b67c67e6b8b746.CSS_ORDER_SELECTED = "order-selected";
$08d160a8fb1a6d7d$export$13b67c67e6b8b746.PWA_BAR_DISMISS_KEY = "orders-pwa-bar-dismissed";
$08d160a8fb1a6d7d$export$13b67c67e6b8b746.PWA_BAR_DISMISS_MS = 604800000 // 7 days
;


class $46d9d5a7d74b48f9$export$ff97ddd7b62e4930 {
}
$46d9d5a7d74b48f9$export$ff97ddd7b62e4930.printWhenReady = async ()=>{
    if (document.readyState !== "complete") await new Promise((resolve)=>window.addEventListener("load", ()=>resolve(), {
            once: true
        }));
    await Promise.all($46d9d5a7d74b48f9$export$ff97ddd7b62e4930.getPendingStylesheets());
    await $46d9d5a7d74b48f9$export$ff97ddd7b62e4930.nextPaint();
    window.print();
};
$46d9d5a7d74b48f9$export$ff97ddd7b62e4930.getPendingStylesheets = ()=>{
    const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
    return links.filter((link)=>!link.sheet).map((link)=>new Promise((resolve)=>{
            link.addEventListener("load", ()=>resolve(), {
                once: true
            });
            link.addEventListener("error", ()=>resolve(), {
                once: true
            });
        }));
};
$46d9d5a7d74b48f9$export$ff97ddd7b62e4930.nextPaint = ()=>new Promise((resolve)=>requestAnimationFrame(()=>requestAnimationFrame(()=>resolve())));


class $234a136dea2648af$export$606a1a80e3707881 {
    constructor(){
        this.getPageId = ()=>"print-order";
        this.execute = ()=>{
            (0, $46d9d5a7d74b48f9$export$ff97ddd7b62e4930).printWhenReady();
        };
        this.onPageClose = ()=>{};
    }
}



class $26c1ce9462577649$export$406ab9555081557 {
    constructor(){
        this.getPageId = ()=>"print-menu";
        this.execute = ()=>{
            (0, $46d9d5a7d74b48f9$export$ff97ddd7b62e4930).printWhenReady();
        };
        this.onPageClose = ()=>{};
    }
}



class $62040c917ec3ef2c$export$f1960bb92669a15f {
    constructor(){
        this.getPageId = ()=>"print-qr-menu";
        this.execute = ()=>{
            (0, $46d9d5a7d74b48f9$export$ff97ddd7b62e4930).printWhenReady();
        };
        this.onPageClose = ()=>{};
    }
}





class $f6810f45a9dae1f7$export$a26873792aacbadd {
    constructor(){
        this.addonModal = null;
        this.pendingAddonDishId = null;
        this.pendingAddonHalves = null;
        this.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
        this.t = (key)=>this.translation.t(key);
        this.getPageId = ()=>"page-restaurant";
        this.execute = async (pjax)=>{
            var _this_menuData;
            this.pjax = pjax;
            const dataEl = document.getElementById("menu-basket-data");
            if (!dataEl) return;
            try {
                this.menuData = JSON.parse(dataEl.textContent || "{}");
            } catch (error) {
                return;
            }
            if (!((_this_menuData = this.menuData) === null || _this_menuData === void 0 ? void 0 : _this_menuData.dishes)) return;
            await this.translation.fetchTranslations($f6810f45a9dae1f7$export$a26873792aacbadd.TRANSLATION_ID);
            this.itemsEl = document.querySelector("[data-basket-items]");
            this.emptyEl = document.querySelector("[data-basket-empty]");
            this.menu = new (0, $c26f41c501210151$export$d9b273488cd8ce6f)(this.menuData);
            this.basket = this.menu.load();
            this.setupAddButtons();
            this.setupHalfAndHalf();
            this.setupAddonModal();
            this.render();
        };
        this.onPageClose = ()=>{};
        this.setupAddButtons = ()=>{
            const buttons = document.querySelectorAll("[data-basket-add]");
            for (const button of buttons)button.addEventListener("click", ()=>this.addDish(button.dataset.dishId));
        };
        this.addDish = (dishId)=>{
            if (!dishId) return;
            if (this.menu.dishHasAddons(dishId)) {
                this.openAddonModal(dishId);
                return;
            }
            this.addDishWithAddons(dishId, []);
        };
        this.addDishWithAddons = (dishId, addons)=>{
            const newItem = {
                dishId: dishId,
                count: 1,
                ...addons.length > 0 && {
                    addons: addons
                }
            };
            const key = this.menu.getItemKey(newItem);
            const existing = this.basket.items.find((item)=>this.menu.getItemKey(item) === key);
            if (existing) existing.count += 1;
            else this.basket.items.push(newItem);
            this.menu.save(this.basket);
            this.render();
        };
        this.setupAddonModal = ()=>{
            var _modalEl_querySelector;
            const modalEl = document.querySelector("[data-addon-modal]");
            if (!modalEl) return;
            this.addonModal = (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).getOrCreateInstance(modalEl);
            for (const cancelButton of modalEl.querySelectorAll("[data-addon-cancel]"))cancelButton.addEventListener("click", ()=>{
                var _this_addonModal;
                return (_this_addonModal = this.addonModal) === null || _this_addonModal === void 0 ? void 0 : _this_addonModal.hide();
            });
            (_modalEl_querySelector = modalEl.querySelector("[data-addon-confirm]")) === null || _modalEl_querySelector === void 0 ? void 0 : _modalEl_querySelector.addEventListener("click", ()=>this.confirmAddons());
        };
        this.openAddonModal = (dishId)=>{
            var _this_addonModal;
            const modalEl = document.querySelector("[data-addon-modal]");
            if (!modalEl) {
                this.addDishWithAddons(dishId, []);
                return;
            }
            this.pendingAddonDishId = dishId;
            this.pendingAddonHalves = null;
            this.populateAddonSection(modalEl, "dish", this.menu.getDishAddons(dishId));
            this.populateAddonSection(modalEl, "category", this.menu.getCategoryAddons(dishId));
            (_this_addonModal = this.addonModal) === null || _this_addonModal === void 0 ? void 0 : _this_addonModal.show();
        };
        this.openAddonModalForHalves = (firstDishId, secondDishId)=>{
            var _this_addonModal;
            const modalEl = document.querySelector("[data-addon-modal]");
            if (!modalEl) {
                this.addHalfAndHalf(firstDishId, secondDishId, []);
                return;
            }
            this.pendingAddonDishId = null;
            this.pendingAddonHalves = [
                firstDishId,
                secondDishId
            ];
            this.populateAddonSection(modalEl, "dish", this.menu.getHalfAndHalfDishAddons(firstDishId, secondDishId));
            this.populateAddonSection(modalEl, "category", this.menu.getHalfAndHalfCategoryAddons(firstDishId, secondDishId));
            (_this_addonModal = this.addonModal) === null || _this_addonModal === void 0 ? void 0 : _this_addonModal.show();
        };
        this.populateAddonSection = (modalEl, section, addons)=>{
            const sectionEl = modalEl.querySelector(`[data-addon-section="${section}"]`);
            const listEl = modalEl.querySelector(`[data-addon-list="${section}"]`);
            if (!sectionEl || !listEl) return;
            sectionEl.classList.toggle("d-none", addons.length === 0);
            listEl.innerHTML = "";
            for (const addon of addons)listEl.appendChild(this.buildAddonRow(addon));
        };
        this.buildAddonRow = (addon)=>{
            const rowEl = document.createElement("div");
            rowEl.className = "d-flex justify-content-between align-items-center py-1";
            rowEl.dataset.addonItem = "true";
            rowEl.dataset.addonName = addon.name;
            rowEl.dataset.addonPrice = String(addon.price);
            rowEl.dataset.addonQty = "0";
            const priceLabel = addon.price > 0 ? `<span class="text-muted ms-1">+${this.menu.formatPrice(addon.price)}</span>` : "";
            rowEl.innerHTML = `
      <label class="d-flex align-items-center gap-2 mb-0" style="cursor:pointer;">
        <input type="checkbox" class="form-check-input mt-0" data-addon-check />
        <span>${addon.name}${priceLabel}</span>
      </label>
    `;
            const checkbox = rowEl.querySelector("[data-addon-check]");
            checkbox === null || checkbox === void 0 ? void 0 : checkbox.addEventListener("change", ()=>{
                rowEl.dataset.addonQty = checkbox.checked ? "1" : "0";
            });
            return rowEl;
        };
        this.confirmAddons = ()=>{
            var _this_addonModal;
            const dishId = this.pendingAddonDishId;
            const halves = this.pendingAddonHalves;
            (_this_addonModal = this.addonModal) === null || _this_addonModal === void 0 ? void 0 : _this_addonModal.hide();
            this.pendingAddonDishId = null;
            this.pendingAddonHalves = null;
            if (!dishId && !halves) return;
            const modalEl = document.querySelector("[data-addon-modal]");
            const addons = [];
            var _modalEl_querySelectorAll;
            for (const itemEl of (_modalEl_querySelectorAll = modalEl === null || modalEl === void 0 ? void 0 : modalEl.querySelectorAll("[data-addon-item]")) !== null && _modalEl_querySelectorAll !== void 0 ? _modalEl_querySelectorAll : []){
                var _itemEl_dataset_addonQty;
                const quantity = parseInt((_itemEl_dataset_addonQty = itemEl.dataset.addonQty) !== null && _itemEl_dataset_addonQty !== void 0 ? _itemEl_dataset_addonQty : "0", 10);
                if (quantity <= 0) continue;
                var _itemEl_dataset_addonName;
                addons.push({
                    name: (_itemEl_dataset_addonName = itemEl.dataset.addonName) !== null && _itemEl_dataset_addonName !== void 0 ? _itemEl_dataset_addonName : "",
                    price: Number(itemEl.dataset.addonPrice) || 0,
                    quantity: quantity
                });
            }
            if (halves) {
                this.addHalfAndHalf(halves[0], halves[1], addons);
                return;
            }
            this.addDishWithAddons(dishId, addons);
        };
        this.addHalfAndHalf = (firstDishId, secondDishId, addons)=>{
            const halves = [
                firstDishId,
                secondDishId
            ].sort();
            const newItem = {
                halfAndHalf: halves,
                count: 1,
                ...addons.length > 0 && {
                    addons: addons
                }
            };
            const key = this.menu.getItemKey(newItem);
            const existing = this.basket.items.find((item)=>this.menu.getItemKey(item) === key);
            if (existing) existing.count += 1;
            else this.basket.items.push(newItem);
            this.menu.save(this.basket);
            this.render();
        };
        this.changeCountByKey = (itemKey, delta)=>{
            if (!itemKey) return;
            const existing = this.basket.items.find((item)=>this.menu.getItemKey(item) === itemKey);
            if (existing) {
                existing.count += delta;
                if (existing.count <= 0) this.basket.items = this.basket.items.filter((item)=>this.menu.getItemKey(item) !== itemKey);
            }
            this.menu.save(this.basket);
            this.render();
        };
        this.setupHalfAndHalf = ()=>{
            for (const openButton of document.querySelectorAll("[data-hh-open]"))openButton.addEventListener("click", ()=>{
                const targetId = openButton.dataset.hhTarget;
                const modalEl = targetId ? document.getElementById(targetId) : null;
                if (!modalEl) return;
                this.clearHalfAndHalfSelection(modalEl);
                (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).getOrCreateInstance(modalEl).show();
            });
            for (const modalEl of document.querySelectorAll("[data-hh-modal]")){
                const modal = modalEl;
                for (const cancelButton of modal.querySelectorAll("[data-hh-cancel]"))cancelButton.addEventListener("click", ()=>(0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).getOrCreateInstance(modal).hide());
                for (const optionButton of modal.querySelectorAll("[data-hh-option]"))optionButton.addEventListener("click", ()=>this.onHalfAndHalfOptionClick(modal, optionButton));
                for (const cellEl of modal.querySelectorAll("td[data-hh-size-col]")){
                    cellEl.addEventListener("mouseenter", ()=>this.toggleHalfAndHalfColumnHover(modal, cellEl.dataset.hhSizeCol, true));
                    cellEl.addEventListener("mouseleave", ()=>this.toggleHalfAndHalfColumnHover(modal, cellEl.dataset.hhSizeCol, false));
                }
                modal.addEventListener("hidden.bs.modal", ()=>this.clearHalfAndHalfSelection(modal));
            }
        };
        this.clearHalfAndHalfSelection = (modal)=>{
            for (const option of modal.querySelectorAll("[data-hh-option]"))option.classList.remove("active");
            this.updateHalfAndHalfSizeLock(modal);
        };
        this.toggleHalfAndHalfColumnHover = (modal, sizeIndex, isHovered)=>{
            if (sizeIndex === undefined) return;
            for (const cellEl of modal.querySelectorAll(`[data-hh-size-col="${sizeIndex}"]`))cellEl.classList.toggle("hh-col-hover", isHovered);
        };
        this.updateHalfAndHalfSizeLock = (modal)=>{
            var _modal_querySelector;
            const activeSize = (_modal_querySelector = modal.querySelector("[data-hh-option].active")) === null || _modal_querySelector === void 0 ? void 0 : _modal_querySelector.dataset.hhSize;
            for (const option of modal.querySelectorAll("[data-hh-option]")){
                if (option.dataset.hhSize === undefined) continue;
                option.disabled = activeSize !== undefined && option.dataset.hhSize !== activeSize;
            }
        };
        this.onHalfAndHalfOptionClick = (modal, optionButton)=>{
            if (optionButton.classList.contains("active")) {
                optionButton.classList.remove("active");
                this.updateHalfAndHalfSizeLock(modal);
                return;
            }
            optionButton.classList.add("active");
            const selected = Array.from(modal.querySelectorAll("[data-hh-option].active"));
            if (selected.length < 2) {
                this.updateHalfAndHalfSizeLock(modal);
                return;
            }
            const firstDishId = selected[0].dataset.dishId;
            const secondDishId = selected[1].dataset.dishId;
            (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772).getOrCreateInstance(modal).hide();
            if (firstDishId && secondDishId) this.onHalfAndHalfSelected(firstDishId, secondDishId);
        };
        this.onHalfAndHalfSelected = (firstDishId, secondDishId)=>{
            if (this.menu.halfAndHalfHasAddons(firstDishId, secondDishId)) {
                this.openAddonModalForHalves(firstDishId, secondDishId);
                return;
            }
            this.addHalfAndHalf(firstDishId, secondDishId, []);
        };
        this.navigateToOrderPage = ()=>{
            const basePath = window.location.pathname.replace(/\/$/, "");
            this.pjax.loadUrl(`${basePath}/order`);
        };
        this.hasUnavailableItems = ()=>this.basket.items.some((item)=>!this.menu.isItemAvailable(item));
        this.buildAddonsSubLines = (item)=>this.menu.getItemAddons(item).map((addon)=>{
                const amount = this.menu.getAddonLineAmount(addon);
                const quantityLabel = addon.quantity > 1 ? ` \xd7${addon.quantity}` : "";
                const priceLabel = amount > 0 ? ` ${this.menu.formatPrice(amount)}` : "";
                return `
        <div class="text-muted small ps-3 pt-1">+ ${addon.name}${quantityLabel}${priceLabel}</div>
      `;
            }).join("");
        this.render = ()=>{
            var _this_emptyEl;
            const hasItems = this.basket.items.length > 0;
            const isStoreOpen = this.menuData.isStoreOpen !== false;
            const canOrder = hasItems && !this.hasUnavailableItems() && isStoreOpen;
            (_this_emptyEl = this.emptyEl) === null || _this_emptyEl === void 0 ? void 0 : _this_emptyEl.classList.toggle("d-none", hasItems);
            for (const button of document.querySelectorAll("[data-basket-order]")){
                const btn = button;
                btn.disabled = !canOrder;
                btn.onclick = canOrder ? this.navigateToOrderPage : null;
            }
            if (!this.itemsEl) return;
            let total = 0;
            const rows = [];
            const unavailableLabel = this.t("(Unavailable)");
            for (const item of this.basket.items){
                if (!this.menu.itemExists(item)) continue;
                const itemKey = this.menu.getItemKey(item);
                const lineTotal = this.menu.getItemLineTotal(item, null);
                total += lineTotal;
                const minusIcon = item.count === 1 ? "bi-trash" : "bi-dash";
                const isUnavailable = !this.menu.isItemAvailable(item);
                const namePrefix = isUnavailable ? `${unavailableLabel} ` : "";
                const feesHtml = this.menu.getItemApplicableFees(item, null).map((fee)=>{
                    const amount = this.menu.getItemFeeLineAmount(item, fee, item.count);
                    const label = fee.type === (0, $c26f41c501210151$export$b3cca15178f70d5).Percentage ? `${fee.name} ${fee.percentage}%` : fee.name;
                    return `
        <div class="text-muted small ps-3 pt-1">+ ${label} ${this.menu.formatPrice(amount)}</div>
      `;
                }).join("");
                const addonsHtml = this.buildAddonsSubLines(item);
                rows.push(`
        <div class="py-2 border-bottom${isUnavailable ? " opacity-50" : ""}">
          <div class="d-flex justify-content-between align-items-center">
            <div class="me-2">
              <div class="fw-semibold">${namePrefix}${this.menu.getItemName(item)}</div>
              <div class="text-muted small">${this.menu.formatPrice(this.menu.getItemUnitPrice(item))}</div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <button type="button" class="btn btn-outline-secondary btn-sm" data-basket-dec data-item-key="${itemKey}" aria-label="decrease">
                <i class="bi ${minusIcon}"></i>
              </button>
              <span class="fw-semibold text-center" style="min-width: 1.5rem;">${item.count}</span>
              <button type="button" class="btn btn-outline-secondary btn-sm" data-basket-inc data-item-key="${itemKey}" aria-label="increase">
                <i class="bi bi-plus"></i>
              </button>
              <span class="fw-semibold text-nowrap text-end ms-2" style="min-width: 4rem;">${this.menu.formatPrice(lineTotal)}</span>
            </div>
          </div>
          ${feesHtml}
          ${addonsHtml}
        </div>
      `);
            }
            this.itemsEl.innerHTML = rows.join("");
            const totalText = hasItems ? `(${this.menu.formatPrice(total)})` : "";
            for (const totalEl of document.querySelectorAll("[data-basket-order-total]"))totalEl.textContent = totalText;
            for (const button of this.itemsEl.querySelectorAll("[data-basket-dec]"))button.addEventListener("click", ()=>this.changeCountByKey(button.dataset.itemKey, -1));
            for (const button of this.itemsEl.querySelectorAll("[data-basket-inc]"))button.addEventListener("click", ()=>this.changeCountByKey(button.dataset.itemKey, 1));
        };
    }
}
$f6810f45a9dae1f7$export$a26873792aacbadd.TRANSLATION_ID = "PageRestaurant";



class $9ffb1d220fd401ba$export$ddba751a0608ff86 {
    constructor(){
        this.getPageId = ()=>"printer-details";
        this.execute = ()=>{
            const copyButton = document.querySelector("[data-copy-url]");
            if (!copyButton) return;
            copyButton.addEventListener("click", ()=>{
                (0, $a30b3a9a137baaed$export$1d8a493107fb4b3a).toClipboard(copyButton.dataset.copyUrl);
                const icon = copyButton.querySelector("i");
                if (!icon) return;
                const originalClassName = icon.className;
                icon.className = "bi bi-check-lg";
                window.setTimeout(()=>{
                    icon.className = originalClassName;
                }, $9ffb1d220fd401ba$export$ddba751a0608ff86.COPIED_FEEDBACK_MS);
            });
        };
        this.onPageClose = ()=>{};
    }
}
$9ffb1d220fd401ba$export$ddba751a0608ff86.COPIED_FEEDBACK_MS = 1500;




class $24cd5cce64c1422a$export$d3353f0f01759c4 {
}
$24cd5cce64c1422a$export$d3353f0f01759c4.MAX_DISTANCE_KM = {
    [(0, $f0ffcdf5c347f6b9$export$917a0a970d86a2f4).Table]: 5,
    [(0, $f0ffcdf5c347f6b9$export$917a0a970d86a2f4).PickUp]: 10
};
$24cd5cce64c1422a$export$d3353f0f01759c4.EARTH_RADIUS_KM = 6371;
$24cd5cce64c1422a$export$d3353f0f01759c4.DEGREES_TO_RADIANS = Math.PI / 180;
$24cd5cce64c1422a$export$d3353f0f01759c4.HALF_ANGLE_DIVISOR = 2;
$24cd5cce64c1422a$export$d3353f0f01759c4.getMaxDistanceKm = (deliveryType)=>{
    var _OrderProximity_MAX_DISTANCE_KM_deliveryType;
    return (_OrderProximity_MAX_DISTANCE_KM_deliveryType = $24cd5cce64c1422a$export$d3353f0f01759c4.MAX_DISTANCE_KM[deliveryType]) !== null && _OrderProximity_MAX_DISTANCE_KM_deliveryType !== void 0 ? _OrderProximity_MAX_DISTANCE_KM_deliveryType : null;
};
$24cd5cce64c1422a$export$d3353f0f01759c4.getDistanceKm = (fromLatitude, fromLongitude, toLatitude, toLongitude)=>{
    const latitudeDelta = (toLatitude - fromLatitude) * $24cd5cce64c1422a$export$d3353f0f01759c4.DEGREES_TO_RADIANS;
    const longitudeDelta = (toLongitude - fromLongitude) * $24cd5cce64c1422a$export$d3353f0f01759c4.DEGREES_TO_RADIANS;
    const fromLatitudeRadians = fromLatitude * $24cd5cce64c1422a$export$d3353f0f01759c4.DEGREES_TO_RADIANS;
    const toLatitudeRadians = toLatitude * $24cd5cce64c1422a$export$d3353f0f01759c4.DEGREES_TO_RADIANS;
    const halfChordSquared = Math.sin(latitudeDelta / $24cd5cce64c1422a$export$d3353f0f01759c4.HALF_ANGLE_DIVISOR) ** 2 + Math.cos(fromLatitudeRadians) * Math.cos(toLatitudeRadians) * Math.sin(longitudeDelta / $24cd5cce64c1422a$export$d3353f0f01759c4.HALF_ANGLE_DIVISOR) ** 2;
    const angularDistance = $24cd5cce64c1422a$export$d3353f0f01759c4.HALF_ANGLE_DIVISOR * Math.atan2(Math.sqrt(halfChordSquared), Math.sqrt(1 - halfChordSquared));
    return $24cd5cce64c1422a$export$d3353f0f01759c4.EARTH_RADIUS_KM * angularDistance;
};




class $9082a69b9dc06d28$export$e6929329b7fcd8ba {
    constructor(){
        this.deliveryQuote = null;
        this.quotedAddressKey = "";
        this.addressConfirmed = false;
        this.locationVerified = false;
        this.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
        this.t = (key)=>this.translation.t(key);
        this.getPageId = ()=>"page-restaurant-order";
        this.execute = async ()=>{
            var _this_menuData;
            const dataEl = document.getElementById("menu-basket-data");
            if (!dataEl) return;
            try {
                this.menuData = JSON.parse(dataEl.textContent || "{}");
            } catch (error) {
                return;
            }
            if (!((_this_menuData = this.menuData) === null || _this_menuData === void 0 ? void 0 : _this_menuData.dishes)) return;
            await this.translation.fetchTranslations($9082a69b9dc06d28$export$e6929329b7fcd8ba.TRANSLATION_ID);
            this.menu = new (0, $c26f41c501210151$export$d9b273488cd8ce6f)(this.menuData);
            this.basket = this.menu.load();
            this.setupDeliveryMethods();
            this.restoreDetails();
            this.addressConfirmed = this.getQuoteAddress() !== null;
            this.renderItems();
            this.updateTotals();
            this.updateDeliveryAddress();
            this.updateEatInSection();
            this.setupFormSubmit();
            this.setupAddressConfirmation();
            if (this.isDeliverySelected() && this.addressConfirmed) {
                await this.fetchDeliveryQuote();
                this.updateTotals();
            }
        };
        this.isDeliverySelected = ()=>this.getDeliveryMethod() === $9082a69b9dc06d28$export$e6929329b7fcd8ba.DELIVERY;
        this.setupAddressConfirmation = ()=>{
            const button = document.querySelector("[data-address-save]");
            button === null || button === void 0 ? void 0 : button.addEventListener("click", async ()=>{
                if (this.addressConfirmed) {
                    this.addressConfirmed = false;
                    this.updateDeliveryAddress();
                    this.updateTotals();
                    return;
                }
                await this.confirmAddress(button);
            });
        };
        this.confirmAddress = async (button)=>{
            var _this_deliveryQuote;
            this.hideUnverifiedAddressMessage();
            const address = this.getQuoteAddress();
            if (!address) {
                this.reportFirstEmptyAddressField();
                return;
            }
            button.disabled = true;
            await this.fetchDeliveryQuote();
            button.disabled = false;
            if (this.deliveryQuote && !this.deliveryQuote.verified) {
                this.showUnverifiedAddressMessage();
                return;
            }
            if (((_this_deliveryQuote = this.deliveryQuote) === null || _this_deliveryQuote === void 0 ? void 0 : _this_deliveryQuote.verified) && !this.deliveryQuote.available) {
                this.updateTotals();
                return;
            }
            this.addressConfirmed = true;
            this.saveDetails();
            this.updateDeliveryAddress();
            this.updateTotals();
        };
        this.reportFirstEmptyAddressField = ()=>{
            for (const fieldName of $9082a69b9dc06d28$export$e6929329b7fcd8ba.QUOTE_ADDRESS_FIELDS){
                var _input_value;
                const input = document.querySelector(`[name="${fieldName}"]`);
                if (!(input === null || input === void 0 ? void 0 : (_input_value = input.value) === null || _input_value === void 0 ? void 0 : _input_value.trim())) {
                    input === null || input === void 0 ? void 0 : input.reportValidity();
                    return;
                }
            }
        };
        this.showUnverifiedAddressMessage = ()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector("[data-delivery-unverified]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("d-none");
        };
        this.hideUnverifiedAddressMessage = ()=>{
            var _document_querySelector;
            (_document_querySelector = document.querySelector("[data-delivery-unverified]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("d-none");
        };
        this.getQuoteAddress = ()=>{
            const address = {};
            for (const fieldName of $9082a69b9dc06d28$export$e6929329b7fcd8ba.QUOTE_ADDRESS_FIELDS){
                var _input_value;
                const input = document.querySelector(`[name="${fieldName}"]`);
                var _input_value_trim;
                const value = (_input_value_trim = input === null || input === void 0 ? void 0 : (_input_value = input.value) === null || _input_value === void 0 ? void 0 : _input_value.trim()) !== null && _input_value_trim !== void 0 ? _input_value_trim : "";
                if (!value) return null;
                address[fieldName] = value;
            }
            return address;
        };
        this.fetchDeliveryQuote = async ()=>{
            const address = this.getQuoteAddress();
            if (!address) return;
            const addressKey = JSON.stringify(address);
            if (addressKey === this.quotedAddressKey) return;
            try {
                const searchParams = new URLSearchParams(address);
                const response = await fetch(`/api/v1/delivery-quote/${this.menuData.storeKey}?${searchParams.toString()}`);
                if (!response.ok) return;
                this.deliveryQuote = await response.json();
                this.quotedAddressKey = addressKey;
                this.updateTotals();
            } catch (error) {
            // Network error; the server validates again when the order is placed
            }
        };
        this.onPageClose = ()=>{};
        this.getDeliveryMethod = ()=>{
            const selected = document.querySelector("[data-delivery-method]:checked");
            var _selected_value;
            return (_selected_value = selected === null || selected === void 0 ? void 0 : selected.value) !== null && _selected_value !== void 0 ? _selected_value : null;
        };
        this.hasUnavailableItems = ()=>this.basket.items.some((item)=>!this.menu.isItemAvailable(item));
        this.renderItems = ()=>{
            const itemsEl = document.querySelector("[data-order-summary-items]");
            const emptyEl = document.querySelector("[data-order-empty]");
            const hasItems = this.basket.items.length > 0;
            emptyEl === null || emptyEl === void 0 ? void 0 : emptyEl.classList.toggle("d-none", hasItems);
            if (!itemsEl) return;
            const unavailableLabel = this.t("(Unavailable)");
            const deliveryMethod = this.getDeliveryMethod();
            const rows = [];
            for (const item of this.basket.items){
                if (!this.menu.itemExists(item)) continue;
                const unitPrice = this.menu.getItemUnitPrice(item);
                const lineTotal = this.menu.getItemLineTotal(item, deliveryMethod);
                const isUnavailable = !this.menu.isItemAvailable(item);
                const namePrefix = isUnavailable ? `${unavailableLabel} ` : "";
                const feesHtml = this.menu.getItemApplicableFees(item, deliveryMethod).map((fee)=>{
                    const amount = this.menu.getItemFeeLineAmount(item, fee, item.count);
                    const label = fee.type === (0, $c26f41c501210151$export$b3cca15178f70d5).Percentage ? `${fee.name} ${fee.percentage}%` : fee.name;
                    return `
        <div class="text-muted small ps-3 pt-1">+ ${label} ${this.menu.formatPrice(amount)}</div>
      `;
                }).join("");
                const addonsHtml = this.menu.getItemAddons(item).map((addon)=>{
                    const amount = this.menu.getAddonLineAmount(addon);
                    const quantityLabel = addon.quantity > 1 ? ` \xd7${addon.quantity}` : "";
                    const priceLabel = amount > 0 ? ` ${this.menu.formatPrice(amount)}` : "";
                    return `
        <div class="text-muted small ps-3 pt-1">+ ${addon.name}${quantityLabel}${priceLabel}</div>
      `;
                }).join("");
                rows.push(`
        <div class="py-2 border-bottom${isUnavailable ? " opacity-50" : ""}">
          <div class="d-flex justify-content-between align-items-center">
            <div class="me-2">
              <div class="fw-semibold">${namePrefix}${this.menu.getItemName(item)}</div>
              <div class="text-muted small">${item.count} \xd7 ${this.menu.formatPrice(unitPrice)}</div>
            </div>
            <span class="fw-semibold text-nowrap text-end">${this.menu.formatPrice(lineTotal)}</span>
          </div>
          ${feesHtml}
          ${addonsHtml}
        </div>
      `);
            }
            itemsEl.innerHTML = rows.join("");
        };
        this.setupFormSubmit = ()=>{
            const form = document.querySelector("form");
            form === null || form === void 0 ? void 0 : form.addEventListener("submit", (event)=>{
                if (this.isDeliverySelected() && !this.addressConfirmed) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                if (this.needsLocationCheck() && !this.locationVerified) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.verifyLocation();
                    return;
                }
                this.saveDetails();
                if (!this.isOnlinePaymentSelected()) localStorage.removeItem(this.menu.getStorageKey());
            });
        };
        this.getStoreCoordinates = ()=>{
            const form = document.querySelector("form");
            var _form_dataset_storeLatitude;
            const latitude = Number((_form_dataset_storeLatitude = form === null || form === void 0 ? void 0 : form.dataset.storeLatitude) !== null && _form_dataset_storeLatitude !== void 0 ? _form_dataset_storeLatitude : "");
            var _form_dataset_storeLongitude;
            const longitude = Number((_form_dataset_storeLongitude = form === null || form === void 0 ? void 0 : form.dataset.storeLongitude) !== null && _form_dataset_storeLongitude !== void 0 ? _form_dataset_storeLongitude : "");
            if (!(form === null || form === void 0 ? void 0 : form.dataset.storeLatitude) || !(form === null || form === void 0 ? void 0 : form.dataset.storeLongitude)) return null;
            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
            return {
                latitude: latitude,
                longitude: longitude
            };
        };
        this.needsLocationCheck = ()=>{
            var _this_getDeliveryMethod;
            const maxDistanceKm = (0, $24cd5cce64c1422a$export$d3353f0f01759c4).getMaxDistanceKm((_this_getDeliveryMethod = this.getDeliveryMethod()) !== null && _this_getDeliveryMethod !== void 0 ? _this_getDeliveryMethod : "");
            if (maxDistanceKm === null) return false;
            if (this.isOnlinePaymentSelected()) return false;
            return this.getStoreCoordinates() !== null;
        };
        this.verifyLocation = ()=>{
            if (!navigator.geolocation) {
                this.showLocationMessage(this.t("We need to confirm that you are at the right restaurant. Please allow location access and try again."), "warning");
                this.restorePlaceOrderButton();
                return;
            }
            this.hideLocationMessage();
            navigator.geolocation.getCurrentPosition(this.onLocationSuccess, this.onLocationError, {
                enableHighAccuracy: true,
                timeout: $9082a69b9dc06d28$export$e6929329b7fcd8ba.LOCATION_TIMEOUT_MS,
                maximumAge: $9082a69b9dc06d28$export$e6929329b7fcd8ba.LOCATION_MAX_AGE_MS
            });
        };
        this.onLocationSuccess = (position)=>{
            const storeCoordinates = this.getStoreCoordinates();
            var _this_getDeliveryMethod;
            const maxDistanceKm = (0, $24cd5cce64c1422a$export$d3353f0f01759c4).getMaxDistanceKm((_this_getDeliveryMethod = this.getDeliveryMethod()) !== null && _this_getDeliveryMethod !== void 0 ? _this_getDeliveryMethod : "");
            if (storeCoordinates && maxDistanceKm !== null) {
                const distanceKm = (0, $24cd5cce64c1422a$export$d3353f0f01759c4).getDistanceKm(position.coords.latitude, position.coords.longitude, storeCoordinates.latitude, storeCoordinates.longitude);
                if (distanceKm > maxDistanceKm) {
                    const message = this.t("You're {{distance}} km away from the restaurant. You need to be closer to place this order.").replace("{{distance}}", distanceKm.toFixed($9082a69b9dc06d28$export$e6929329b7fcd8ba.DISTANCE_DECIMALS));
                    this.showLocationMessage(message, "danger");
                    this.restorePlaceOrderButton();
                    return;
                }
            }
            const latitudeInput = document.querySelector("[data-browser-latitude]");
            const longitudeInput = document.querySelector("[data-browser-longitude]");
            if (latitudeInput) latitudeInput.value = String(position.coords.latitude);
            if (longitudeInput) longitudeInput.value = String(position.coords.longitude);
            this.locationVerified = true;
            this.hideLocationMessage();
            this.restorePlaceOrderButton();
            const form = document.querySelector("form");
            form === null || form === void 0 ? void 0 : form.requestSubmit();
        };
        this.onLocationError = ()=>{
            this.showLocationMessage(this.t("We need to confirm that you are at the right restaurant. Please allow location access and try again."), "warning");
            this.restorePlaceOrderButton();
        };
        this.restorePlaceOrderButton = ()=>{
            const button = document.querySelector("[data-order-place]");
            if (button) button.type = "submit";
            this.updateTotals();
        };
        this.showLocationMessage = (message, style)=>{
            const messageEl = document.querySelector("[data-location-check-message]");
            if (!messageEl) return;
            messageEl.className = `alert alert-${style} mb-3`;
            messageEl.textContent = message;
        };
        this.hideLocationMessage = ()=>{
            const messageEl = document.querySelector("[data-location-check-message]");
            if (messageEl) messageEl.className = "alert mb-3 d-none";
        };
        this.isOnlinePaymentSelected = ()=>{
            const selected = document.querySelector('input[name="paymentMethod"]:checked');
            return (selected === null || selected === void 0 ? void 0 : selected.value) === (0, $f0ffcdf5c347f6b9$export$34b52ce9cfcb0a39).Online;
        };
        this.saveDetails = ()=>{
            const form = document.querySelector("form");
            if (!form) return;
            const details = {};
            for (const fieldName of $9082a69b9dc06d28$export$e6929329b7fcd8ba.PERSISTED_FIELDS){
                const input = form.querySelector(`[name="${fieldName}"]`);
                var _input_value;
                details[fieldName] = (_input_value = input === null || input === void 0 ? void 0 : input.value) !== null && _input_value !== void 0 ? _input_value : "";
            }
            const deliveryMethod = this.getDeliveryMethod();
            if (deliveryMethod) details.deliveryMethod = deliveryMethod;
            try {
                localStorage.setItem($9082a69b9dc06d28$export$e6929329b7fcd8ba.STORAGE_KEY_DETAILS, JSON.stringify(details));
            } catch (error) {
            // localStorage unavailable (e.g. private mode); ignore
            }
        };
        this.restoreDetails = ()=>{
            const form = document.querySelector("form");
            if (!form) return;
            let details;
            try {
                const raw = localStorage.getItem($9082a69b9dc06d28$export$e6929329b7fcd8ba.STORAGE_KEY_DETAILS);
                if (!raw) return;
                details = JSON.parse(raw);
            } catch (error) {
                return;
            }
            if (!details) return;
            for (const fieldName of $9082a69b9dc06d28$export$e6929329b7fcd8ba.PERSISTED_FIELDS){
                const value = details[fieldName];
                if (value === undefined) continue;
                const input = form.querySelector(`[name="${fieldName}"]`);
                if (input) input.value = value;
            }
            const deliveryMethod = details.deliveryMethod;
            if (deliveryMethod) {
                const radio = form.querySelector(`[name="deliveryMethod"][value="${deliveryMethod}"]`);
                if (radio) radio.checked = true;
            }
        };
        this.setupDeliveryMethods = ()=>{
            for (const radio of document.querySelectorAll("[data-delivery-method]"))radio.addEventListener("change", this.refresh);
            for (const radio of document.querySelectorAll("[data-eatin-place]"))radio.addEventListener("change", this.updateEatInSection);
            for (const radio of document.querySelectorAll('input[name="paymentMethod"]'))radio.addEventListener("change", this.refresh);
        };
        this.refresh = ()=>{
            this.locationVerified = false;
            this.hideLocationMessage();
            this.renderItems();
            this.updateTotals();
            this.updateDeliveryAddress();
            this.updateEatInSection();
            if (this.isDeliverySelected() && this.addressConfirmed) this.fetchDeliveryQuote();
        };
        this.getSelectedEatInPlace = ()=>{
            const places = document.querySelectorAll("[data-eatin-place]");
            for (const place of places){
                const input = place;
                if (input.type !== "radio") return input;
                if (input.checked) return input;
            }
            return null;
        };
        this.updateEatInSection = ()=>{
            var _document_querySelector;
            const isEatIn = this.getDeliveryMethod() === $9082a69b9dc06d28$export$e6929329b7fcd8ba.EAT_IN;
            (_document_querySelector = document.querySelector("[data-eatin-section]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.toggle("d-none", !isEatIn);
            const selectedPlace = this.getSelectedEatInPlace();
            const needsNumber = isEatIn && (selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.dataset.needsNumber) === "true";
            const numberField = document.querySelector("[data-eatin-number-field]");
            const numberInput = document.querySelector("[data-eatin-number-input]");
            const numberLabel = document.querySelector("[data-eatin-number-label]");
            numberField === null || numberField === void 0 ? void 0 : numberField.classList.toggle("d-none", !needsNumber);
            if (numberInput) numberInput.required = !!needsNumber;
            var _selectedPlace_dataset_numberLabel;
            if (needsNumber && numberLabel) numberLabel.textContent = (_selectedPlace_dataset_numberLabel = selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.dataset.numberLabel) !== null && _selectedPlace_dataset_numberLabel !== void 0 ? _selectedPlace_dataset_numberLabel : "";
            var _selectedPlace_dataset_numberPlaceholder;
            if (needsNumber && numberInput) numberInput.placeholder = (_selectedPlace_dataset_numberPlaceholder = selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.dataset.numberPlaceholder) !== null && _selectedPlace_dataset_numberPlaceholder !== void 0 ? _selectedPlace_dataset_numberPlaceholder : "";
            var _selectedPlace_dataset_customerInfo;
            const counterInfo = isEatIn && !needsNumber ? (_selectedPlace_dataset_customerInfo = selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.dataset.customerInfo) !== null && _selectedPlace_dataset_customerInfo !== void 0 ? _selectedPlace_dataset_customerInfo : "" : "";
            const counterInfoEl = document.querySelector("[data-eatin-counter-info]");
            if (counterInfoEl) {
                counterInfoEl.textContent = counterInfo;
                counterInfoEl.classList.toggle("d-none", !counterInfo);
            }
        };
        this.updateDeliveryAddress = ()=>{
            var _document_querySelector;
            const isDelivery = this.isDeliverySelected();
            const addressEl = document.querySelector("[data-delivery-address]");
            addressEl === null || addressEl === void 0 ? void 0 : addressEl.classList.toggle("d-none", !isDelivery);
            for (const input of document.querySelectorAll("input[data-required-for-delivery]"))input.required = isDelivery;
            const needsAddressConfirmation = isDelivery && !this.addressConfirmed;
            (_document_querySelector = document.querySelector("[data-order-rest]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.toggle("d-none", needsAddressConfirmation);
            if (!needsAddressConfirmation) this.hideUnverifiedAddressMessage();
            const button = document.querySelector("[data-address-save]");
            if (button) {
                var _button_dataset_labelChange, _button_dataset_labelSave;
                button.textContent = this.addressConfirmed ? (_button_dataset_labelChange = button.dataset.labelChange) !== null && _button_dataset_labelChange !== void 0 ? _button_dataset_labelChange : "" : (_button_dataset_labelSave = button.dataset.labelSave) !== null && _button_dataset_labelSave !== void 0 ? _button_dataset_labelSave : "";
                button.className = this.addressConfirmed ? "btn btn-outline-secondary" : "btn btn-primary";
            }
            for (const fieldName of $9082a69b9dc06d28$export$e6929329b7fcd8ba.ADDRESS_CARD_FIELDS){
                const input = document.querySelector(`[name="${fieldName}"]`);
                if (input) input.readOnly = this.addressConfirmed;
            }
        };
        this.updateTotals = ()=>{
            var _this_deliveryQuote, _this_deliveryQuote1, _this_deliveryQuote2, _document_querySelector;
            const deliveryMethod = this.getDeliveryMethod();
            const isDelivery = deliveryMethod === $9082a69b9dc06d28$export$e6929329b7fcd8ba.DELIVERY;
            const hasItems = this.basket.items.length > 0;
            const subtotal = this.menu.getSubtotal(this.basket, deliveryMethod);
            const isDeliveryUnavailable = isDelivery && !!((_this_deliveryQuote = this.deliveryQuote) === null || _this_deliveryQuote === void 0 ? void 0 : _this_deliveryQuote.verified) && !((_this_deliveryQuote1 = this.deliveryQuote) === null || _this_deliveryQuote1 === void 0 ? void 0 : _this_deliveryQuote1.available);
            const deliveryCost = isDelivery && ((_this_deliveryQuote2 = this.deliveryQuote) === null || _this_deliveryQuote2 === void 0 ? void 0 : _this_deliveryQuote2.available) ? this.deliveryQuote.deliveryCost : 0;
            const total = subtotal + deliveryCost;
            const subtotalEl = document.querySelector("[data-order-subtotal]");
            if (subtotalEl) subtotalEl.textContent = this.menu.formatPrice(subtotal);
            const deliveryRow = document.querySelector("[data-order-delivery-row]");
            const deliveryEl = document.querySelector("[data-order-delivery]");
            deliveryRow === null || deliveryRow === void 0 ? void 0 : deliveryRow.classList.toggle("d-none", deliveryCost <= 0);
            if (deliveryEl) deliveryEl.textContent = this.menu.formatPrice(deliveryCost);
            const totalEl = document.querySelector("[data-order-total]");
            if (totalEl) totalEl.textContent = this.menu.formatPrice(total);
            (_document_querySelector = document.querySelector("[data-delivery-unavailable]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.toggle("d-none", !isDeliveryUnavailable);
            const isStoreOpen = this.menuData.isStoreOpen !== false;
            const placeBtn = document.querySelector("[data-order-place]");
            if (placeBtn) placeBtn.disabled = !hasItems || this.hasUnavailableItems() || !isStoreOpen || isDeliveryUnavailable;
            const basketInput = document.querySelector("[data-order-basket-input]");
            if (basketInput) basketInput.value = JSON.stringify(this.basket);
        };
    }
}
$9082a69b9dc06d28$export$e6929329b7fcd8ba.TRANSLATION_ID = "PageRestaurantOrder";
$9082a69b9dc06d28$export$e6929329b7fcd8ba.DELIVERY = "delivery";
$9082a69b9dc06d28$export$e6929329b7fcd8ba.EAT_IN = "table";
$9082a69b9dc06d28$export$e6929329b7fcd8ba.STORAGE_KEY_DETAILS = "restaurant-order-details";
$9082a69b9dc06d28$export$e6929329b7fcd8ba.PERSISTED_FIELDS = [
    "firstName",
    "lastName",
    "phoneNumber",
    "email",
    "city",
    "zipCode",
    "street",
    "streetNumber",
    "unitNumber",
    "floor"
];
$9082a69b9dc06d28$export$e6929329b7fcd8ba.QUOTE_ADDRESS_FIELDS = [
    "city",
    "zipCode",
    "street",
    "streetNumber"
];
$9082a69b9dc06d28$export$e6929329b7fcd8ba.ADDRESS_CARD_FIELDS = [
    "city",
    "zipCode",
    "street",
    "streetNumber",
    "unitNumber",
    "floor"
];
$9082a69b9dc06d28$export$e6929329b7fcd8ba.LOCATION_TIMEOUT_MS = 15000;
$9082a69b9dc06d28$export$e6929329b7fcd8ba.LOCATION_MAX_AGE_MS = 30000;
$9082a69b9dc06d28$export$e6929329b7fcd8ba.DISTANCE_DECIMALS = 1;





class $96a194e6c0d55846$export$c722ad0af08974c9 {
    constructor(){
        this.orderId = null;
        this.statusChangedHandler = null;
        this.getPageId = ()=>"page-restaurant-order-confirmation";
        this.execute = (pjax)=>{
            this.pjax = pjax;
            const confirmationEl = document.querySelector("[data-order-confirmation]");
            if (!confirmationEl) return;
            this.orderId = confirmationEl.dataset.orderId || null;
            if (!this.orderId) return;
            this.clearBasketWhenSettled(confirmationEl);
            (0, $16521f78b103838e$export$4bbaa2811faa41de).emit((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderJoin, {
                orderId: this.orderId
            });
            const onStatusChanged = (data)=>{
                if (data.orderId !== this.orderId) return;
                this.pjax.loadUrl(window.location.href);
            };
            (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderUpdated, onStatusChanged);
            this.statusChangedHandler = onStatusChanged;
        };
        this.clearBasketWhenSettled = (confirmationEl)=>{
            const storeKey = confirmationEl.dataset.storeKey;
            if (!storeKey || confirmationEl.dataset.clearBasket !== "true") return;
            try {
                localStorage.removeItem((0, $c26f41c501210151$export$d9b273488cd8ce6f).getStorageKeyFor(storeKey));
            } catch (error) {
                return;
            }
        };
        this.onPageClose = ()=>{
            if (this.statusChangedHandler) (0, $16521f78b103838e$export$4bbaa2811faa41de).off((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderUpdated, this.statusChangedHandler);
        };
    }
}



class $d2ae2d8be4a94988$export$4fe290a385e6544a {
    constructor(){
        this.getPageId = ()=>"theme-edit-page";
        this.execute = async ()=>{
            const modalEl = document.querySelector("[data-theme-upgrade-modal]");
            if (!modalEl) return;
            const modal = new (0, $d9aa5c6b16d90faa$export$2b77a92f1a5ad772)(modalEl);
            modal.show();
        };
        this.onPageClose = ()=>{};
    }
}


class $b1792a5ee911bd48$export$5aabc7b69b716437 {
    constructor(){
        this.getPageId = ()=>"manage-leads";
        this.execute = (pjax)=>{
            this.pjax = pjax;
            const importButton = document.querySelector(".js-import-leads");
            const fileInput = document.querySelector(".js-import-leads-file");
            if (!importButton || !fileInput) return;
            importButton.addEventListener("click", ()=>fileInput.click());
            fileInput.addEventListener("change", ()=>this.importFile(importButton, fileInput));
        };
        this.importFile = async (importButton, fileInput)=>{
            var _fileInput_files;
            const file = (_fileInput_files = fileInput.files) === null || _fileInput_files === void 0 ? void 0 : _fileInput_files[0];
            if (!file) return;
            importButton.disabled = true;
            try {
                var _document_querySelector;
                const formData = new FormData();
                formData.append("file", file);
                var _document_querySelector_value;
                const csrfToken = (_document_querySelector_value = (_document_querySelector = document.querySelector('input[name="_csrf"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value) !== null && _document_querySelector_value !== void 0 ? _document_querySelector_value : "";
                const response = await fetch("/api/v1/leads/import", {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": csrfToken
                    },
                    body: formData
                });
                const result = await response.json().catch(()=>null);
                if (!response.ok || !(result === null || result === void 0 ? void 0 : result.success)) {
                    var _result_error;
                    window.alert((_result_error = result === null || result === void 0 ? void 0 : result.error) !== null && _result_error !== void 0 ? _result_error : "Couldn't import leads");
                    return;
                }
                this.pjax.loadUrl(window.location.pathname + window.location.search);
            } catch (error) {
                window.alert("Couldn't import leads");
            } finally{
                importButton.disabled = false;
                fileInput.value = "";
            }
        };
        this.onPageClose = ()=>{};
    }
}


/**
 * Swiper 11.2.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 19, 2025
 */ /**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ function $59962c5e7ec9755b$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $59962c5e7ec9755b$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($59962c5e7ec9755b$var$isObject(src[key]) && $59962c5e7ec9755b$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $59962c5e7ec9755b$var$extend(target[key], src[key]);
    });
}
const $59962c5e7ec9755b$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $59962c5e7ec9755b$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $59962c5e7ec9755b$var$extend(doc, $59962c5e7ec9755b$var$ssrDocument);
    return doc;
}
const $59962c5e7ec9755b$var$ssrWindow = {
    document: $59962c5e7ec9755b$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $59962c5e7ec9755b$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $59962c5e7ec9755b$var$extend(win, $59962c5e7ec9755b$var$ssrWindow);
    return win;
}



function $74e748383b8b0bc3$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $74e748383b8b0bc3$export$d141bba7fdc215a3(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $74e748383b8b0bc3$export$4368d992c4eafac0() {
    return Date.now();
}
function $74e748383b8b0bc3$var$getComputedStyle(el) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $74e748383b8b0bc3$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $74e748383b8b0bc3$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $74e748383b8b0bc3$export$882b5998b3b9117c(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $74e748383b8b0bc3$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $74e748383b8b0bc3$export$efccba1c4a2ef57b() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$74e748383b8b0bc3$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($74e748383b8b0bc3$export$882b5998b3b9117c(to[nextKey]) && $74e748383b8b0bc3$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $74e748383b8b0bc3$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$74e748383b8b0bc3$export$882b5998b3b9117c(to[nextKey]) && $74e748383b8b0bc3$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $74e748383b8b0bc3$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $74e748383b8b0bc3$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $74e748383b8b0bc3$export$625550452a3fa3ec(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $74e748383b8b0bc3$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $74e748383b8b0bc3$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $74e748383b8b0bc3$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $74e748383b8b0bc3$export$90a7f3efeed30595(el, parent) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $74e748383b8b0bc3$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $74e748383b8b0bc3$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $74e748383b8b0bc3$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $74e748383b8b0bc3$export$23f2a1d2818174ef(classes));
    return el;
}
function $74e748383b8b0bc3$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $74e748383b8b0bc3$export$43caf9889c228507(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $74e748383b8b0bc3$export$9e5f44173e64f162(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $74e748383b8b0bc3$export$ffb5f4729a158638(el, prop) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $74e748383b8b0bc3$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $74e748383b8b0bc3$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $74e748383b8b0bc3$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $74e748383b8b0bc3$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $74e748383b8b0bc3$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $74e748383b8b0bc3$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


let $540c81a3e159e837$var$support;
function $540c81a3e159e837$var$calcSupport() {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $540c81a3e159e837$var$getSupport() {
    if (!$540c81a3e159e837$var$support) $540c81a3e159e837$var$support = $540c81a3e159e837$var$calcSupport();
    return $540c81a3e159e837$var$support;
}
let $540c81a3e159e837$var$deviceCached;
function $540c81a3e159e837$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $540c81a3e159e837$var$getSupport();
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $540c81a3e159e837$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$540c81a3e159e837$var$deviceCached) $540c81a3e159e837$var$deviceCached = $540c81a3e159e837$var$calcDevice(overrides);
    return $540c81a3e159e837$var$deviceCached;
}
let $540c81a3e159e837$var$browser;
function $540c81a3e159e837$var$calcBrowser() {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const device = $540c81a3e159e837$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $540c81a3e159e837$var$getBrowser() {
    if (!$540c81a3e159e837$var$browser) $540c81a3e159e837$var$browser = $540c81a3e159e837$var$calcBrowser();
    return $540c81a3e159e837$var$browser;
}
function $540c81a3e159e837$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $540c81a3e159e837$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $74e748383b8b0bc3$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $540c81a3e159e837$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $540c81a3e159e837$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "padding-left") || 0, 10) - parseInt((0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "padding-top") || 0, 10) - parseInt((0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $540c81a3e159e837$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $74e748383b8b0bc3$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $74e748383b8b0bc3$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $74e748383b8b0bc3$export$ffb5f4729a158638)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $74e748383b8b0bc3$export$2d1720544b23b823)(slide, "width", true) : (0, $74e748383b8b0bc3$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $74e748383b8b0bc3$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $74e748383b8b0bc3$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $540c81a3e159e837$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $540c81a3e159e837$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $540c81a3e159e837$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $540c81a3e159e837$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $540c81a3e159e837$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $540c81a3e159e837$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $540c81a3e159e837$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const $540c81a3e159e837$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $540c81a3e159e837$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $74e748383b8b0bc3$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $74e748383b8b0bc3$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $540c81a3e159e837$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $540c81a3e159e837$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $540c81a3e159e837$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $540c81a3e159e837$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $540c81a3e159e837$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $540c81a3e159e837$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $540c81a3e159e837$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $540c81a3e159e837$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $540c81a3e159e837$var$unlazy(swiper, i);
    }
};
function $540c81a3e159e837$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $540c81a3e159e837$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $540c81a3e159e837$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $540c81a3e159e837$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $540c81a3e159e837$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $540c81a3e159e837$var$update = {
    updateSize: $540c81a3e159e837$var$updateSize,
    updateSlides: $540c81a3e159e837$var$updateSlides,
    updateAutoHeight: $540c81a3e159e837$var$updateAutoHeight,
    updateSlidesOffset: $540c81a3e159e837$var$updateSlidesOffset,
    updateSlidesProgress: $540c81a3e159e837$var$updateSlidesProgress,
    updateProgress: $540c81a3e159e837$var$updateProgress,
    updateSlidesClasses: $540c81a3e159e837$var$updateSlidesClasses,
    updateActiveIndex: $540c81a3e159e837$var$updateActiveIndex,
    updateClickedSlide: $540c81a3e159e837$var$updateClickedSlide
};
function $540c81a3e159e837$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $74e748383b8b0bc3$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $540c81a3e159e837$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $540c81a3e159e837$var$minTranslate() {
    return -this.snapGrid[0];
}
function $540c81a3e159e837$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $540c81a3e159e837$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $74e748383b8b0bc3$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $540c81a3e159e837$var$translate = {
    getTranslate: $540c81a3e159e837$var$getSwiperTranslate,
    setTranslate: $540c81a3e159e837$var$setTranslate,
    minTranslate: $540c81a3e159e837$var$minTranslate,
    maxTranslate: $540c81a3e159e837$var$maxTranslate,
    translateTo: $540c81a3e159e837$var$translateTo
};
function $540c81a3e159e837$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $540c81a3e159e837$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $540c81a3e159e837$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $540c81a3e159e837$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $540c81a3e159e837$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $540c81a3e159e837$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $540c81a3e159e837$var$transition = {
    setTransition: $540c81a3e159e837$var$setTransition,
    transitionStart: $540c81a3e159e837$var$transitionStart,
    transitionEnd: $540c81a3e159e837$var$transitionEnd
};
function $540c81a3e159e837$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $74e748383b8b0bc3$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    const browser = $540c81a3e159e837$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $540c81a3e159e837$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $540c81a3e159e837$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $540c81a3e159e837$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $540c81a3e159e837$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $540c81a3e159e837$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $540c81a3e159e837$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $540c81a3e159e837$var$slide = {
    slideTo: $540c81a3e159e837$var$slideTo,
    slideToLoop: $540c81a3e159e837$var$slideToLoop,
    slideNext: $540c81a3e159e837$var$slideNext,
    slidePrev: $540c81a3e159e837$var$slidePrev,
    slideReset: $540c81a3e159e837$var$slideReset,
    slideToClosest: $540c81a3e159e837$var$slideToClosest,
    slideToClickedSlide: $540c81a3e159e837$var$slideToClickedSlide
};
function $540c81a3e159e837$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $74e748383b8b0bc3$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $74e748383b8b0bc3$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next",
        initial: initial
    });
}
function $540c81a3e159e837$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) (0, $74e748383b8b0bc3$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $74e748383b8b0bc3$export$3b14a55fb2447963)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $540c81a3e159e837$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $540c81a3e159e837$var$loop = {
    loopCreate: $540c81a3e159e837$var$loopCreate,
    loopFix: $540c81a3e159e837$var$loopFix,
    loopDestroy: $540c81a3e159e837$var$loopDestroy
};
function $540c81a3e159e837$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $540c81a3e159e837$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $540c81a3e159e837$var$grabCursor = {
    setGrabCursor: $540c81a3e159e837$var$setGrabCursor,
    unsetGrabCursor: $540c81a3e159e837$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $540c81a3e159e837$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $59962c5e7ec9755b$export$39b482c5e57630a8)() || el === (0, $59962c5e7ec9755b$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $540c81a3e159e837$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $540c81a3e159e837$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $540c81a3e159e837$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!(0, $74e748383b8b0bc3$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $540c81a3e159e837$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$540c81a3e159e837$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $540c81a3e159e837$var$onTouchMove(event) {
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== "mouse") document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $540c81a3e159e837$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
    (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $540c81a3e159e837$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $540c81a3e159e837$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $540c81a3e159e837$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $540c81a3e159e837$var$onLoad(e) {
    const swiper = this;
    $540c81a3e159e837$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $540c81a3e159e837$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $540c81a3e159e837$var$events = (swiper, method)=>{
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $540c81a3e159e837$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $540c81a3e159e837$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $540c81a3e159e837$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $540c81a3e159e837$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $540c81a3e159e837$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $540c81a3e159e837$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $540c81a3e159e837$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $540c81a3e159e837$var$onScroll.bind(swiper);
    swiper.onClick = $540c81a3e159e837$var$onClick.bind(swiper);
    swiper.onLoad = $540c81a3e159e837$var$onLoad.bind(swiper);
    $540c81a3e159e837$var$events(swiper, "on");
}
function $540c81a3e159e837$var$detachEvents() {
    const swiper = this;
    $540c81a3e159e837$var$events(swiper, "off");
}
var $540c81a3e159e837$var$events$1 = {
    attachEvents: $540c81a3e159e837$var$attachEvents,
    detachEvents: $540c81a3e159e837$var$detachEvents
};
const $540c81a3e159e837$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $540c81a3e159e837$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
    const breakpointContainer = [
        "window",
        "container"
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $540c81a3e159e837$var$isGridEnabled(swiper, params);
    const isMultiRow = $540c81a3e159e837$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $540c81a3e159e837$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $540c81a3e159e837$var$breakpoints = {
    setBreakpoint: $540c81a3e159e837$var$setBreakpoint,
    getBreakpoint: $540c81a3e159e837$var$getBreakpoint
};
function $540c81a3e159e837$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $540c81a3e159e837$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $540c81a3e159e837$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $540c81a3e159e837$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $540c81a3e159e837$var$classes = {
    addClasses: $540c81a3e159e837$var$addClasses,
    removeClasses: $540c81a3e159e837$var$removeClasses
};
function $540c81a3e159e837$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $540c81a3e159e837$var$checkOverflow$1 = {
    checkOverflow: $540c81a3e159e837$var$checkOverflow
};
var $540c81a3e159e837$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $540c81a3e159e837$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $540c81a3e159e837$var$prototypes = {
    eventsEmitter: $540c81a3e159e837$var$eventsEmitter,
    update: $540c81a3e159e837$var$update,
    translate: $540c81a3e159e837$var$translate,
    transition: $540c81a3e159e837$var$transition,
    slide: $540c81a3e159e837$var$slide,
    loop: $540c81a3e159e837$var$loop,
    grabCursor: $540c81a3e159e837$var$grabCursor,
    events: $540c81a3e159e837$var$events$1,
    breakpoints: $540c81a3e159e837$var$breakpoints,
    checkOverflow: $540c81a3e159e837$var$checkOverflow$1,
    classes: $540c81a3e159e837$var$classes
};
const $540c81a3e159e837$var$extendedDefaults = {};
class $540c81a3e159e837$export$25ce5a424b770e84 {
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $74e748383b8b0bc3$export$dda1d9f60106f0e9)(slides[0]);
        return (0, $74e748383b8b0bc3$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $74e748383b8b0bc3$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $540c81a3e159e837$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $74e748383b8b0bc3$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $74e748383b8b0bc3$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $74e748383b8b0bc3$export$ffb5f4729a158638)(el, "direction") === "rtl"),
            wrongRTL: (0, $74e748383b8b0bc3$export$ffb5f4729a158638)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $540c81a3e159e837$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $540c81a3e159e837$var$processLazyPreloader(swiper, e.target);
            });
        });
        $540c81a3e159e837$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $540c81a3e159e837$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== "string") el.removeAttribute("style");
            if (wrapperEl) wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== "string") swiper.el.swiper = null;
            (0, $74e748383b8b0bc3$export$d141bba7fdc215a3)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)($540c81a3e159e837$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $540c81a3e159e837$var$extendedDefaults;
    }
    static get defaults() {
        return $540c81a3e159e837$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$540c81a3e159e837$export$25ce5a424b770e84.prototype.__modules__) $540c81a3e159e837$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $540c81a3e159e837$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$540c81a3e159e837$export$25ce5a424b770e84.installModule(m));
            return $540c81a3e159e837$export$25ce5a424b770e84;
        }
        $540c81a3e159e837$export$25ce5a424b770e84.installModule(module);
        return $540c81a3e159e837$export$25ce5a424b770e84;
    }
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new $540c81a3e159e837$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $540c81a3e159e837$var$getSupport();
        swiper.device = $540c81a3e159e837$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $540c81a3e159e837$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $540c81a3e159e837$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, $540c81a3e159e837$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, swiperParams, $540c81a3e159e837$var$extendedDefaults, params);
        swiper.originalParams = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $74e748383b8b0bc3$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
}
Object.keys($540c81a3e159e837$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($540c81a3e159e837$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $540c81a3e159e837$export$25ce5a424b770e84.prototype[protoMethod] = $540c81a3e159e837$var$prototypes[prototypeGroup][protoMethod];
    });
});
$540c81a3e159e837$export$25ce5a424b770e84.use([
    $540c81a3e159e837$var$Resize,
    $540c81a3e159e837$var$Observer
]);






function $516bc34d40de0ef2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === "undefined" ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $74e748383b8b0bc3$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $d0ca0479ad77fa33$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $74e748383b8b0bc3$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $74e748383b8b0bc3$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $74e748383b8b0bc3$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $e8c7371909f86cd8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $74e748383b8b0bc3$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $74e748383b8b0bc3$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $74e748383b8b0bc3$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $74e748383b8b0bc3$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $8aa340d2c4d78ba0$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $ba8e2b4f1c933621$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $8aa340d2c4d78ba0$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $4426ca189cf7b3bf$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $13887a4da5353b27$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return "next";
        else if (nextIndex === prevIndex - 1) return "previous";
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $74e748383b8b0bc3$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === "next") swiper.slideNext();
            else if (moveDirection === "previous") swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $74e748383b8b0bc3$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $74e748383b8b0bc3$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $8aa340d2c4d78ba0$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $74e748383b8b0bc3$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $3d15702a15f35ae3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $74e748383b8b0bc3$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $8aa340d2c4d78ba0$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $74e748383b8b0bc3$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $3f14410d5e9139c8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $74e748383b8b0bc3$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $bc4ce0c811bc4496$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $74e748383b8b0bc3$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === "mouse";
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $74e748383b8b0bc3$export$35e795649ee09318)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $74e748383b8b0bc3$export$35e795649ee09318)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = "0ms";
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $74e748383b8b0bc3$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $74e748383b8b0bc3$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $74e748383b8b0bc3$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === "number" && typeof image.currentY === "number") {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $74e748383b8b0bc3$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $235f4384e84ce076$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $74e748383b8b0bc3$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $74e748383b8b0bc3$export$342063e11d6c3cad)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === "string" ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $7e69c02dd04e7ec3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $74e748383b8b0bc3$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $4426ca189cf7b3bf$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $74e748383b8b0bc3$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
        }
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $c2852e1b3ac4a9ca$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $38f0f5f3be8f902a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
    const window = (0, $59962c5e7ec9755b$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-hash") === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $74e748383b8b0bc3$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $57cf5d2620767251$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains("swiper-slide-active"));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $e13179c485429aa0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $74e748383b8b0bc3$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $74e748383b8b0bc3$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $59962c5e7ec9755b$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $0cf09f0faabf2954$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $74e748383b8b0bc3$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $74e748383b8b0bc3$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $74e748383b8b0bc3$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $74e748383b8b0bc3$export$342063e11d6c3cad)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $74e748383b8b0bc3$export$342063e11d6c3cad)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $74e748383b8b0bc3$export$342063e11d6c3cad)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $aadd52fc036ef157$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $878f377e4851faec$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $878f377e4851faec$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $878f377e4851faec$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $878f377e4851faec$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $878f377e4851faec$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $878f377e4851faec$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $878f377e4851faec$var$appendSlide.bind(swiper),
        prependSlide: $878f377e4851faec$var$prependSlide.bind(swiper),
        addSlide: $878f377e4851faec$var$addSlide.bind(swiper),
        removeSlide: $878f377e4851faec$var$removeSlide.bind(swiper),
        removeAllSlides: $878f377e4851faec$var$removeAllSlides.bind(swiper)
    });
}


function $b17515bdea7e7b7d$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $5a76e694219b4363$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $bd7634a7b864e060$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $74e748383b8b0bc3$export$342063e11d6c3cad)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $a859ea649c0ca620$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $5a76e694219b4363$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $bd7634a7b864e060$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $8b289ab3a4a082c9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $74e748383b8b0bc3$export$ae1af26003f05816)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $4302fd02eca7c208$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $74e748383b8b0bc3$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $a2b9a8ec2c57aaf9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $74e748383b8b0bc3$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $5a76e694219b4363$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $bd7634a7b864e060$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $9bf79fe07184fefe$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $74e748383b8b0bc3$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $5a76e694219b4363$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $0766f3bc9cc2759b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $74e748383b8b0bc3$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $5a76e694219b4363$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $bd7634a7b864e060$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $2256394f302060d7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $4302fd02eca7c208$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $5a76e694219b4363$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $74e748383b8b0bc3$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $bd7634a7b864e060$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $b17515bdea7e7b7d$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}



























// Copyright (C) Konrad Gadzinowski
const $fef0c03397c92874$export$4fd215b7e124a07f = "hosted-app";


const $d476ec73b381cdbd$var$PWA_DISMISS_KEY = "pwa-install-dismissed";
const $d476ec73b381cdbd$var$DISMISS_DURATION_MS = 604800000 // 7 days
;
const $d476ec73b381cdbd$var$TRANSLATION_ID = "PwaInstall";
class $d476ec73b381cdbd$export$f0fbe5e5a631a19d {
    setup() {
        if (document.body.classList.contains((0, $fef0c03397c92874$export$4fd215b7e124a07f))) return;
        // Don't show if already installed (standalone mode)
        if (window.matchMedia("(display-mode: standalone)").matches) return;
        if (navigator.standalone === true) return;
        this.translation.fetchTranslations($d476ec73b381cdbd$var$TRANSLATION_ID);
        window.addEventListener("beforeinstallprompt", (event)=>{
            event.preventDefault();
            this.deferredPrompt = event;
            // Check if user dismissed recently
            const dismissedAt = localStorage.getItem($d476ec73b381cdbd$var$PWA_DISMISS_KEY);
            if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < $d476ec73b381cdbd$var$DISMISS_DURATION_MS) return;
            this.showBanner();
        });
    }
    async showBanner() {
        var _this_banner_querySelector, _this_banner_querySelector1;
        // Don't stack a second banner if one is already shown
        if (this.banner || document.querySelector(".pwa-install-banner")) return;
        if (this.translation.isEmpty()) await this.translation.fetchTranslations($d476ec73b381cdbd$var$TRANSLATION_ID);
        const t = this.translation.t;
        this.banner = document.createElement("div");
        this.banner.className = "pwa-install-banner";
        this.banner.innerHTML = `
      <div class="pwa-install-banner-content">
        <img src="/client/assets/favicon.svg" alt="Restanaut" class="pwa-install-icon" />
        <div class="pwa-install-text">
          <strong>${t("Install Restanaut")}</strong>
          <span>${t("Add to your home screen for quick access")}</span>
        </div>
        <div class="pwa-install-actions">
          <button class="btn btn-sm btn-primary pwa-install-btn">${t("Install")}</button>
          <button class="btn btn-sm btn-outline-secondary pwa-install-dismiss">&times;</button>
        </div>
      </div>
    `;
        document.body.appendChild(this.banner);
        // Animate in
        requestAnimationFrame(()=>{
            var _this_banner;
            (_this_banner = this.banner) === null || _this_banner === void 0 ? void 0 : _this_banner.classList.add("pwa-install-banner--visible");
        });
        (_this_banner_querySelector = this.banner.querySelector(".pwa-install-btn")) === null || _this_banner_querySelector === void 0 ? void 0 : _this_banner_querySelector.addEventListener("click", async ()=>{
            if (!this.deferredPrompt) return;
            this.deferredPrompt.prompt();
            await this.deferredPrompt.userChoice;
            this.deferredPrompt = null;
            this.removeBanner();
        });
        (_this_banner_querySelector1 = this.banner.querySelector(".pwa-install-dismiss")) === null || _this_banner_querySelector1 === void 0 ? void 0 : _this_banner_querySelector1.addEventListener("click", ()=>{
            localStorage.setItem($d476ec73b381cdbd$var$PWA_DISMISS_KEY, Date.now().toString());
            this.removeBanner();
        });
    }
    removeBanner() {
        if (!this.banner) return;
        this.banner.classList.remove("pwa-install-banner--visible");
        this.banner.addEventListener("transitionend", ()=>{
            var _this_banner;
            return (_this_banner = this.banner) === null || _this_banner === void 0 ? void 0 : _this_banner.remove();
        });
        this.banner = null;
    }
    constructor(){
        this.deferredPrompt = null;
        this.banner = null;
        this.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
    }
}









class $efbd41b9f0e5c1fd$export$19e216bd97563560 {
}
$efbd41b9f0e5c1fd$export$19e216bd97563560.CONTAINER_ID = "order-toast-container";
$efbd41b9f0e5c1fd$export$19e216bd97563560.CONTAINER_STYLE = "position:fixed;top:1rem;right:1rem;z-index:1100;min-width:280px;";
$efbd41b9f0e5c1fd$export$19e216bd97563560.AUTOHIDE_DELAY_MS = 10000;
$efbd41b9f0e5c1fd$export$19e216bd97563560.TRANSLATION_ID = "OrderToast";
$efbd41b9f0e5c1fd$export$19e216bd97563560.translation = new (0, $c1f3774614d137bd$export$b63289fbda65eed1)();
$efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_VOLUME = 0.9;
$efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_FADE_S = 0.02;
// A short two-tone ascending chime so a new order is recognisable by ear.
$efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_TONES = [
    {
        frequency: 880,
        startOffset: 0,
        duration: 0.15
    },
    {
        frequency: 1320,
        startOffset: 0.18,
        duration: 0.2
    }
];
$efbd41b9f0e5c1fd$export$19e216bd97563560.audioContext = null;
$efbd41b9f0e5c1fd$export$19e216bd97563560.initialize = ()=>{
    (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderNew, $efbd41b9f0e5c1fd$export$19e216bd97563560.show);
    (0, $16521f78b103838e$export$4bbaa2811faa41de).on((0, $af3e60c4682271e9$export$bdfa458742e675ed).OrderRefundFailed, $efbd41b9f0e5c1fd$export$19e216bd97563560.showRefundFailed);
    $efbd41b9f0e5c1fd$export$19e216bd97563560.translation.fetchTranslations($efbd41b9f0e5c1fd$export$19e216bd97563560.TRANSLATION_ID);
    $efbd41b9f0e5c1fd$export$19e216bd97563560.primeAudioOnFirstGesture();
};
// Browsers block audio until the user interacts with the page, so resume the context on the first
// gesture. By the time an order arrives the chime can then play without a user gesture of its own.
$efbd41b9f0e5c1fd$export$19e216bd97563560.primeAudioOnFirstGesture = ()=>{
    const prime = ()=>{
        var _OrderToast_getAudioContext;
        (_OrderToast_getAudioContext = $efbd41b9f0e5c1fd$export$19e216bd97563560.getAudioContext()) === null || _OrderToast_getAudioContext === void 0 ? void 0 : _OrderToast_getAudioContext.resume();
        window.removeEventListener("pointerdown", prime);
        window.removeEventListener("keydown", prime);
    };
    window.addEventListener("pointerdown", prime);
    window.addEventListener("keydown", prime);
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.getAudioContext = ()=>{
    try {
        var _window_AudioContext;
        const AudioContextClass = (_window_AudioContext = window.AudioContext) !== null && _window_AudioContext !== void 0 ? _window_AudioContext : window.webkitAudioContext;
        if (!AudioContextClass) return null;
        if (!$efbd41b9f0e5c1fd$export$19e216bd97563560.audioContext) $efbd41b9f0e5c1fd$export$19e216bd97563560.audioContext = new AudioContextClass();
        return $efbd41b9f0e5c1fd$export$19e216bd97563560.audioContext;
    } catch (error) {
        return null;
    }
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.playSound = ()=>{
    if (!(0, $007892703817a59c$export$df13b27c19527dbe).isEnabled()) return;
    try {
        const ctx = $efbd41b9f0e5c1fd$export$19e216bd97563560.getAudioContext();
        if (!ctx) return;
        if (ctx.state === "suspended") ctx.resume();
        for (const tone of $efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_TONES)$efbd41b9f0e5c1fd$export$19e216bd97563560.playTone(ctx, tone.frequency, ctx.currentTime + tone.startOffset, tone.duration);
    } catch (error) {
    // Best-effort: never let a missing/blocked audio device disrupt the page.
    }
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.playTone = (ctx, frequency, startTime, duration)=>{
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    // Ramp the volume up/down so the tone doesn't click on start/stop.
    gain.gain.setValueAtTime(0, startTime);
    gain.gain.linearRampToValueAtTime($efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_VOLUME, startTime + $efbd41b9f0e5c1fd$export$19e216bd97563560.SOUND_FADE_S);
    gain.gain.linearRampToValueAtTime(0, startTime + duration);
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start(startTime);
    oscillator.stop(startTime + duration);
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.getOrCreateContainer = ()=>{
    let container = document.getElementById($efbd41b9f0e5c1fd$export$19e216bd97563560.CONTAINER_ID);
    if (!container) {
        container = document.createElement("div");
        container.id = $efbd41b9f0e5c1fd$export$19e216bd97563560.CONTAINER_ID;
        container.style.cssText = $efbd41b9f0e5c1fd$export$19e216bd97563560.CONTAINER_STYLE;
        document.body.appendChild(container);
    }
    return container;
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.show = async (data)=>{
    if (!(data === null || data === void 0 ? void 0 : data.restaurantKey)) return;
    $efbd41b9f0e5c1fd$export$19e216bd97563560.playSound();
    const t = await $efbd41b9f0e5c1fd$export$19e216bd97563560.getTranslator();
    await $efbd41b9f0e5c1fd$export$19e216bd97563560.renderToast({
        iconClass: "bi bi-bell-fill text-warning",
        title: t("New order"),
        message: t("A new order has been received."),
        restaurantKey: data.restaurantKey,
        orderId: data.orderId,
        autohide: true
    });
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.showRefundFailed = async (data)=>{
    if (!(data === null || data === void 0 ? void 0 : data.restaurantKey)) return;
    const t = await $efbd41b9f0e5c1fd$export$19e216bd97563560.getTranslator();
    const message = data.reason === (0, $f0ffcdf5c347f6b9$export$77de14a781ca4626).InsufficientFunds ? t("Your Stripe balance doesn't have enough available funds to refund this order. Recent payments may still be settling. Try again later.") : t("The refund couldn't be processed. Please try again later.");
    await $efbd41b9f0e5c1fd$export$19e216bd97563560.renderToast({
        iconClass: "bi bi-exclamation-triangle-fill text-danger",
        title: t("Refund failed"),
        message: message,
        restaurantKey: data.restaurantKey,
        orderId: data.orderId,
        autohide: false
    });
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.getTranslator = async ()=>{
    if ($efbd41b9f0e5c1fd$export$19e216bd97563560.translation.isEmpty()) await $efbd41b9f0e5c1fd$export$19e216bd97563560.translation.fetchTranslations($efbd41b9f0e5c1fd$export$19e216bd97563560.TRANSLATION_ID);
    return $efbd41b9f0e5c1fd$export$19e216bd97563560.translation.t;
};
$efbd41b9f0e5c1fd$export$19e216bd97563560.renderToast = async (params)=>{
    const t = await $efbd41b9f0e5c1fd$export$19e216bd97563560.getTranslator();
    const container = $efbd41b9f0e5c1fd$export$19e216bd97563560.getOrCreateContainer();
    const ordersUrl = `/${(0, $c1f3774614d137bd$export$b63289fbda65eed1).getLocationCode()}/orders/${params.restaurantKey}?page=1&orderId=${params.orderId}`;
    const toastEl = document.createElement("div");
    toastEl.className = "toast";
    toastEl.setAttribute("role", "alert");
    toastEl.setAttribute("aria-live", "assertive");
    toastEl.setAttribute("aria-atomic", "true");
    toastEl.innerHTML = `
      <div class="toast-header">
        <i class="${params.iconClass} me-2"></i>
        <strong class="me-auto">${params.title}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="${t("Close")}"></button>
      </div>
      <div class="toast-body">
        ${params.message}
        <div class="mt-2">
          <a href="${ordersUrl}" class="btn btn-sm btn-primary">${t("View order")}</a>
        </div>
      </div>
    `;
    container.appendChild(toastEl);
    const toast = new (0, $d9aa5c6b16d90faa$export$8d8dc7d5f743331b)(toastEl, {
        autohide: params.autohide,
        delay: $efbd41b9f0e5c1fd$export$19e216bd97563560.AUTOHIDE_DELAY_MS
    });
    toast.show();
    toastEl.addEventListener("hidden.bs.toast", ()=>toastEl.remove());
};


class $1fa087aa712bec2f$export$3dc3a9199b4bd348 {
}
$1fa087aa712bec2f$export$3dc3a9199b4bd348.MAIN_SELECTOR = "main";
$1fa087aa712bec2f$export$3dc3a9199b4bd348.BACKDROP_SELECTOR = ".modal-backdrop";
$1fa087aa712bec2f$export$3dc3a9199b4bd348.MODAL_SHOWN_EVENT = "shown.bs.modal";
$1fa087aa712bec2f$export$3dc3a9199b4bd348.initialize = ()=>{
    document.addEventListener($1fa087aa712bec2f$export$3dc3a9199b4bd348.MODAL_SHOWN_EVENT, $1fa087aa712bec2f$export$3dc3a9199b4bd348.moveBackdropsIntoMain);
};
$1fa087aa712bec2f$export$3dc3a9199b4bd348.moveBackdropsIntoMain = ()=>{
    // We need to make sure that modal backdrop is always in the main element, otherwise it will stay on PJAX load
    const main = document.querySelector($1fa087aa712bec2f$export$3dc3a9199b4bd348.MAIN_SELECTOR);
    if (!main) return;
    const orphanedBackdrops = document.querySelectorAll(`body > ${$1fa087aa712bec2f$export$3dc3a9199b4bd348.BACKDROP_SELECTOR}`);
    for (const backdrop of orphanedBackdrops)main.appendChild(backdrop);
};



const $6c481b2984ee262b$var$setupSearchableSelects = ()=>{
    const allSelectElements = document.querySelectorAll("select.searchable");
    for (const selectElement of allSelectElements)new (0, (/*@__PURE__*/$parcel$interopDefault($e2e66a1c8132829f$exports)))({
        select: selectElement
    });
};
const $6c481b2984ee262b$var$setupTooltips = ()=>{
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    for (const tooltipTriggerEl of tooltipTriggerList)new (0, $d9aa5c6b16d90faa$export$28c660c63b792dea)(tooltipTriggerEl);
};
const $6c481b2984ee262b$var$setupCarousel = ()=>{
    const carousels = document.querySelectorAll(".swiper");
    for (const carousel of carousels)new (0, $540c81a3e159e837$export$25ce5a424b770e84)(carousel, {
        modules: [
            (0, $ba8e2b4f1c933621$export$2e2bcd8739ae039),
            (0, $13887a4da5353b27$export$2e2bcd8739ae039)
        ],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: carousel.querySelector(".swiper-button-next"),
            prevEl: carousel.querySelector(".swiper-button-prev")
        },
        pagination: {
            el: carousel.querySelector(".swiper-pagination"),
            clickable: true
        },
        touchRatio: 1,
        observer: true,
        observeParents: true
    });
};
const $6c481b2984ee262b$var$setupLightbox = ()=>{
    const lightboxes = document.querySelectorAll('img[data-toggle="lightbox-image"]');
    for (const lightbox of lightboxes)lightbox.addEventListener("click", (0, $b27ab831ffac140c$export$7d2670a66155874b).initialize);
};
const $6c481b2984ee262b$var$onPageLoaded = ()=>{
    (0, $00e16369510e6292$export$3f10bfc286408f86).setupDropzones();
    $6c481b2984ee262b$var$setupSearchableSelects();
    $6c481b2984ee262b$var$setupTooltips();
    $6c481b2984ee262b$var$setupCarousel();
    $6c481b2984ee262b$var$setupLightbox();
};
(0, $16521f78b103838e$export$4bbaa2811faa41de).initialize();
new (0, $d476ec73b381cdbd$export$f0fbe5e5a631a19d)().setup();
(0, $1fa087aa712bec2f$export$3dc3a9199b4bd348).initialize();
const $6c481b2984ee262b$var$isHostedPage = document.body.classList.contains((0, $fef0c03397c92874$export$4fd215b7e124a07f));
if (!$6c481b2984ee262b$var$isHostedPage) (0, $efbd41b9f0e5c1fd$export$19e216bd97563560).initialize();
const $6c481b2984ee262b$var$app = new (0, $63b595d905f6b553$export$9bbedc1992a787b4)($6c481b2984ee262b$var$onPageLoaded);
const $6c481b2984ee262b$var$pages = [];
$6c481b2984ee262b$var$pages.push(new (0, $bd361655b21580a8$export$da8e434173032913)());
$6c481b2984ee262b$var$pages.push(new (0, $a5749f8efb25cf9e$export$593bf50f5d507e87)($6c481b2984ee262b$var$app));
$6c481b2984ee262b$var$pages.push(new (0, $b464f021e34710d1$export$ea3253f9deb4bf31)());
$6c481b2984ee262b$var$pages.push(new (0, $605c700ea6afc11e$export$c3da8c344445fc4f)());
$6c481b2984ee262b$var$pages.push(new (0, $9f73d72aa8d837e0$export$61bde38e73a8e56f)());
$6c481b2984ee262b$var$pages.push(new (0, $bb8053455085b9f5$export$b86106c69b68c29f)());
$6c481b2984ee262b$var$pages.push(new (0, $f3204faad6b88721$export$58b4806257715dc0)());
$6c481b2984ee262b$var$pages.push(new (0, $152116d178fe9046$export$26dd6e4410a57735)());
$6c481b2984ee262b$var$pages.push(new (0, $c681d84e804ccd9c$export$42a146b10ea741e8)());
$6c481b2984ee262b$var$pages.push(new (0, $b5d852b3bcb6d8e7$export$1a2d016bdbb8b398)());
$6c481b2984ee262b$var$pages.push(new (0, $da9f2f80f7f34750$export$4f4ee9834b214a1e)());
$6c481b2984ee262b$var$pages.push(new (0, $1018f4a3afef5808$export$4d39be767278cf3e)());
$6c481b2984ee262b$var$pages.push(new (0, $c44d3dba511247a0$export$5dfad489588434f3)());
$6c481b2984ee262b$var$pages.push(new (0, $08d160a8fb1a6d7d$export$13b67c67e6b8b746)());
$6c481b2984ee262b$var$pages.push(new (0, $234a136dea2648af$export$606a1a80e3707881)());
$6c481b2984ee262b$var$pages.push(new (0, $26c1ce9462577649$export$406ab9555081557)());
$6c481b2984ee262b$var$pages.push(new (0, $62040c917ec3ef2c$export$f1960bb92669a15f)());
$6c481b2984ee262b$var$pages.push(new (0, $f6810f45a9dae1f7$export$a26873792aacbadd)());
$6c481b2984ee262b$var$pages.push(new (0, $9ffb1d220fd401ba$export$ddba751a0608ff86)());
$6c481b2984ee262b$var$pages.push(new (0, $9082a69b9dc06d28$export$e6929329b7fcd8ba)());
$6c481b2984ee262b$var$pages.push(new (0, $96a194e6c0d55846$export$c722ad0af08974c9)());
$6c481b2984ee262b$var$pages.push(new (0, $d2ae2d8be4a94988$export$4fe290a385e6544a)());
$6c481b2984ee262b$var$pages.push(new (0, $b1792a5ee911bd48$export$5aabc7b69b716437)());
$6c481b2984ee262b$var$app.start($6c481b2984ee262b$var$pages);
window.CookiesEuBanner = (0, (/*@__PURE__*/$parcel$interopDefault($23aee52180e1383d$exports)));
new (0, (/*@__PURE__*/$parcel$interopDefault($23aee52180e1383d$exports)))(()=>{
// On cookies accepted
});

})();
//# sourceMappingURL=App.js.map
